(function() {
    'use strict';

    angular
        .module('app.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.login', {
            url: '/app/login',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.login': {
                    templateUrl: 'app/main/login/login.html',
                    controller: 'LoginController as vm'
                }
            },
            bodyClass: 'Login',
            ModuleName: 'Login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/login');

        // Navigation
        // msNavigationServiceProvider.saveItem('Demo.login', {
        //     title : 'Authentication',
        //     icon  : 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Demo.login', {
        //     title: 'Login',
        //     state: 'app.login',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }

})();
(function() {
    'use strict';

    angular
        .module('app.login')
        .controller('RegisterController', RegisterController);

    /** @ngInject */
    function RegisterController($http, $mdDialog, $mdToast, $scope, $rootScope, $cookieStore, Tasks, event, DTOptionsBuilder, DTColumnDefBuilder) {
        var vm = this;

        $scope.init = function() {
            $scope.model = {
                email: '',
                username: '',
                password: '',
                cpassword: '',
                phone: '',
                country: '',
                state: '',
                city: '',
                gender: '',
                createdby: '',
                createddate: new Date(),
            };
            GetAllCountry();
        }

        function GetAllCountry() {
            $http.get($rootScope.RoutePath + "country/GetAllCountry").then(function(data) {
                $scope.lstCountry = data.data;
            });
        }

        $scope.GetAllStateByCountry = function(idCountry) {
            for (var i = 0; i < $scope.lstCountry.length; i++) {
                if ($scope.lstCountry[i].Country == idCountry) {
                    idCountry = $scope.lstCountry[i].id;
                }
            }
            $scope.model.idState = '';
            $scope.lstState = '';
            var params = {
                CountryId: idCountry
            };
            $http.get($rootScope.RoutePath + "state/GetAllStateByCountryId", { params: params }).success(function(data) {
                $scope.lstState = data.data;

            });
        }


        $scope.Register = function(o) {          
                o.createdby=o.username;               
                if (o.password.length < 6) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent("Enter six digit Password.")
                        .position('top right')
                        .hideDelay(3000)
                    );

                    return;
                } else if (o.password != o.cpassword) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent("Password and confirm password must be same.")
                        .position('top right')
                        .hideDelay(3000)
                    );

                    return;
                } else {
                    $http.post($rootScope.RoutePath + "account/register",o).success(function(data) {
                        console.log(data);
                        if (data.success == 1) {
                            $mdToast.show(
                                $mdToast.simple()
                                .textContent(data.message)
                                .position('top right')
                                .hideDelay(3000)
                            );
                            $mdDialog.hide();
                            $scope.init();
                        } else {
                            $mdToast.show(
                                $mdToast.simple()
                                .textContent(data.message)
                                .position('top right')
                                .hideDelay(3000)
                            );
                        }
                    });

                }
            }  

         $scope.Cancel=function(){
            $mdDialog.hide();
            $scope.init();
         }             
        $scope.init();
    }
})();

(function() {
    'use strict';

    angular
        .module('app.login')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController($http, $mdDialog, $mdToast, $scope, $rootScope, $cookieStore, Tasks, event, DTOptionsBuilder, DTColumnDefBuilder) {
        var vm = this;

        $scope.init = function() {
            $scope.model = {
                Email: '',
            };

        }

        //Forgot Password
        $scope.SubmitForgotPassword = 0;
        $scope.ForgotPassword = function(o) {
        console.log(o);
                // if (form.$valid) {
                    var params = {
                        Email: o.Email,
                    }
                //     $http.get(route.Lookup.ForgotPassword, { params: params }).success(function(data) {
                //         if (data.success == 1) {
                //             toastr.success(data.message);
                //               $scope.SubmitForgotPassword = 0;
                //             $scope.Reset();
                //         } else {
                //             toastr.error(data.message);
                //         }
                //     });
                // } else {
                //     $scope.SubmitForgotPassword = 1;
                // }
            }
            //End Forgot Password
            // if (objCountry == 0) {
            //     $scope.tab = { selectedIndex: 1 };
            // }
            // else {
            // }

        $scope.init();
    }
})();

(function() {
    'use strict';

    angular
        .module('app.unlinkeddevices', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.unlinkeddevices', {
                url: '/unlinkeddevices',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/InactiveDevices/InactiveDevices.html',
                        controller: 'InactiveDevicesController as vm'
                    }
                },
                bodyClass: 'Unlinked Devices',
                ModuleName: 'Unlinked Devices'
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/user');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.user', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('customerdevices', {
        //     title: 'Customer Devices',
        //     state: 'app.customerdevices',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.unlinkeddevices')
        .controller('ScoketSettingController', ScoketSettingController);

    /** @ngInject */
    function ScoketSettingController($http, $mdDialog, $mdToast, $scope, $cookieStore, $rootScope, objSocket, InactiveVm, Tasks, event) {
        var vm = this;

        $scope.init = function() {
            $scope.model = {
                id: objSocket.id,
                CustomerMasterId: objSocket.CustomerMasterId,
                DeviceType: objSocket.DeviceType,
                DeviceName: objSocket.DeviceName,
                DeviceSerial: objSocket.DeviceSerial,
                TriggerType: objSocket.TriggerType,
                LightOff_Timer: objSocket.LightOff_Timer,
                Scheduler_StartTime: objSocket.Scheduler_StartTime,
                Scheduler_EndTime: objSocket.Scheduler_EndTime,
                Device_Mat_Id: objSocket.Device_Mat_Id,
                Setting_Sync_Flag: objSocket.Setting_Sync_Flag,
                Connection_Status: objSocket.Connection_Status,
                IsActive: objSocket.IsActive,
                SchedulType: 'Always On',
            }
            if (objSocket.Scheduler_StartTime == '00:00:00' && objSocket.Scheduler_EndTime == '23:59:59') {
                $scope.model.Scheduler_StartTime = '';
                $scope.model.Scheduler_EndTime = '';
                $scope.model.SchedulType = 'Always On';
            } else {
                $scope.model.Scheduler_StartTime = ConvertToTime(objSocket.Scheduler_StartTime);
                $scope.model.Scheduler_EndTime = ConvertToTime(objSocket.Scheduler_EndTime);
                $scope.model.SchedulType = 'Scheduling';
            }
            $scope.tab = { selectedIndex: 0 };
            $scope.TimingList = [{ value: 30000, time: '30 Seconds' }, { value: 60000, time: '1 Minute' }, { value: 120000, time: '2 Minute' }, { value: 180000, time: '3 Minute' }, { value: 240000, time: '4 Minute' }, { value: 300000, time: '5 Minute' }, { value: 360000, time: '6 Minute' }, { value: 420000, time: '7 Minute' }, { value: 480000, time: '8 Minute' }, { value: 540000, time: '9 Minute' }, { value: 600000, time: '10 Minute' }, { value: 660000, time: '11 Minute' }, { value: 720000, time: '12 Minute' }, { value: 780000, time: '13 Minute' }, { value: 840000, time: '14 Minute' }, { value: 900000, time: '15 Minute' }, { value: 960000, time: '16 Minute' }, { value: 1020000, time: '17 Minute' }, { value: 1080000, time: '18 Minute' }, { value: 1140000, time: '19 Minute' }, { value: 1200000, time: '20 Minute' }, { value: 1500000, time: '25 Minute' }, { value: 1800000, time: '30 Minute' }, { value: 2100000, time: '35 Minute' }, { value: 2400000, time: '40 Minute' }, { value: 2700000, time: '45 Minute' }, { value: 3000000, time: '50 Minute' }, { value: 3300000, time: '55 Minute' }, { value: 3600000, time: '1 Hour' }];

            $('.mobiscrollTime').scroller({ preset: 'time' });
            $('.mobiscrollDate').scroller();
            $('.mobiscrollDateTime').scroller({ preset: 'datetime' });
        }

        $scope.CreateCustomerDevice = function(o, lst) {
            if (o.SchedulType == "Always On") {
                o.Scheduler_StartTime = "00:00:00";
                o.Scheduler_EndTime = "23:59:59";
            }
            $http.post($rootScope.RoutePath + "customerdevices/SaveCustomerDevice", o).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );

                    $rootScope.FlgAddedEditlocal = false;
                    if ($rootScope.FlgAddedAccess == true) {
                        $rootScope.FlgAddedEditlocal = true
                    }
                    InactiveVm.GetAllInavtiveAlarmDevice();
                    $scope.Reset();
                } else {
                    if (data.data.data == 'TOKEN') {

                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                        InactiveVm.GetAllInavtiveAlarmDevice();
                        $scope.Reset();
                    }
                }
            });
            // }

        }

        function ConvertToTime(Time) {

            if (Time != null) {
                var splitedData = Time.split(':')
                if (parseInt(splitedData[0]) < 12) {
                    if (splitedData[0] == 0) {
                        return 12 + ":" + splitedData[1] + " AM";
                    } else {
                        return splitedData[0] + ":" + splitedData[1] + " AM";
                    }
                } else {
                    if (parseInt(splitedData[0]) - 12 == 0) {
                        return 12 + ":" + splitedData[1] + " PM";
                    } else {
                        return parseInt(splitedData[0]) - 12 + ":" + splitedData[1] + " PM";
                    }
                }
            } else {
                return null;
            }
        }

        $scope.OpenDetail = function(Type, flg) {
            var obj = {
                Type: Type,
                Flag: flg
            }
            $mdDialog.show({
                skipHide: true,
                controller: 'InformationDetail1Controller',
                controllerAs: 'vm',
                templateUrl: 'app/main/InactiveDevices/dialogs/InformationDetail/InformationDetail.html',
                parent: angular.element(document.body),
                targetEvent: '',
                clickOutsideToClose: false,
                locals: {
                    objInformation: obj,
                    Tasks: [],
                    event: '',
                    ActiveVm: vm,
                }
            })
        }

        $scope.Reset = function() {
            $mdDialog.hide();
        }

        $scope.closeModel = function() {
            $mdDialog.hide();
        }

        $scope.init();
    }
})();
(function() {
    'use strict';

    angular
        .module('app.linkeddevices', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.linkeddevices', {
                url: '/linkeddevices',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/ActiveDevices/ActiveDevices.html',
                        controller: 'ActiveDevicesController as vm'
                    }
                },
                bodyClass: 'Linked Devices',
                ModuleName: 'Linked Devices'
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/user');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.user', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('customerdevices', {
        //     title: 'Customer Devices',
        //     state: 'app.customerdevices',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.linkeddevices')
        .controller('InformationDetail1Controller', InformationDetail1Controller);

    /** @ngInject */
    function InformationDetail1Controller($http, $mdDialog, $mdToast, $scope, $cookieStore, $rootScope, objInformation, ActiveVm, Tasks, event) {
        var vm = this;

        $scope.init = function() {
            $scope.Type = objInformation.Type;
            $scope.Flag = objInformation.Flag;
        }

        $scope.closeModel = function() {
            $mdDialog.hide();
        }

        $scope.init();
    }
})();
(function() {
    'use strict';

    angular
        .module('app.unlinkeddevices')
        .controller('AlarmSettingController', AlarmSettingController);

    /** @ngInject */
    function AlarmSettingController($http, $mdDialog, $mdToast, $scope, $cookieStore, $rootScope, objAlarm, InactiveVm, Tasks, event) {
        var vm = this;

        $scope.init = function() {
            $scope.model = {
                id: objAlarm.id,
                CustomerMasterId: objAlarm.CustomerMasterId,
                DeviceType: objAlarm.DeviceType,
                DeviceName: objAlarm.DeviceName,
                DeviceSerial: objAlarm.DeviceSerial,
                TriggerType: objAlarm.TriggerType,
                Alarm_Time: objAlarm.Alarm_Time,
                Scheduler_StartTime: objAlarm.Scheduler_StartTime,
                Scheduler_EndTime: objAlarm.Scheduler_EndTime,
                Device_Mat_Id: objAlarm.Device_Mat_Id,
                AlertType: objAlarm.AlertType,
                Setting_Sync_Flag: objAlarm.Setting_Sync_Flag,
                Connection_Status: objAlarm.Connection_Status,
                IsActive: objAlarm.IsActive,
                SchedulType: 'Always On',
                Volume: objAlarm.Volume,
            }

            if (objAlarm.Scheduler_StartTime == '00:00:00' && objAlarm.Scheduler_EndTime == '23:59:59') {
                $scope.model.Scheduler_StartTime = '';
                $scope.model.Scheduler_EndTime = '';
                $scope.model.SchedulType = 'Always On';
            } else {
                $scope.model.Scheduler_StartTime = ConvertToTime(objAlarm.Scheduler_StartTime);
                $scope.model.Scheduler_EndTime = ConvertToTime(objAlarm.Scheduler_EndTime);
                $scope.model.SchedulType = 'Scheduling';
            }
            $scope.tab = { selectedIndex: 0 };
            $scope.TimingList = [{ value: 30000, time: '30 Seconds' }, { value: 60000, time: '1 Minute' }, { value: 120000, time: '2 Minute' }, { value: 180000, time: '3 Minute' }, { value: 240000, time: '4 Minute' }, { value: 300000, time: '5 Minute' }, { value: 360000, time: '6 Minute' }, { value: 420000, time: '7 Minute' }, { value: 480000, time: '8 Minute' }, { value: 540000, time: '9 Minute' }, { value: 600000, time: '10 Minute' }, { value: 660000, time: '11 Minute' }, { value: 720000, time: '12 Minute' }, { value: 780000, time: '13 Minute' }, { value: 840000, time: '14 Minute' }, { value: 900000, time: '15 Minute' }, { value: 960000, time: '16 Minute' }, { value: 1020000, time: '17 Minute' }, { value: 1080000, time: '18 Minute' }, { value: 1140000, time: '19 Minute' }, { value: 1200000, time: '20 Minute' }, { value: 1500000, time: '25 Minute' }, { value: 1800000, time: '30 Minute' }, { value: 2100000, time: '35 Minute' }, { value: 2400000, time: '40 Minute' }, { value: 2700000, time: '45 Minute' }, { value: 3000000, time: '50 Minute' }, { value: 3300000, time: '55 Minute' }, { value: 3600000, time: '1 Hour' }];

            $('.mobiscrollTime').scroller({ preset: 'time' });
            $('.mobiscrollDate').scroller();
            $('.mobiscrollDateTime').scroller({ preset: 'datetime' });
        }

        $scope.CreateCustomerDevice = function(o, lst) {
            if (o.SchedulType == "Always On") {
                o.Scheduler_StartTime = "00:00:00";
                o.Scheduler_EndTime = "23:59:59";
            }
            $http.post($rootScope.RoutePath + "customerdevices/SaveCustomerDevice", o).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );

                    $rootScope.FlgAddedEditlocal = false;
                    if ($rootScope.FlgAddedAccess == true) {
                        $rootScope.FlgAddedEditlocal = true
                    }
                    InactiveVm.GetAllInavtiveAlarmDevice();
                    $scope.Reset();
                } else {
                    if (data.data.data == 'TOKEN') {

                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                        InactiveVm.GetAllInavtiveAlarmDevice();
                        $scope.Reset();
                    }
                }
            });
            // }

        }

        function ConvertToTime(Time) {

            if (Time != null) {
                var splitedData = Time.split(':')
                if (parseInt(splitedData[0]) < 12) {
                    if (splitedData[0] == 0) {
                        return 12 + ":" + splitedData[1] + " AM";
                    } else {
                        return splitedData[0] + ":" + splitedData[1] + " AM";
                    }
                } else {
                    if (parseInt(splitedData[0]) - 12 == 0) {
                        return 12 + ":" + splitedData[1] + " PM";
                    } else {
                        return parseInt(splitedData[0]) - 12 + ":" + splitedData[1] + " PM";
                    }
                }
            } else {
                return null;
            }
        }

        $scope.OpenDetail = function(Type, flg) {
            var obj = {
                Type: Type,
                Flag: flg
            }
            $mdDialog.show({
                skipHide: true,
                controller: 'InformationDetail1Controller',
                controllerAs: 'vm',
                templateUrl: 'app/main/InactiveDevices/dialogs/InformationDetail/InformationDetail.html',
                parent: angular.element(document.body),
                targetEvent: '',
                clickOutsideToClose: false,
                locals: {
                    objInformation: obj,
                    Tasks: [],
                    event: '',
                    ActiveVm: vm,
                }
            })
        }

        $scope.Reset = function() {
            $mdDialog.hide();
        }

        $scope.closeModel = function() {
            $mdDialog.hide();
        }

        $scope.init();
    }
})();
(function() {
    'use strict';

    angular
        .module('app.firmwareupgrade', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $httpProvider) {

        // State
        $stateProvider
            .state('app.firmwareupgrade', {
                url: '/firmwareupgrade',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/FirmwareUpgrade/FirmwareUpgrade.html',
                        controller: 'FirmwareUpgradeController as vm'
                    }
                },
                data: { requiresLogin: true },
                bodyClass: 'Firmware Upgrade',
                ModuleName: 'Firmware Upgrade'
            });

        $httpProvider.interceptors.push(function($q) {
            return {
                'request': function(config) {
                    $('#processing').show();
                    return config;
                },

                'response': function(response) {
                    $('#processing').hide();
                    return response;
                }
            };
        });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/user');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.user', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('System Setup.rcufirmwareupgrade', {
        //     title: 'RCU Firmware Upgrade',
        //     state: 'app.rcufirmwareupgrade',
        //     icon: 'icon-package-down',
        //     weight: 1
        // });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.firmwareupgrade')
        .controller('ProgressModalUpgradeController', ProgressModalUpgradeController);

    /** @ngInject */
    function ProgressModalUpgradeController($http, $interval, $mdDialog, $scope, $rootScope, event, socket, lstDevice, $mdToast) {

        $scope.lstDevice = lstDevice;
        $scope.TotalDevice = lstDevice.length;
        $scope.UploadDevice = 0;
        $scope.device = 0;
        var StepNo = 1;
        var idD = 0;

        $scope.DispalyMessage = 'Transferring Firmware to';

        var self = this,
            j = 0,
            counter = 0;
        self.mode = 'query';
        self.activated = true;
        var TotalDevices = $scope.lstDevice.length;

        var perdevicerangesubProcess = 100 / 4;
        var perdevicerangemainProcess = 100 / TotalDevices;
        $scope.ProgressPercentage = 0;
        self.determinateValueDeviceProgressBar = 0;
        self.determinateValueDeviceProcessProgressBar = 0;
        $scope.IsStopDisabled = true;
        var CallWaitInterval = 0;

        socket.on('SocketCanStop', function(msg1) {
            $scope.IsStopDisabled = false;
        });

        socket.on('FirmwareUpgradeProcess', function(msg1) {
            $scope.$apply(function() {
                $scope.lstDevice = lstDevice;
                var obj = JSON.parse(msg1);
                var objDevice = _.findWhere($scope.lstDevice, { id: parseInt(obj.idDevice) });

                //For Step 1 to Chnage Message
                if (obj.StepNo == 1 && obj.Step == "CDEV Send") {
                    var CountDownWait = 60;
                    if (obj.WaitingSeconds) {
                        CountDownWait = parseInt(obj.WaitingSeconds);
                    }
                    $scope.DispalyMessage = 'Wait' + CountDownWait + ' sec for Device Reboot of';
                    CallWaitInterval = setInterval(function() {

                        CountDownWait = CountDownWait - 1;

                        if (CountDownWait == 0) {
                            clearInterval(CallWaitInterval);
                            CallWaitInterval = 0;
                        } else {
                            $scope.DispalyMessage = 'Wait ' + CountDownWait + ' sec for Device Reboot of';
                        }

                    }, 1000);
                } else {
                    $scope.DispalyMessage = 'Transferring Firmware to';
                    clearInterval(CallWaitInterval);
                    CallWaitInterval = 0;
                }

                if (obj.StepNo == 0 && obj.status == true) {
                    perdevicerangesubProcess = 100 / parseInt(obj.Count);
                };
                //For Packet
                if (obj.StepNo == "Packet" && (obj.status == true)) {
                    $scope.DeviceProcessProgressBar(objDevice, obj.StepNo);
                }

                //Logic For sub Process
                if (obj.StepNo == StepNo && (obj.status == true)) {
                    $scope.DeviceProcessProgressBar(objDevice, obj.StepNo);
                    StepNo += 1;
                }

                //Logic For Main Process
                if (obj.StepNo == 4 && obj.Step == "CDEV Success") {
                    StepNo = 1;
                    $scope.DeviceProgressBar(objDevice, obj.StepNo);
                }
            })
        });

        socket.on('FirmwareUpgradeProcessSuccess', function(msg1) {
            $scope.$apply(function() {
                var obj = JSON.parse(msg1);
                if (obj.success) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(obj.message)
                        .position('top right')
                        .hideDelay(3000)
                    );

                    $scope.closeModal();
                } else {
                    var lstUpgradedDevice = obj.data;
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(lstUpgradedDevice.length + ' out of ' + $scope.TotalDevice + ' Device Upgraded Successfully.')
                        .position('top right')
                        .hideDelay(3000)
                    );
                    $scope.closeModal();
                }
            })
        });

        // main Progress Bar
        $scope.DeviceProgressBar = function() {
            self.determinateValueDeviceProgressBar += perdevicerangemainProcess;
            if (self.determinateValueDeviceProgressBar > 100) {
                self.determinateValueDeviceProgressBar = 0
            };

            //Initoalize sub Progress bar
            self.determinateValueDeviceProcessProgressBar = 0;
        }

        //Sub Progress Bar
        $scope.DeviceProcessProgressBar = function(obj, stepno) {
            $scope.Currentstepno = stepno;
            $scope.DeviceName = obj.DeviceName;
            if ($scope.device == 0 || $scope.device != obj.DeviceName) {
                $scope.device = obj.DeviceName;
                $scope.UploadDevice = $scope.UploadDevice + 1;
            }

            self.determinateValueDeviceProcessProgressBar += perdevicerangesubProcess;
            $scope.ProgressPercentage = parseInt(self.determinateValueDeviceProcessProgressBar);
            if (self.determinateValueDeviceProcessProgressBar > 100) {
                self.determinateValueDeviceProcessProgressBar = 0;
            }
        }

        $scope.ForceStopProcess = function() {
            socket.emit('ForceStopUpgradeProcess', 'Stop');
        }

        $scope.closeModal = function() {
            $mdDialog.hide();
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app.firmwareupgrade')
        .controller('FileListController', FileListController);

    /** @ngInject */
    function FileListController($http, $mdDialog, $mdToast, $scope, $cookieStore, $rootScope, DeviceType, UpgradeVm, Tasks, event) {
        var vm = this;

        $scope.init = function() {
            $scope.FileList = [];
            $scope.model = {
                Filename: ''
            }
            $scope.GetAllFileByDeviceType(DeviceType);
        }

        $scope.GetAllFileByDeviceType = function(o) {
            $http.get($rootScope.RoutePath + "firmwareupgrade/GetAllFileByDeviceType?DeviceType=" + o).then(function(data) {
                $scope.FileList = data.data;
            })
        }

        $scope.GetAllInavtiveSocketDevice = function() {
            var params = {
                CustomerMasterId: $rootScope.UserId
            }
            $http.get($rootScope.RoutePath + "customerdevices/GetAllInavtiveSocketDevice", { params: params }).then(function(data) {
                $scope.SocketList = _.filter(data.data.data, function(q) {
                    q.DeviceType = "Socket";
                    return q;
                });
                if ($scope.SocketList.length > 0) {
                    for (var i = 0; i < $scope.SocketList.length; i++) {
                        $scope.InActiveDeviceList.push($scope.SocketList[i]);
                    }
                }
            });
        }

        $scope.CallUpgrade = function() {
            $scope.closeModel();
            UpgradeVm.Upgrade($scope.model.Filename);
        }

        $scope.Reset = function() {
            $mdDialog.hide();
        }

        $scope.closeModel = function() {
            $mdDialog.hide();
        }

        $scope.init();
    }
})();
(function() {
    'use strict';

    angular
        .module('app.devicesetting_call_sms', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.devicesetting_call_sms', {
                url: '/devicesetting_call_sms',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/DeviceSetting_Call_Sms/DeviceSetting_Call_Sms.html',
                        controller: 'DeviceSetting_Call_SmsController as vm'
                    }
                },
                bodyClass: 'Device Setting',
                ModuleName: 'Device Setting'
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/user');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.user', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('devicesetting_call_sms', {
        //     title: 'Device Setting',
        //     state: 'app.devicesetting_call_sms',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.devicesetting_call_sms')
        .controller('EventListController', EventListController);

    /** @ngInject */
    function EventListController($http, $mdDialog, $mdToast, $scope, $cookieStore, $rootScope, objUser, Tasks, event) {
        var vm = this;

        $scope.init = function () {
            
            $scope.model = {
                id: '',
                DeviceSettingCallSMSId: '',
                Event: '',
                EventType: '',
                ActionType: '',
                Message: '',
            };
            $scope.DeviceType = objUser.id;
            $scope.GetEventList($scope.DeviceType);
        }
                
        $scope.GetEventList = function (o) {
            var params = {
                id: o
            }
            
            $http.get($rootScope.RoutePath + "devicesetting_call_sms/GetAllEventListByDeviceSetting", { params: params }).then(function (data) {
                $scope.lstDevice = data.data;
                $scope.model.id = $scope.lstDevice[0].id;
                $scope.model.DeviceSettingCallSMSId = $scope.lstDevice[0].DeviceSettingCallSMSId;
                $scope.model.Event = $scope.lstDevice[0].Event;
                $scope.model.EventType = $scope.lstDevice[0].EventType;
                $scope.model.ActionType = $scope.lstDevice[0].ActionType;
                $scope.model.Message = $scope.lstDevice[0].Message;
            });
        }

        $scope.Reset = function () {
            $mdDialog.hide();
        }

        $scope.closeModel = function () {
            $mdDialog.hide();
        }

        $scope.init();
    }
})();

(function() {
    'use strict';

    angular
        .module('app.devicedetail', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.devicedetail', {
                url: '/devicedetail/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/DeviceDetail/DeviceDetail.html',
                        controller: 'DeviceDetailController as vm'
                    }
                },
                bodyClass: 'Device Detail',
                ModuleName: 'Device Detail'
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/user');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.user', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('devicedetail', {
        //     title: 'Device Detail',
        //     state: 'app.devicedetail',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.devicedetail')
        .controller('EventListController', EventListController);

    /** @ngInject */
    function EventListController($http, $mdDialog, $mdToast, $scope, $cookieStore, $rootScope, objUser, Tasks, event) {
        var vm = this;

        $scope.init = function() {

            $scope.model = {
                id: '',
                DeviceSettingCallSMSId: '',
                Event: '',
                EventType: '',
                ActionType: '',
                Message: '',
            };
            $scope.id = objUser.id;
            $scope.GetEventList($scope.id);
        }

        $scope.GetEventList = function(o) {
            var params = {
                id: o
            }

            $http.get($rootScope.RoutePath + "devicesetting_call_sms/GetAllEventListByDeviceSetting", { params: params }).then(function(data) {
                $scope.lstDevice = data.data;
                if ($scope.lstDevice.length > 0) {
                    $scope.model.id = $scope.lstDevice[0].id;
                    $scope.model.DeviceSettingCallSMSId = $scope.lstDevice[0].DeviceSettingCallSMSId;
                    $scope.model.Event = $scope.lstDevice[0].Event;
                    $scope.model.EventType = $scope.lstDevice[0].EventType;
                    $scope.model.ActionType = $scope.lstDevice[0].ActionType;
                    $scope.model.Message = $scope.lstDevice[0].Message;
                }
            });
        }

        $scope.Reset = function() {
            $mdDialog.hide();
        }

        $scope.closeModel = function() {
            $mdDialog.hide();
        }

        $scope.init();
    }
})();
(function() {
    'use strict';

    angular
        .module('app.devicedetail')
        .controller('DeviceTypeDetailController', DeviceTypeDetailController);

    /** @ngInject */
    function DeviceTypeDetailController($http, $mdDialog, $mdToast, $scope, $cookieStore, $rootScope, objUser, Tasks, event, DTColumnDefBuilder) {
        var vm = this;

        $scope.init = function() {
            $scope.model = {
                CustomerDeviceId: '',
                MD_Timer: '',
                Alert_Msg_Timer: '',
                Standby_Timer: '',
                LED_Timer: '',
                TriggerType: '',
                LightOff_Timer: '',
                Scheduler_StartTime: '',
                Scheduler_EndTime: '',
                Alarm_Time: '',
                AlertType: '',
                Type: '',
                MobileNo: '',
                Email: '',
                Event_Scheduler_StartTime: '',
                Event_Scheduler_EndTime: '',
                Alert_Scheduler_StartTime: '',
                Alert_Scheduler_Endtime: '',
                Mat_id: '',
                DeviceType: '',
            };
            $scope.id = objUser.id;
            $scope.DeviceType = objUser.DeviceType;
            $scope.GetUserDevices($scope.id);
        }

        $scope.GetUserDevices = function(o) {
            var params = {
                id: o
            }
            $http.get($rootScope.RoutePath + "customerdevices/GetAllDeviceTypeDetailByDevice", { params: params }).then(function(data) {
                $scope.lstDevice = data.data;
                if ($scope.lstDevice.length) {

                    $scope.model.MD_Timer = $scope.lstDevice[0].MD_Timer;
                    $scope.model.Alert_Msg_Timer = $scope.lstDevice[0].Alert_Msg_Timer;
                    $scope.model.Standby_Timer = $scope.lstDevice[0].Standby_Timer;
                    $scope.model.LED_Timer = $scope.lstDevice[0].LED_Timer;
                    $scope.model.TriggerType = $scope.lstDevice[0].TriggerType;
                    $scope.model.LightOff_Timer = $scope.lstDevice[0].LightOff_Timer;
                    $scope.model.Scheduler_StartTime = $scope.lstDevice[0].Scheduler_StartTime;
                    $scope.model.Scheduler_EndTime = $scope.lstDevice[0].Scheduler_EndTime;
                    $scope.model.Mat_id = $scope.lstDevice[0].tblcustomerdevice.DeviceName;
                    $scope.model.Alarm_Time = $scope.lstDevice[0].Alarm_Time;
                    $scope.model.AlertType = $scope.lstDevice[0].AlertType;
                    $scope.model.Type = $scope.lstDevice[0].Type;
                    $scope.model.MobileNo = $scope.lstDevice[0].MobileNo;
                    $scope.model.Email = $scope.lstDevice[0].Email;
                    $scope.model.Event_Scheduler_StartTime = $scope.lstDevice[0].Event_Scheduler_StartTime;
                    $scope.model.Event_Scheduler_EndTime = $scope.lstDevice[0].Event_Scheduler_EndTime;
                    $scope.model.Alert_Scheduler_StartTime = $scope.lstDevice[0].Alert_Scheduler_StartTime;
                    $scope.model.Alert_Scheduler_Endtime = $scope.lstDevice[0].Alert_Scheduler_Endtime;
                    $scope.model.DeviceType = $scope.DeviceType;
                }
            });
        }


        $scope.Reset = function() {
            $mdDialog.hide();
        }

        $scope.closeModel = function() {
            $mdDialog.hide();
        }

        $scope.init();
    }
})();
(function() {
    'use strict';

    angular
        .module('app.customerservice', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.customerservice', {
                url: '/customerservice',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/CustomerService/CustomerService.html',
                        controller: 'CustomerServiceController as vm'
                    }
                },
                bodyClass: 'Customer Service',
                ModuleName: 'Customer Service'
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/user');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.user', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('customerdevices', {
        //     title: 'Customer Devices',
        //     state: 'app.customerdevices',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.customerservice')
        .controller('ActiveScoketSetting2Controller', ActiveScoketSetting2Controller);

    /** @ngInject */
    function ActiveScoketSetting2Controller($http, $mdDialog, $mdToast, $scope, $cookieStore, $rootScope, objSocket, CustomerServiceVm, Tasks, event) {
        var vm = this;

        $scope.init = function() {
            $scope.model = {
                id: objSocket.id,
                CustomerMasterId: objSocket.CustomerMasterId,
                DeviceType: objSocket.DeviceType,
                DeviceName: objSocket.DeviceName,
                DeviceSerial: objSocket.DeviceSerial,
                TriggerType: objSocket.TriggerType,
                LightOff_Timer: objSocket.LightOff_Timer,
                Scheduler_StartTime: objSocket.Scheduler_StartTime,
                Scheduler_EndTime: objSocket.Scheduler_EndTime,
                Device_Mat_Id: objSocket.Device_Mat_Id,
                Setting_Sync_Flag: objSocket.Setting_Sync_Flag,
                Connection_Status: objSocket.Connection_Status,
                IsActive: objSocket.IsActive,
                SchedulType: 'Always On',
            }
            if (objSocket.Scheduler_StartTime == '00:00:00' && objSocket.Scheduler_EndTime == '23:59:59') {
                $scope.model.Scheduler_StartTime = '';
                $scope.model.Scheduler_EndTime = '';
                $scope.model.SchedulType = 'Always On';
            } else {
                $scope.model.Scheduler_StartTime = ConvertToTime(objSocket.Scheduler_StartTime);
                $scope.model.Scheduler_EndTime = ConvertToTime(objSocket.Scheduler_EndTime);
                $scope.model.SchedulType = 'Scheduling';
            }
            $scope.tab = { selectedIndex: 0 };
            $scope.TimingList = [{ value: 30000, time: '30 Seconds' }, { value: 60000, time: '1 Minute' }, { value: 120000, time: '2 Minute' }, { value: 180000, time: '3 Minute' }, { value: 240000, time: '4 Minute' }, { value: 300000, time: '5 Minute' }, { value: 360000, time: '6 Minute' }, { value: 420000, time: '7 Minute' }, { value: 480000, time: '8 Minute' }, { value: 540000, time: '9 Minute' }, { value: 600000, time: '10 Minute' }, { value: 660000, time: '11 Minute' }, { value: 720000, time: '12 Minute' }, { value: 780000, time: '13 Minute' }, { value: 840000, time: '14 Minute' }, { value: 900000, time: '15 Minute' }, { value: 960000, time: '16 Minute' }, { value: 1020000, time: '17 Minute' }, { value: 1080000, time: '18 Minute' }, { value: 1140000, time: '19 Minute' }, { value: 1200000, time: '20 Minute' }, { value: 1500000, time: '25 Minute' }, { value: 1800000, time: '30 Minute' }, { value: 2100000, time: '35 Minute' }, { value: 2400000, time: '40 Minute' }, { value: 2700000, time: '45 Minute' }, { value: 3000000, time: '50 Minute' }, { value: 3300000, time: '55 Minute' }, { value: 3600000, time: '1 Hour' }];

            $('.mobiscrollTime').scroller({ preset: 'time' });
            $('.mobiscrollDate').scroller();
            $('.mobiscrollDateTime').scroller({ preset: 'datetime' });
        }

        $scope.CreateCustomerDevice = function(o, lst) {
            if (o.SchedulType == "Always On") {
                o.Scheduler_StartTime = "00:00:00";
                o.Scheduler_EndTime = "23:59:59";
            }
            $http.post($rootScope.RoutePath + "customerdevices/SaveCustomerDevice", o).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );

                    $rootScope.FlgAddedEditlocal = false;
                    if ($rootScope.FlgAddedAccess == true) {
                        $rootScope.FlgAddedEditlocal = true
                    }
                    CustomerServiceVm.GetAllDeviceByCustomerId(o.CustomerMasterId);
                    $scope.Reset();
                } else {
                    if (data.data.data == 'TOKEN') {

                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                        CustomerServiceVm.GetAllDeviceByCustomerId(o.CustomerMasterId);
                        $scope.Reset();
                    }
                }
            });
        }

        function ConvertToTime(Time) {

            if (Time != null) {
                var splitedData = Time.split(':')
                if (parseInt(splitedData[0]) < 12) {
                    if (splitedData[0] == 0) {
                        return 12 + ":" + splitedData[1] + " AM";
                    } else {
                        return splitedData[0] + ":" + splitedData[1] + " AM";
                    }
                } else {
                    if (parseInt(splitedData[0]) - 12 == 0) {
                        return 12 + ":" + splitedData[1] + " PM";
                    } else {
                        return parseInt(splitedData[0]) - 12 + ":" + splitedData[1] + " PM";
                    }
                }
            } else {
                return null;
            }
        }

        $scope.Reset = function() {
            $mdDialog.hide();
        }

        $scope.closeModel = function() {
            $mdDialog.hide();
        }

        $scope.init();
    }
})();
(function() {
    'use strict';

    angular
        .module('app.customerservice')
        .controller('ActiveMatSetting2Controller', ActiveMatSetting2Controller);

    /** @ngInject */
    function ActiveMatSetting2Controller($http, $mdDialog, $mdToast, $scope, $cookieStore, $rootScope, objMat, CustomerServiceVm, Tasks, event, DTOptionsBuilder, DTColumnDefBuilder) {
        var vm = this;

        $scope.init = function() {
            $scope.model = {
                id: objMat.id,
                CustomerMasterId: objMat.CustomerMasterId,
                DeviceType: objMat.DeviceType,
                DeviceName: objMat.DeviceName,
                DeviceSerial: objMat.DeviceSerial,
                MD_Timer: objMat.MD_Timer,
                Alert_Msg_Timer: objMat.Alert_Msg_Timer,
                Standby_Timer: objMat.Standby_Timer,
                LED_Timer: objMat.LED_Timer,
                Text_for_1St_Step: objMat.Text_for_1St_Step,
                Text_for_2nd_Step: objMat.Text_for_2nd_Step,
                Text_for_Alert_Event: objMat.Text_for_Alert_Event,
                Setting_Sync_Flag: objMat.Setting_Sync_Flag,
                Connection_Status: objMat.Connection_Status,
                IsActive: objMat.IsActive,
                SchedulType: 'Always On',
            }

            $scope.SMSmodel = {
                id: '',
                MobileNo: '',
                Scheduler_StartTime: '',
                Scheduler_EndTime: '',
                Device_Mat_Id: objMat.id,
                First_Step: 1,
                Second_Step: 1,
                Alert: 1,
                Device_Faliure: 0,
                SchedulType_SMS: 'Always On',
                Text_for_1St_Step: 'Client Stepped on Mat.',
                Text_for_2nd_Step: 'Client Stepped Back on Mat.',
                Text_for_Alert_Event: 'Client didn’t returned.',
            };
            // $scope.lstSMS = objMat.tblsms_settings;
            $scope.GetAllSMSByMatId(objMat.id);
            $("#MobileNo").intlTelInput();
            $scope.tab = { selectedIndex: 0 };
            $scope.TimingList = [{ value: 30000, time: '30 Seconds' }, { value: 60000, time: '1 Minute' }, { value: 120000, time: '2 Minute' }, { value: 180000, time: '3 Minute' }, { value: 240000, time: '4 Minute' }, { value: 300000, time: '5 Minute' }, { value: 360000, time: '6 Minute' }, { value: 420000, time: '7 Minute' }, { value: 480000, time: '8 Minute' }, { value: 540000, time: '9 Minute' }, { value: 600000, time: '10 Minute' }, { value: 660000, time: '11 Minute' }, { value: 720000, time: '12 Minute' }, { value: 780000, time: '13 Minute' }, { value: 840000, time: '14 Minute' }, { value: 900000, time: '15 Minute' }, { value: 960000, time: '16 Minute' }, { value: 1020000, time: '17 Minute' }, { value: 1080000, time: '18 Minute' }, { value: 1140000, time: '19 Minute' }, { value: 1200000, time: '20 Minute' }, { value: 1500000, time: '25 Minute' }, { value: 1800000, time: '30 Minute' }, { value: 2100000, time: '35 Minute' }, { value: 2400000, time: '40 Minute' }, { value: 2700000, time: '45 Minute' }, { value: 3000000, time: '50 Minute' }, { value: 3300000, time: '55 Minute' }, { value: 3600000, time: '1 Hour' }];
            $scope.TimingListforMDtime = [{ value: 10000, time: '10 Seconds' }, { value: 15000, time: '15 Seconds' }, { value: 20000, time: '20 Seconds' }, { value: 25000, time: '25 Seconds' }, { value: 30000, time: '30 Seconds' }, { value: 60000, time: '1 Minute' }, { value: 120000, time: '2 Minute' }, { value: 180000, time: '3 Minute' }, { value: 240000, time: '4 Minute' }, { value: 300000, time: '5 Minute' }, { value: 360000, time: '6 Minute' }, { value: 420000, time: '7 Minute' }, { value: 480000, time: '8 Minute' }, { value: 540000, time: '9 Minute' }, { value: 600000, time: '10 Minute' }, { value: 900000, time: '15 Minute' }, { value: 1200000, time: '20 Minute' }, { value: 1500000, time: '25 Minute' }, { value: 1800000, time: '30 Minute' }];

            $('.mobiscrollTime').scroller({ preset: 'time' });
            $('.mobiscrollDate').scroller();
            $('.mobiscrollDateTime').scroller({ preset: 'datetime' });
        }

        $scope.dtOptions2 = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withDisplayLength(100)
            .withOption('responsive', false)
            .withOption('autoWidth', false)
            .withOption('searching', false)
            .withOption('paging', false)
            .withOption('info', false)
            .withOption('deferRender', true)
            .withOption('language', {
                'zeroRecords': "No Record Found",
                'emptyTable': "No Record Found"
            })

        $scope.dtColumnDefsDevice = [
            DTColumnDefBuilder.newColumnDef(0).notSortable(),
            DTColumnDefBuilder.newColumnDef(1).notSortable(),
            DTColumnDefBuilder.newColumnDef(2).notSortable(),
            DTColumnDefBuilder.newColumnDef(3).notSortable(),
            DTColumnDefBuilder.newColumnDef(4).notSortable(),
            DTColumnDefBuilder.newColumnDef(5).notSortable(),
            DTColumnDefBuilder.newColumnDef(6).notSortable(),
            DTColumnDefBuilder.newColumnDef(7).notSortable(),
            // DTColumnDefBuilder.newColumnDef(8).notSortable(),
        ];

        $scope.GetAllSMSByMatId = function(o) {
            var params = {
                id: o
            }
            $http.get($rootScope.RoutePath + "customerdevices/GetAllSMSByMatId", { params: params }).then(function(data) {
                $scope.lstSMS = data.data.data;

            });
        }

        $scope.CreateCustomerDevice = function(o, lst) {
            o.SMSList = [];

            $http.post($rootScope.RoutePath + "customerdevices/SaveCustomerDevice", o).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );

                    $rootScope.FlgAddedEditlocal = false;
                    if ($rootScope.FlgAddedAccess == true) {
                        $rootScope.FlgAddedEditlocal = true
                    }
                    CustomerServiceVm.GetAllDeviceByCustomerId(o.CustomerMasterId);
                    $scope.Reset();
                } else {
                    if (data.data.data == 'TOKEN') {

                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                        CustomerServiceVm.GetAllDeviceByCustomerId(o.CustomerMasterId);
                        $scope.Reset();
                    }
                }
            });
        }

        $scope.CreateSMSSetting = function(o) {
            if (o.SchedulType_SMS == "Always On") {
                o.Scheduler_StartTime = "00:00:00";
                o.Scheduler_EndTime = "23:59:59";
            }
            $http.post($rootScope.RoutePath + "customerdevices/AddSMSForMat", o).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );

                    $rootScope.FlgAddedEditlocal = false;
                    if ($rootScope.FlgAddedAccess == true) {
                        $rootScope.FlgAddedEditlocal = true
                    }
                    $scope.GetAllSMSByMatId(objMat.id);
                    $scope.Reset1();
                } else {
                    if (data.data.data == 'TOKEN') {

                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                    }
                }
            });
        }

        $scope.UpdateSMSSetting = function(o) {
            $http.post($rootScope.RoutePath + "customerdevices/ChangeSMSSetting", o).then(function(response) {
                if (response.data.data == 'TOKEN') {
                    $rootScope.logout();
                }
            });

        }

        $scope.addMore2 = function(o) {
            if (o.SchedulType_SMS == "Always On") {
                o.Scheduler_StartTime = "00:00:00";
                o.Scheduler_EndTime = "23:59:59";
            }
            $scope.lstSMS.push(o);
            $scope.SMSmodel = {
                id: '',
                MobileNo: '',
                Scheduler_StartTime: '',
                Scheduler_EndTime: '',
                Device_Mat_Id: '',
                First_Step: 1,
                Second_Step: 1,
                Alert: 1,
                Device_Faliure: 0,
                SchedulType_SMS: 'Always On',
            }
        };

        $scope.remove2 = function($index, o, ev) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure to delete this SMS Configuration?')
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent(ev)
                .ok('Yes')
                .cancel('No');
            $mdDialog.show(confirm).then(function() {
                if (o.id != "" && o.id != 0) {
                    var params = {
                        id: o.id
                    }
                    $http.get($rootScope.RoutePath + "devicesetting_call_sms/DeleteSMSSetting", { params: params }).then(function(data) {
                        if (data.data.success) {
                            $mdToast.show(
                                $mdToast.simple()
                                .textContent(data.data.message)
                                .position('top right')
                                .hideDelay(3000)
                            );
                            $scope.lstSMS.splice($index, 1);
                            CustomerServiceVm.GetAllDeviceByCustomerId($scope.model.CustomerMasterId);
                        } else {
                            if (data.data.data == 'TOKEN') {
                                $rootScope.logout();
                            } else {
                                $mdToast.show(
                                    $mdToast.simple()
                                    .textContent(data.data.message)
                                    .position('top right')
                                    .hideDelay(3000)
                                );
                                CustomerServiceVm.GetAllDeviceByCustomerId($scope.model.CustomerMasterId);
                            }
                        }
                        $mdDialog.show({
                            controller: 'ActiveMatSetting2Controller',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/CustomerService/dialogs/MatSetting/MatSetting.html',
                            parent: angular.element(document.body),
                            targetEvent: '',
                            clickOutsideToClose: true,
                            locals: {
                                objMat: objMat,
                                Tasks: [],
                                event: '',
                                CustomerServiceVm: CustomerServiceVm,

                            }
                        })
                    });
                } else {
                    $scope.lstSMS.splice($index, 1);
                }
            }, function() {
                $mdDialog.show({
                    controller: 'ActiveMatSetting2Controller',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/CustomerService/dialogs/MatSetting/MatSetting.html',
                    parent: angular.element(document.body),
                    targetEvent: '',
                    clickOutsideToClose: true,
                    locals: {
                        objMat: objMat,
                        Tasks: [],
                        event: '',
                        CustomerServiceVm: CustomerServiceVm,

                    }
                })
            });

        };

        $scope.FetchSMSSettingById = function(o) {
            $scope.SMSmodel.id = o.id;
            $scope.SMSmodel.MobileNo = o.MobileNo;
            $("#MobileNo").intlTelInput("setNumber", $scope.SMSmodel.MobileNo);
            $scope.SMSmodel.Device_Mat_Id = o.Device_Mat_Id;
            $scope.SMSmodel.First_Step = o.First_Step;
            $scope.SMSmodel.Second_Step = o.Second_Step;
            $scope.SMSmodel.Alert = o.Alert;
            $scope.SMSmodel.Device_Faliure = o.Device_Faliure;
            if (o.Scheduler_StartTime == '00:00:00' && o.Scheduler_EndTime == '23:59:59') {
                $scope.SMSmodel.Scheduler_StartTime = '';
                $scope.SMSmodel.Scheduler_EndTime = '';
                $scope.SMSmodel.SchedulType_SMS = 'Always On';
            } else {
                $scope.SMSmodel.Scheduler_StartTime = ConvertToTime(o.Scheduler_StartTime);
                $scope.SMSmodel.Scheduler_EndTime = ConvertToTime(o.Scheduler_EndTime);
                $scope.SMSmodel.SchedulType_SMS = 'Scheduling';
            }
            $scope.SMSmodel.Text_for_1St_Step = o.Text_for_1St_Step;
            $scope.SMSmodel.Text_for_2nd_Step = o.Text_for_2nd_Step;
            $scope.SMSmodel.Text_for_Alert_Event = o.Text_for_Alert_Event;
        }

        function ConvertToTime(Time) {

            if (Time != null) {
                var splitedData = Time.split(':')
                if (parseInt(splitedData[0]) < 12) {
                    if (splitedData[0] == 0) {
                        return 12 + ":" + splitedData[1] + " AM";
                    } else {
                        return splitedData[0] + ":" + splitedData[1] + " AM";
                    }
                } else {
                    if (parseInt(splitedData[0]) - 12 == 0) {
                        return 12 + ":" + splitedData[1] + " PM";
                    } else {
                        return parseInt(splitedData[0]) - 12 + ":" + splitedData[1] + " PM";
                    }
                }
            } else {
                return null;
            }
        }

        $scope.Reset = function() {
            $mdDialog.hide();
        }

        $scope.Reset1 = function() {
            $scope.MatSettingForm.$setUntouched();
            $scope.MatSettingForm.$setPristine();
            $scope.SMSmodel = {
                id: '',
                MobileNo: '',
                Scheduler_StartTime: '',
                Scheduler_EndTime: '',
                Device_Mat_Id: objMat.id,
                First_Step: 1,
                Second_Step: 1,
                Alert: 1,
                Device_Faliure: 0,
                SchedulType_SMS: 'Always On',
                Text_for_1St_Step: 'Client Stepped on Mat.',
                Text_for_2nd_Step: 'Client Stepped Back on Mat.',
                Text_for_Alert_Event: 'Client didn’t returned.',
            }
        }

        $scope.closeModel = function() {
            $mdDialog.hide();
        }

        $scope.init();
    }
})();
(function() {
    'use strict';

    angular
        .module('app.customerservice')
        .controller('DebugController', DebugController);

    /** @ngInject */
    function DebugController($http, $mdDialog, $mdToast, $scope, $cookieStore, $rootScope, ObjData, CustomerServiceVm, Tasks, event) {
        var vm = this;
        $scope.init = function() {
            $scope.model = {
                DeviceType: ObjData.DeviceType,
            }
        }

        $scope.RebootDevice = function() {
            var params = {
                id: ObjData.id,
                CustomerMasterId: ObjData.CustomerMasterId,
                DeviceName: ObjData.DeviceName,
                DeviceSerial: ObjData.DeviceSerial,
                DeviceType: ObjData.DeviceType
            }

            $http.get($rootScope.RoutePath + "customerdevices/RebootDevice", { params: params }).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );

                    $rootScope.FlgAddedEditlocal = false;
                    if ($rootScope.FlgAddedAccess == true) {
                        $rootScope.FlgAddedEditlocal = true
                    }
                    CustomerServiceVm.GetAllDeviceByCustomerId(ObjData.CustomerMasterId);
                    $scope.Reset();
                } else {
                    if (data.data.data == 'TOKEN') {

                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                        CustomerServiceVm.GetAllDeviceByCustomerId(ObjData.CustomerMasterId);
                        $scope.Reset();
                    }
                }
            })
        }

        $scope.DeviceInConfigMode = function() {
            var params = {
                id: ObjData.id,
                CustomerMasterId: ObjData.CustomerMasterId,
                DeviceName: ObjData.DeviceName,
                DeviceSerial: ObjData.DeviceSerial,
                DeviceType: ObjData.DeviceType
            }

            $http.get($rootScope.RoutePath + "customerdevices/DeviceInConfigMode", { params: params }).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );

                    $rootScope.FlgAddedEditlocal = false;
                    if ($rootScope.FlgAddedAccess == true) {
                        $rootScope.FlgAddedEditlocal = true
                    }
                    CustomerServiceVm.GetAllDeviceByCustomerId(ObjData.CustomerMasterId);
                    $scope.Reset();
                } else {
                    if (data.data.data == 'TOKEN') {

                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                        CustomerServiceVm.GetAllDeviceByCustomerId(ObjData.CustomerMasterId);
                        $scope.Reset();
                    }
                }
            })
        }

        $scope.DeviceIdentify = function() {
            var params = {
                id: ObjData.id,
                CustomerMasterId: ObjData.CustomerMasterId,
                DeviceName: ObjData.DeviceName,
                DeviceSerial: ObjData.DeviceSerial,
                DeviceType: ObjData.DeviceType
            }

            $http.get($rootScope.RoutePath + "customerdevices/DeviceIdentify", { params: params }).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );

                    $rootScope.FlgAddedEditlocal = false;
                    if ($rootScope.FlgAddedAccess == true) {
                        $rootScope.FlgAddedEditlocal = true
                    }
                    CustomerServiceVm.GetAllDeviceByCustomerId(ObjData.CustomerMasterId);
                    $scope.Reset();
                } else {
                    if (data.data.data == 'TOKEN') {

                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                        CustomerServiceVm.GetAllDeviceByCustomerId(ObjData.CustomerMasterId);
                        $scope.Reset();
                    }
                }
            })
        }

        $scope.TurnOnAlarm = function() {
            var params = {
                id: ObjData.id,
                CustomerMasterId: ObjData.CustomerMasterId,
                DeviceName: ObjData.DeviceName,
                DeviceSerial: ObjData.DeviceSerial,
                DeviceType: ObjData.DeviceType
            }

            $http.get($rootScope.RoutePath + "customerdevices/TurnOnAlarm", { params: params }).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );

                    $rootScope.FlgAddedEditlocal = false;
                    if ($rootScope.FlgAddedAccess == true) {
                        $rootScope.FlgAddedEditlocal = true
                    }
                    CustomerServiceVm.GetAllDeviceByCustomerId(ObjData.CustomerMasterId);
                    $scope.Reset();
                } else {
                    if (data.data.data == 'TOKEN') {

                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                        CustomerServiceVm.GetAllDeviceByCustomerId(ObjData.CustomerMasterId);
                        $scope.Reset();
                    }
                }
            })
        }

        $scope.TurnOffAlarm = function() {
            var params = {
                id: ObjData.id,
                CustomerMasterId: ObjData.CustomerMasterId,
                DeviceName: ObjData.DeviceName,
                DeviceSerial: ObjData.DeviceSerial,
                DeviceType: ObjData.DeviceType
            }

            $http.get($rootScope.RoutePath + "customerdevices/TurnOffAlarm", { params: params }).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );

                    $rootScope.FlgAddedEditlocal = false;
                    if ($rootScope.FlgAddedAccess == true) {
                        $rootScope.FlgAddedEditlocal = true
                    }
                    CustomerServiceVm.GetAllDeviceByCustomerId(ObjData.CustomerMasterId);
                    $scope.Reset();
                } else {
                    if (data.data.data == 'TOKEN') {

                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                        CustomerServiceVm.GetAllDeviceByCustomerId(ObjData.CustomerMasterId);
                        $scope.Reset();
                    }
                }
            })
        }

        $scope.TurnOnLight = function() {
            var params = {
                id: ObjData.id,
                CustomerMasterId: ObjData.CustomerMasterId,
                DeviceName: ObjData.DeviceName,
                DeviceSerial: ObjData.DeviceSerial,
                DeviceType: ObjData.DeviceType
            }

            $http.get($rootScope.RoutePath + "customerdevices/TurnOnLight", { params: params }).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );

                    $rootScope.FlgAddedEditlocal = false;
                    if ($rootScope.FlgAddedAccess == true) {
                        $rootScope.FlgAddedEditlocal = true
                    }
                    CustomerServiceVm.GetAllDeviceByCustomerId(ObjData.CustomerMasterId);
                    $scope.Reset();
                } else {
                    if (data.data.data == 'TOKEN') {

                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                        CustomerServiceVm.GetAllDeviceByCustomerId(ObjData.CustomerMasterId);
                        $scope.Reset();
                    }
                }
            })
        }

        $scope.TurnOffLight = function() {
            var params = {
                id: ObjData.id,
                CustomerMasterId: ObjData.CustomerMasterId,
                DeviceName: ObjData.DeviceName,
                DeviceSerial: ObjData.DeviceSerial,
                DeviceType: ObjData.DeviceType
            }

            $http.get($rootScope.RoutePath + "customerdevices/TurnOffLight", { params: params }).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );

                    $rootScope.FlgAddedEditlocal = false;
                    if ($rootScope.FlgAddedAccess == true) {
                        $rootScope.FlgAddedEditlocal = true
                    }
                    CustomerServiceVm.GetAllDeviceByCustomerId(ObjData.CustomerMasterId);
                    $scope.Reset();
                } else {
                    if (data.data.data == 'TOKEN') {

                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                        CustomerServiceVm.GetAllDeviceByCustomerId(ObjData.CustomerMasterId);
                        $scope.Reset();
                    }
                }
            })
        }

        $scope.TurnOnMatLED = function() {
            var params = {
                id: ObjData.id,
                CustomerMasterId: ObjData.CustomerMasterId,
                DeviceName: ObjData.DeviceName,
                DeviceSerial: ObjData.DeviceSerial,
                DeviceType: ObjData.DeviceType
            }

            $http.get($rootScope.RoutePath + "customerdevices/TurnOnMatLED", { params: params }).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );

                    $rootScope.FlgAddedEditlocal = false;
                    if ($rootScope.FlgAddedAccess == true) {
                        $rootScope.FlgAddedEditlocal = true
                    }
                    CustomerServiceVm.GetAllDeviceByCustomerId(ObjData.CustomerMasterId);
                    $scope.Reset();
                } else {
                    if (data.data.data == 'TOKEN') {

                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                        CustomerServiceVm.GetAllDeviceByCustomerId(ObjData.CustomerMasterId);
                        $scope.Reset();
                    }
                }
            })
        }

        $scope.TurnOffMatLED = function() {
            var params = {
                id: ObjData.id,
                CustomerMasterId: ObjData.CustomerMasterId,
                DeviceName: ObjData.DeviceName,
                DeviceSerial: ObjData.DeviceSerial,
                DeviceType: ObjData.DeviceType
            }

            $http.get($rootScope.RoutePath + "customerdevices/TurnOffMatLED", { params: params }).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );

                    $rootScope.FlgAddedEditlocal = false;
                    if ($rootScope.FlgAddedAccess == true) {
                        $rootScope.FlgAddedEditlocal = true
                    }
                    CustomerServiceVm.GetAllDeviceByCustomerId(ObjData.CustomerMasterId);
                    $scope.Reset();
                } else {
                    if (data.data.data == 'TOKEN') {

                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                        CustomerServiceVm.GetAllDeviceByCustomerId(ObjData.CustomerMasterId);
                        $scope.Reset();
                    }
                }
            })
        }

        $scope.Reset = function() {
            $mdDialog.hide();
        }

        $scope.closeModel = function() {
            $mdDialog.hide();
        }

        $scope.init();
    }
})();
(function() {
    'use strict';

    angular
        .module('app.customerservice')
        .controller('ActiveAlarmSetting2Controller', ActiveAlarmSetting2Controller);

    /** @ngInject */
    function ActiveAlarmSetting2Controller($http, $mdDialog, $mdToast, $scope, $cookieStore, $rootScope, objAlarm, CustomerServiceVm, Tasks, event) {
        var vm = this;
        $scope.init = function() {
            $scope.model = {
                id: objAlarm.id,
                CustomerMasterId: objAlarm.CustomerMasterId,
                DeviceType: objAlarm.DeviceType,
                DeviceName: objAlarm.DeviceName,
                DeviceSerial: objAlarm.DeviceSerial,
                TriggerType: objAlarm.TriggerType,
                Alarm_Time: objAlarm.Alarm_Time,
                Scheduler_StartTime: objAlarm.Scheduler_StartTime,
                Scheduler_EndTime: objAlarm.Scheduler_EndTime,
                Device_Mat_Id: objAlarm.Device_Mat_Id,
                AlertType: objAlarm.AlertType,
                Setting_Sync_Flag: objAlarm.Setting_Sync_Flag,
                Connection_Status: objAlarm.Connection_Status,
                IsActive: objAlarm.IsActive,
                SchedulType: 'Always On',
                Volume: objAlarm.Volume,
            }

            if (objAlarm.Scheduler_StartTime == '00:00:00' && objAlarm.Scheduler_EndTime == '23:59:59') {
                $scope.model.Scheduler_StartTime = '';
                $scope.model.Scheduler_EndTime = '';
                $scope.model.SchedulType = 'Always On';
            } else {
                $scope.model.Scheduler_StartTime = ConvertToTime(objAlarm.Scheduler_StartTime);
                $scope.model.Scheduler_EndTime = ConvertToTime(objAlarm.Scheduler_EndTime);
                $scope.model.SchedulType = 'Scheduling';
            }
            $scope.tab = { selectedIndex: 0 };
            $scope.TimingList = [{ value: 30000, time: '30 Seconds' }, { value: 60000, time: '1 Minute' }, { value: 120000, time: '2 Minute' }, { value: 180000, time: '3 Minute' }, { value: 240000, time: '4 Minute' }, { value: 300000, time: '5 Minute' }, { value: 360000, time: '6 Minute' }, { value: 420000, time: '7 Minute' }, { value: 480000, time: '8 Minute' }, { value: 540000, time: '9 Minute' }, { value: 600000, time: '10 Minute' }, { value: 660000, time: '11 Minute' }, { value: 720000, time: '12 Minute' }, { value: 780000, time: '13 Minute' }, { value: 840000, time: '14 Minute' }, { value: 900000, time: '15 Minute' }, { value: 960000, time: '16 Minute' }, { value: 1020000, time: '17 Minute' }, { value: 1080000, time: '18 Minute' }, { value: 1140000, time: '19 Minute' }, { value: 1200000, time: '20 Minute' }, { value: 1500000, time: '25 Minute' }, { value: 1800000, time: '30 Minute' }, { value: 2100000, time: '35 Minute' }, { value: 2400000, time: '40 Minute' }, { value: 2700000, time: '45 Minute' }, { value: 3000000, time: '50 Minute' }, { value: 3300000, time: '55 Minute' }, { value: 3600000, time: '1 Hour' }];

            $('.mobiscrollTime').scroller({ preset: 'time' });
            $('.mobiscrollDate').scroller();
            $('.mobiscrollDateTime').scroller({ preset: 'datetime' });
        }

        $scope.CreateCustomerDevice = function(o, lst) {
            if (o.SchedulType == "Always On") {
                o.Scheduler_StartTime = "00:00:00";
                o.Scheduler_EndTime = "23:59:59";
            }
            $http.post($rootScope.RoutePath + "customerdevices/SaveCustomerDevice", o).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );

                    $rootScope.FlgAddedEditlocal = false;
                    if ($rootScope.FlgAddedAccess == true) {
                        $rootScope.FlgAddedEditlocal = true
                    }
                    CustomerServiceVm.GetAllDeviceByCustomerId(o.CustomerMasterId);
                    $scope.Reset();
                } else {
                    if (data.data.data == 'TOKEN') {

                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                        CustomerServiceVm.GetAllDeviceByCustomerId(o.CustomerMasterId);
                        $scope.Reset();
                    }
                }
            });
            // }

        }

        function ConvertToTime(Time) {

            if (Time != null) {
                var splitedData = Time.split(':')
                if (parseInt(splitedData[0]) < 12) {
                    if (splitedData[0] == 0) {
                        return 12 + ":" + splitedData[1] + " AM";
                    } else {
                        return splitedData[0] + ":" + splitedData[1] + " AM";
                    }
                } else {
                    if (parseInt(splitedData[0]) - 12 == 0) {
                        return 12 + ":" + splitedData[1] + " PM";
                    } else {
                        return parseInt(splitedData[0]) - 12 + ":" + splitedData[1] + " PM";
                    }
                }
            } else {
                return null;
            }
        }

        $scope.Reset = function() {
            $mdDialog.hide();
        }

        $scope.closeModel = function() {
            $mdDialog.hide();
        }

        $scope.init();
    }
})();
(function() {
    'use strict';

    angular
        .module('app.customerdevices', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.customerdevices', {
                url: '/customerdevices',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/CustomerDevices/CustomerDevices.html',
                        controller: 'CustomerDevicesController as vm'
                    }
                },
                bodyClass: 'Customer Devices',
                ModuleName: 'Customer Devices'
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/user');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.user', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('customerdevices', {
        //     title: 'Customer Devices',
        //     state: 'app.customerdevices',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.customerdevices')
        .controller('EventListDetailController', EventListDetailController);

    /** @ngInject */
    function EventListDetailController($http, $mdDialog, $mdToast, $scope, $cookieStore, $rootScope, objUser, Tasks, event) {
        var vm = this;

        $scope.init = function() {

            $scope.model = {
                id: '',
                DeviceSettingCallSMSId: '',
                Event: '',
                EventType: '',
                ActionType: '',
                Message: '',
            };
            $scope.id = objUser.id;
            $scope.GetEventList($scope.id);
        }

        $scope.GetEventList = function(o) {
            var params = {
                id: o
            }

            $http.get($rootScope.RoutePath + "devicesetting_call_sms/GetAllEventListByDeviceSetting", { params: params }).then(function(data) {
                $scope.lstDevice = data.data;
                if ($scope.lstDevice.length) {
                    $scope.model.id = $scope.lstDevice[0].id;
                    $scope.model.DeviceSettingCallSMSId = $scope.lstDevice[0].DeviceSettingCallSMSId;
                    $scope.model.Event = $scope.lstDevice[0].Event;
                    $scope.model.EventType = $scope.lstDevice[0].EventType;
                    $scope.model.ActionType = $scope.lstDevice[0].ActionType;
                    $scope.model.Message = $scope.lstDevice[0].Message;
                }
            });
        }

        $scope.Reset = function() {
            $mdDialog.hide();
        }

        $scope.closeModel = function() {
            $mdDialog.hide();
        }

        $scope.init();
    }
})();
(function() {
    'use strict';

    angular
        .module('app.customerdevices')
        .controller('DeviceTypeController', DeviceTypeController);

    /** @ngInject */
    function DeviceTypeController($http, $mdDialog, $mdToast, $scope, $cookieStore, $rootScope, objUser, Tasks, event) {
        var vm = this;

        $scope.init = function() {
            $scope.model = {
                CustomerDeviceId: '',
                MD_Timer: '',
                Alert_Msg_Timer: '',
                Standby_Timer: '',
                LED_Timer: '',
                Text_for_1St_Step: '',
                Text_for_2nd_Step: '',
                Text_for_Alert_Event: '',
                TriggerType: '',
                LightOff_Timer: '',
                Scheduler_StartTime: '',
                Scheduler_EndTime: '',
                Alarm_Time: '',
                AlertType: '',
                Type: '',
                MobileNo: '',
                Email: '',
                Event_Scheduler_StartTime: '',
                Event_Scheduler_EndTime: '',
                Alert_Scheduler_StartTime: '',
                Alert_Scheduler_Endtime: '',
                Mat_id: '',
                DeviceType: '',
            };
            $scope.id = objUser.id;
            $scope.DeviceType = objUser.DeviceType;
            $scope.GetUserDevices($scope.id, $scope.DeviceType);
            $scope.TimingList = [{ value: 30000, time: '30 Seconds' }, { value: 60000, time: '1 Minute' }, { value: 120000, time: '2 Minute' }, { value: 180000, time: '3 Minute' }, { value: 240000, time: '4 Minute' }, { value: 300000, time: '5 Minute' }, { value: 360000, time: '6 Minute' }, { value: 420000, time: '7 Minute' }, { value: 480000, time: '8 Minute' }, { value: 540000, time: '9 Minute' }, { value: 600000, time: '10 Minute' }, { value: 660000, time: '11 Minute' }, { value: 720000, time: '12 Minute' }, { value: 780000, time: '13 Minute' }, { value: 840000, time: '14 Minute' }, { value: 900000, time: '15 Minute' }, { value: 960000, time: '16 Minute' }, { value: 1020000, time: '17 Minute' }, { value: 1080000, time: '18 Minute' }, { value: 1140000, time: '19 Minute' }, { value: 1200000, time: '20 Minute' }, { value: 1500000, time: '25 Minute' }, { value: 1800000, time: '30 Minute' }, { value: 2100000, time: '35 Minute' }, { value: 2400000, time: '40 Minute' }, { value: 2700000, time: '45 Minute' }, { value: 3000000, time: '50 Minute' }, { value: 3300000, time: '55 Minute' }, { value: 3600000, time: '1 Hour' }];
            $scope.TimingListforMDtime = [{ value: 10000, time: '10 Seconds' }, { value: 15000, time: '15 Seconds' }, { value: 20000, time: '20 Seconds' }, { value: 25000, time: '25 Seconds' }, { value: 30000, time: '30 Seconds' }, { value: 60000, time: '1 Minute' }, { value: 120000, time: '2 Minute' }, { value: 180000, time: '3 Minute' }, { value: 240000, time: '4 Minute' }, { value: 300000, time: '5 Minute' }, { value: 360000, time: '6 Minute' }, { value: 420000, time: '7 Minute' }, { value: 480000, time: '8 Minute' }, { value: 540000, time: '9 Minute' }, { value: 600000, time: '10 Minute' }, { value: 900000, time: '15 Minute' }, { value: 1200000, time: '20 Minute' }, { value: 1500000, time: '25 Minute' }, { value: 1800000, time: '30 Minute' }];
        }

        $scope.GetUserDevices = function(id, devicetype) {
            var params = {
                id: id,
                DeviceType: devicetype,
            }
            $http.get($rootScope.RoutePath + "customerdevices/GetAllDeviceTypeDetailByDevice", { params: params }).then(function(data) {
                $scope.lstDevice = data.data;
                if ($scope.lstDevice.length > 0) {
                    $scope.model.DeviceType = $scope.DeviceType;
                    if ($scope.model.DeviceType == 'Mat') {
                        $scope.model.MD_Timer = _.where($scope.TimingListforMDtime, { value: $scope.lstDevice[0].MD_Timer });
                        $scope.model.Alert_Msg_Timer = _.where($scope.TimingList, { value: $scope.lstDevice[0].Alert_Msg_Timer });
                        $scope.model.Standby_Timer = _.where($scope.TimingList, { value: $scope.lstDevice[0].Standby_Timer });
                        $scope.model.LED_Timer = _.where($scope.TimingList, { value: $scope.lstDevice[0].LED_Timer });
                        $scope.model.Text_for_1St_Step = $scope.lstDevice[0].Text_for_1St_Step;
                        $scope.model.Text_for_2nd_Step = $scope.lstDevice[0].Text_for_2nd_Step;
                        $scope.model.Text_for_Alert_Event = $scope.lstDevice[0].Text_for_Alert_Event;
                    } else if ($scope.model.DeviceType == 'Socket') {
                        $scope.model.TriggerType = $scope.lstDevice[0].TriggerType;
                        $scope.model.LightOff_Timer = _.where($scope.TimingList, { value: $scope.lstDevice[0].LightOff_Timer });
                        $scope.model.Scheduler_StartTime = ConvertToTime($scope.lstDevice[0].Scheduler_StartTime);
                        $scope.model.Scheduler_EndTime = ConvertToTime($scope.lstDevice[0].Scheduler_EndTime);
                        $scope.model.Mat_id = $scope.lstDevice[0].tbldevice_mat.DeviceName;
                    } else {
                        $scope.model.TriggerType = $scope.lstDevice[0].TriggerType;
                        $scope.model.Scheduler_StartTime = ConvertToTime($scope.lstDevice[0].Scheduler_StartTime);
                        $scope.model.Scheduler_EndTime = ConvertToTime($scope.lstDevice[0].Scheduler_EndTime);
                        $scope.model.Mat_id = $scope.lstDevice[0].tbldevice_mat.DeviceName;
                        $scope.model.Alarm_Time = _.where($scope.TimingList, { value: $scope.lstDevice[0].Alarm_Time });
                        $scope.model.AlertType = $scope.lstDevice[0].AlertType;
                    }

                    // $scope.model.Type = $scope.lstDevice[0].Type;
                    // $scope.model.MobileNo = $scope.lstDevice[0].MobileNo;
                    // $scope.model.Email = $scope.lstDevice[0].Email;
                    // $scope.model.Event_Scheduler_StartTime = $scope.lstDevice[0].Event_Scheduler_StartTime;
                    // $scope.model.Event_Scheduler_EndTime = $scope.lstDevice[0].Event_Scheduler_EndTime;
                    // $scope.model.Alert_Scheduler_StartTime = $scope.lstDevice[0].Alert_Scheduler_StartTime;
                    // $scope.model.Alert_Scheduler_Endtime = $scope.lstDevice[0].Alert_Scheduler_Endtime;

                }
            });
        }

        function ConvertToTime(Time) {

            if (Time != null) {
                var splitedData = Time.split(':')
                if (parseInt(splitedData[0]) < 12) {
                    if (splitedData[0] == 0) {
                        return 12 + ":" + splitedData[1] + " AM";
                    } else {
                        return splitedData[0] + ":" + splitedData[1] + " AM";
                    }
                } else {
                    if (parseInt(splitedData[0]) - 12 == 0) {
                        return 12 + ":" + splitedData[1] + " PM";
                    } else {
                        return parseInt(splitedData[0]) - 12 + ":" + splitedData[1] + " PM";
                    }
                }
            } else {
                return null;
            }
        }

        $scope.Reset = function() {
            $mdDialog.hide();
        }

        $scope.closeModel = function() {
            $mdDialog.hide();
        }

        $scope.init();
    }
})();
(function() {
    'use strict';

    angular
        .module('app.customer', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.customer', {
                url: '/customer',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/Customer/Customer.html',
                        controller: 'CustomerController as vm'
                    }
                },
                bodyClass: 'Customer',
                ModuleName: 'Customer'
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/user');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.user', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('customer', {
        //     title: 'Customer',
        //     state: 'app.customer',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.customer')
        .controller('DeviceModelController', DeviceModelController);

    /** @ngInject */
    function DeviceModelController($http, $mdDialog, $mdToast, $scope, $cookieStore, $rootScope, objUser, Tasks, event) {
        var vm = this;

        $scope.init = function () {
            
            $scope.UserName = objUser.Name;
            $scope.GetUserDevices($scope.UserName);
        }
                
        $scope.GetUserDevices = function (o) {
            var params = {
                Name: o
            }
            $http.get($rootScope.RoutePath + "customerdevices/GetAllCustomerDeviceByUser", { params: params }).then(function (data) {
                $scope.lstDevice = data.data;
            });
        }

        $scope.Reset = function () {
            $mdDialog.hide();
        }

        $scope.closeModel = function () {
            $mdDialog.hide();
        }

        $scope.init();
    }
})();

(function() {
    'use strict';

    angular
        .module('app.linkeddevices')
        .controller('ActiveScoketSettingController', ActiveScoketSettingController);

    /** @ngInject */
    function ActiveScoketSettingController($http, $mdDialog, $mdToast, $scope, $cookieStore, $rootScope, objSocket, ActiveVm, Tasks, event) {
        var vm = this;

        $scope.init = function() {
            $scope.model = {
                id: objSocket.id,
                CustomerMasterId: objSocket.CustomerMasterId,
                DeviceType: objSocket.DeviceType,
                DeviceName: objSocket.DeviceName,
                DeviceSerial: objSocket.DeviceSerial,
                TriggerType: objSocket.TriggerType,
                LightOff_Timer: objSocket.LightOff_Timer,
                Scheduler_StartTime: objSocket.Scheduler_StartTime,
                Scheduler_EndTime: objSocket.Scheduler_EndTime,
                Device_Mat_Id: objSocket.Device_Mat_Id,
                Setting_Sync_Flag: objSocket.Setting_Sync_Flag,
                Connection_Status: objSocket.Connection_Status,
                IsActive: objSocket.IsActive,
                SchedulType: 'Always On',
            }
            if (objSocket.Scheduler_StartTime == '00:00:00' && objSocket.Scheduler_EndTime == '23:59:59') {
                $scope.model.Scheduler_StartTime = '';
                $scope.model.Scheduler_EndTime = '';
                $scope.model.SchedulType = 'Always On';
            } else {
                $scope.model.Scheduler_StartTime = ConvertToTime(objSocket.Scheduler_StartTime);
                $scope.model.Scheduler_EndTime = ConvertToTime(objSocket.Scheduler_EndTime);
                $scope.model.SchedulType = 'Scheduling';
            }
            $scope.tab = { selectedIndex: 0 };
            $scope.TimingList = [{ value: 30000, time: '30 Seconds' }, { value: 60000, time: '1 Minute' }, { value: 120000, time: '2 Minute' }, { value: 180000, time: '3 Minute' }, { value: 240000, time: '4 Minute' }, { value: 300000, time: '5 Minute' }, { value: 360000, time: '6 Minute' }, { value: 420000, time: '7 Minute' }, { value: 480000, time: '8 Minute' }, { value: 540000, time: '9 Minute' }, { value: 600000, time: '10 Minute' }, { value: 660000, time: '11 Minute' }, { value: 720000, time: '12 Minute' }, { value: 780000, time: '13 Minute' }, { value: 840000, time: '14 Minute' }, { value: 900000, time: '15 Minute' }, { value: 960000, time: '16 Minute' }, { value: 1020000, time: '17 Minute' }, { value: 1080000, time: '18 Minute' }, { value: 1140000, time: '19 Minute' }, { value: 1200000, time: '20 Minute' }, { value: 1500000, time: '25 Minute' }, { value: 1800000, time: '30 Minute' }, { value: 2100000, time: '35 Minute' }, { value: 2400000, time: '40 Minute' }, { value: 2700000, time: '45 Minute' }, { value: 3000000, time: '50 Minute' }, { value: 3300000, time: '55 Minute' }, { value: 3600000, time: '1 Hour' }];

            $('.mobiscrollTime').scroller({ preset: 'time' });
            $('.mobiscrollDate').scroller();
            $('.mobiscrollDateTime').scroller({ preset: 'datetime' });
        }

        $scope.CreateCustomerDevice = function(o, lst) {
            if (o.SchedulType == "Always On") {
                o.Scheduler_StartTime = "00:00:00";
                o.Scheduler_EndTime = "23:59:59";
            }
            $http.post($rootScope.RoutePath + "customerdevices/SaveCustomerDevice", o).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );

                    $rootScope.FlgAddedEditlocal = false;
                    if ($rootScope.FlgAddedAccess == true) {
                        $rootScope.FlgAddedEditlocal = true
                    }
                    ActiveVm.GetMatList();
                    $scope.Reset();
                } else {
                    if (data.data.data == 'TOKEN') {

                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                        ActiveVm.GetMatList();
                        $scope.Reset();
                    }
                }
            });
        }

        $scope.show2 = function() {
            $mdDialog.show({
                skipHide: true,
                controller: 'ActiveAlarmSettingController',
                controllerAs: 'vm',
                templateUrl: 'app/main/ActiveDevices/dialogs/AlarmSetting/AlarmSetting.html',
                parent: angular.element(document.body),
                targetEvent: '',
                clickOutsideToClose: true,
                fullscreen: $scope.customFullscreen, // Only for -xs, -sm breakpoints.
                locals: {
                    objAlarm: objSocket,
                    Tasks: [],
                    event: '',
                    ActiveVm: vm,

                }
            });
        }

        $scope.OpenDetail = function(Type, flg) {
            var obj = {
                Type: Type,
                Flag: flg
            }
            $mdDialog.show({
                skipHide: true,
                controller: 'InformationDetailController',
                controllerAs: 'vm',
                templateUrl: 'app/main/ActiveDevices/dialogs/InformationDetail/InformationDetail.html',
                parent: angular.element(document.body),
                targetEvent: '',
                clickOutsideToClose: false,
                locals: {
                    objInformation: obj,
                    Tasks: [],
                    event: '',
                    ActiveVm: vm,
                }
            })
        }

        function ConvertToTime(Time) {

            if (Time != null) {
                var splitedData = Time.split(':')
                if (parseInt(splitedData[0]) < 12) {
                    if (splitedData[0] == 0) {
                        return 12 + ":" + splitedData[1] + " AM";
                    } else {
                        return splitedData[0] + ":" + splitedData[1] + " AM";
                    }
                } else {
                    if (parseInt(splitedData[0]) - 12 == 0) {
                        return 12 + ":" + splitedData[1] + " PM";
                    } else {
                        return parseInt(splitedData[0]) - 12 + ":" + splitedData[1] + " PM";
                    }
                }
            } else {
                return null;
            }
        }

        $scope.Reset = function() {
            $mdDialog.hide();
        }

        $scope.closeModel = function() {
            $mdDialog.hide();
        }

        $scope.init();
    }
})();
(function() {
    'use strict';

    angular
        .module('app.linkeddevices')
        .controller('ActiveMatSettingController', ActiveMatSettingController);

    /** @ngInject */
    function ActiveMatSettingController($http, $mdDialog, $mdToast, $scope, $cookieStore, $rootScope, objMat, ActiveVm, Tasks, event, DTOptionsBuilder, DTColumnDefBuilder) {
        var vm = this;

        $scope.init = function() {
            $scope.model = {
                id: objMat.id,
                CustomerMasterId: objMat.CustomerMasterId,
                DeviceType: objMat.DeviceType,
                DeviceName: objMat.DeviceName,
                DeviceSerial: objMat.DeviceSerial,
                MD_Timer: objMat.MD_Timer,
                Alert_Msg_Timer: objMat.Alert_Msg_Timer,
                Standby_Timer: objMat.Standby_Timer,
                LED_Timer: objMat.LED_Timer,
                Text_for_1St_Step: objMat.Text_for_1St_Step,
                Text_for_2nd_Step: objMat.Text_for_2nd_Step,
                Text_for_Alert_Event: objMat.Text_for_Alert_Event,
                Setting_Sync_Flag: objMat.Setting_Sync_Flag,
                Connection_Status: objMat.Connection_Status,
                IsActive: objMat.IsActive,
                SchedulType: 'Always On',
            }

            $scope.SMSmodel = {
                id: '',
                MobileNo: '',
                Scheduler_StartTime: '',
                Scheduler_EndTime: '',
                Device_Mat_Id: objMat.id,
                First_Step: 1,
                Second_Step: 1,
                Alert: 1,
                Device_Faliure: 0,
                SchedulType_SMS: 'Always On',
                Text_for_1St_Step: 'Client Stepped on Mat.',
                Text_for_2nd_Step: 'Client Stepped Back on Mat.',
                Text_for_Alert_Event: 'Client didn’t returned.',
            };
            // $scope.lstSMS = objMat.tblsms_settings;
            $scope.GetAllSMSByMatId(objMat.id);
            $("#MobileNo").intlTelInput();
            $scope.tab = { selectedIndex: 0 };
            $scope.TimingList = [{ value: 30000, time: '30 Seconds' }, { value: 60000, time: '1 Minute' }, { value: 120000, time: '2 Minute' }, { value: 180000, time: '3 Minute' }, { value: 240000, time: '4 Minute' }, { value: 300000, time: '5 Minute' }, { value: 360000, time: '6 Minute' }, { value: 420000, time: '7 Minute' }, { value: 480000, time: '8 Minute' }, { value: 540000, time: '9 Minute' }, { value: 600000, time: '10 Minute' }, { value: 660000, time: '11 Minute' }, { value: 720000, time: '12 Minute' }, { value: 780000, time: '13 Minute' }, { value: 840000, time: '14 Minute' }, { value: 900000, time: '15 Minute' }, { value: 960000, time: '16 Minute' }, { value: 1020000, time: '17 Minute' }, { value: 1080000, time: '18 Minute' }, { value: 1140000, time: '19 Minute' }, { value: 1200000, time: '20 Minute' }, { value: 1500000, time: '25 Minute' }, { value: 1800000, time: '30 Minute' }, { value: 2100000, time: '35 Minute' }, { value: 2400000, time: '40 Minute' }, { value: 2700000, time: '45 Minute' }, { value: 3000000, time: '50 Minute' }, { value: 3300000, time: '55 Minute' }, { value: 3600000, time: '1 Hour' }];
            $scope.TimingListforMDtime = [{ value: 10000, time: '10 Seconds' }, { value: 15000, time: '15 Seconds' }, { value: 20000, time: '20 Seconds' }, { value: 25000, time: '25 Seconds' }, { value: 30000, time: '30 Seconds' }, { value: 60000, time: '1 Minute' }, { value: 120000, time: '2 Minute' }, { value: 180000, time: '3 Minute' }, { value: 240000, time: '4 Minute' }, { value: 300000, time: '5 Minute' }, { value: 360000, time: '6 Minute' }, { value: 420000, time: '7 Minute' }, { value: 480000, time: '8 Minute' }, { value: 540000, time: '9 Minute' }, { value: 600000, time: '10 Minute' }, { value: 900000, time: '15 Minute' }, { value: 1200000, time: '20 Minute' }, { value: 1500000, time: '25 Minute' }, { value: 1800000, time: '30 Minute' }];

            $('.mobiscrollTime').scroller({ preset: 'time' });
            $('.mobiscrollDate').scroller();
            $('.mobiscrollDateTime').scroller({ preset: 'datetime' });
        }

        $scope.dtOptions2 = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withDisplayLength(100)
            .withOption('responsive', false)
            .withOption('autoWidth', false)
            .withOption('searching', false)
            .withOption('paging', false)
            .withOption('info', false)
            .withOption('deferRender', true)
            .withOption('language', {
                'zeroRecords': "No Record Found",
                'emptyTable': "No Record Found"
            })

        $scope.dtColumnDefsDevice = [
            DTColumnDefBuilder.newColumnDef(0).notSortable(),
            DTColumnDefBuilder.newColumnDef(1).notSortable(),
            DTColumnDefBuilder.newColumnDef(2).notSortable(),
            DTColumnDefBuilder.newColumnDef(3).notSortable(),
            DTColumnDefBuilder.newColumnDef(4).notSortable(),
            DTColumnDefBuilder.newColumnDef(5).notSortable(),
            DTColumnDefBuilder.newColumnDef(6).notSortable(),
            DTColumnDefBuilder.newColumnDef(7).notSortable(),
            // DTColumnDefBuilder.newColumnDef(8).notSortable(),
        ];

        $scope.GetAllSMSByMatId = function(o) {
            var params = {
                id: o
            }
            $http.get($rootScope.RoutePath + "customerdevices/GetAllSMSByMatId", { params: params }).then(function(data) {
                $scope.lstSMS = data.data.data;

            });
        }

        $scope.CreateCustomerDevice = function(o, lst) {
            // if (lst.MobileNo != '') {
            //     if (lst.SchedulType_SMS == "Always On") {
            //         lst.Scheduler_StartTime = "00:00:00";
            //         lst.Scheduler_EndTime = "23:59:59";
            //     }
            //     $scope.lstSMS.push(lst);
            //     $scope.SMSmodel = {
            //         id: '',
            //         MobileNo: '',
            //         Scheduler_StartTime: '',
            //         Scheduler_EndTime: '',
            //         Device_Mat_Id: '',
            //         First_Step: 0,
            //         Second_Step: 0,
            //         Alert: 0,
            //         Device_Faliure: 0,
            //         SchedulType_SMS: 'Always On',
            //     }
            // }
            o.SMSList = [];

            $http.post($rootScope.RoutePath + "customerdevices/SaveCustomerDevice", o).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );

                    $rootScope.FlgAddedEditlocal = false;
                    if ($rootScope.FlgAddedAccess == true) {
                        $rootScope.FlgAddedEditlocal = true
                    }
                    ActiveVm.GetMatList();
                    $scope.Reset();
                } else {
                    if (data.data.data == 'TOKEN') {

                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                        ActiveVm.GetMatList();
                        $scope.Reset();
                    }
                }
            });
            // }

        }

        $scope.CreateSMSSetting = function(o) {
            // if (lst.MobileNo != '') {
            if (o.SchedulType_SMS == "Always On") {
                o.Scheduler_StartTime = "00:00:00";
                o.Scheduler_EndTime = "23:59:59";
            }
            //     $scope.lstSMS.push(lst);
            //     $scope.SMSmodel = {
            //         id: '',
            //         MobileNo: '',
            //         Scheduler_StartTime: '',
            //         Scheduler_EndTime: '',
            //         Device_Mat_Id: '',
            //         First_Step: 0,
            //         Second_Step: 0,
            //         Alert: 0,
            //         Device_Faliure: 0,
            //         SchedulType_SMS: 'Always On',
            //     }
            // }
            // o.SMSList = $scope.lstSMS;

            $http.post($rootScope.RoutePath + "customerdevices/AddSMSForMat", o).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );

                    $rootScope.FlgAddedEditlocal = false;
                    if ($rootScope.FlgAddedAccess == true) {
                        $rootScope.FlgAddedEditlocal = true
                    }
                    $scope.GetAllSMSByMatId(objMat.id);
                    $scope.Reset1();
                } else {
                    if (data.data.data == 'TOKEN') {

                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                    }
                }
            });
        }

        $scope.UpdateSMSSetting = function(o) {
            $http.post($rootScope.RoutePath + "customerdevices/ChangeSMSSetting", o).then(function(response) {
                if (response.data.data == 'TOKEN') {
                    //$cookieStore.remove('UserName');
                    //$cookieStore.remove('token');
                    //window.location.href = '/app/login';
                    $rootScope.logout();
                }
            });

        }

        $scope.addMore2 = function(o) {
            if (o.SchedulType_SMS == "Always On") {
                o.Scheduler_StartTime = "00:00:00";
                o.Scheduler_EndTime = "23:59:59";
            }
            // var newItemNo = $scope.Mobiles2.length + 1;
            // $scope.Mobiles2.push({ 'id': 'Mobile' + newItemNo });
            $scope.lstSMS.push(o);
            $scope.SMSmodel = {
                id: '',
                MobileNo: '',
                Scheduler_StartTime: '',
                Scheduler_EndTime: '',
                Device_Mat_Id: '',
                First_Step: 1,
                Second_Step: 1,
                Alert: 1,
                Device_Faliure: 0,
                SchedulType_SMS: 'Always On',
            }
        };

        $scope.remove2 = function($index, o, ev) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure to delete this SMS Configuration?')
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent(ev)
                .ok('Yes')
                .cancel('No');
            $mdDialog.show(confirm).then(function() {
                if (o.id != "" && o.id != 0) {
                    var params = {
                        id: o.id
                    }
                    $http.get($rootScope.RoutePath + "devicesetting_call_sms/DeleteSMSSetting", { params: params }).then(function(data) {
                        if (data.data.success) {
                            $mdToast.show(
                                $mdToast.simple()
                                .textContent(data.data.message)
                                .position('top right')
                                .hideDelay(3000)
                            );
                            $scope.lstSMS.splice($index, 1);
                            ActiveVm.GetMatList();
                        } else {
                            if (data.data.data == 'TOKEN') {
                                $rootScope.logout();
                            } else {
                                $mdToast.show(
                                    $mdToast.simple()
                                    .textContent(data.data.message)
                                    .position('top right')
                                    .hideDelay(3000)
                                );
                                ActiveVm.GetMatList();
                            }
                        }
                        $mdDialog.show({
                            controller: 'ActiveMatSettingController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/ActiveDevices/dialogs/MatSetting/MatSetting.html',
                            parent: angular.element(document.body),
                            targetEvent: '',
                            clickOutsideToClose: true,
                            locals: {
                                objMat: objMat,
                                Tasks: [],
                                event: '',
                                ActiveVm: ActiveVm,

                            }
                        })
                    });
                } else {
                    $scope.lstSMS.splice($index, 1);
                }
            }, function() {
                $mdDialog.show({
                    controller: 'ActiveMatSettingController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/ActiveDevices/dialogs/MatSetting/MatSetting.html',
                    parent: angular.element(document.body),
                    targetEvent: '',
                    clickOutsideToClose: true,
                    locals: {
                        objMat: objMat,
                        Tasks: [],
                        event: '',
                        ActiveVm: ActiveVm,

                    }
                })
            });

        };

        $scope.FetchSMSSettingById = function(o) {
            $scope.SMSmodel.id = o.id;
            $scope.SMSmodel.MobileNo = o.MobileNo;
            $("#MobileNo").intlTelInput("setNumber", $scope.SMSmodel.MobileNo);
            $scope.SMSmodel.Device_Mat_Id = o.Device_Mat_Id;
            $scope.SMSmodel.First_Step = o.First_Step;
            $scope.SMSmodel.Second_Step = o.Second_Step;
            $scope.SMSmodel.Alert = o.Alert;
            $scope.SMSmodel.Device_Faliure = o.Device_Faliure;
            if (o.Scheduler_StartTime == '00:00:00' && o.Scheduler_EndTime == '23:59:59') {
                $scope.SMSmodel.Scheduler_StartTime = '';
                $scope.SMSmodel.Scheduler_EndTime = '';
                $scope.SMSmodel.SchedulType_SMS = 'Always On';
            } else {
                $scope.SMSmodel.Scheduler_StartTime = ConvertToTime(o.Scheduler_StartTime);
                $scope.SMSmodel.Scheduler_EndTime = ConvertToTime(o.Scheduler_EndTime);
                $scope.SMSmodel.SchedulType_SMS = 'Scheduling';
            }
            $scope.SMSmodel.Text_for_1St_Step = o.Text_for_1St_Step;
            $scope.SMSmodel.Text_for_2nd_Step = o.Text_for_2nd_Step;
            $scope.SMSmodel.Text_for_Alert_Event = o.Text_for_Alert_Event;
        }

        $scope.OpenDetail = function(Type, flg) {
            var obj = {
                Type: Type,
                Flag: flg
            }
            $mdDialog.show({
                skipHide: true,
                controller: 'InformationDetailController',
                controllerAs: 'vm',
                templateUrl: 'app/main/ActiveDevices/dialogs/InformationDetail/InformationDetail.html',
                parent: angular.element(document.body),
                targetEvent: '',
                clickOutsideToClose: false,
                locals: {
                    objInformation: obj,
                    Tasks: [],
                    event: '',
                    ActiveVm: vm,
                }
            })
        }

        function ConvertToTime(Time) {

            if (Time != null) {
                var splitedData = Time.split(':')
                if (parseInt(splitedData[0]) < 12) {
                    if (splitedData[0] == 0) {
                        return 12 + ":" + splitedData[1] + " AM";
                    } else {
                        return splitedData[0] + ":" + splitedData[1] + " AM";
                    }
                } else {
                    if (parseInt(splitedData[0]) - 12 == 0) {
                        return 12 + ":" + splitedData[1] + " PM";
                    } else {
                        return parseInt(splitedData[0]) - 12 + ":" + splitedData[1] + " PM";
                    }
                }
            } else {
                return null;
            }
        }

        $scope.Reset = function() {
            $mdDialog.hide();
        }

        $scope.Reset1 = function() {
            $scope.MatSettingForm.$setUntouched();
            $scope.MatSettingForm.$setPristine();
            $scope.SMSmodel = {
                id: '',
                MobileNo: '',
                Scheduler_StartTime: '',
                Scheduler_EndTime: '',
                Device_Mat_Id: objMat.id,
                First_Step: 1,
                Second_Step: 1,
                Alert: 1,
                Device_Faliure: 0,
                SchedulType_SMS: 'Always On',
                Text_for_1St_Step: 'Client Stepped on Mat.',
                Text_for_2nd_Step: 'Client Stepped Back on Mat.',
                Text_for_Alert_Event: 'Client didn’t returned.',
            }
        }

        $scope.closeModel = function() {
            $mdDialog.hide();
        }

        $scope.init();
    }
})();
(function() {
    'use strict';

    angular
        .module('app.linkeddevices')
        .controller('LinkDeviceController', LinkDeviceController);

    /** @ngInject */
    function LinkDeviceController($http, $mdDialog, $mdToast, $scope, $cookieStore, $rootScope, objMatId, ActiveVm, Tasks, event) {
        var vm = this;

        $scope.init = function() {
            $scope.InActiveDeviceList = [];
            $scope.Selected = [];
            $scope.GetAllInavtiveAlarmDevice();
        }

        $scope.GetAllInavtiveAlarmDevice = function() {
            var params = {
                CustomerMasterId: $rootScope.UserId
            }
            $http.get($rootScope.RoutePath + "customerdevices/GetAllInavtiveAlarmDevice", { params: params }).then(function(data) {
                $scope.AlarmList = _.filter(data.data.data, function(p) {
                    p.DeviceType = "Alarm";
                    return p;
                });
                $scope.InActiveDeviceList = $scope.AlarmList;
                $scope.GetAllInavtiveSocketDevice();
            });
        }

        $scope.GetAllInavtiveSocketDevice = function() {
            var params = {
                CustomerMasterId: $rootScope.UserId
            }
            $http.get($rootScope.RoutePath + "customerdevices/GetAllInavtiveSocketDevice", { params: params }).then(function(data) {
                $scope.SocketList = _.filter(data.data.data, function(q) {
                    q.DeviceType = "Socket";
                    return q;
                });
                if ($scope.SocketList.length > 0) {
                    for (var i = 0; i < $scope.SocketList.length; i++) {
                        $scope.InActiveDeviceList.push($scope.SocketList[i]);
                    }
                }
            });
        }

        $scope.toggle1 = function(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        };

        $scope.exists1 = function(item, list) {
            return list.indexOf(item) > -1;
        };

        $scope.LinkDevices = function(o) {
            var obj = {
                MatId: objMatId,
                LinkDeviceList: o
            }

            $http.post($rootScope.RoutePath + "customerdevices/LinkDeviceswithMat", obj).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );

                    $rootScope.FlgAddedEditlocal = false;
                    if ($rootScope.FlgAddedAccess == true) {
                        $rootScope.FlgAddedEditlocal = true
                    }
                    ActiveVm.GetMatList();
                    $scope.Reset();
                } else {
                    if (data.data.data == 'TOKEN') {

                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                        ActiveVm.GetMatList();
                        $scope.Reset();
                    }
                }
            });
        }

        $scope.Reset = function() {
            $mdDialog.hide();
        }

        $scope.closeModel = function() {
            $mdDialog.hide();
        }

        $scope.init();
    }
})();
(function() {
    'use strict';

    angular
        .module('app.linkeddevices')
        .controller('InformationDetailController', InformationDetailController);

    /** @ngInject */
    function InformationDetailController($http, $mdDialog, $mdToast, $scope, $cookieStore, $rootScope, objInformation, ActiveVm, Tasks, event) {
        var vm = this;

        $scope.init = function() {
            $scope.Type = objInformation.Type;
            $scope.Flag = objInformation.Flag;
        }

        $scope.closeModel = function() {
            $mdDialog.hide();
        }

        $scope.init();
    }
})();
(function() {
    'use strict';

    angular
        .module('app.linkeddevices')
        .controller('CordlessDeviceController', CordlessDeviceController);

    /** @ngInject */
    function CordlessDeviceController($http, $mdDialog, $mdToast, $scope, $cookieStore, $rootScope, objMatId, ActiveVm, Tasks, event, DTOptionsBuilder, DTColumnDefBuilder) {
        var vm = this;

        $scope.init = function() {
            $scope.InActiveDeviceList = [];
            $scope.Selected = [];
            $scope.GetAllCordlessDevice();
        }

        $scope.GetAllCordlessDevice = function() {
            var params = {
                MatId: objMatId
            }
            $http.get($rootScope.RoutePath + "customerdevices/GetAllCordlessDevice", { params: params }).then(function(data) {
                $scope.CordlessDeviceList = data.data.data
            });
        }

        $scope.dtOptions2 = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withDisplayLength(100)
            .withOption('responsive', false)
            .withOption('autoWidth', false)
            .withOption('searching', false)
            .withOption('paging', false)
            .withOption('info', false)
            .withOption('deferRender', true)
            .withOption('language', {
                'zeroRecords': "No Record Found",
                'emptyTable': "No Record Found"
            })

        $scope.dtColumnDefsDevice = [
            DTColumnDefBuilder.newColumnDef(0).notSortable(),
            DTColumnDefBuilder.newColumnDef(1).notSortable(),
            DTColumnDefBuilder.newColumnDef(2).notSortable(),
            DTColumnDefBuilder.newColumnDef(3).notSortable(),
            DTColumnDefBuilder.newColumnDef(4).notSortable(),
            // DTColumnDefBuilder.newColumnDef(5).notSortable(),
        ];

        $scope.Reset = function() {
            $mdDialog.hide();
        }

        $scope.closeModel = function() {
            $mdDialog.hide();
        }

        $scope.init();
    }
})();
(function() {
    'use strict';

    angular
        .module('app.linkeddevices')
        .controller('ActiveAlarmSettingController', ActiveAlarmSettingController);

    /** @ngInject */
    function ActiveAlarmSettingController($http, $mdDialog, $mdToast, $scope, $cookieStore, $rootScope, objAlarm, ActiveVm, Tasks, event) {
        var vm = this;

        $scope.init = function() {
            $scope.model = {
                id: objAlarm.id,
                CustomerMasterId: objAlarm.CustomerMasterId,
                DeviceType: objAlarm.DeviceType,
                DeviceName: objAlarm.DeviceName,
                DeviceSerial: objAlarm.DeviceSerial,
                TriggerType: objAlarm.TriggerType,
                Alarm_Time: objAlarm.Alarm_Time,
                Scheduler_StartTime: objAlarm.Scheduler_StartTime,
                Scheduler_EndTime: objAlarm.Scheduler_EndTime,
                Device_Mat_Id: objAlarm.Device_Mat_Id,
                AlertType: objAlarm.AlertType,
                Setting_Sync_Flag: objAlarm.Setting_Sync_Flag,
                Connection_Status: objAlarm.Connection_Status,
                IsActive: objAlarm.IsActive,
                SchedulType: 'Always On',
                Volume: objAlarm.Volume,
            }

            if (objAlarm.Scheduler_StartTime == '00:00:00' && objAlarm.Scheduler_EndTime == '23:59:59') {
                $scope.model.Scheduler_StartTime = '';
                $scope.model.Scheduler_EndTime = '';
                $scope.model.SchedulType = 'Always On';
            } else {
                $scope.model.Scheduler_StartTime = ConvertToTime(objAlarm.Scheduler_StartTime);
                $scope.model.Scheduler_EndTime = ConvertToTime(objAlarm.Scheduler_EndTime);
                $scope.model.SchedulType = 'Scheduling';
            }
            $scope.tab = { selectedIndex: 0 };
            $scope.TimingList = [{ value: 30000, time: '30 Seconds' }, { value: 60000, time: '1 Minute' }, { value: 120000, time: '2 Minute' }, { value: 180000, time: '3 Minute' }, { value: 240000, time: '4 Minute' }, { value: 300000, time: '5 Minute' }, { value: 360000, time: '6 Minute' }, { value: 420000, time: '7 Minute' }, { value: 480000, time: '8 Minute' }, { value: 540000, time: '9 Minute' }, { value: 600000, time: '10 Minute' }, { value: 660000, time: '11 Minute' }, { value: 720000, time: '12 Minute' }, { value: 780000, time: '13 Minute' }, { value: 840000, time: '14 Minute' }, { value: 900000, time: '15 Minute' }, { value: 960000, time: '16 Minute' }, { value: 1020000, time: '17 Minute' }, { value: 1080000, time: '18 Minute' }, { value: 1140000, time: '19 Minute' }, { value: 1200000, time: '20 Minute' }, { value: 1500000, time: '25 Minute' }, { value: 1800000, time: '30 Minute' }, { value: 2100000, time: '35 Minute' }, { value: 2400000, time: '40 Minute' }, { value: 2700000, time: '45 Minute' }, { value: 3000000, time: '50 Minute' }, { value: 3300000, time: '55 Minute' }, { value: 3600000, time: '1 Hour' }];

            $('.mobiscrollTime').scroller({ preset: 'time' });
            $('.mobiscrollDate').scroller();
            $('.mobiscrollDateTime').scroller({ preset: 'datetime' });
        }

        $scope.CreateCustomerDevice = function(o, lst) {
            if (o.SchedulType == "Always On") {
                o.Scheduler_StartTime = "00:00:00";
                o.Scheduler_EndTime = "23:59:59";
            }
            $http.post($rootScope.RoutePath + "customerdevices/SaveCustomerDevice", o).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );

                    $rootScope.FlgAddedEditlocal = false;
                    if ($rootScope.FlgAddedAccess == true) {
                        $rootScope.FlgAddedEditlocal = true
                    }
                    ActiveVm.GetMatList();
                    $scope.Reset();
                } else {
                    if (data.data.data == 'TOKEN') {

                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                        ActiveVm.GetMatList();
                        $scope.Reset();
                    }
                }
            });
            // }

        }

        function ConvertToTime(Time) {

            if (Time != null) {
                var splitedData = Time.split(':')
                if (parseInt(splitedData[0]) < 12) {
                    if (splitedData[0] == 0) {
                        return 12 + ":" + splitedData[1] + " AM";
                    } else {
                        return splitedData[0] + ":" + splitedData[1] + " AM";
                    }
                } else {
                    if (parseInt(splitedData[0]) - 12 == 0) {
                        return 12 + ":" + splitedData[1] + " PM";
                    } else {
                        return parseInt(splitedData[0]) - 12 + ":" + splitedData[1] + " PM";
                    }
                }
            } else {
                return null;
            }
        }

        $scope.OpenDetail = function(Type, flg) {
            var obj = {
                Type: Type,
                Flag: flg
            }
            $mdDialog.show({
                skipHide: true,
                controller: 'InformationDetailController',
                controllerAs: 'vm',
                templateUrl: 'app/main/ActiveDevices/dialogs/InformationDetail/InformationDetail.html',
                parent: angular.element(document.body),
                targetEvent: '',
                clickOutsideToClose: false,
                locals: {
                    objInformation: obj,
                    Tasks: [],
                    event: '',
                    ActiveVm: vm,
                }
            })
        }

        $scope.Reset = function() {
            $mdDialog.hide();
        }

        $scope.closeModel = function() {
            $mdDialog.hide();
        }

        $scope.init();
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function() {
    'use strict';

    angular
        .module('app.core', [
            'ngAnimate',
            'ngAria',
            'ngCookies',
            'ngMessages',
            'ngResource',
            'ngSanitize',
            'ngMaterial',
            'chart.js',
            'pascalprecht.translate',
            'ui.router',
            'ngRoute',
            'dndLists',
            'datatables',

            'lfNgMdFileInput',
            'ngCkeditor',
            'angAccordion',
            'ngTagsInput',
            'ngMaterialDatePicker',
            'ngImgCrop',
        ]);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                loadMore: '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element('#content');
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msStepper', msStepperDirective)
        .directive('msStepperStep', msStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;
        // Data
        vm.mainForm = undefined;

        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;
        vm.resetStepperForm = resetStepperForm;
        vm.setCurrentStep = setCurrentStep;

        // vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element   : element,
                scope     : scope,
                form      : form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle : scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });
        }



        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {   
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            })
        }

        //Custom Function Start
        function resetStepperForm(formid) {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function() {
                vm.steps[formid-1].form.$setPristine();
                vm.steps[formid-1].form.$setUntouched();

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

            })
        }



        //Custom function Ends

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            // Hide all steps
            for ( var i = 0; i < vm.steps.length; i++ )
            {
                vm.steps[i].element.hide();
            }

            // Show the current step
            vm.steps[vm.currentStepNumber - 1].element.show();
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        // function gotoStep(stepNumber)
        // {
        //     console.log("casllll");
        //     console.log(stepNumber);

        //     vm.setCurrentStep(stepNumber);
        // }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            vm.setCurrentStep(vm.currentStepNumber - 1);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep(idRCUType)
        {
            vm.setCurrentStep(vm.currentStepNumber + 1);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...

            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msStepperDirective()
    {
        return {
            restrict        : 'A',
            require         : ['form', 'msStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        }
    }

    /** @ngInject */
    function msStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msStepper'],
            priority: 1000,
            scope   : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : true,
            templateUrl: 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile    : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    var expanderEl,
                        collapserEl;

                    // Initialize
                    init();

                    function init()
                    {
                        expanderEl = iElement.find('#ms-search-bar-expander');
                        collapserEl = iElement.find('#ms-search-bar-collapser');

                        expanderEl.on('click', expand);
                        collapserEl.on('click', collapse);
                    }

                    /**
                     * Expand
                     */
                    function expand()
                    {
                        iElement.addClass('expanded');

                        // Esc key event
                        $document.on('keyup', escKeyEvent);
                    }

                    /**
                     * Collapse
                     */
                    function collapse()
                    {
                        iElement.removeClass('expanded');
                    }

                    /**
                     * Escape key event
                     *
                     * @param e
                     */
                    function escKeyEvent(e)
                    {
                        if ( e.keyCode === 27 )
                        {
                            collapse();
                            $document.off('keyup', escKeyEvent);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    var moduledata;

    function msNavigationServiceProvider() {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');
        var initInjector = angular.injector(['ng', 'ngCookies', 'ui.router']);
        // var initInjector1 = angular.injector(['ngCookies']);
        // var initInjector2 = angular.injector(['ui.router']);
        var $http = initInjector.get('$http');
        var $rootScope = initInjector.get('$rootScope');
        var $cookieStore = initInjector.get('$cookieStore');
        var $window = initInjector.get('$window');


        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item) {

            var token = $cookieStore.get('token');
            $http.defaults.headers.common['Authorization'] = token;
            var l = [];
            // var params = {
            //     tablename: item.title,
            //     permission: "Show"
            // }

            // var RoutePath = "http://localhost:3737/";
            // var RoutePath= "http://182.70.126.194:3737/";
            // var RoutePath = "http://embin.hopto.org:3737/";

            // $http.get(RoutePath + "userPermission/CheckRights", { params: params }).then(function(data) {
            //     // moduledata = (data.data);

            //     // console.log(item.title)
            //     // console.log(data.data)
            //     //console.log(data.data.success)
            //     // var l = _.where(moduledata, { Module: item.title });

            //     // console.log(l);
            //     if (data.data.success == false) {
            //         if (data.data.data == "TOKEN") {
            //             if (window.location.href.indexOf('app/login') == -1 && window.location.href.indexOf('VerifyAccount') == -1 && window.location.href.indexOf('ChangePassword') == -1) {
            //                 $window.location.href = '/#/app/login';
            //             } else {
            //                 return;
            //             };
            //         } else {
            //             return;
            //         };

            //     };



            // if (l.length > 0) {
            //     if (l[0].IsActive == false) {
            //         // console.log(item.title);
            //         return;
            //     };
            // }

            if (!angular.isString(path)) {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }
            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            // var parent = _findOrCreateParent(parts);
            var parent = _findOrCreateParent(parts, item.order);

            // Decide if we are going to update or create
            var updateItem = false;

            for (var i = 0; i < parent.length; i++) {
                if (parent[i]._id === id) {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if (updateItem) {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if (angular.isUndefined(item.weight) || !angular.isNumber(item.weight)) {
                    item.weight = 1;
                }

                item.weight = item.order;

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);

                parent.sort(function(a, b) {
                    // console.log(a)
                    // console.log(b)
                    return parseFloat(a.weight) - parseFloat(b.weight);
                });
            }
            // });
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path) {
            if (!angular.isString(path)) {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for (var p = 0; p < parts.length; p++) {
                var id = parts[p];

                for (var i = 0; i < item.length; i++) {
                    if (item[i]._id === id) {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if (item[i]._path === path) {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent) {
            // If parent not provided, sort the root items
            if (!parent) {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for (var i = 0; i < parent.length; i++) {
                var children = parent[i].children;

                if (children.length > 1) {
                    children.sort(_byWeight);
                }

                if (children.length > 0) {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts, weight) {
            navigation.sort(function(a, b) {

                return parseFloat(a.weight) - parseFloat(b.weight);
            });
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if (parts.length === 1) {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for (var i = 0; i < parts.length; i++) {
                var _id = parts[i],
                    createParent = true;

                for (var p = 0; p < parent.length; p++) {
                    if (parent[p]._id === _id) {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if (createParent) {
                    var item = {
                        _id: _id,
                        _path: parts.join('.'),
                        title: _id,
                        weight: weight,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y) {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item) {
            var uisref = '';

            if (angular.isDefined(item.state)) {
                uisref = item.state;

                if (angular.isDefined(item.stateParams) && angular.isObject(item.stateParams)) {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function() {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem: saveItem,
                deleteItem: deleteItem,
                sort: sortByWeight,
                clearNavigation: clearNavigation,
                setActiveItem: setActiveItem,
                getActiveItem: getActiveItem,
                getNavigationObject: getNavigationObject,
                setNavigationScope: setNavigationScope,
                setFolded: setFolded,
                getFolded: getFolded,
                setFoldedOpen: setFoldedOpen,
                getFoldedOpen: getFoldedOpen,
                toggleFolded: toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation() {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if (navigationScope) {
                    navigationScope.vm.navigation = [];
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope) {
                activeItem = {
                    node: node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem() {
                return activeItem;
            }

            /**
             * Return navigation object
             *
             * @param root
             * @returns {Array}
             */
            function getNavigationObject(root) {

                if (root) {
                    for (var i = 0; i < navigation.length; i++) {
                        if (navigation[i]._id === root) {
                            return [navigation[i]];
                        }
                    }
                }

                return navigation;
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope) {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status) {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded() {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status) {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen() {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded() {
                navigationScope.toggleFolded();
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService) {
        var vm = this;
        // Data

        if ($scope.root) {
            $scope.navigation = msNavigationService.getNavigationObject($scope.root);
        } else {
            $scope.navigation = msNavigationService.getNavigationObject();
        }


        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService) {
        return {
            restrict: 'E',
            scope: {
                folded: '=',
                root: '@'
            },
            controller: 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude: true,
            compile: function(tElement) {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement) {

                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init() {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if (msNavigationService.getFolded() === null) {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if (msNavigationService.getFolded()) {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function() {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function() {
                        return sidenav.isLockedOpen();
                    }, function(current, old) {
                        if (angular.isUndefined(current) || angular.equals(current, old)) {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if (folded) {
                            if (current) {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            } else {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if (activeItem) {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function(current, old) {
                        if (angular.isUndefined(current) || angular.equals(current, old)) {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded) {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if (folded) {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        } else {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if (activeItem) {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander() {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function() {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser() {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser() {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event) {
                        if (event) {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if (activeItem) {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event) {
                        if (event) {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function() {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function() {
                        // Close the sidenav
                        sidenav.close();

                        // If navigation is folded open, close it
                        if (msNavigationService.getFolded()) {
                            onFoldCollapserHover();
                        }
                    });

                    // Cleanup
                    scope.$on('$destroy', function() {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService) {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if (!vm.hasChildren || vm.group) {
                vm.collapsable = false;
            } else {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if (!vm.collapsable) {
                vm.collapsed = false;
            } else {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function() {
                // Expand if the current scope is collapsable and is collapsed
                if (vm.collapsable && vm.collapsed) {
                    $scope.$evalAsync(function() {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function(event, path) {
                if (vm.collapsed || !vm.collapsable) {
                    return;
                }

                // If there is no path defined, collapse
                if (angular.isUndefined(path)) {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if (activeItem) {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if (givenPathParts.indexOf(vm.node._id) > -1) {
                        return;
                    }

                    // Test for active path
                    if (activePathParts.indexOf(vm.node._id) > -1) {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function() {
                if (vm.node.state === $state.current.name) {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed() {
            if (vm.collapsed) {
                vm.expand();
            } else {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse() {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function() {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl, {
                        'display': 'block',
                        'height': height + 'px'
                    }, {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function() {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height': ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand() {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position': 'absolute',
                'visibility': 'hidden',
                'display': 'block',
                'height': 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position': '',
                'visibility': '',
                'display': '',
                'height': ''
            });

            $scope.$evalAsync(function() {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl, {
                        'display': 'block',
                        'height': '0px'
                    }, {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function() {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass() {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden() {
            if (angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden)) {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective() {
        return {
            restrict: 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller: 'MsNavigationNodeController as vm',
            compile: function(tElement) {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if (MsNavigationNodeCtrl.group) {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective() {
        return {
            restrict: 'A',
            require: '^msNavigationNode',
            compile: function(tElement) {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
                    // If the item is collapsable...
                    if (MsNavigationNodeCtrl.collapsable) {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function() {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService) {
        return {
            restrict: 'E',
            scope: {
                root: '@'
            },
            controller: 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude: true,
            compile: function(tElement) {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope) {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService) {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function() {
                // Mark as active if has children
                if (vm.hasChildren) {
                    $scope.$evalAsync(function() {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function() {
                if (!vm.hasChildren) {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if (activeItem) {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if (activePathParts.indexOf(vm.node._id) > -1) {
                    $scope.$evalAsync(function() {
                        vm.isActive = true;
                    });
                } else {
                    $scope.$evalAsync(function() {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function() {
                if (vm.node.state === $state.current.name) {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states everything except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass() {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective() {
        return {
            restrict: 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller: 'MsNavigationHorizontalNodeController as vm',
            compile: function(tElement) {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if (MsNavigationHorizontalNodeCtrl.group) {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia) {
        return {
            restrict: 'A',
            require: '^msNavigationHorizontalNode',
            compile: function(tElement) {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
                    iElement.on('click', onClick);

                    function onClick() {
                        if (!MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md')) {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function() {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService() {
        var foldable = {};

        var service = {
            setFoldable: setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold: toggleFold,
            openFolded: openFolded,
            closeFolded: closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element) {
            foldable = {
                'scope': scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen() {
            if (foldable.scope != undefined) {
                return foldable.scope.isNavFoldedOpen();
            } else {
                return false;
            }

        }

        /**
         * Toggle fold
         */
        function toggleFold() {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded() {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded() {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService) {
        return {
            restrict: 'A',
            link: function(scope, iElement, iAttrs) {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if (isFolded) {
                    fold();
                } else {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen() {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold() {
                    isFolded = !isFolded;

                    if (isFolded) {
                        fold();
                    } else {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold() {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function(event) {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event) {
                    if (angular.isDefined(event)) {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function(event) {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event) {
                    if (angular.isDefined(event)) {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function(event) {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold() {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function() {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController() {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled() {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable() {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable() {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope) {
            toggleItems.push({
                'element': element,
                'scope': scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems() {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope) {
            lockedItems.push({
                'element': element,
                'scope': scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems() {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService) {
        return {
            restrict: 'E',
            scope: {},
            controller: 'MsNavController',
            compile: function(tElement) {
                tElement.addClass('ms-nav');

                return function postLink(scope) {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function() {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function(navigation) {
                            navigation.close();

                            if (msNavFoldService.isNavFoldedOpen()) {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function() {
                        stateChangeSuccessEvent();
                    })
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective() {
        return {
            restrict: 'A',
            compile: function(tElement) {
                tElement.addClass('ms-nav-title');

                return function postLink() {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective() {
        return {
            restrict: 'AE',
            compile: function(tElement) {
                tElement.addClass('ms-nav-button');

                return function postLink() {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state) {
        return {
            restrict: 'A',
            require: '^msNav',
            scope: true,
            compile: function(tElement, tAttrs) {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if (angular.isUndefined(tAttrs.collapsed)) {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl) {
                    var classes = {
                        expanded: 'expanded',
                        expandAnimation: 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function(link) {
                        var state = angular.element(link).attr('ui-sref');

                        if (angular.isUndefined(state)) {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle() {
                        // If navigation is disabled, do nothing...
                        if (MsNavCtrl.isDisabled()) {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if (isCollapsed()) {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function() {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        } else {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function() {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function() {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function(lockedItem) {
                            if (angular.equals(lockedItem.scope, scope)) {
                                locked = true;
                            }
                        });

                        if (locked) {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function() {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function() {
                        // Collapse and then...
                        collapse().then(function() {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function() {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function(state) {
                            if (currentState === state) {
                                shouldExpand = true;
                            }
                        });

                        if (shouldExpand) {
                            expand();
                        } else {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function() {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed() {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded() {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand() {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if (isExpanded()) {
                            // Reject the deferred object
                            deferred.reject({ 'error': true });

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position': 'absolute',
                            'visibility': 'hidden',
                            'display': 'block',
                            'height': 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position': '',
                            'visibility': '',
                            'display': '',
                            'height': ''
                        });

                        // Animate the height
                        scope.$evalAsync(function() {
                            $animate.animate(elementToExpand, {
                                    'display': 'block',
                                    'height': '0px'
                                }, {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function() {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({ 'height': '' });

                                    // Resolve the deferred object
                                    deferred.resolve({ 'success': true });
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse() {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if (isCollapsed()) {
                            // Reject the deferred object
                            deferred.reject({ 'error': true });

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function() {
                            $animate.animate(elementToCollapse, {
                                    'height': height + 'px'
                                }, {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function() {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height': ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({ 'success': true });
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPicker($mdMenu, $mdColorPalette, fuseGenerator)
    {
        return {
            require    : 'ngModel',
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function ($scope, element, attrs, ngModel)
            {
                // Material Color Palette
                $scope.palettes = $mdColorPalette;
                $scope.selectedPalette = false;
                $scope.selectedHues = false;

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                $scope.msModelType = $scope.msModelType || 'class';

                /**
                 * Initialize / Watch model changes
                 */
                $scope.$watch('ngModel', setSelectedColor);

                /**
                 * Activate Hue Selection
                 * @param palette
                 * @param hues
                 */
                $scope.activateHueSelection = function (palette, hues)
                {
                    $scope.selectedPalette = palette;
                    $scope.selectedHues = hues;
                };

                /**
                 * Select Color
                 * @type {selectColor}
                 */
                $scope.selectColor = function (palette, hue)
                {
                    // Update Selected Color
                    updateSelectedColor(palette, hue);

                    // Update Model Value
                    updateModel();

                    // Hide The picker
                    $mdMenu.hide();
                };

                $scope.removeColor = function ()
                {

                    $scope.selectedColor = {
                        palette: '',
                        hue    : '',
                        class  : ''
                    };

                    $scope.activateHueSelection(false, false);

                    updateModel();
                };

                /**
                 * Set SelectedColor by model type
                 */
                function setSelectedColor()
                {
                    if ( !ngModel.$viewValue || ngModel.$viewValue === '' )
                    {
                        return;
                    }

                    var palette, hue;

                    // If ModelType Class
                    if ( $scope.msModelType === 'class' )
                    {
                        var color = ngModel.$viewValue.split('-');
                        if ( color.length >= 5 )
                        {
                            palette = color[1] + '-' + color[2];
                            hue = color[3];
                        }
                        else
                        {
                            palette = color[1];
                            hue = color[2];
                        }
                    }
                    // If ModelType Object
                    else if ( $scope.msModelType === 'obj' )
                    {
                        palette = ngModel.$viewValue.palette;
                        hue = ngModel.$viewValue.hue || 500;
                    }

                    // Update Selected Color
                    updateSelectedColor(palette, hue);
                }


                /**
                 * Update Selected Color
                 * @param palette
                 * @param hue
                 */
                function updateSelectedColor(palette, hue)
                {
                    $scope.selectedColor = {
                        palette     : palette,
                        hue         : hue,
                        class       : 'md-' + palette + '-' + hue + '-bg',
                        bgColorValue: fuseGenerator.rgba($scope.palettes[palette][hue].value),
                        fgColorValue: fuseGenerator.rgba($scope.palettes[palette][hue].contrast)
                    };

                    // If Model object not Equals the selectedColor update it
                    // it can be happen when the model only have pallete and hue values
                    if ( $scope.msModelType === 'obj' && !angular.equals($scope.selectedColor, ngModel.$viewValue) )
                    {
                        // Update Model Value
                        updateModel();
                    }

                    $scope.activateHueSelection(palette, $scope.palettes[palette]);
                }

                /**
                 * Update Model Value by model type
                 */
                function updateModel()
                {
                    if ( $scope.msModelType === 'class' )
                    {
                        ngModel.$setViewValue($scope.selectedColor.class);
                    }
                    else if ( $scope.msModelType === 'obj' )
                    {
                        ngModel.$setViewValue($scope.selectedColor);
                    }
                }
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        }

    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '@template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app.core').directive('errSrc', function() {
            return {
                link: function(scope, element, attrs) {
                    element.bind('error', function() {
                        if (attrs.src != attrs.errSrc) {
                            attrs.$set('src', attrs.errSrc);
                        }
                    });
                }
            }
        })

    // angular
    //     .module('app.core').directive('numbersOnly', function() {
    //         return {
    //             require: 'ngModel',
    //             link: function(scope, element, attrs, modelCtrl) {
    //                 modelCtrl.$parsers.push(function(inputValue) {
    //                     if (inputValue == undefined) return ''
    //                     var transformedInput = inputValue.replace(/[^0-9]/g, '');
    //                     if (transformedInput != inputValue) {
    //                         modelCtrl.$setViewValue(transformedInput);
    //                         modelCtrl.$render();
    //                     }

    //                     return transformedInput;
    //                 });
    //             }
    //         };
    //     })
})();

(function() {
    'use strict';

    angular
        .module('app.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($scope, $state, $rootScope, $timeout, $http, $cookieStore, $mdDialog, $document, $mdToast, $stateParams, $window) {
        var vm = this;

        $scope.init = function() {
            $scope.model = {
                Name: '',
                Password: '',
                RemeberMe: false
            }
            $scope.Isactive = true;
            $scope.IsResend = false;
            $scope.IsEmail = true;
            $scope.EmailErrorMessage = false;
            $scope.PasswordErrorMessage = false;
        }

        $scope.EmailCheck = function(o) {
            var params = {
                Name: o.Name,
                Password: o.Password
            }
            $http.get($rootScope.RoutePath + "account/EmailCheckForLogin", { params: params }).then(function(data) {
                if (data.data.success == true) {
                    $scope.IsEmail = false;
                } else {
                    // $mdToast.show(
                    //     $mdToast.simple()
                    //     .textContent(data.data.message)
                    //     .position('top right')
                    //     .hideDelay(3000)
                    // );
                    if (data.data.message == "Your Account is not Verify...") {
                        $scope.Isactive = false;
                    }
                    if (data.data.message == "Invalid Username.") {
                        $scope.EmailErrorMessage = true;
                    }
                };
            });

        }

        $scope.Login = function(o) {
            var params = {
                Name: o.Name,
                Password: o.Password
            }
            $http.get($rootScope.RoutePath + "account/login", { params: params }).then(function(data) {
                if (data.data.success == true) {
                    $cookieStore.put('UserImage', data.data.UserImage);
                    $rootScope.UserImage = $cookieStore.get('UserImage');
                    $cookieStore.put('UserName', data.data.UserName);
                    $cookieStore.put('UserRoles', data.data.UserRoles[0]);
                    $rootScope.UserRole = $cookieStore.get('UserRoles');
                    $cookieStore.put('UserId', data.data.UserId);
                    $rootScope.UserId = $cookieStore.get('UserId');
                    $cookieStore.put('FirstName', data.data.FirstName);
                    $rootScope.FirstName = $cookieStore.get('FirstName');
                    $cookieStore.put('LastName', data.data.LastName);
                    $rootScope.LastName = $cookieStore.get('LastName');
                    $cookieStore.put('OrganizationName', data.data.OrganizationName);
                    $rootScope.OrganizationName = $cookieStore.get('OrganizationName');
                    $cookieStore.put('AccountType', data.data.AccountType);
                    $rootScope.AccountType = $cookieStore.get('AccountType');
                    $cookieStore.put('token', data.data.token);
                    $http.defaults.headers.common['Authorization'] = data.data.token; // jshint ignore:line
                    $rootScope.MenuSet();

                    if ($rootScope.UserRole == "User") {
                        // $window.location.href = '/#/customerdevices';
                        // $timeout(function() {
                        //     $window.location.reload();
                        // });
                        $state.go('app.linkeddevices');
                    } else {
                        // $window.location.href = '/#/customer';
                        // $timeout(function() {
                        //     $window.location.reload();
                        // });
                        $state.go('app.salesinfo');
                    }

                    // window.location.href = "/#/Dashboard";
                    // $state.go('app.Dashboard');

                } else {
                    // $mdToast.show(
                    //     $mdToast.simple()
                    //     .textContent(data.data.message)
                    //     .position('top right')
                    //     .hideDelay(3000)
                    // );
                    if (data.data.message == "Your Account is not Verify...") {
                        $scope.Isactive = false;
                    }
                    if (data.data.message == "Invalid Password...") {
                        $scope.PasswordErrorMessage = true;
                    }
                };
            });

        }

        $scope.ResendEmail = function() {
            var params = {
                email: $scope.model.Name,
            }
            $scope.IsResend = true;
            $scope.Isactive = false;
            $http.get($rootScope.RoutePath + "account/resendEmail", { params: params }).success(function(data) {
                if (data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );

                    // window.location.href = "/#/app/login";
                    // $scope.init();
                } else {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );
                    // window.location.href = "/#/app/login";
                    // $scope.init();
                }
            });
        }

        $scope.BackLogin = function() {
            $scope.IsResend = false;
            $scope.Isactive = true;
            $scope.EmailErrorMessage = false;
            $scope.PasswordErrorMessage = false;
        }
        $scope.ShowForgotPassword = function(ev, o) {
            $state.go('app.Forgotpassword');
        }

        $scope.ShowRegister = function(ev, o) {
            $state.go('app.Register');
        }
        $scope.init();
    }
})();
(function() {
    'use strict';

    angular
        .module('app.datatable', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.datatable', {
                url: '/datatable',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/datatable/datatable.html',
                        controller: 'DatatableController as vm'
                    }
                },
                bodyClass: 'datatable',
                ModuleName: 'datatable'
            });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/datatable');

        // Navigation
        // msNavigationServiceProvider.saveItem('Demo.datatable', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        msNavigationServiceProvider.saveItem('Demo.datatable', {
            title: 'datatable Sample',
            state: 'app.datatable',
            icon: 'icon-lock',
            weight: 1
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.datatable')
        .controller('DatatableController', DatatableController);

    /** @ngInject */
    function DatatableController($http, $scope, $compile, $mdToast, $rootScope, $document, $mdDialog, $stateParams, DTOptionsBuilder, DTColumnDefBuilder, DTColumnBuilder) {
        var vm = this;
        $scope.Name = "";
        // vm.dtOptions = DTOptionsBuilder.newOptions()
        //     .withOption('ajax', {
        //         // Either you specify the AjaxDataProp here
        //         // dataSrc: 'data',
        //         type: 'GET',
        //         url: $rootScope.RoutePath + "customer/GetAllMedia",

        //     })
        //     .withPaginationType('full_numbers')
        //     .withDisplayLength(10)
        //     .withOption('responsive', true)
        //     .withOption('autoWidth', true)
        //     // .withOption('paging', false)
        //     // .withOption('deferRender', true)
        //     .withOption('language', {
        //         'zeroRecords': "No Record Found",
        //         'emptyTable': "No Record Found"
        //     })
        //     .withOption('dom', '<"top"<"left"<"length"l>>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
        //     .withDataProp('data')
        //     .withOption('processing', true)
        //     .withOption('serverSide', true);


        // vm.dtColumns = [
        //     DTColumnBuilder.newColumn('id').withTitle('ID'),
        //     DTColumnBuilder.newColumn('FileName').withTitle('First name'),
        //     DTColumnBuilder.newColumn('Author').withTitle('Last name'),
        //     DTColumnBuilder.newColumn(null).withTitle('Action').notSortable().renderWith(function(data, type, full, meta) {
        //         // if (data.status != "CLOSED") {
        //         //     return '<button class="btn btn-primary" ng-click="edit(' + data.id + ')">' +
        //         //         '   <i class="fa fa-eye"></i>' + "View" +
        //         //         '</button>&nbsp;' + '<button class="btn btn-warning" ng-click="edit(' + data.id + ')">' +
        //         //         '   <i class="fa fa-edit"></i>' + "Edit" +
        //         //         '</button>&nbsp;' +
        //         //         '<button class="btn btn-danger" ng-click="delete(' + data.id + ')">' +
        //         //         '   <i class="fa fa-trash-o"></i>' + "Delete"
        //         //     '</button>';
        //         // } else {
        //         //     return '<button class="btn btn-primary" ng-click="edit(' + data.id + ')">' +
        //         //         '   <i class="fa fa-eye"></i>' + "View" +
        //         //         '</button>&nbsp;' + '<button class="btn btn-warning" ng-click="update(' + data.id + ')">' +
        //         //         '   <i class="fa fa-clipboard"></i>' + "Clone" +
        //         //         '</button>&nbsp;' +
        //         //         '<button class="btn btn-primary" ng-click="delete(' + data.id + ')">' +
        //         //         '   <i class="fa fa-refresh"></i>' + "Update"
        //         //     '</button>';
        //         // }
        //         // console.log(data);

        //         return '<button class="md-icon-button md-accent md-raised md-hue-2 md-button md-ink-ripple md-default-theme" type="button" ng-transclude="">' +
        //             '<md-icon md-font-icon="icon-pencil-box-outline" ng-click="FetchProductById(' + data.id + ')" class="ng-scope ng-isolate-scope md-font icon-pencil-box-outline material-icons md-default-theme" role="button" aria-hidden="true"></md-icon>' +
        //             '</button>' +
        //             '<button class="md-icon-button md-raised md-warn md-raised md-hue-2 md-button md-ink-ripple md-default-theme" type="button" ng-transclude="">' +
        //             '<md-icon md-font-icon="icon-trash" ng-click="DeleteProductPanel(o)" class="ng-scope ng-isolate-scope md-font icon-trash material-icons md-default-theme" role="button" aria-hidden="true"></md-icon>' +
        //             '</button>';
        //     })
        // ];
        // vm.GetAllMedia = GetAllMedia;
        $scope.checked = {};
        $scope.lstdata = [];

        $scope.GetAllData = function() {
            // vm.dtOptions.ajax.reload();
            $scope.reloadData();
        }

        vm.dtColumns = [
            // DTColumnBuilder.newColumn(null),
            DTColumnBuilder.newColumn(null).notSortable().renderWith(CheckboxHTML),
            DTColumnBuilder.newColumn('id').renderWith(NumberHtml),
            DTColumnBuilder.newColumn(null).notSortable().renderWith(ImageHtml),
            DTColumnBuilder.newColumn('FileName'),
            DTColumnBuilder.newColumn('Author'),
            DTColumnBuilder.newColumn(null).notSortable()
            .renderWith(actionsHtml)
        ]
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                // dataSrc: "data",
                url: $rootScope.RoutePath + "customer/GetAllMedia",
                // data: {
                //     Name: $scope.Name
                // },
                data: function(d) {
                    d.Name = $scope.Name;
                    return d;
                },
                type: "get",
                dataSrc: function(json) {

                    for (var i = 0; i < json.data.length; i++) {
                        json.data[i].checked = false;
                    };
                    $scope.toggleChecked = false;
                    $scope.lstdata = json.data;
                    return json.data;
                },
            })

        .withOption('serverSide', true) // for server side processing
            .withPaginationType('full_numbers') // for get full pagination options // first / last / prev / next and page numbers
            .withDisplayLength(10) // Page size
            .withOption('aaSorting', [1, 'asc'])
            .withOption('createdRow', createdRow);


        // vm.reloadData = reloadData;
        vm.dtInstance = {};

        $scope.reloadData = function() {
            // var resetPaging = false;
            // vm.dtInstance.reloadData(callback, resetPaging);
            // vm.dtInstance.DataTable.reload()
            console.log(vm.dtInstance.DataTable.rows())
        }

        function callback(json) {
            // console.log(json);
        }

        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }

        $scope.toggleSeleted = function() {
            console.log($scope.lstdata);
            console.log($scope.checked)
            $scope.allSelected = !$scope.allSelected;
            angular.forEach($scope.lstdata, function(o) {
                $scope.checked[o.id] = $scope.allSelected;
            });
        };


        function actionsHtml(data, type, full, meta) {

            return '  <md-button class="md-icon-button md-accent md-raised md-hue-2" ng-transclude ng-click="Dhaval2()">' +
                '<md-icon md-font-icon="icon-pencil-box-outline"></md-icon>' +
                '</md-button>' +
                '<md-button class="md-icon-button md-raised md-warn md-raised md-hue-2" ng-transclude ng-click="DeleteBrand(item.id)">' +
                '<md-icon md-font-icon="icon-trash"></md-icon>' +
                '</md-button>';


            // return '<md-menu md-offset="0 -7" md-position-mode="target-right target">' +
            //     ' <md-button aria-label="Open demo menu" class="md-icon-button" field-transclude ng-click="$mdOpenMenu($event)">' +
            //     '     <md-icon md-font-icon="icon-dots-horizontal"></md-icon>' +
            //     '  </md-button>' +
            //     '  <md-menu-content width="2">' +
            //     '<md-menu-item>' +
            //     ' <md-button class="md-raised md-primary md-hue-3">' +
            //     '      Detail' +
            //     '   </md-button>' +
            //     '</md-menu-item>' +
            //     ' <md-menu-item>' +
            //     '   <md-button class="md-raised md-primary md-hue-3">' +
            //     '        Invoice' +
            //     '     </md-button>' +
            //     '  </md-menu-item>' +
            //     '   <md-menu-item>' +
            //     '        <md-button class="md-raised md-primary md-hue-3">' +
            //     '             Edit' +
            //     '          </md-button>' +
            //     '       </md-menu-item>' +

            //     '    </md-menu-content>' +
            //     '</md-menu>';
        }

        function ImageHtml(data, type, full, meta) {

            return ' <img src="' + $rootScope.RoutePath + 'MediaUploads/' + data.FileName + '" err-src="assets/images/no-image.png" height="50px" width="50px">';
        }

        function CheckboxHTML(data, type, full, meta) {

            return ' <md-checkbox ng-model="checked[' + data.id + ']" aria-label="Checkbox 1" class="md-primary"></md-checkbox>';
        }

        function NumberHtml(data, type, full, meta) {
            return (meta.row + 1);
        }

        function Renderdata(data, DT_RowId, full, meta) {
            console.log(data)
        }

        // function rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
        //     // console.log(aData)
        //     // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
        //     $('td button', nRow).unbind('click');
        //     $('td button#UpdateButton', nRow).bind('click', function() {
        //         $scope.$apply(function() {
        //             // alert("You've clicked row," + iDisplayIndex);
        //             console.log("Update Button")
        //             console.log(aData)

        //         });
        //     });
        //     $('td button#DeleteButton', nRow).bind('click', function() {
        //         $scope.$apply(function() {
        //             // alert("You've clicked row," + iDisplayIndex);
        //             console.log("Delete Button")
        //             console.log(aData)
        //         });
        //     });

        //     return nRow;
        // }

        // Data
        // vm.employees = Employees.data;

        // $scope.Dhaval = function() {
        //     console.log("Test1");
        //     // Data
        //     $http.get("http://localhost:3030/customer/GetAllDynamicPages").then(function(data) {
        //         console.log(data);
        //         vm.employees = data.data.rows;
        //         // $scope.TotalProduct=data.data.count;
        //     });
        // }
        // $scope.GetAllData();

        //  $scope.GetAllProductProductAttribute = function(Id) {

        //     $http.get($rootScope.RoutePath + "productAttributeMapping/GetAllProductAttributeMappingByProductId?idProduct=" + Id).success(function(data) {
        //         console.log(data)
        //         if (data.length > 0) {
        //             $scope.listProductAttribute = data;
        //         } else {
        //             $scope.listProductAttribute = null;
        //         }

        //     });
        // }

        //  $scope.GetAllProductProductAttribute(2130);


        $scope.Dhaval1 = function() {
            // console.log("Test1");
            // Data
            // $http.get("http://localhost:3030/customer/GetAllProductTest").then(function(data) {
            $http.get("http://localhost:3030/product/ExportProducts").then(function(data) {
                console.log(data.data);
                // vm.employees = data.data.rows;
                // $scope.TotalProduct=data.data.count;
            });
        }

        $scope.Dhaval2 = function() {
            // console.log("Test1");
            // Data
            $http.get("http://localhost:3030/customer/GetAllProductTest").then(function(data) {
                console.log(data.data);
                // vm.employees = data.data.rows;
                // $scope.TotalProduct=data.data.count;
            });
        }

        function GetAllMedia() {
            // console.log("Test1");
            // Data
            $http.get("http://localhost:3030/customer/GetAllMedia").then(function(data) {
                console.log(data.data);
                // vm.employees = data.data.rows;
                // $scope.TotalProduct=data.data.count;
            });
        }

        // $scope.Dhaval1();
        // $scope.Dhaval2();

        // $scope.dtInstance = {
        //         "id": "foobar",
        //         "DataTable": oTable,
        //         "dataTable": $oTable
        //             // "reloadData": function(callback, resetPaging),
        //             // "changeData": function(newData),
        //             // "rerender": function()
        //     }
        // $scope.dtOptions = DTOptionsBuilder.newOptions()
        //     .withPaginationType('full_numbers')
        //     // Active Responsive plugin
        //     .withOption('responsive', true);

        // vm.dtOptions = DTOptionBuilder.newOptions()
        //     .withOptions('autoWidth', fnThatReturnsAPromise);


        // function fnThatReturnsAPromise() {
        //     var defer = $q.defer();
        //     defer.resolve(false);
        //     return defer.promise;
        // }



        // vm.dtOptions = DTOptionsBuilder.newOptions()
        //     .withPaginationType('full_numbers')
        //     .withDisplayLength(5)
        //     .withOption('responsive', true)
        //     .withOption('autoWidth', true)
        //     .withOption('language', {
        //         'zeroRecords': "No Record Found",
        //         'emptyTable': "No Record Found"
        //     })
        //     .withOption('dom', '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>');
        // .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>');
        // vm.dtColumnDefs = [
        //     DTColumnDefBuilder.newColumnDef(0),
        //     DTColumnDefBuilder.newColumnDef(1),
        //     DTColumnDefBuilder.newColumnDef(2),
        //     DTColumnDefBuilder.newColumnDef(3),
        //     DTColumnDefBuilder.newColumnDef(4),
        //     DTColumnDefBuilder.newColumnDef(5).notSortable()
        // ];

        // vm.dtOptions = {
        //     dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
        //     pagingType: 'simple',
        //     autoWidth: false,
        //     responsive: true
        // };

        // vm.dtColumnDefs = [
        //     DTColumnDefBuilder.newColumnDef(0),
        //     DTColumnDefBuilder.newColumnDef(1),
        //     DTColumnDefBuilder.newColumnDef(2),

        // ];
        $scope.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0),
            DTColumnDefBuilder.newColumnDef(1),
            DTColumnDefBuilder.newColumnDef(2),
            DTColumnDefBuilder.newColumnDef(3)
        ];

        // Methods

        //////////
    }

})();

(function() {
    'use strict';

    angular
        .module('app.VerifyAccount', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.VerifyAccount', {
            url: '/app/VerifyAccount/:UniqueKey/:date',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.VerifyAccount': {
                    templateUrl: 'app/main/VerifyAccount/VerifyAccount.html',
                    controller: 'VerifyAccountController as vm'
                }
            },
            bodyClass: 'VerifyAccount',
            ModuleName: 'VerifyAccount'
        });

        // Translation
        ///$translatePartialLoaderProvider.addPart('app/main/Register');

        // Navigation
        // msNavigationServiceProvider.saveItem('Demo.login', {
        //     title : 'Authentication',
        //     icon  : 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Demo.Register', {
        //     title: 'Register',
        //     state: 'app.Register',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }

})();
(function() {
    'use strict';

    angular
        .module('app.VerifyAccount')
        .controller('VerifyAccountController', VerifyAccountController);

    /** @ngInject */
    function VerifyAccountController($http, $scope, $rootScope, $state, $mdToast, $document, $cookieStore, $mdDialog, $stateParams, DTOptionsBuilder, DTColumnDefBuilder) {

        $scope.init = function() {
            $scope.flgVerify = false;
            $scope.flagExpire = false;
            $scope.checkIsVerify();
        }

        $scope.checkIsVerify = function() {
            var date = new Date(parseInt($stateParams.date));
            var currentdate = new Date();
            var day = (currentdate - date) / (1000 * 60 * 60 * 24);
            day = Math.round(day);

            if (day < 1) {
                $http.get($rootScope.RoutePath + "account/checkIsVerify?UniqueNumber=" + $stateParams.UniqueKey).then(function(data) {
                    if (data.data.success == true) {
                        $scope.flgVerify = true;
                    }
                });
            } else {
                $scope.flagExpire = true;
            }

        }

        $scope.init();
    }

})();
(function() {
    'use strict';

    angular
        .module('app.UserPermission', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.UserPermission', {
                url: '/UserPermission',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/UserPermission/UserPermission.html',
                        controller: 'UserPermissionController'
                    }
                },
                bodyClass: 'User Permission',
                ModuleName: 'User Permission'
            });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/UserPermission');

        // msNavigationServiceProvider.saveItem('Users.UserPermission', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Users.UserPermission', {
        //     title: 'User Permission',
        //     state: 'app.UserPermission',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.UserPermission')
        .controller('UserPermissionController', UserPermissionController);

    /** @ngInject */
    function UserPermissionController($http, $scope, $mdDialog, $document, $cookieStore, $mdToast, DTOptionsBuilder, DTColumnDefBuilder, $rootScope) {
        var vm = this;

        $scope.init = function () {
            $scope.model = {
                RoleName: '',
            };

            $scope.modelPermission = {
                View: false,
                Add: false,
                Update: false,
                Delete: false
            };

            $scope.GetAllRoles();
            $scope.GetAllModule();
        }

        $scope.GetAllRoles = function () {
            $http.get($rootScope.RoutePath + "role/GetAllRole").then(function (response) {
                $scope.lstRoles = response.data;
            });
        }

        $scope.GetAllModule = function () {
            $http.get($rootScope.RoutePath + "module/GetAllModule").then(function (response) {
                $scope.lstModules = response.data;
                for (var i = 0; i < $scope.lstModules.length; i++) {
                    $scope.lstModules[i]["Added"] = null;
                    $scope.lstModules[i]["Deleted"] = null;
                    $scope.lstModules[i]["RoleName"] = null;
                    $scope.lstModules[i]["Show"] = null;
                    $scope.lstModules[i]["Modified"] = null;
                    $scope.lstModules[i]["idModule"] = $scope.lstModules[i].id;
                    $scope.lstModules[i].id = 0;
                }
            });
        }

        $scope.GetAllPermissionByRole = function () {
            $http.get($rootScope.RoutePath + "userPermission/GetAllPermissionByRole?RoleName=" + $scope.model.RoleName).then(function (response) {
                $scope.lstUserPermission = response.data;
                if ($scope.lstUserPermission.length > 0) {
                    $scope.ClearDataItems();
                    $scope.GetDataItems();
                } else {
                    $scope.GetAllModule();
                }
                $scope.modelPermission = {
                    View: false,
                    Add: false,
                    Update: false,
                    Delete: false
                };
            });
        }

        $scope.GetDataItems = function () {
            for (var i = 0; i < $scope.lstUserPermission.length; i++) {
                for (var j = 0; j < $scope.lstModules.length; j++) {
                    if ($scope.lstUserPermission[i].idModule == $scope.lstModules[j].idModule && $scope.model.RoleName == $scope.lstUserPermission[i].RoleName) {
                        $scope.lstModules[j].Added = $scope.lstUserPermission[i].Added;
                        $scope.lstModules[j].Modified = $scope.lstUserPermission[i].Modified;
                        $scope.lstModules[j].Deleted = $scope.lstUserPermission[i].Deleted;
                        $scope.lstModules[j].Show = $scope.lstUserPermission[i].Show;
                    }
                }
            }
        }

        $scope.ClearDataItems = function () {
            for (var i = 0; i < $scope.lstUserPermission.length; i++) {
                for (var j = 0; j < $scope.lstModules.length; j++) {
                    $scope.lstModules[j].Added = false;
                    $scope.lstModules[j].Modified = false;
                    $scope.lstModules[j].Deleted = false;
                    $scope.lstModules[j].Show = false;
                }
            }
        }
        $scope.ChangePermission = function (o) {
            if ($scope.model.RoleName != null && $scope.model.RoleName != '' && $scope.model.RoleName != undefined) {
                o.RoleName = $scope.model.RoleName;
                $http.post($rootScope.RoutePath + "userPermission/ChangePermission", o).then(function (response) {
                    if (response.data.data == 'TOKEN') {
                        //$cookieStore.remove('UserName');
                        //$cookieStore.remove('token');
                        //window.location.href = '/app/login';
                        $rootScope.logout();
                    }
                });
            } else {
                var confirm = $mdDialog.confirm()
                    .title('You must select user role.')
                    .ok('ok')
                $mdDialog.show(confirm).then(function () {

                }, function () {

                });
            }
        }

        $scope.ChangePermissionAllView = function() {
            if ($scope.model.RoleName != null && $scope.model.RoleName != '' && $scope.model.RoleName != undefined) {

                var obj = new Object();
                obj.Show = $scope.modelPermission.View;
                obj.Data = $scope.lstModules;
                obj.RoleName = $scope.model.RoleName;
                obj.Type = "View";

                for (var i = 0; i < $scope.lstModules.length; i++) {
                    $scope.lstModules[i].Show = $scope.modelPermission.View;
                }
                $http.post($rootScope.RoutePath + "userPermission/ChangeAllPermissions", obj).then(function(response) {
                    if(response.data.data == 'TOKEN') {
                        $rootScope.logout();
                    }
                });
            } else {
                var confirm = $mdDialog.confirm()
                    .title('You must select user role.')
                    .ok('ok')
                $mdDialog.show(confirm).then(function() {
                    $scope.modelPermission.View = false;
                }, function() {

                });
            }
        }

        $scope.ChangePermissionAllAdd = function() {
            if ($scope.model.RoleName != null && $scope.model.RoleName != '' && $scope.model.RoleName != undefined) {

                for (var i = 0; i < $scope.lstModules.length; i++) {
                    $scope.lstModules[i].Added = $scope.modelPermission.Add;
                }

                var obj = new Object();
                obj.Show = $scope.modelPermission.Add;
                obj.Data = $scope.lstModules;
                obj.RoleName = $scope.model.RoleName;
                obj.Type = "Add";
                $http.post($rootScope.RoutePath + "userPermission/ChangeAllPermissions", obj).then(function(response) {
                    if (response.data.data == 'TOKEN') {
                        $rootScope.logout();
                    }
                });

            } else {
                var confirm = $mdDialog.confirm()
                    .title('You must select user role.')
                    .ok('ok')
                $mdDialog.show(confirm).then(function() {
                    $scope.modelPermission.Add = false;
                }, function() {

                });
            }
        }

        $scope.ChangePermissionAllUpdate = function() {
            if ($scope.model.RoleName != null && $scope.model.RoleName != '' && $scope.model.RoleName != undefined) {

                for (var i = 0; i < $scope.lstModules.length; i++) {
                    $scope.lstModules[i].Modified = $scope.modelPermission.Update;
                }

                var obj = new Object();
                obj.Show = $scope.modelPermission.Update;
                obj.Data = $scope.lstModules;
                obj.RoleName = $scope.model.RoleName;
                obj.Type = "Update";
                $http.post($rootScope.RoutePath + "userPermission/ChangeAllPermissions", obj).then(function(response) {
                    if (response.data.data == 'TOKEN') {
                        $rootScope.logout();
                    }
                });

            } else {
                var confirm = $mdDialog.confirm()
                    .title('You must select user role.')
                    .ok('ok')
                $mdDialog.show(confirm).then(function() {
                    $scope.modelPermission.Update = false;
                }, function() {

                });
            }
        }

        $scope.ChangePermissionAllDelete = function() {
            if ($scope.model.RoleName != null && $scope.model.RoleName != '' && $scope.model.RoleName != undefined) {

                for (var i = 0; i < $scope.lstModules.length; i++) {
                    $scope.lstModules[i].Deleted = $scope.modelPermission.Delete;
                }

                var obj = new Object();
                obj.Show = $scope.modelPermission.Delete;
                obj.Data = $scope.lstModules;
                obj.RoleName = $scope.model.RoleName;
                obj.Type = "Delete";
                $http.post($rootScope.RoutePath + "userPermission/ChangeAllPermissions", obj).then(function(response) {
                    if (response.data.data == 'TOKEN') {
                        $rootScope.logout();
                    }
                });

            } else {
                var confirm = $mdDialog.confirm()
                    .title('You must select user role.')
                    .ok('ok')
                $mdDialog.show(confirm).then(function() {
                    $scope.modelPermission.Delete = false;
                }, function() {

                });
            }
        }

         $scope.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0),
            DTColumnDefBuilder.newColumnDef(1),

            DTColumnDefBuilder.newColumnDef(2).notSortable(),
            DTColumnDefBuilder.newColumnDef(3).notSortable(),
            DTColumnDefBuilder.newColumnDef(4).notSortable(),
            DTColumnDefBuilder.newColumnDef(5).notSortable(),
           

        ];

        $scope.Reset = function () {
            $scope.init();
        }

        $scope.init();
    }
})();

(function() {
    'use strict';

    angular
        .module('app.user', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.user', {
                url: '/user',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/User/User.html',
                        controller: 'UserController as vm'
                    }
                },
                bodyClass: 'User',
                ModuleName: 'User'
            });

        // Translation
       // $translatePartialLoaderProvider.addPart('app/main/user');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.user', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        msNavigationServiceProvider.saveItem('Users.user', {
            title: 'User',
            state: 'app.user',
            icon: 'icon-lock',
            weight: 1
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.user')
        .controller('UserController', UserController);

    /** @ngInject */
    function UserController($http, $scope, $rootScope, $state, $q, $timeout, $mdToast, $document, $mdDialog, $cookieStore, $stateParams, DTOptionsBuilder, DTColumnDefBuilder, DTColumnBuilder, $compile) {

        var vm = this;

        $scope.init = function() {
            $scope.model = {
                id: '',
                email: '',
                username: '',
                phone: '',
                createdby: 'Admin',
                createddate: new Date(),
                modifiedby: '',
                modifieddate: null,
                roleId: '',
                userId: '',
                country: '',
                state: '',
                city: '',
                gender: '',
                image: '',
                IsMobileVerify: false,
            };
            //$scope.GetAllUser();
            $scope.GetAllRoles();
            //$scope.GetAllCountry();
            $scope.tab = { selectedIndex: 0 };

            $scope.FlgImage = 0;
            $scope.FlgCropImage = 0;
        }

        // $scope.GetAllUser = function () {
        //     // Data
        //     $http.get($rootScope.RoutePath + "user/GetAllUser").then(function (data) {
        //         $scope.lstUsers = data.data;
        //     });
        // }

        $scope.GetAllRoles = function() {
            // Data
            $http.get($rootScope.RoutePath + "role/GetAllRole").then(function(data) {
                $scope.lstRoles = data.data;
            });
        }

        $scope.FetchRoleById = function(id) {
            $rootScope.FlgAddedEditlocal = true;
            var o = _.findWhere($scope.lstdata, { id: id });
            $scope.tab.selectedIndex = 1;
            $scope.model.phone = o.phone;
            $scope.model.email = o.email;
            $scope.model.phone = parseInt(o.phone);
            $scope.model.username = o.username;
            $scope.model.createddate = o.createddate;
            $scope.model.createdby = o.createdby;
            $scope.model.modifieddate = new Date();
            $scope.model.modifiedby = "Admin";
            $scope.model.id = o.id;
            $scope.model.userId = o.id;
            //$scope.model.password = o.password;
            //$scope.model.country = o.country;
            //$scope.GetAllStateByCountry($scope.model.country);
            //$scope.model.state = o.state;
            // $timeout(function() {
            //     $scope.GetAllCityByStateId($scope.model.state);
            //     $scope.model.city = o.city;
            // }, 1000);

            $scope.model.gender = o.gender;
            $scope.model.IsMobileVerify = o.IsMobileVerify;

            if (o.tbluserinroles.length > 0) {
                for (var i = 0; i < o.tbluserinroles.length; i++) {
                    var obj = _.findWhere($scope.lstRoles, { id: o.tbluserinroles[i].roleId })
                    obj.checked = true;
                }
            }

            $scope.model.image = o.image;
            $scope.myCroppedImage = $rootScope.RoutePath + 'MediaUploads/UserUpload/' + $scope.model.image;
            if ($scope.model.image != null && $scope.model.image != '' && $scope.model.image != undefined) {
                $scope.FlgImage = 1;
            } else {
                $scope.FlgImage = 0;
            }

        }


        ////Get All Country
        // $scope.GetAllCountry = function() {
        //     $http.get($rootScope.RoutePath + "country/GetAllCountry").then(function(data) {
        //         $scope.lstCountry = data.data;
        //     });
        // }

        ////Get All State By Country Name
        // $scope.GetAllStateByCountry = function(Country) {
        //     $scope.lstState = '';
        //     $scope.lstCity = '';
        //     if (Country != null && Country != '' && Country != undefined) {
        //         var Countryid = _.where($scope.lstCountry, { Country: Country })[0].id;
        //         $scope.lstState = '';
        //         $scope.lstCity = '';
        //         var params = {
        //             CountryId: Countryid
        //         };
        //         $http.get($rootScope.RoutePath + "state/GetAllStateByCountryId", { params: params }).success(function(data) {
        //             $scope.lstState = data.data;
        //         });
        //     }

        // }

        // //Get All City By State Name
// $scope.GetAllCityByStateId = function(State) {
//     if (State != null && State != '' && State != undefined) {

//         var Stateid = _.where($scope.lstState, { Name: State })[0].id;
//         console.log(State);
//         $scope.lstCity = '';
//         var params = {
//             StateId: Stateid
//         };
//         $http.get($rootScope.RoutePath + "city/GetAllCityByStateId", { params: params }).success(function(data) {
//             $scope.lstCity = data.data;
//         });
//     }
// }


        //Create New User With It's Role
        $scope.CreateUser = function(o) {
            o.roleId = _.where($scope.lstRoles, { checked: true });
            console.log(o.image)
            if (o.roleId.length > 0) {
                if ($scope.Mediafiles.length == 0 && (o.id == 0 || o.id == '')) {
                    o.image = null;
                    $cookieStore.put('UserImage', null);
                    $rootScope.UserImage = $cookieStore.get('UserImage');
                }
                $http.post($rootScope.RoutePath + "user/SaveUser", o).then(function(data) {
                    //$scope.SaveUserInRole(o);
                    if (data.data.success == true) {
                        var id;
                        if (o.id != 0) {
                            id = o.id;
                        } else {
                            id = data.data.data.userId;
                        }
                        if ($scope.Mediafiles.length > 0) {
                            var formData = new FormData();
                            // angular.forEach($scope.Mediafiles, function(d) {
                            formData.append(id, file);
                            // });
                            $http.post($rootScope.RoutePath + "user/uploadImage", formData, {
                                transformRequest: angular.identity,
                                headers: { 'Content-Type': undefined }
                            }).then(function(data) {
                                console.log("IMGREsPONSE", data)
                                if ($rootScope.UserName == o.username) {
                                    if (data.data.data != null) {
                                        $cookieStore.put('UserImage', data.data.data);
                                        $rootScope.UserImage = $cookieStore.get('UserImage');
                                    }
                                }

                                $scope.myImage = '';
                                $scope.myCroppedImage = '';
                                $scope.apiMedia.removeAll();
                                $scope.GetAllUser(true);
                                $rootScope.FlgAddedEditlocal = false;
                                if ($rootScope.FlgAddedAccess == true) {
                                    $rootScope.FlgAddedEditlocal = true;
                                }

                                $scope.init();
                            }, function(err) {
                                $scope.myImage = '';
                                $scope.myCroppedImage = '';
                                $scope.apiMedia.removeAll();
                                $mdToast.show(
                                    $mdToast.simple()
                                    .textContent(err)
                                    .position('top right')
                                    .hideDelay(3000)
                                );
                                // do sometingh
                            });

                        } else {
                            $rootScope.FlgAddedEditlocal = false;
                            if ($rootScope.FlgAddedAccess == true) {
                                $rootScope.FlgAddedEditlocal = true;
                            }
                            $scope.GetAllUser(true);
                            $scope.init();
                        }
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                    } else {
                        if (data.data.data == 'TOKEN') {
                            //$cookieStore.remove('UserName');
                            //$cookieStore.remove('token');
                            //window.location.href = '/app/login';
                        } else {
                            $mdToast.show(
                                $mdToast.simple()
                                .textContent(data.data.message)
                                .position('top right')
                                .hideDelay(3000)
                            );
                        }
                    }
                });
            } else {
                $mdToast.show(
                    $mdToast.simple()
                    .textContent('Please Select atleast One Role...')
                    .position('top right')
                    .hideDelay(3000)
                );
            }

        }

        //$scope.SaveUserInRole = function (o) {
        //    o.roleId = parseInt(o.roleId);
        //    $http.post($rootScope.RoutePath + "user/SaveUserInRole", o).then(function (data) {
        //        if (data.data.success == true) {
        //            $mdToast.show(
        //                $mdToast.simple()
        //                .textContent(data.data.message)
        //                .position('top right')
        //                .hideDelay(3000)
        //            );
        //            $scope.GetAllUser(true);
        //            $scope.init();
        //        } else {
        //            if (data.data.data == 'TOKEN') {
        //                $cookieStore.remove('UserName');
        //                $cookieStore.remove('token');
        //                window.location.href = '/app/login';
        //            } else {
        //                $mdToast.show(
        //                    $mdToast.simple()
        //                    .textContent(data.data.message)
        //                    .position('top right')
        //                    .hideDelay(3000)
        //                );
        //            }
        //        }
        //    });
        //};


        //Dynamic Pagging
        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function(response) {
            $scope.FilterStatus = 1;
            $scope.dtColumns = [
                DTColumnBuilder.newColumn('createddate').renderWith(NumberHtml).notSortable(),
                DTColumnBuilder.newColumn(null).notSortable().renderWith(ImageHtml),
                DTColumnBuilder.newColumn('username'),
                DTColumnBuilder.newColumn('email'),
                DTColumnBuilder.newColumn('phone'),
                DTColumnBuilder.newColumn(null).notSortable().renderWith(roleHtml),
                DTColumnBuilder.newColumn(null).notSortable().renderWith(actionsHtml)
            ]

            $scope.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
                    url: $rootScope.RoutePath + "user/GetAllDynamicUser",
                    data: function(d) {
                        return d;
                    },
                    type: "get",
                    dataSrc: function(json) {
                        if (json.success != false) {
                            $scope.lstdata = json.data;
                            return json.data;
                        } else {
                            return [];
                        }
                    },
                })
                .withOption('processing', true) //for show progress bar
                .withOption('serverSide', true) // for server side processing
                .withPaginationType('full_numbers') // for get full pagination options // first / last / prev / next and page numbers
                .withDisplayLength(100) // Page size
                .withOption('aaSorting', [0, 'asc'])
                .withOption('responsive', true)
                .withOption('createdRow', createdRow);
        });
        $scope.dtInstance = {};


        //Reload Datatable
        $scope.GetAllUser = function(IsUpdate) {
            var resetPaging = false;
            if (IsUpdate == true) {
                resetPaging = true;
            };
            $scope.dtInstance.reloadData(callback, resetPaging);
            $('#Usertable').dataTable()._fnAjaxUpdate();

        }

        $scope.reloadData = function() {}

        function callback(json) {}

        //compile Datatable And Apply Class
        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }


        function NumberHtml(data, type, full, meta) {
            return (meta.row + 1);
        }

        function roleHtml(data, type, full, meta) {
            var varspan = '';
            if (full.tbluserinroles.length > 0) {
                for (var i = 0; i < full.tbluserinroles.length; i++) {
                    if (i == 0) {
                        varspan = full.tbluserinroles[i].tblrole.RoleName;
                    } else {
                        varspan = varspan + ', ' + full.tbluserinroles[i].tblrole.RoleName;
                    }
                }
            } else {
                varspan = 'N/A';
            }
            return varspan;
        };

        function DateFormateHtml(data, type, full, meta) {
            if (data != null && data != undefined && data != '') {
                return $rootScope.convertdateformat(data);
            } else {
                return 'N/A';
            }
        }

        function ImageHtml(data, type, full, meta) {
            var img = '';
            if (full.image != "") {
                img = '<img ng-src="' + $rootScope.RoutePath + 'MediaUploads/UserUpload/' + full.image + '" err-src="assets/images/default-user.png" height="50px" width="50px">';

            } else if (full.image == "") {
                img = '<img ng-src="assets/images/default-user.png" height="50px" width="50px">';
            }
            return img;
        }


        function actionsHtml(data, type, full, meta) {

            var btns = '<md-button class="md-icon-button md-accent md-raised md-hue-2" ng-if="' + $rootScope.FlgModifiedAccess + '" ng-click="FetchRoleById(' + data.id + ')" aria-label="">' +
                '<md-icon md-font-icon="icon-pencil-box-outline"></md-icon>' +
                '</md-button>';

            btns += '<md-button class="md-raised md-primary" ng-if="' + $rootScope.FlgModifiedAccess + '" ng-click="ResetPassword(' + data.id + ')">Reset Password</md-button>';

            return btns;
        };

        //Dynamic Pagging End


        //Reset Password User By Id
        $scope.ResetPassword = function(id) {
            $scope.obj = _.findWhere($scope.lstdata, { id: id });
            var confirm = $mdDialog.confirm()
                .title('Are you sure to Reset Password of this User ?')
                .ok('Ok')
                .cancel('Cancel')
            $mdDialog.show(confirm).then(function() {
                $http.get($rootScope.RoutePath + "account/forgotpassword?email=" + $scope.obj.email).then(function(data) {
                    if (data.data.success == true) {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                    } else {
                        if (data.data.data == 'TOKEN') {
                            $cookieStore.remove('UserName');
                            $cookieStore.remove('token');
                            $state.go('app.login', {
                                cache: false
                            });
                        } else {
                            $mdToast.show(
                                $mdToast.simple()
                                .textContent(data.data.message)
                                .position('top right')
                                .hideDelay(3000)
                            );
                        }
                    }
                });

            });

        }


        $scope.myImage = '';
        $scope.myCroppedImage = '';

        $scope.setFiles = function() {
            $timeout(function() {

                if ($scope.Mediafiles.length > 0) {
                    $scope.FlgImage = 1;
                    $scope.FlgCropImage = 1;

                    $scope.myImage = $scope.Mediafiles[0].lfDataUrl;


                } else {
                    $scope.myImage = '';

                    if ($scope.model.image != '' && $scope.model.image != null && $scope.model.image != undefined) {
                        $scope.$apply(function() {
                            $scope.myCroppedImage = $rootScope.RoutePath + 'MediaUploads/UserUpload/' + $scope.model.image;
                            $scope.FlgImage = 1;
                        })

                    } else {
                        $scope.$apply(function() {
                            $scope.myCroppedImage = '';
                        })

                        $scope.FlgImage = 0;
                    };


                    $scope.FlgCropImage = 0;
                }
                $scope.removeAllFiles();
            }, 1000);

        };

        // $scope.$watch('Mediafiles', function(newVal) {
        //     console.log(newVal);
        //     console.log($scope.Mediafiles);
        // })

        $scope.removeAllFiles = function() {

            function callMethod(i) {
                if (i < 2) {
                    $timeout(function() {
                        if ($scope.Mediafiles.length > 0) {
                            $scope.FlgImage = 1;
                            $scope.FlgCropImage = 1;

                            $scope.myImage = $scope.Mediafiles[0].lfDataUrl;

                        } else {
                            $scope.myImage = '';

                            if ($scope.model.image != '' && $scope.model.image != null && $scope.model.image != undefined) {
                                $scope.$apply(function() {
                                    $scope.myCroppedImage = $rootScope.RoutePath + 'MediaUploads/UserUpload/' + $scope.model.image;
                                    $scope.FlgImage = 1;
                                })

                                // $('#UploadedImage').attr('src','');
                                //$('#UploadedImage').remove();
                                // $('#UploadedImage')[0].removeAttribute("src");
                                // $('#UploadedImage')[0].src = $scope.myCroppedImage;
                                // document.getElementById("UploadedImage").src = $scope.myCroppedImage;
                                //document.getElementById("UploadedImage").innerHTML = "<img src\= " + $scope.myCroppedImage + " width='150px' />";
                            } else {
                                $scope.$apply(function() {
                                    $scope.myCroppedImage = '';
                                })

                                $scope.FlgImage = 0;
                            };
                            $scope.FlgCropImage = 0;
                            callMethod(i + 1);

                        }
                    });
                };
            }
            callMethod(0);
        }

        function b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;

            var byteCharacters = atob(b64Data);
            var byteArrays = [];

            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);

                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }

            var blob = new Blob(byteArrays, { type: contentType });
            return blob;
        }

        $scope.$watch('myCroppedImage', function(newval) {
            if ($scope.myCroppedImage != '' && $scope.myCroppedImage != $rootScope.RoutePath + 'MediaUploads/UserUpload/' + $scope.model.image && $scope.Mediafiles.length > 0) {
                var image = $scope.myCroppedImage;
                var blob = b64toBlob(image.split(",")[1], $scope.Mediafiles[0].lfFile.type, 512);
                file = new File([blob], $scope.Mediafiles[0].lfFileName, { type: $scope.Mediafiles[0].lfFile.type });
            }
        })

        var file;
        $scope.CropImageToFile = function() {
            if ($scope.myCroppedImage != '' && $scope.myCroppedImage != $rootScope.RoutePath + 'MediaUploads/UserUpload/' + $scope.model.image) {
                var image = $scope.myCroppedImage;
                var blob = b64toBlob(image.split(",")[1], $scope.Mediafiles[0].lfFile.type, 512);
                file = new File([blob], $scope.Mediafiles[0].lfFileName, { type: $scope.Mediafiles[0].lfFile.type });
            }
        }

        $scope.RemoveImage = function() {
            $scope.myImage = '';
            $scope.FlgImage = 0;
        }


        $scope.restForm = function() {
            $scope.AddUserForm.$setUntouched();
            $scope.AddUserForm.$setPristine();
        }

        $scope.ResetEdit = function() {
            if ($rootScope.FlgAddedAccess == true) {
                $scope.model = {
                    id: '',
                    email: '',
                    username: '',
                    phone: '',
                    createdby: 'Admin',
                    createddate: new Date(),
                    modifiedby: '',
                    modifieddate: null,
                    roleId: '',
                    userId: '',
                    country: '',
                    state: '',
                    city: '',
                    gender: '',
                    image: '',
                    IsMobileVerify: false,
                };
                $scope.FlgImage = 0;
                $scope.FlgCropImage = 0;

                $scope.GetAllRoles();
                $scope.restForm();
                $scope.myImage = '';
                $scope.myCroppedImage = '';
                $scope.apiMedia.removeAll();
            }
        }
        $scope.ResetTab = function() {
            if ($rootScope.FlgAddedAccess != true) {
                $scope.FlgAddedEditlocal = false;
            }
        }

        $scope.Reset = function() {
            $rootScope.FlgAddedEditlocal = false;
            if ($rootScope.FlgAddedAccess == true) {
                $rootScope.FlgAddedEditlocal = true;
            }
            $scope.init();
            $scope.myImage = '';
            $scope.myCroppedImage = '';
            $scope.apiMedia.removeAll();

        }

        $scope.init();
    }

})();

(function() {
    'use strict';

    angular
        .module('app.SequenceNumberSetting', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.SequenceNumberSetting', {
                url: '/SequenceNumberSetting',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/SequenceNumberSetting/SequenceNumberSetting.html',
                        controller: 'SequenceNumberSettingController as vm'
                    }
                },
                bodyClass: 'Sequence Number Setting',
                ModuleName: 'Sequence Number Setting'
            });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/MediaSetting');

        // Navigation
        // msNavigationServiceProvider.saveItem('Settings.MediaSetting', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Settings.SequenceNumberSetting', {
        //     title: 'Sequence Number Setting',
        //     state: 'app.SequenceNumberSetting',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.SequenceNumberSetting')
        .controller('SequenceNumberSettingController', SequenceNumberSettingController);

    /** @ngInject */
    function SequenceNumberSettingController($http, $scope, $rootScope, $state, $mdToast, $document, $mdDialog, $stateParams, $cookieStore, DTOptionsBuilder, DTColumnDefBuilder) {
        var vm = this;

        $scope.init = function() {
            $scope.model = {
                Name: '',
                Value: '',
            };
            $scope.GetAllSequenceSetting();
            // $scope.GenerateOrderNumber();
            $scope.tab = { selectedIndex: 0 };
        }

        $scope.GetAllSequenceSetting = function() {
            $http.get($rootScope.RoutePath + "settings/GetAllSequenceSetting").then(function(data) {
                $scope.lstSequenceSetting = [];
                var list=[];
                if (data.data.length == 0) {
                    var obj = new Object();
                    obj.Name = "Customer Account Number";
                    obj.Value = "";

                    $scope.model.Name = "Customer Account Number";
                    $scope.model.Value = "";
                    $scope.lstSequenceSetting.push(obj);
                } else {
                    $scope.lstSequenceSetting = data.data;
                    for (var i = 0; i < $scope.lstSequenceSetting.length; i++) {
                        if ($scope.lstSequenceSetting[i].Name == "Customer Account Number") {
                            $scope.model.Name = $scope.lstSequenceSetting[i].Name;
                            $scope.model.Value = $scope.lstSequenceSetting[i].Value;                            
                        }
                        else{
                            list.push($scope.lstSequenceSetting[i]);
                            $scope.lstSequenceSetting=list;
                        }
                    }
                    
                }
            });
        }

        $scope.CreateSequenceSetting = function(o) {
            $http.post($rootScope.RoutePath + "settings/SaveSequenceSetting", o).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );
                    $scope.init();
                } else {
                    if (data.data.data == 'TOKEN') {
                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                    }
                }
            });
        }

        $scope.pad = function(number, length) {
            var str = '' + number;
            while (str.length < length) {
                str = '0' + str;
            }
            return str;
        }

        $scope.GenerateAccountNumber = function(){
            $http.get($rootScope.RoutePath + "settings/GenerateAccountNumber1").then(function(data) {
                var obj = new Object();
                obj.Name = "LastAccountNumber";
                obj.Value = data.data.data;
                $scope.CreateSequenceSetting(obj);
            })
        }

        // $scope.GenerateMerchantNumber = function() {
        //     var MerchantNumberFormat = "";
        //     var LastMerchantNumberId = 0;

        //     var objLastSequence = _.where($scope.lstSequenceSetting, { Name: "Customer Account Number" });

        //     if (objLastSequence.length != 0) {
        //         LastMerchantNumberId = parseInt(objLastSequence[0].Value);
        //         $scope.model.Name = objLastSequence[0].Name;
        //         $scope.model.Value = (LastMerchantNumberId+1).toString();
        //         // $scope.model.StoreId=0;

        //         $scope.CreateSequenceSetting($scope.model);
        //     } else {
        //         var obj=new Object();
        //         obj.Name = "Customer Account Number";
        //         obj.Value = (LastMerchantNumberId).toString(); 
        //         // obj.StoreId=0;    
        //         $scope.CreateSequenceSetting(obj);
        //     }

        //     var objMerchantNumberFormat = _.where($scope.lstSequenceSetting, { Name: "Customer Account Number" });

        //     if (objMerchantNumberFormat.length != 0) {
        //         objMerchantNumberFormat = objMerchantNumberFormat[0];

        //         if (objMerchantNumberFormat != null) {

        //             var MerchantFormat = objMerchantNumberFormat.Value;

        //             var MerchantFormat1 = "";
        //             var FixChar = "";
        //             var MerchantFormat2 = "";

        //             if (MerchantFormat.indexOf("{") >= 0) {

        //                 var FixCharStartIndex = MerchantFormat.indexOf("{");

        //                 var FixCharEndIndex = MerchantFormat.indexOf("}");

        //                 MerchantFormat1 = MerchantFormat.substring(0, FixCharStartIndex);
        //                 MerchantFormat2 = MerchantFormat.substring(FixCharEndIndex + 1, MerchantFormat.length);

        //                 FixChar = MerchantFormat.substring(FixCharStartIndex + 1, FixCharEndIndex);


        //                 if (MerchantFormat1.indexOf("{") >= 0) {
        //                     var MerchantFormat11 = "";
        //                     var FixChar1 = "";
        //                     var MerchantFormat12 = "";

        //                     var FixCharStartIndex1 = MerchantFormat1.indexOf("{");
        //                     var FixCharEndIndex1 = MerchantFormat1.indexOf("}");

        //                     MerchantFormat11 = MerchantFormat1.substring(0, FixCharStartIndex1);

        //                     MerchantFormat12 = MerchantFormat1.substring(FixCharEndIndex1 + 1, MerchantFormat1.length - (FixCharEndIndex1));

        //                     FixChar1 = MerchantFormat1.substring(FixCharStartIndex1 + 1, FixCharEndIndex1);

        //                     MerchantFormat1 = MerchantFormat11 + FixChar1 + MerchantFormat12;

        //                 }
        //                 if (MerchantFormat2.indexOf("{") >= 0) {
        //                     var MerchantFormat21 = "";
        //                     var FixChar2 = "";
        //                     var MerchantFormat22 = "";

        //                     var FixCharStartIndex2 = MerchantFormat2.indexOf("{");
        //                     var FixCharEndIndex2 = MerchantFormat2.indexOf("}");
        //                     MerchantFormat21 = MerchantFormat2.substring(0, FixCharStartIndex2);
        //                     MerchantFormat22 = MerchantFormat2.substring(FixCharEndIndex2 + 1, MerchantFormat2.length - (FixCharEndIndex2 + 1));
        //                     FixChar2 = MerchantFormat2.substring(FixCharStartIndex2 + 1, FixCharEndIndex2 - (FixCharStartIndex2 + 1));

        //                     MerchantFormat2 = MerchantFormat21 + FixChar2 + MerchantFormat22;
        //                 }


        //             } else {
        //                 MerchantFormat1 = MerchantFormat;
        //             }


        //             var today = new Date();
        //             var D = today.getDate();
        //             var M = today.getMonth() + 1;
        //             var Y = today.getFullYear()

        //             var Date1 = D.toString();
        //             var Month = M.toString();
        //             var Year = Y.toString();

        //             var Year2 = (Y % 100).toFixed(2);
        //             var Year3 = (Y % 1000).toFixed(3);

        //             var Digit = "";

        //             if (D <= 9) {
        //                 Date1 = "0" + Date1;
        //             }
        //             if (M <= 9) {
        //                 Month = "0" + Month;
        //             }

        //             //For MerchantFormate 1
        //             if (MerchantFormat1.indexOf("n") > 0) {
        //                 var numericIndex = MerchantFormat1.indexOf("n");
        //                 var digits = MerchantFormat1[numericIndex - 1];
        //                 Digit = $scope.pad(LastMerchantNumberId+1, digits);
        //             }

            
        //             //Replace date
        //             MerchantFormat1 = MerchantFormat1.replace("dd", Date1).replace("d", D.toString());
        //             //Replace Month
        //             MerchantFormat1 = MerchantFormat1.replace("MM", Month).replace("M", M.toString());
        //             //Replace Year
        //             MerchantFormat1 = MerchantFormat1.replace("yyyy", Year).replace("yyy", Year3).replace("yy", Year2);

        //             if (MerchantFormat1.indexOf("n") > 0) {
        //                 var TempMerchantFormat1 = MerchantFormat1;
        //                 var numericIndex = MerchantFormat1.indexOf("n");
        //                 MerchantFormat1 = TempMerchantFormat1.substring(0, (numericIndex - 1)) + Digit; //+ TempMerchantFormat1.substring(numericIndex + 1, (TempMerchantFormat1.length - (numericIndex + 1)));
        //             }

        //             //For OrderFormate 2
        //             if (MerchantFormat2.indexOf("n") > 0) {
        //                 var numericIndex = MerchantFormat2.indexOf("n");
        //                 var digits = MerchantFormat2[numericIndex - 1];
        //                 Digit = $scope.pad(LastMerchantNumberId+1, digits); //LastMerchantNumberId.toFixed(parseInt(digits));
        //             }

        //             //Replace date
        //             MerchantFormat2 = MerchantFormat2.replace("dd", Date1).replace("d", D.toString());
        //             //Replace Month
        //             MerchantFormat2 = MerchantFormat2.replace("MM", Month).replace("M", M.toString());
        //             //Replace Year
        //             MerchantFormat2 = MerchantFormat2.replace("yyyy", Year).replace("yyy", Year3).replace("yy", Year2);

        //             if (MerchantFormat2.indexOf("n") > 0) {
        //                 var TempMerchantFormat2 = MerchantFormat2;
        //                 var numericIndex = MerchantFormat2.indexOf("n");
        //                 MerchantFormat2 = TempMerchantFormat2.substring(0, (numericIndex - 1)) + Digit; // + TempMerchantFormat2.substring(numericIndex + 1, (TempMerchantFormat2.length - (numericIndex + 1)));
        //             }

        //             MerchantFormat = MerchantFormat1 + FixChar + MerchantFormat2;

        //             console.log(MerchantFormat);
        //         } else {
        //             MerchantFormat = (LastMerchantNumberId+1).toString();

        //         }
        //     }
        // }

        $scope.ResetMerchantNumber = function() {
            $scope.model.Name = "Customer Account Number";
            $scope.model.Value = (1).toString();
            $scope.CreateSequenceSetting($scope.model);
        }

        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0),
            DTColumnDefBuilder.newColumnDef(1),
            DTColumnDefBuilder.newColumnDef(2),
            DTColumnDefBuilder.newColumnDef(3),

        ];

        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function(response) {
            $scope.init();
        })
    }

})();

(function() {
    'use strict';

    angular
        .module('app.salesinfo', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.salesinfo', {
                url: '/salesinfo',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/SalesInfo/SalesInfo.html',
                        controller: 'SalesInfoController as vm'
                    }
                },
                bodyClass: 'Sales Info',
                ModuleName: 'Sales Info'
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/user');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.user', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('customerdevices', {
        //     title: 'Customer Devices',
        //     state: 'app.customerdevices',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.salesinfo')
        .controller('SalesInfoController', SalesInfoController);

    /** @ngInject */
    function SalesInfoController($http, $scope, $state, $rootScope, $location, $anchorScroll, $mdToast, $document, $cookieStore, $mdDialog, $stateParams, DTOptionsBuilder, DTColumnDefBuilder) {

        var vm = this;
        $rootScope.UserName = $cookieStore.get('UserName');
        $rootScope.UserId = $cookieStore.get('UserId');

        $scope.FilterValue = $location.search();

        vm.ZipCodes = [];

        var socket = io($rootScope.RoutePath);
        socket.on('DeviceConnectionStatusUpdate', function(msg) {
            var obj = JSON.parse(msg);
            var objDevice = _.filter($scope.ListOfSales, function(item) {
                if (item.DeviceSerial == obj.MacAddress && item.DeviceType == obj.Type && item.IsActive == true) {
                    return item;
                }
            });
            if (objDevice[0]) {
                $scope.$apply(function() {
                    objDevice[0].Connection_Status = obj.Connection_Status;
                });
            };
        });

        socket.on('DeviceConnectionStatus', function(msg) {
            var obj = JSON.parse(msg);
            var objDevice = _.filter($scope.ListOfSales, function(item) {
                if (item.DeviceSerial == obj.MacAddress && item.CustomerMasterId == obj.CustomerId && item.DeviceType == obj.Type) {
                    return item;
                }
            });
            if (objDevice[0]) {
                $scope.$apply(function() {
                    objDevice[0].Connection_Status = obj.Connection_Status;
                    objDevice[0].IsActive = obj.IsActive;
                });
            };
        });

        $scope.init = function() {
            $scope.model = {
                StartDate: '',
                EndDate: '',
            };
            $scope.SearchField = 'ZipCode';
            $scope.FlagSearch = true;
            if (_.isEmpty($scope.FilterValue) != true) {
                if (Array.isArray($scope.FilterValue.ListZipCode) == true && $scope.FilterValue.ListZipCode != undefined) {
                    vm.ZipCodes = $scope.FilterValue.ListZipCode;
                    $scope.GetSalesInfoByZipCode($scope.FilterValue.ListZipCode);
                } else if (Array.isArray($scope.FilterValue.ListZipCode) == false && $scope.FilterValue.ListZipCode != undefined) {
                    vm.ZipCodes.push($scope.FilterValue.ListZipCode)
                    $scope.GetSalesInfoByZipCode($scope.FilterValue.ListZipCode);
                }

                if ($scope.FilterValue.StartDate != undefined && $scope.FilterValue.EndDate != undefined) {
                    if ($scope.FilterValue.StartDate != "" && $scope.FilterValue.EndDate != "") {
                        $scope.model.StartDate = new Date($scope.FilterValue.StartDate);
                        $scope.model.EndDate = new Date($scope.FilterValue.EndDate);
                    } else if ($scope.FilterValue.StartDate != "" && $scope.FilterValue.EndDate == "") {
                        $scope.model.StartDate = new Date($scope.FilterValue.StartDate);
                        $scope.model.EndDate = '';
                    } else if ($scope.FilterValue.StartDate == "" && $scope.FilterValue.EndDate != "") {
                        $scope.model.StartDate = '';
                        $scope.model.EndDate = new Date($scope.FilterValue.EndDate);
                    }
                    $scope.GetSalesInfoByDate($scope.model);
                }
            }
        }

        $scope.GetSalesInfoByZipCode = function(o) {
            $location.search('ListZipCode', o);
            var params = {
                ListZipCode: o
            }
            $scope.ListOfSales = [];
            $http.get($rootScope.RoutePath + "adminpanel/GetSalesInfoByZipCode", { params: params }).then(function(data) {
                $scope.FlagSearch = false;
                $scope.List = data.data;
                _.filter($scope.List, function(item) {
                    if (item.tbldevice_alarms.length > 0) {
                        for (var i = 0; i < item.tbldevice_alarms.length; i++) {
                            var obj = {
                                CustomerAccountNo: item.CustomerAccountNo,
                                CustomerName: item.Name,
                                DeviceType: 'Alarm',
                                CreatedDate: item.tbldevice_alarms[i].CreatedDate,
                                Connection_Status: item.tbldevice_alarms[i].Connection_Status,
                                DeviceSerial: item.tbldevice_alarms[i].DeviceSerial,
                                IsActive: item.tbldevice_alarms[i].IsActive,
                            }
                            $scope.ListOfSales.push(obj);
                        }
                    }
                    if (item.tbldevice_mats.length > 0) {
                        for (var k = 0; k < item.tbldevice_mats.length; k++) {
                            var obj1 = {
                                CustomerAccountNo: item.CustomerAccountNo,
                                CustomerName: item.Name,
                                DeviceType: 'Mat',
                                CreatedDate: item.tbldevice_mats[k].CreatedDate,
                                Connection_Status: item.tbldevice_mats[k].Connection_Status,
                                DeviceSerial: item.tbldevice_mats[k].DeviceSerial,
                                IsActive: item.tbldevice_mats[k].IsActive,
                            }
                            $scope.ListOfSales.push(obj1);
                        }
                    }
                    if (item.tbldevice_sockets.length > 0) {
                        for (var j = 0; j < item.tbldevice_sockets.length; j++) {
                            var obj2 = {
                                CustomerAccountNo: item.CustomerAccountNo,
                                CustomerName: item.Name,
                                DeviceType: 'Socket',
                                CreatedDate: item.tbldevice_sockets[j].CreatedDate,
                                Connection_Status: item.tbldevice_sockets[j].Connection_Status,
                                DeviceSerial: item.tbldevice_sockets[j].DeviceSerial,
                                IsActive: item.tbldevice_sockets[j].IsActive,
                            }
                            $scope.ListOfSales.push(obj2);
                        }
                    }
                })
            })
        }

        $scope.GetSalesInfoByDate = function(o) {
            $location.search('StartDate', o.StartDate);
            $location.search('EndDate', o.EndDate);
            $scope.ListOfSales = [];
            $http.get($rootScope.RoutePath + "adminpanel/GetSalesInfoByDate", { params: o }).then(function(data) {
                $scope.FlagSearch = false;
                $scope.ListOfSales = _.filter(data.data, function(item) {
                    item.CustomerAccountNo = item.tblcustomermaster.CustomerAccountNo;
                    item.CustomerName = item.tblcustomermaster.Name;
                    return item;
                });
            })
        }

        $scope.ExportSalesInfo = function(date, zipcodes) {
            if (zipcodes != '') {
                window.location = $rootScope.RoutePath + "adminpanel/ExportSalesInfoByZipCode?ListZipCode=" + zipcodes;
            } else {
                window.location = $rootScope.RoutePath + "adminpanel/ExportSalesInfoByDate?StartDate=" + date.StartDate + "&EndDate=" + date.EndDate;
            }

        }

        $scope.dtOptions2 = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withDisplayLength(100)
            .withOption('responsive', true)
            .withOption('autoWidth', false)
            .withOption('searching', false)
            .withOption('paging', true)
            .withOption('info', false)
            .withOption('deferRender', true)
            .withOption('language', {
                'zeroRecords': "No Record Found",
                'emptyTable': "No Record Found"
            })

        $scope.dtColumnDefsDevice = [
            DTColumnDefBuilder.newColumnDef(0).notSortable(),
            DTColumnDefBuilder.newColumnDef(1).notSortable(),
            DTColumnDefBuilder.newColumnDef(2).notSortable(),
            DTColumnDefBuilder.newColumnDef(3).notSortable(),
            DTColumnDefBuilder.newColumnDef(4).notSortable(),
            DTColumnDefBuilder.newColumnDef(5).notSortable(),
            DTColumnDefBuilder.newColumnDef(6).notSortable(),
        ];

        $scope.GoBack = function() {
            if (_.isEmpty($location.search()) != true) {
                $location.search('ListZipCode', null);
                $location.search('StartDate', null);
                $location.search('EndDate', null);
            }
            vm.ZipCodes = [];
            $scope.model = {
                StartDate: '',
                EndDate: '',
            };
            $scope.SearchField = 'ZipCode';
            $scope.FlagSearch = true;
        }

        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function(response) {
            $scope.init();
        })
    }

})();
(function() {
    'use strict';

    angular
        .module('app.roles', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.roles', {
                url: '/roles',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/Roles/Roles.html',
                        controller: 'RolesController as vm'
                    }
                },
                bodyClass: 'Roles',
                ModuleName: 'Roles'
            });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/roles');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.roles', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Users.roles', {
        //     title: 'Roles',
        //     state: 'app.roles',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.roles')
        .controller('RolesController', RolesController);

    /** @ngInject */
    function RolesController($http, $scope, $rootScope, $state, $mdToast, $document, $mdDialog, $cookieStore, $stateParams, DTOptionsBuilder, DTColumnDefBuilder) {

        var vm = this;

        $scope.init = function() {
            // if ($rootScope.FlgAddedAccess == true) {
            //     $scope.FlgAddedEditlocal = true;
            // } else {
            //     $scope.FlgAddedEditlocal = false;
            // }
            $scope.model = {
                RoleName: '',
                Description: '',
                id: '',

            };
            $scope.GetAllRoles();
            $scope.tab = { selectedIndex: 0 };
        }

        $scope.GetAllRoles = function() {
            // Data
            $http.get($rootScope.RoutePath + "role/GetAllRole").then(function(data) {
                $scope.lstRoles = data.data;
            });
        }

        $scope.DeleteRole = function(id, ev) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure to delete this Role?')
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent(ev)
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function() {
                $http.get($rootScope.RoutePath + "role/DeleteRole?idRole=" + id).then(function(data) {
                    if (data.data.success) {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                        $scope.init();
                    } else {
                        if (data.data.data == 'TOKEN') {
                            //$cookieStore.remove('UserName');
                            //$cookieStore.remove('token');
                            //window.location.href = '/app/login';
                            $rootScope.logout();
                        } else {
                            $mdToast.show(
                                $mdToast.simple()
                                .textContent(data.data.message)
                                .position('top right')
                                .hideDelay(3000)
                            );
                        }
                    }
                });
            }, function() {});

        }

        $scope.FetchRoleById = function(o) {
            $rootScope.FlgAddedEditlocal = true;

            $scope.tab.selectedIndex = 1;
            $scope.model.Description = o.Description;
            $scope.model.RoleName = o.RoleName;
            $scope.model.id = o.id;
        }

        $scope.CreateRole = function(o, form) {
            $http.post($rootScope.RoutePath + "role/SaveRole", o).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );
                    $rootScope.FlgAddedEditlocal = false;
                    if ($rootScope.FlgAddedAccess == true) {
                        $rootScope.FlgAddedEditlocal = true
                    }

                    $scope.init();
                } else {
                    if (data.data.data == 'TOKEN') {
                        //$cookieStore.remove('UserName');
                        //$cookieStore.remove('token');
                        //window.location.href = '/app/login';
                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                    }
                }
            });
        };

        // $scope.dtOptions = DTOptionsBuilder.newOptions()
        //     .withPaginationType('full_numbers')
        //     .withDisplayLength(10)
        //     .withOption('responsive', true)
        //     .withOption('autoWidth', true)
        //      .withOption('language', {
        //          'zeroRecords': "No Record Found",
        //          'emptyTable': "No Record Found"
        //      })
        //     .withOption('dom', '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>');
        // .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>');
        $scope.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0),
            DTColumnDefBuilder.newColumnDef(1),

            DTColumnDefBuilder.newColumnDef(2),
            DTColumnDefBuilder.newColumnDef(3).notSortable(),

        ];

        $scope.ResetTab = function() {
            if ($rootScope.FlgAddedAccess != true) {
                $scope.FlgAddedEditlocal = false;
            }
        }

        $scope.ResetEdit = function() {
            if ($rootScope.FlgAddedAccess == true) {

                $scope.FormManageRoles.$setPristine();
                $scope.FormManageRoles.$setUntouched();
                $scope.model = {
                    RoleName: '',
                    Description: '',
                    id: '',

                };
            }
        }
        $scope.Reset = function() {
            $rootScope.FlgAddedEditlocal = false;
            if ($rootScope.FlgAddedAccess == true) {
                $rootScope.FlgAddedEditlocal = true
            }
            $scope.init();
        }
        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function(response) {
            $scope.init();
        })
    }

})();

(function() {
    'use strict';

    angular
        .module('app.Register', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, $httpProvider) {
        // State
        $stateProvider.state('app.Register', {
            url: '/app/Register',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.Register': {
                    templateUrl: 'app/main/Register/Register.html',
                    controller: 'RegisterController as vm'
                }
            },
            bodyClass: 'Register',
            ModuleName: 'Register'
        });

        $httpProvider.interceptors.push(function($q) {
            return {
                'request': function(config) {
                    $('#processing').show();
                    return config;
                },

                'response': function(response) {
                    $('#processing').hide();
                    return response;
                }
            };
        });

        // Translation
        ///$translatePartialLoaderProvider.addPart('app/main/Register');

        // Navigation
        // msNavigationServiceProvider.saveItem('Demo.login', {
        //     title : 'Authentication',
        //     icon  : 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Demo.Register', {
        //     title: 'Register',
        //     state: 'app.Register',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }

})();
(function() {
    'use strict';

    angular
        .module('app.Register')
        .controller('RegisterController', RegisterController);

    /** @ngInject */
    function RegisterController($http, $scope, $rootScope, $state, $mdToast, $document, $cookieStore, $mdDialog, $stateParams, DTOptionsBuilder, DTColumnDefBuilder) {

        $scope.init = function() {
            $scope.model = {
                id: '',
                Type: 'Individual',
                CustomerAccountNo: '',
                EmailAddress: '',
                ContactNo: '',
                Pincode: '',
                Name: '',
                LastName: '',
                Address: '',
                ContactPersonName: '',
                ContactPersionEmail: '',
                ContactPersionMobile: '',
                URL: '',
                CreatedDate: new Date(),
                CreatedBy: '',
                ModifiedDate: '',
                ModifiedBy: '',
                DOB: null,
                Password: '',
                ConfirmPassword: '',
                UniqueNumber: '',
                IsVerify: 0,
                Country: '',
                OrganizationName: '',
                year: '',
                month: '',
                day: '',
                captcha: '',
                TimeZone: '',
            };
            $scope.OTP = "";
            $scope.IsValidOTP = false;
            $scope.flgSendOTP = false;
            $scope.flgResendMail = false;
            $scope.GetAllCountry();
            $scope.GetAllTimeZones();
            $scope.flgValidCaptcha = false;
            $scope.ValidDate = true;
            $scope.days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
            $scope.months = [{ id: 1, name: "January" },
                { id: 2, name: "February" },
                { id: 3, name: "March" },
                { id: 4, name: "April" },
                { id: 5, name: "May" },
                { id: 6, name: "June" },
                { id: 7, name: "July" },
                { id: 8, name: "August" },
                { id: 9, name: "September" },
                { id: 10, name: "October" },
                { id: 11, name: "November" },
                { id: 12, name: "December" }
            ];
            $scope.years = [];
            var d = new Date();
            var lastyear = new Date();
            lastyear.setFullYear(1899);
            for (var i = (d.getFullYear()); i > (lastyear.getFullYear()); i--) {
                $scope.years.push(i);
            }
            // $scope.year = "";
            // $scope.month = "";
            // $scope.day = "";
            $scope.FilterMonth = [];
            $scope.FilterDays = [];
            $scope.DrawCaptcha();
            $scope.errorMessage = false;
            $scope.CaptchaError = false;
            $scope.IsSuceessOtp = false;
            $scope.IsSendOtp = false;
            $scope.OTPErrormessage = false;
            $scope.IsValidEmail = true;
        }


        $scope.GetAllCountry = function() {
            $http.get($rootScope.RoutePath + "customer/GetAllCountry").then(function(data) {
                $scope.lstCountry = data.data;
            });
        }

        $scope.GetAllTimeZones = function() {
            $http.get($rootScope.RoutePath + "customer/GetMobileLanguageData").then(function(data) {
                $scope.lstTimeZones = _.filter(data.data, function(item) {
                    if (item.utc != undefined) {
                        item.TimeZone = item.utc[0];
                        return item;
                    }
                });
            });
        }

        $scope.DrawCaptcha = function() {
            var a = Math.ceil(Math.random() * 9) + '';
            var b = Math.ceil(Math.random() * 9) + '';
            var c = Math.ceil(Math.random() * 9) + '';
            var d = Math.ceil(Math.random() * 9) + '';
            var e = Math.ceil(Math.random() * 9) + '';
            var f = Math.ceil(Math.random() * 9) + '';
            var code = a + ' ' + b + ' ' + ' ' + c + ' ' + d + ' ' + e + ' ' + f;
            $scope.Captcha = code;
        }

        function removeSpaces(string) {
            return string.split(' ').join('');
        }


        $scope.PlayCaptcha = function(captcha) {
            var msg = new SpeechSynthesisUtterance();
            msg.text = captcha;
            speechSynthesis.speak(msg);
        }

        $scope.updateDate = function(input) {
            // if (input == "year") {
            //     $scope.model.month = "";
            //     $scope.model.day = "";
            //     $scope.FilterMonth = [];
            //     $scope.FilterDays = [];
            // } else 
            // if (input == "month") {
            //     $scope.model.day = "";
            //     $scope.FilterDays = [];
            // }
            if ($scope.model.year != '' && $scope.model.month != '' && $scope.model.day != '') {
                $scope.model.DOB = new Date($scope.model.year, $scope.model.month - 1, $scope.model.day, 5, 30);
                if (($scope.model.month == 4 || $scope.model.month == 6 || $scope.model.month == 9 || $scope.model.month == 11) && $scope.model.day >= 31) {
                    $scope.ValidDate = false;
                } else if ($scope.model.month == 2) {
                    if ($scope.model.year % 4 == 0 && $scope.model.day > 29) {
                        $scope.ValidDate = false;
                    } else if ($scope.model.year % 4 != 0 && $scope.model.day > 28) {
                        $scope.ValidDate = false;
                    } else {
                        $scope.ValidDate = true;
                    }
                } else {
                    $scope.ValidDate = true;
                }
            }
        };

        $scope.validMonths = function(year) {
            $scope.FilterMonth = [];
            // var filtered = [];
            var now = new Date();
            var over18Month = now.getUTCMonth() + 1;
            var over18Year = now.getUTCFullYear() - 18;
            if (year != "" && year != undefined) {
                if (year == over18Year) {
                    angular.forEach($scope.months, function(month) {
                        if (month.id <= over18Month) {
                            $scope.FilterMonth.push(month);
                        }
                    });
                } else {
                    angular.forEach($scope.months, function(month) {
                        $scope.FilterMonth.push(month);
                    });
                }
            } else {
                $scope.FilterMonth = [];
            }
        }

        $scope.daysInMonth = function(year, month) {
            $scope.FilterDays = [];
            angular.forEach($scope.days, function(day) {
                if (month != "") {
                    if (month == 1 || month == 3 || month == 5 || month == 7 || month == 8 || month == 10 || month == 12) {
                        $scope.FilterDays.push(day);
                    } else if ((month == 4 || month == 6 || month == 9 || month == 11) && day <= 30) {
                        $scope.FilterDays.push(day);
                    } else if (month == 2) {
                        if (year % 4 == 0 && day <= 29) {
                            $scope.FilterDays.push(day);
                        } else if (day <= 28) {
                            $scope.FilterDays.push(day);
                        }
                    }
                }
            });
        }

        // $scope.GetAllStateByCountry = function(idCountry) {
        //     for (var i = 0; i < $scope.lstCountry.length; i++) {
        //         if ($scope.lstCountry[i].Country == idCountry) {
        //             idCountry = $scope.lstCountry[i].id;
        //         }
        //     }
        //     $scope.model.idState = '';
        //     $scope.lstState = '';
        //     $scope.model.idCity = '';
        //     $scope.lstCity = '';
        //     var params = {
        //         CountryId: idCountry
        //     };
        //     $http.get($rootScope.RoutePath + "state/GetAllStateByCountryId", { params: params }).success(function(data) {
        //         $scope.lstState = data.data;

        //     });
        // }

        // $scope.GetAllCityByState = function(idState) {
        //     for (var i = 0; i < $scope.lstState.length; i++) {
        //         if ($scope.lstState[i].Name == idState) {
        //             idState = $scope.lstState[i].id;
        //         }
        //     }
        //     $scope.model.idCity = '';
        //     $scope.lstCity = '';
        //     var params = {
        //         StateId: idState
        //     };
        //     $http.get($rootScope.RoutePath + "city/GetAllCityByStateId", { params: params }).success(function(data) {
        //         $scope.lstCity = data.data;

        //     });
        // }

        $scope.Register = function(o) {
            o.CreatedBy = o.Name;
            // if (o.Password.length < 6) {
            //     $mdToast.show(
            //         $mdToast.simple()
            //         .textContent("Enter six digit Password.")
            //         .position('top right')
            //         .hideDelay(3000)
            //     );

            //     return;
            // } else if (o.Password != o.ConfirmPassword) {
            //     // $scope.RegisterForm.$setValidity('password-verify', false)
            //     $mdToast.show(
            //         $mdToast.simple()
            //         .textContent("Password and Confirm Password must be same.")
            //         .position('top right')
            //         .hideDelay(3000)
            //     );

            //     return;
            // } else 
            // if ($scope.ValidDate == false) {
            //     $mdToast.show(
            //         $mdToast.simple()
            //         .textContent("Invalid Date of Birth.")
            //         .position('top right')
            //         .hideDelay(3000)
            //     );
            // } else if (o.captcha != removeSpaces($scope.Captcha)) {
            //     $mdToast.show(
            //         $mdToast.simple()
            //         .textContent("Invalid Captcha Code.")
            //         .position('top right')
            //         .hideDelay(3000)
            //     );
            //     o.captcha = '';
            //     $scope.DrawCaptcha();

            if (o.captcha != removeSpaces($scope.Captcha)) {
                $scope.CaptchaError = true;
                o.captcha = '';
                $scope.DrawCaptcha();

            } else {
                // var isValid = document.getElementById("CaptchValid").value;
                // if (isValid == "true") {
                $http.post($rootScope.RoutePath + "account/register", o).success(function(data) {
                    if (data.success == true) {
                        $scope.flgResendMail = true;
                        $scope.Firstname = data.data.Name;
                        $scope.Lastname = data.data.LastName;
                        $scope.emailid = data.data.EmailAddress;
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                        // window.location.href = "/#/app/login";
                        // $scope.init();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                    }
                });
                // } else {
                //     $mdToast.show(
                //         $mdToast.simple()
                //         .textContent("Please verify captcha before register.")
                //         .position('top right')
                //         .hideDelay(3000)
                //     );
                // }
            }
        }

        $scope.CheckEmail = function(email) {
            if (email != '' && email != undefined && email != null) {
                var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
                if (reg.test(email) == true) {
                    var params = {
                        email: email,
                    }
                    $http.get($rootScope.RoutePath + "account/CheckUserEmailExist", { params: params }).success(function(data) {
                        if (data.success == true) {
                            $scope.IsValidEmail = true;
                        } else {
                            $scope.MsgEmail = data.message;
                            $scope.IsValidEmail = false;
                        }
                    });
                }
            }
        }


        $scope.ResendEmail = function() {
            var params = {
                email: $scope.model.EmailAddress,
            }
            $http.get($rootScope.RoutePath + "account/resendEmail", { params: params }).success(function(data) {
                if (data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );
                    // window.location.href = "/#/app/login";
                    // $scope.init();
                } else {
                    $scope.flgSend = false;
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );
                    // window.location.href = "/#/app/login";
                    // $scope.init();
                }
            });
        }

        $scope.Cancel = function() {
            $scope.RegisterForm.$setUntouched();
            $scope.RegisterForm.$setPristine();
            window.location.href = "/#/app/login";
            // $scope.init();
        }

        $scope.VerifyMobileNo = function(MobileNo) {
            $scope.OTP = "";
            $scope.flgSendOTP = false;
            $scope.IsValidOTP = false;
            $scope.model.OTP = "";
            $scope.RegisterForm.OTP.$setUntouched();
            $scope.RegisterForm.OTP.$setPristine();
            var params = {
                MobileNo: MobileNo,
            }
            $http.get($rootScope.RoutePath + "account/SendOTPRegister", { params: params }).success(function(data) {
                if (data.success == true) {
                    $scope.flgSendOTP = true;
                    $scope.OTP = data.data;

                    // $mdToast.show(
                    //   $mdToast.simple()
                    //   .textContent(data.message)
                    //   .position('top right')
                    //   .hideDelay(3000)
                    // );
                    $scope.IsSendOtp = true;
                    $scope.OtpSendMsg = data.message;
                } else {
                    $scope.errorMessage = true;
                    $scope.message = data.message;
                    // $mdToast.show(
                    //     $mdToast.simple()
                    //     .textContent(data.message)
                    //     .position('top right')
                    //     .hideDelay(3000)
                    // );
                }
            });
        }

        $scope.SubmitOTP = function(OTP) {
            if (OTP == $scope.OTP) {
                $scope.IsValidOTP = true;
                // $mdToast.show(
                //   $mdToast.simple()
                //   .textContent("Your OTP is correct, now you can register.")
                //   .position('top right')
                //   .hideDelay(3000)
                // );
                $scope.IsSendOtp = false;
                $scope.IsSuceessOtp = true;
                $scope.Otpmsg = "Your OTP is correct, now you can register.";
            } else {
                $scope.IsSendOtp = false;
                $scope.IsValidOTP = false;
                $scope.IsSuceessOtp = false;
                $scope.OTPErrormessage = true;
                // $mdToast.show(
                //     $mdToast.simple()
                //     .textContent("OTP is incorrect.")
                //     .position('top right')
                //     .hideDelay(3000)
                // );
            }
        }

        $scope.ResetModel = function(o) {
            $scope.RegisterForm.$setUntouched();
            $scope.RegisterForm.$setPristine();
            $scope.model = {
                id: '',
                Type: o,
                CustomerAccountNo: '',
                EmailAddress: '',
                ContactNo: '',
                Pincode: '',
                Name: '',
                LastName: '',
                Address: '',
                ContactPersonName: '',
                ContactPersionEmail: '',
                ContactPersionMobile: '',
                URL: '',
                CreatedDate: new Date(),
                CreatedBy: '',
                ModifiedDate: '',
                ModifiedBy: '',
                DOB: null,
                Password: '',
                ConfirmPassword: '',
                UniqueNumber: '',
                IsVerify: 0,
                Country: '',
                OrganizationName: '',
                year: '',
                month: '',
                day: '',
                captcha: '',
                TimeZone: '',
            };
            $scope.OTP = "";
            $scope.IsValidOTP = false;
            $scope.flgSendOTP = false;
            $scope.flgResendMail = false;
            $scope.flgValidCaptcha = false;
            $scope.ValidDate = true;
            $scope.days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
            $scope.months = [{ id: 1, name: "January" },
                { id: 2, name: "February" },
                { id: 3, name: "March" },
                { id: 4, name: "April" },
                { id: 5, name: "May" },
                { id: 6, name: "June" },
                { id: 7, name: "July" },
                { id: 8, name: "August" },
                { id: 9, name: "September" },
                { id: 10, name: "October" },
                { id: 11, name: "November" },
                { id: 12, name: "December" }
            ];
            $scope.years = [];
            var d = new Date();
            var lastyear = new Date();
            lastyear.setFullYear(1899);
            for (var i = (d.getFullYear()); i > (lastyear.getFullYear()); i--) {
                $scope.years.push(i);
            }
            $scope.FilterMonth = [];
            $scope.FilterDays = [];
            $scope.DrawCaptcha();
            $scope.errorMessage = false;
            $scope.OTPErrormessage = false;
            $scope.CaptchaError = false;
            $scope.IsSuceessOtp = false;
            $scope.IsSendOtp = false;
            $scope.IsValidEmail = true;
        }

        $scope.ShowLogin = function(ev, o) {
            $state.go('app.login');
        }

        $scope.init();
    }

})();
(function() {
    'use strict';

    angular
        .module('app.profiledetails', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.profiledetails', {
                url: '/profiledetails',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/MyProfile/MyProfile.html',
                        controller: 'MyProfileController as vm'
                    }
                },
                bodyClass: 'Profile Details',
                ModuleName: 'Profile Details'
            });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/EmailSetting');

        // Navigation
        // msNavigationServiceProvider.saveItem('Settings.EmailSetting', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('myprofile', {
        //     title: 'My Profile',
        //     state: 'app.myprofile',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.profiledetails')
        .controller('MyProfileController', MyProfileController);


    /** @ngInject */
    function MyProfileController($http, $rootScope, $scope, $state, $mdToast, $document, $mdDialog, $stateParams, $cookieStore, DTOptionsBuilder, DTColumnDefBuilder, $timeout) {
        var vm = this;
        $scope.init = function() {
            $scope.model = {
                id: '',
                Type: '',
                CustomerAccountNo: '',
                EmailAddress: '',
                ContactNo: '',
                ContactNoForVerify: '',
                Pincode: '',
                Name: '',
                LastName: '',
                Address: '',
                ContactPersonName: '',
                ContactPersionEmail: '',
                ContactPersionMobile: '',
                URL: '',
                CreatedDate: new Date(),
                CreatedBy: '',
                ModifiedDate: '',
                ModifiedBy: '',
                DOB: null,
                Password: '',
                UniqueNumber: '',
                IsVerify: '',
                image: '',
                OTP: '',
                Country: '',
                OrganizationName: '',
                year: '',
                month: '',
                day: '',
                TimeZone: '',

            };

            $scope.modelPassword = {
                username: $cookieStore.get('UserName'),
                oldpassword: '',
                password: '',
                confirmpassword: '',
            };

            $scope.GetCustomerProfile($rootScope.UserId);
            $scope.GetAllCountry();
            $scope.GetAllTimeZones();
            $scope.tab = { selectedIndex: 0 };

            $scope.FlgImage = 0;
            $scope.FlgCropImage = 0;
            $scope.flgSendOTP = false;
            $scope.IsValidOTP = false;
            $scope.flgChangeContact = false;
            $scope.changeCnt = 0;

            $scope.ValidDate = true;
            $scope.days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
            $scope.months = [{ id: 1, name: "January" },
                { id: 2, name: "February" },
                { id: 3, name: "March" },
                { id: 4, name: "April" },
                { id: 5, name: "May" },
                { id: 6, name: "June" },
                { id: 7, name: "July" },
                { id: 8, name: "August" },
                { id: 9, name: "September" },
                { id: 10, name: "October" },
                { id: 11, name: "November" },
                { id: 12, name: "December" }
            ];
            $scope.years = [];
            var d = new Date();
            var lastyear = new Date();
            lastyear.setFullYear(1899);
            for (var i = (d.getFullYear()); i > (lastyear.getFullYear()); i--) {
                $scope.years.push(i);
            }
            $scope.FilterMonth = [];
            $scope.FilterDays = [];
        }

        $scope.GetAllCountry = function() {
            $http.get($rootScope.RoutePath + "customer/GetAllCountry").then(function(data) {
                $scope.lstCountry = data.data;
            });
        }

        $scope.GetAllTimeZones = function() {
            $http.get($rootScope.RoutePath + "customer/GetMobileLanguageData").then(function(data) {
                $scope.lstTimeZones = _.filter(data.data, function(item) {
                    if (item.utc != undefined) {
                        item.TimeZone = item.utc[0];
                        return item;
                    }
                });
            });
        }

        $scope.updateDate = function(input) {
            // if (input == "year") {
            //     $scope.model.month = "";
            //     $scope.model.day = "";
            //     $scope.FilterMonth = [];
            //     $scope.FilterDays = [];
            // } else 
            // if (input == "month") {
            //     $scope.model.day = "";
            //     $scope.FilterDays = [];
            // }
            if ($scope.model.year != '' && $scope.model.month != '' && $scope.model.day != '') {
                $scope.model.DOB = new Date($scope.model.year, $scope.model.month - 1, $scope.model.day, 5, 30);
                if (($scope.model.month == 4 || $scope.model.month == 6 || $scope.model.month == 9 || $scope.model.month == 11) && $scope.model.day >= 31) {
                    $scope.ValidDate = false;
                } else if ($scope.model.month == 2) {
                    if ($scope.model.year % 4 == 0 && $scope.model.day > 29) {
                        $scope.ValidDate = false;
                    } else if ($scope.model.year % 4 != 0 && $scope.model.day > 28) {
                        $scope.ValidDate = false;
                    } else {
                        $scope.ValidDate = true;
                    }
                } else {
                    $scope.ValidDate = true;
                }
            }
        };

        $scope.GetCustomerProfile = function(o) {
            var params = {
                id: o
            }
            $http.get($rootScope.RoutePath + "account/GetCustomereById", { params: params }).then(function(data) {
                if (data.data.data != null) {
                    $scope.model.id = data.data.data.id;
                    $scope.model.Type = data.data.data.Type;
                    $scope.model.CustomerAccountNo = data.data.data.CustomerAccountNo;
                    $scope.model.EmailAddress = data.data.data.EmailAddress;
                    $scope.model.ContactNo = data.data.data.ContactNo;
                    $cookieStore.put('ContactNoForVerify', data.data.data.ContactNo);
                    $("#Phone").intlTelInput("setNumber", $scope.model.ContactNo);
                    $scope.model.Pincode = data.data.data.Pincode;
                    $scope.model.Name = data.data.data.Name;
                    $scope.model.LastName = data.data.data.LastName;
                    $scope.model.Address = data.data.data.Address;
                    $scope.model.ContactPersonName = data.data.data.ContactPersonName;
                    $scope.model.ContactPersionEmail = data.data.data.ContactPersionEmail;
                    $scope.model.ContactPersionMobile = data.data.data.ContactPersionMobile;
                    if ($scope.model.ContactPersionMobile != null && $scope.model.ContactPersionMobile != "") {
                        $("#ContactPersionMobile").intlTelInput("setNumber", $scope.model.ContactPersionMobile);
                    }
                    $scope.model.URL = data.data.data.URL;
                    $scope.model.Country = data.data.data.Country;
                    $scope.model.OrganizationName = data.data.data.OrganizationName;
                    $scope.model.DOB = data.data.data.DOB;
                    var d = new Date($scope.model.DOB);
                    $scope.model.month = d.getUTCMonth() + 1;
                    $scope.model.year = d.getFullYear();
                    $scope.model.day = d.getDate();
                    $scope.updateDate();
                    $scope.model.Password = data.data.data.Password;
                    $scope.model.UniqueNumber = data.data.data.UniqueNumber;
                    $scope.model.IsVerify = data.data.data.IsVerify;
                    $scope.model.TimeZone = data.data.data.TimeZone;
                    $scope.model.image = data.data.data.image;
                    $scope.myCroppedImage = $rootScope.RoutePath + 'MediaUploads/UserUpload/' + $scope.model.image;
                    if ($scope.model.image != null && $scope.model.image != '' && $scope.model.image != undefined) {
                        $scope.FlgImage = 1;
                    } else {
                        $scope.FlgImage = 0;
                    }
                    $scope.CountryCode = $scope.model.ContactNo.split(' ')[0];
                }

            });
        }

        $scope.SaveMyProfile = function(o) {
            $scope.Form.$setUntouched();
            $scope.Form.$setPristine();
            if ($scope.FlgImage == 0) {
                o.image = null;

                $cookieStore.put('UserImage', null);
                $rootScope.UserImage = $cookieStore.get('UserImage');
            }
            if ($scope.ValidDate == false) {
                $mdToast.show(
                    $mdToast.simple()
                    .textContent("Invalid Date of Birth.")
                    .position('top right')
                    .hideDelay(3000)
                );
            } else {
                $http.post($rootScope.RoutePath + "account/UpdateCustomer", o).then(function(data) {
                    if (data.data.success == true) {
                        $cookieStore.put('FirstName', null);
                        $cookieStore.put('LastName', null);
                        $cookieStore.put('FirstName', o.Name);
                        $cookieStore.put('LastName', o.LastName);
                        $rootScope.FirstName = $cookieStore.get('FirstName');
                        $rootScope.LastName = $cookieStore.get('LastName');
                        var id;
                        if (o.id != 0) {
                            id = o.id;
                        }
                        if ($scope.Mediafiles.length > 0) {
                            var formData = new FormData();
                            // angular.forEach($scope.Mediafiles, function(d) {
                            formData.append(id, file);
                            // });
                            $http.post($rootScope.RoutePath + "account/uploadImage", formData, {
                                transformRequest: angular.identity,
                                headers: { 'Content-Type': undefined }
                            }).then(function(data) {
                                if ($rootScope.UserName == o.EmailAddress) {
                                    if (data.data.data != null) {
                                        $cookieStore.put('UserImage', data.data.data);
                                        $rootScope.UserImage = $cookieStore.get('UserImage');
                                    }
                                }
                                $scope.IsValidOTP = false;
                                $scope.myImage = '';
                                $scope.myCroppedImage = '';
                                $scope.apiMedia.removeAll();
                                // $scope.GetAllUser(true);
                                $rootScope.FlgAddedEditlocal = false;
                                if ($rootScope.FlgAddedAccess == true) {
                                    $rootScope.FlgAddedEditlocal = true;
                                }

                                $scope.Reset();
                            }, function(err) {
                                $scope.myImage = '';
                                $scope.myCroppedImage = '';
                                $scope.apiMedia.removeAll();
                                $mdToast.show(
                                    $mdToast.simple()
                                    .textContent(err)
                                    .position('top right')
                                    .hideDelay(3000)
                                );
                                // do sometingh
                            });

                        } else {
                            $rootScope.FlgAddedEditlocal = false;
                            if ($rootScope.FlgAddedAccess == true) {
                                $rootScope.FlgAddedEditlocal = true;
                            }
                            // $scope.GetAllUser(true);
                            $scope.Reset();
                        }
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                    } else {
                        if (data.data.data == 'TOKEN') {
                            //$cookieStore.remove('UserName');
                            //$cookieStore.remove('token');
                            //window.location.href = '/app/login';
                        } else {
                            $mdToast.show(
                                $mdToast.simple()
                                .textContent(data.data.message)
                                .position('top right')
                                .hideDelay(3000)
                            );
                            $rootScope.FlgAddedEditlocal = false;
                            $scope.Reset();
                        }
                    }

                });
            }
        }

        $scope.myImage = '';
        $scope.myCroppedImage = '';

        $scope.setFiles = function() {
            $timeout(function() {

                if ($scope.Mediafiles.length > 0) {
                    $scope.FlgImage = 1;
                    $scope.FlgCropImage = 1;

                    $scope.myImage = $scope.Mediafiles[0].lfDataUrl;


                } else {
                    $scope.myImage = '';

                    if ($scope.model.image != '' && $scope.model.image != null && $scope.model.image != undefined) {
                        $scope.$apply(function() {
                            $scope.myCroppedImage = $rootScope.RoutePath + 'MediaUploads/UserUpload/' + $scope.model.image;
                            $scope.FlgImage = 1;
                        })

                    } else {
                        $scope.$apply(function() {
                            $scope.myCroppedImage = '';
                        })

                        $scope.FlgImage = 0;
                    };


                    $scope.FlgCropImage = 0;
                }
                $scope.removeAllFiles();
            }, 1000);

        };

        $scope.removeAllFiles = function() {

            function callMethod(i) {
                if (i < 2) {
                    $timeout(function() {
                        if ($scope.Mediafiles.length > 0) {
                            $scope.FlgImage = 1;
                            $scope.FlgCropImage = 1;

                            $scope.myImage = $scope.Mediafiles[0].lfDataUrl;

                        } else {
                            $scope.myImage = '';

                            if ($scope.model.image != '' && $scope.model.image != null && $scope.model.image != undefined) {
                                $scope.$apply(function() {
                                    $scope.myCroppedImage = $rootScope.RoutePath + 'MediaUploads/UserUpload/' + $scope.model.image;
                                    $scope.FlgImage = 1;
                                })

                                // $('#UploadedImage').attr('src','');
                                //$('#UploadedImage').remove();
                                // $('#UploadedImage')[0].removeAttribute("src");
                                // $('#UploadedImage')[0].src = $scope.myCroppedImage;
                                // document.getElementById("UploadedImage").src = $scope.myCroppedImage;
                                //document.getElementById("UploadedImage").innerHTML = "<img src\= " + $scope.myCroppedImage + " width='150px' />";
                            } else {
                                $scope.$apply(function() {
                                    $scope.myCroppedImage = '';
                                })

                                $scope.FlgImage = 0;
                            };
                            $scope.FlgCropImage = 0;
                            callMethod(i + 1);

                        }
                    });
                };
            }
            callMethod(0);
        }

        function b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;

            var byteCharacters = atob(b64Data);
            var byteArrays = [];

            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);

                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }

            var blob = new Blob(byteArrays, { type: contentType });
            return blob;
        }

        $scope.$watch('myCroppedImage', function(newval) {
            if ($scope.myCroppedImage != '' && $scope.myCroppedImage != $rootScope.RoutePath + 'MediaUploads/UserUpload/' + $scope.model.image && $scope.Mediafiles.length > 0) {
                var image = $scope.myCroppedImage;
                var blob = b64toBlob(image.split(",")[1], $scope.Mediafiles[0].lfFile.type, 512);
                file = new File([blob], $scope.Mediafiles[0].lfFileName, { type: $scope.Mediafiles[0].lfFile.type });
            }
        })

        var file;
        $scope.CropImageToFile = function() {
            if ($scope.myCroppedImage != '' && $scope.myCroppedImage != $rootScope.RoutePath + 'MediaUploads/UserUpload/' + $scope.model.image) {
                var image = $scope.myCroppedImage;
                var blob = b64toBlob(image.split(",")[1], $scope.Mediafiles[0].lfFile.type, 512);
                file = new File([blob], $scope.Mediafiles[0].lfFileName, { type: $scope.Mediafiles[0].lfFile.type });
            }
        }

        $scope.RemoveImage = function() {
            $scope.myImage = '';
            $scope.FlgImage = 0;
        }

        $scope.ChangePassword = function(o) {
            $http.post($rootScope.RoutePath + "account/changepassword", o).then(function(response) {

                if (response.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(response.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );
                    // $scope.GetAllBanner();
                    // $rootScope.FlgAddedEditlocal = false;
                    $scope.Reset();
                } else {
                    if (response.data.data == 'TOKEN') {
                        //$cookieStore.remove('UserName');
                        //$cookieStore.remove('token');
                        //window.location.href = '/app/login';
                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(response.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                    }
                }
            });
        }

        $scope.$watch(function() {
            $("#Phone").on("countrychange", function(e, countryData) {
                $("#hdnPhone").val(countryData.dialCode);
                var code = "+" + countryData.dialCode;
                if ($scope.CountryCode != undefined) {
                    if ($scope.CountryCode == code) {
                        $scope.flgChangeContact = false;
                    } else {
                        $scope.flgChangeContact = true;
                    }
                }
            });
        });

        $scope.ChangeContactNo = function(o, flg) {
            if (o != undefined) {
                if (o.split(" ").join("") != $cookieStore.get('ContactNoForVerify').split(" ").join("") && flg) {
                    $scope.flgChangeContact = true;
                } else {
                    $scope.flgChangeContact = false;
                }
            } else {
                $scope.flgChangeContact = false;
            }
        }

        $scope.VerifyMobileNo = function() {
            $scope.model.ContactNo = document.getElementById("Phone").value;
            $scope.OTP = "";
            $scope.flgSendOTP = false;
            $scope.IsValidOTP = false;
            $scope.model.OTP = "";
            var params = {
                MobileNo: $scope.model.ContactNo,
            }
            $http.get($rootScope.RoutePath + "account/SendOTPRegister", { params: params }).success(function(data) {
                if (data.success == true) {
                    $scope.flgSendOTP = true;
                    $scope.OTP = data.data;

                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );
                } else {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );
                }
            });
        }

        $scope.SubmitOTP = function(OTP) {
            if (OTP == $scope.OTP) {
                $scope.IsValidOTP = true;
                $scope.flgChangeContact = false;
                $mdToast.show(
                    $mdToast.simple()
                    .textContent("Your OTP is correct, now your can update.")
                    .position('top right')
                    .hideDelay(3000)
                );
            } else {
                $scope.IsValidOTP = false;
                $mdToast.show(
                    $mdToast.simple()
                    .textContent("OTP is incorrect.")
                    .position('top right')
                    .hideDelay(3000)
                );
            }
        }

        $scope.Reset = function() {
            $scope.Form.$setUntouched();
            $scope.Form.$setPristine();
            $scope.init();
        }

        $scope.ResetTab = function() {
            $scope.RegisterForm.$setUntouched();
            $scope.RegisterForm.$setPristine();
            if ($rootScope.FlgAddedAccess != true) {
                $scope.FlgAddedEditlocal = false;
            }
        }

        $scope.init();

    }


})();
(function() {
    'use strict';

    angular
        .module('app.Module', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.Module', {
                url: '/Module',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/Module/Module.html',
                        controller: 'ModuleController as vm'
                    }
                },
                bodyClass: 'Manage Module',
                ModuleName: 'Manage Module'
            });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/Module');

        // Navigation
        // msNavigationServiceProvider.saveItem('Module.Module', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        msNavigationServiceProvider.saveItem('Module.Module', {
            title: 'Manage Module',
            state: 'app.Module',
            icon: 'icon-lock',
            weight: 1
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.Module')
        .controller('ModuleController', ModuleController);


    /** @ngInject */
    function ModuleController($http, $scope, $rootScope, $state, $mdToast, $document, $mdDialog, $cookieStore, $stateParams, DTOptionsBuilder, DTColumnDefBuilder) {
        var vm = this;

        $scope.init = function () {
            $scope.model = {
                id: '',
                Module: '',
                IsActive: '',
            };
            $scope.GetAllModule();
            $scope.tab = { selectedIndex: 0 };
        }


        $scope.GetAllModule = function () {
            $http.get($rootScope.RoutePath + "module/GetAllModuleName").then(function (data) {
                $scope.lstModules = data.data;
            });
        }

        $scope.SaveModule = function (o) {
            $http.post($rootScope.RoutePath + "module/UpdateModule", o).then(function (data) {
                if (data.data.success == false) {
                    if (data.data.data == 'TOKEN') {
                        //$cookieStore.remove('UserName');
                        //$cookieStore.remove('token');
                        //window.location.href = '/app/login';
                        $rootScope.logout();
                    }
                }
                $mdToast.show(
                    $mdToast.simple()
                    .textContent(data.data.message)
                    .position('top right')
                    .hideDelay(3000)
                );
                $scope.init();
            });
        }


        $scope.Reset = function () {
            $scope.init();
        }


        //vm.dtOptions = DTOptionsBuilder.newOptions()
        //    .withPaginationType('full_numbers')
        //    .withDisplayLength(10)
        //    .withOption('responsive', true)
        //    .withOption('autoWidth', true)
        //     .withOption('language', {
        //         'zeroRecords': "No Record Found",
        //         'emptyTable': "No Record Found"
        //     })
        //    .withOption('dom', '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>');
        // .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>');
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0),
            DTColumnDefBuilder.newColumnDef(1),
            //DTColumnDefBuilder.newColumnDef(2),
            //DTColumnDefBuilder.newColumnDef(3),
            //DTColumnDefBuilder.newColumnDef(4),
           // DTColumnDefBuilder.newColumnDef(5)
        ];

        $scope.init();
    }

})();

(function() {
    'use strict';

    angular
        .module('app.unlinkeddevices')
        .controller('InactiveDevicesController', InactiveDevicesController);

    /** @ngInject */
    function InactiveDevicesController($http, $scope, $state, $rootScope, $location, $anchorScroll, $mdToast, $document, $cookieStore, $mdDialog, $stateParams, DTOptionsBuilder, DTColumnDefBuilder) {

        var vm = this;
        $rootScope.UserName = $cookieStore.get('UserName');
        $rootScope.UserId = $cookieStore.get('UserId');
        vm.GetAllInavtiveAlarmDevice = GetAllInavtiveAlarmDevice;

        var socket = io($rootScope.RoutePath);
        socket.on('DeviceConnectionStatusUpdate', function(msg) {
            var obj = JSON.parse(msg);

            var objDevice = _.filter($scope.InActiveDeviceList, function(item) {
                if (item.DeviceSerial == obj.MacAddress && item.IsActive == true && item.DeviceType == obj.Type) {
                    return item;
                }
            });

            if (objDevice != '') {
                $scope.$apply(function() {
                    objDevice[0].Connection_Status = obj.Connection_Status;
                });
            };
        });

        socket.on('DeviceConnectionStatus', function(msg) {
            var obj = JSON.parse(msg);
            var objDevice = _.filter($scope.InActiveDeviceList, function(item) {
                if (item.DeviceSerial == obj.MacAddress && item.CustomerMasterId == obj.CustomerId && item.DeviceType == obj.Type) {
                    return item;
                }
            });
            if (objDevice != '') {
                $scope.$apply(function() {
                    objDevice[0].Connection_Status = obj.Connection_Status;
                    objDevice[0].IsActive = obj.IsActive;
                });
            };
        });

        socket.on('AddDevice', function(msg) {
            var obj = JSON.parse(msg);
            if (obj != null && obj.CustomerMasterId == $rootScope.UserId) {
                $scope.$apply(function() {
                    $rootScope.GetAllInavtiveAlarmDevice();
                })
            }
        });
        // socket.emit('dailog', JSON.stringify(Userid));

        $scope.init = function() {
            $scope.model = {};

            $scope.GetUserDevices();
            $scope.GetAllDeviceSetting();
            $scope.GetMatList();
            GetAllInavtiveAlarmDevice();
        }

        $scope.treeOptions = {
            nodeChildren: "children",
            dirSelectable: true,
            injectClasses: {
                ul: "a1",
                li: "a2",
                liSelected: "a7",
                iExpanded: "a3",
                iCollapsed: "a4",
                iLeaf: "a5",
                label: "a6",
                labelSelected: "a8"
            }
        }

        $scope.ChangeFlg = function(o) {
            if (o.EditFlag == false) {
                o.EditFlag = true;
            } else {
                o.EditFlag = false;
            }
        }

        $scope.ShowSetting = function(item) {
            if (item.DeviceType == "Socket") {
                $scope.ShowSocketSetting(item);
            } else if (item.DeviceType = "Alarm") {
                $scope.ShowAlarmSetting(item);
            }
        }

        //Show Socket Setting
        $scope.ShowSocketSetting = function(o) {
            $mdDialog.show({
                skipHide: true,
                controller: 'ScoketSettingController',
                controllerAs: 'vm',
                templateUrl: 'app/main/InactiveDevices/dialogs/SocketSetting/SocketSetting.html',
                parent: angular.element(document.body),
                targetEvent: '',
                clickOutsideToClose: false,
                locals: {
                    objSocket: o,
                    Tasks: [],
                    event: '',
                    InactiveVm: vm,

                }
            })
        }

        //Show Alarm Setting
        $scope.ShowAlarmSetting = function(o) {
            $mdDialog.show({
                skipHide: true,
                controller: 'AlarmSettingController',
                controllerAs: 'vm',
                templateUrl: 'app/main/InactiveDevices/dialogs/AlarmSetting/AlarmSetting.html',
                parent: angular.element(document.body),
                targetEvent: '',
                clickOutsideToClose: false,
                locals: {
                    objAlarm: o,
                    Tasks: [],
                    event: '',
                    InactiveVm: vm,

                }
            })
        }

        $scope.DeleteCustomerDevice = function(o, ev) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure to delete this Customer Device?')
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent(ev)
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function() {
                var params = {
                    DeviceType: o.DeviceType,
                    id: o.id
                }
                $http.get($rootScope.RoutePath + "customerdevices/DeleteCustomerDevice", { params: params }).then(function(data) {
                    if (data.data.success) {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                        $scope.init();
                    } else {
                        if (data.data.data == 'TOKEN') {
                            $rootScope.logout();
                        } else {
                            $mdToast.show(
                                $mdToast.simple()
                                .textContent(data.data.message)
                                .position('top right')
                                .hideDelay(3000)
                            );
                        }
                    }
                });
            }, function() {});
        }

        $scope.UpdateDevice = function(o) {
            $http.post($rootScope.RoutePath + "customerdevices/UpdateDevice", o).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );

                    $rootScope.FlgAddedEditlocal = false;
                    if ($rootScope.FlgAddedAccess == true) {
                        $rootScope.FlgAddedEditlocal = true
                    }
                    GetAllInavtiveAlarmDevice();
                } else {
                    if (data.data.data == 'TOKEN') {

                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                        GetAllInavtiveAlarmDevice();
                    }
                }
            });
        }

        $scope.close = function() {
            $mdDialog.hide();
        };

        $scope.GetMatList = function() {
            $scope.list = [];
            var params = {
                CustomerMasterId: $rootScope.UserId
            }
            $http.get($rootScope.RoutePath + "customerdevices/GetAllMatDeviceByUser", { params: params }).then(function(data) {
                $scope.MatList = data.data.data;
            });
        }

        function GetAllInavtiveAlarmDevice() {
            $scope.InActiveDeviceList = [];
            var params = {
                CustomerMasterId: $rootScope.UserId
            }
            $http.get($rootScope.RoutePath + "customerdevices/GetAllInavtiveAlarmDevice", { params: params }).then(function(data) {
                $scope.AlarmList = _.filter(data.data.data, function(p) {
                    p.DeviceType = "Alarm";
                    p.DisplayType = "Alarm";
                    p.EditFlag = false;
                    return p;
                });
                $scope.InActiveDeviceList = $scope.AlarmList;
                GetAllInavtiveSocketDevice();
            });
        }

        function GetAllInavtiveSocketDevice() {
            var params = {
                CustomerMasterId: $rootScope.UserId
            }
            $http.get($rootScope.RoutePath + "customerdevices/GetAllInavtiveSocketDevice", { params: params }).then(function(data) {
                $scope.SocketList = _.filter(data.data.data, function(q) {
                    q.DeviceType = "Socket";
                    q.DisplayType = "Lamp";
                    q.EditFlag = false;
                    return q;
                });
                if ($scope.SocketList.length > 0) {
                    if ($scope.InActiveDeviceList.length == 0) {
                        $scope.InActiveDeviceList = $scope.SocketList;
                    } else {
                        for (var i = 0; i < $scope.SocketList.length; i++) {
                            $scope.InActiveDeviceList.push($scope.SocketList[i]);
                        }
                    }
                }
            });
        }

        $rootScope.GetAllInavtiveAlarmDevice = function() {
            $scope.InActiveDeviceList = [];
            var params = {
                CustomerMasterId: $rootScope.UserId
            }
            $http.get($rootScope.RoutePath + "customerdevices/GetAllInavtiveAlarmDevice", { params: params }).then(function(data) {
                $scope.AlarmList = _.filter(data.data.data, function(p) {
                    p.DeviceType = "Alarm";
                    p.DisplayType = "Alarm";
                    p.EditFlag = false;
                    return p;
                });
                $scope.InActiveDeviceList = $scope.AlarmList;
                $rootScope.GetAllInavtiveSocketDevice();
            });
        }

        $rootScope.GetAllInavtiveSocketDevice = function() {
            var params = {
                CustomerMasterId: $rootScope.UserId
            }
            $http.get($rootScope.RoutePath + "customerdevices/GetAllInavtiveSocketDevice", { params: params }).then(function(data) {
                $scope.SocketList = _.filter(data.data.data, function(q) {
                    q.DeviceType = "Socket";
                    q.DisplayType = "Lamp";
                    q.EditFlag = false;
                    return q;
                });
                if ($scope.SocketList.length > 0) {
                    if ($scope.InActiveDeviceList.length == 0) {
                        $scope.InActiveDeviceList = $scope.SocketList;
                    } else {
                        for (var i = 0; i < $scope.SocketList.length; i++) {
                            $scope.InActiveDeviceList.push($scope.SocketList[i]);
                        }
                    }
                }
                socket.emit('dailog', JSON.stringify($rootScope.UserId));
            });
        }

        $scope.GetUserDevices = function(o) {

            var params = {
                EmailAddress: $rootScope.UserName
            }
            $http.get($rootScope.RoutePath + "customerdevices/GetAllCustomerDeviceByUser", { params: params }).then(function(data) {
                $rootScope.lstCustomerDevice = data.data;
                socket.emit('dailog', JSON.stringify($rootScope.UserId));
            });
        }

        $scope.GetAllDeviceSetting = function() {
            $http.get($rootScope.RoutePath + "devicesetting_call_sms/GetAllDeviceSetting").then(function(data) {
                $scope.lstDeviceSetting = data.data;
            });
        }

        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function(response) {
            $scope.init();
        })
    }

})();
(function() {
    'use strict';

    angular
        .module('app.Forgotpassword', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.Forgotpassword', {
            url: '/app/Forgotpassword',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.Forgotpassword': {
                    templateUrl: 'app/main/Forgotpassword/Forgotpassword.html',
                    controller: 'ForgotpasswordController as vm'
                }
            },
            bodyClass: 'Forgotpassword',
            ModuleName: 'Forgotpassword'
        });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/Forgotpassword');

        // Navigation
        // msNavigationServiceProvider.saveItem('Demo.login', {
        //     title : 'Authentication',
        //     icon  : 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Demo.Forgotpassword', {
        //     title: 'Login',
        //     state: 'app.Forgotpassword',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }

})();

(function() {
    'use strict';

    angular
        .module('app.Forgotpassword')
        .controller('ForgotpasswordController', ForgotpasswordController);

    /** @ngInject */
    function ForgotpasswordController($scope, $state, $rootScope, $http, $cookieStore, $mdDialog, $document, $mdToast, $timeout) {
        $scope.init = function() {
            $scope.model = {
                EmailAddress: '',
                ContactNo: '',
                OTP: ''
            }
            $scope.VerifyWith = "Email";
            $scope.IsActive = true;
            $scope.flgSendOTP = false;
            $scope.IsValidOTP = false;
            $scope.EmailErrorMessage = false;
            $scope.MobileErrorMessage = false;
            $scope.OTPErrorMessage = false;
        }

        $scope.ResetPassword = function() {
            var EmailAddress = $scope.model.EmailAddress;
            $http.get($rootScope.RoutePath + "account/forgotpassword?email=" + EmailAddress.toLowerCase()).then(function(response) {
                if (response.data.success == true) {
                    $scope.IsActive = false;
                    $scope.Firstname = response.data.data.Name;
                    $scope.Lastname = response.data.data.LastName;
                    $scope.emailid = response.data.data.EmailAddress;
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(response.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );
                    //$scope.model.EmailAddress = '';
                    // $timeout(function() {
                    //     $state.go('app.login', {
                    //         cache: false
                    //     });
                    // }, 1500);                    
                } else {
                    if (response.data.data == 'TOKEN') {
                        $cookieStore.remove('UserName');
                        $cookieStore.remove('token');
                    } else {
                        $scope.EmailErrorMessage = true;
                        // $mdToast.show(
                        //     $mdToast.simple()
                        //     .textContent(response.data.message)
                        //     .position('top right')
                        //     .hideDelay(3000)
                        // );
                    }
                }
                // $scope.IsActive = false;
            });
        }

        $scope.ResendPassword = function() {
            var EmailAddress = $scope.model.EmailAddress;
            $scope.IsActive = false;
            $http.get($rootScope.RoutePath + "account/forgotpassword?email=" + EmailAddress.toLowerCase()).then(function(response) {
                if (response.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(response.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );
                    // $scope.model.EmailAddress = '';
                    // $timeout(function() {
                    //     $state.go('app.login', {
                    //         cache: false
                    //     });
                    // }, 1500);
                    //$scope.IsActive = false;
                } else {
                    if (response.data.data == 'TOKEN') {
                        $cookieStore.remove('UserName');
                        $cookieStore.remove('token');
                        $scope.IsActive = false;
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(response.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                    }
                    // $scope.model.EmailAddress = '';
                    // $timeout(function() {
                    //     $state.go('app.login', {
                    //         cache: false
                    //     });
                    // }, 1500);
                }
            });
        }

        $scope.VerifyMobileNo = function(MobileNo) {
            // $scope.OTPForm.OTP.$setUntouched();
            // $scope.OTPForm.OTP.$setPristine();
            var params = {
                MobileNo: MobileNo,
            }
            $http.get($rootScope.RoutePath + "account/SendOTPForgotPwd", { params: params }).success(function(data) {
                if (data.success == true) {
                    $scope.flgSendOTP = true;
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );
                } else {
                    $scope.MobileErrorMessage = true;
                    // $mdToast.show(
                    //     $mdToast.simple()
                    //     .textContent(data.message)
                    //     .position('top right')
                    //     .hideDelay(3000)
                    // );
                }
            });
        }

        $scope.SubmitOTP = function(OTP, MobileNo) {
            var params = {
                MobileNo: MobileNo,
                OTP: OTP,
            }
            $http.get($rootScope.RoutePath + "account/SubmitOTPForgotPwd", { params: params }).success(function(data) {
                if (data.success == true) {
                    window.location.href = data.link;
                } else {
                    $scope.OTPErrorMessage = true;
                    // $mdToast.show(
                    //     $mdToast.simple()
                    //     .textContent(data.message)
                    //     .position('top right')
                    //     .hideDelay(3000)
                    // );
                }
            });
        }

        $scope.ChangeErrorMessageFlag = function() {
            $scope.EmailErrorMessage = false;
        }

        $scope.init();
    }
})();
(function() {
    'use strict';

    angular
        .module('app.firmwareupgrade')
        .controller('FirmwareUpgradeController', FirmwareUpgradeController);

    /** @ngInject */
    function FirmwareUpgradeController($http, $scope, $state, $rootScope, $mdToast, $document, $cookieStore, $mdDialog, $stateParams, DTOptionsBuilder, DTColumnDefBuilder, $interval, $timeout) {

        var vm = this;
        vm.Upgrade = Upgrade;

        var j = 0;
        var counter = 0;
        vm.mode = 'query';
        vm.activated = true;
        vm.determinateValue = 30;
        vm.determinateValue2 = 30;
        vm.showList = [];

        var socket = io($rootScope.RoutePath);
        socket.on('DeviceConnectionStatusUpdate', function(msg) {
            var obj = JSON.parse(msg);
            if (obj.Type == "Socket") {
                obj.Type = "Lamp"
            }
            var objDevice = _.filter($scope.lstDevice, function(item) {
                if (item.DeviceSerial == obj.MacAddress && $scope.model.DeviceType == obj.Type && item.IsActive == true) {
                    return item;
                }
            });
            if (objDevice[0]) {
                $scope.$apply(function() {
                    objDevice[0].Connection_Status = obj.Connection_Status;
                });
            };
        });

        socket.on('DeviceConnectionStatus', function(msg) {
            var obj = JSON.parse(msg);
            if (obj.Type == "Socket") {
                obj.Type = "Lamp"
            }
            var objDevice = _.filter($scope.lstDevice, function(item) {
                if (item.DeviceSerial == obj.MacAddress && item.CustomerMasterId == obj.CustomerId && item.DeviceType == $scope.model.DeviceType) {
                    return item;
                }
            });
            if (objDevice[0]) {
                $scope.$apply(function() {
                    objDevice[0].Connection_Status = obj.Connection_Status;
                    objDevice[0].IsActive = obj.IsActive;
                });
            };
        });

        $scope.init = function() {
            $scope.model = {
                DeviceType: 'Mat',
            };
            $scope.IsSocketCall = true;
            $scope.GetAllDevice($scope.model.DeviceType);
            $scope.tab = { selectedIndex: 0 };
        }

        $scope.toggle1 = function(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        };

        $scope.exists1 = function(item, list) {
            return list.indexOf(item) > -1;
        };

        $scope.OpenProgressModal = function(ev, lst) {
            $mdDialog.show({
                controller: 'ProgressModalUpgradeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/FirmwareUpgrade/dialogs/ProgressModal/ProgressModal.html',
                targetEvent: ev,
                clickOutsideToClose: false,
                locals: {
                    event: ev,
                    socket: socket,
                    lstDevice: lst,
                }
            })
        }

        $scope.closeModal = function() {
            $mdDialog.hide();
        };

        /**
         * Turn off or on the 5 themed loaders
         */
        vm.toggleActivation = function() {
            if (!self.activated) self.showList = [];
            if (self.activated) {
                j = counter = 0;
                self.determinateValue = 30;
                self.determinateValue2 = 30;
            }
        };

        $interval(function() {
            vm.determinateValue += 1;
            vm.determinateValue2 += 1.5;
            if (vm.determinateValue > 100) vm.determinateValue = 30;
            if (vm.determinateValue2 > 100) vm.determinateValue2 = 30;

            // Incrementally start animation the five (5) Indeterminate,
            // themed progress circular bars
            if ((j < 2) && !vm.showList[j] && vm.activated) {
                vm.showList[j] = true;
            }
            if (counter++ % 4 == 0) j++;
            // Show the indicator in the "Used within Containers" after 200ms delay
            if (j == 2) vm.contained = "indeterminate";
        }, 100, 0, true);

        $interval(function() {
            vm.mode = (vm.mode == 'query' ? 'determinate' : 'query');
        }, 7200, 0, true);

        $scope.GetAllDevice = function(o) {
            var params = {
                DeviceType: o,
            }
            $http.get($rootScope.RoutePath + "firmwareupgrade/GetAllDeviceTypeDetailByDevice", { params: params }).then(function(data) {
                $scope.lstDevice = data.data;

                for (var i = 0; i < $scope.lstDevice.length; i++) {
                    $scope.lstDevice[i].checked = false;
                };

                $scope.selected = [];
                $scope.toggle = function(item, list) {
                    var idx = list.indexOf(item);
                    if (idx > -1) {
                        list.splice(idx, 1);
                    } else {
                        list.push(item);
                    }
                };

                $scope.exists = function(item, list) {
                    return list.indexOf(item) > -1;
                };

                $scope.isIndeterminate = function() {
                    return ($scope.selected.length !== 0 && $scope.selected.length !== $scope.lstRCU.length);
                };

                $scope.isChecked = function() {
                    return $scope.selected.length === $scope.lstDevice.length;
                };

                $scope.toggleAll = function() {
                    if ($scope.selected.length === $scope.lstDevice.length) {
                        $scope.selected = [];
                    } else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
                        $scope.selected = $scope.lstDevice.slice(0);
                    }
                };
            });
        };

        //Open File
        $scope.OpenFile = function() {
            $mdDialog.show({
                skipHide: true,
                controller: 'FileListController',
                controllerAs: 'vm',
                templateUrl: 'app/main/FirmwareUpgrade/dialogs/FileList/FileList.html',
                parent: angular.element(document.body),
                targetEvent: '',
                clickOutsideToClose: true,
                locals: {
                    DeviceType: $scope.model.DeviceType,
                    Tasks: [],
                    event: '',
                    UpgradeVm: vm,
                }
            })
        }

        function Upgrade(obj1) {
            var fixButtons = function() {
                var foundCancelButton = false;
                var $dialog = angular.element(document.querySelector('md-dialog'));
                var $actionsSection = $dialog.find('md-dialog-actions');
                var $cancelButton = $actionsSection.children()[0];
                var $confirmButton = $actionsSection.children()[1];
                angular.element($confirmButton).addClass('md-raised md-warn');
                if ($cancelButton) {
                    foundCancelButton = true;
                    angular.element($cancelButton).addClass('md-raised');
                }
                return foundCancelButton;
            }

            var confirm = $mdDialog.confirm({
                    onShowing: function onShowAnimation() {
                        if (!fixButtons()) {
                            $timeout(function() {
                                fixButtons();
                            });
                        }
                    },
                    onComplete: function afterShowAnimation() {
                        fixButtons();
                    }
                })
                .title('Are You sure want to upgrade ? Improper steps might loss Device permanently.')
                .ariaLabel('Lucky day')
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function() {
                var o = _.where($scope.lstDevice, { checked: true });

                $scope.OpenProgressModal('', o);

                var formData = {
                    DeviceList: o,
                    Filename: obj1,
                    DeviceType: $scope.model.DeviceType,
                }

                $http.post($rootScope.RoutePath + "firmwareupgrade/UpgradeByDeviceType", formData).then(function(data) {
                    if (data.data.success) {
                        // $mdToast.show(
                        //     $mdToast.simple()
                        //     .textContent(data.data.message)
                        //     .position('top right')
                        //     .hideDelay(3000)
                        // );

                        $scope.closeModal();
                        $scope.init();
                    } else {
                        // var lstUpgradedDevice = data.data.data;
                        // for (var i = 0; i < lstUpgradedDevice.length; i++) {
                        //     var DeviceId = parseInt(lstUpgradedDevice[i]);
                        //     var obj = _.findWhere($scope.lstDevice, { id: DeviceId });
                        //     obj.checked = false;
                        // };
                        $scope.closeModal();

                        if (data.data.data == 'TOKEN') {
                            $rootScope.logout();
                        } else {
                            // $mdToast.show(
                            //     $mdToast.simple()
                            //     .textContent(lstUpgradedDevice.length + ' out of ' + o.length + ' Device Upgraded Successfully.')
                            //     .position('top right')
                            //     .hideDelay(3000)
                            // );
                        }

                    }
                });
            }, function() {});
        }

        $scope.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0),
            DTColumnDefBuilder.newColumnDef(1),
            DTColumnDefBuilder.newColumnDef(2),
            DTColumnDefBuilder.newColumnDef(3),
            DTColumnDefBuilder.newColumnDef(4),
            DTColumnDefBuilder.newColumnDef(5).notSortable(),
        ];

        $scope.restForm = function() {
            $scope.model = {
                DeviceType: 'Mat',
            };
        }

        $scope.ResetTab = function() {
            if ($rootScope.FlgAddedAccess != true) {
                $scope.FlgAddedEditlocal = false;
            }
        }

        $scope.Reset = function() {
            $rootScope.FlgAddedEditlocal = false;
            if ($rootScope.FlgAddedAccess == true) {
                $rootScope.FlgAddedEditlocal = true
            }
            $scope.init();
        }

        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function(response) {
            $scope.init();
        })
    }

})();
(function() {
    'use strict';

    angular
        .module('app.devicesetting_call_sms')
        .controller('DeviceSetting_Call_SmsController', DeviceSetting_Call_SmsController);

    /** @ngInject */
    function DeviceSetting_Call_SmsController($http, $scope, $rootScope, $state, $q, $timeout, $mdToast, $document, $mdDialog, $cookieStore, $stateParams, DTOptionsBuilder, DTColumnDefBuilder, DTColumnBuilder, $compile) {

        var vm = this;

        $scope.init = function() {
            $scope.modelSearch = {
                CustomerMasterId: $state.params.id,
            }
            // $scope.GetAllCustomer();
        }

        // $scope.GetAllCustomer = function() {
        //     $http.get($rootScope.RoutePath + "customer/GetAllUser").then(function(data) {
        //         $scope.lstCustomer = data.data;
        //     });
        // }
        //Dynamic Pagging
        
        $scope.FilterStatus = 1;
        $scope.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable().renderWith(NumberHtml),
            DTColumnBuilder.newColumn('tblcustomerdevice.DeviceName'),
            DTColumnBuilder.newColumn('Type'),
            DTColumnBuilder.newColumn('MobileNo'),
            DTColumnBuilder.newColumn('Email'),
            DTColumnBuilder.newColumn('Event_Scheduler_StartTime'),
            DTColumnBuilder.newColumn('Event_Scheduler_EndTime'),
            DTColumnBuilder.newColumn('Alert_Scheduler_StartTime'),
            DTColumnBuilder.newColumn('Alert_Scheduler_Endtime'),
            DTColumnBuilder.newColumn('tblcustomerdevice.DeviceName'),
            DTColumnBuilder.newColumn(null).notSortable().renderWith(actionsHtml)
        ]

        $scope.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
                url: $rootScope.RoutePath + "devicesetting_call_sms/GetAllDynamicDeviceSetting",
                data: function(d) {
                    return d;
                },
                type: "get",
                dataSrc: function(json) {
                    if (json.success != false) {
                        $scope.lstdata = json.data;
                        return json.data;
                    } else {
                        return [];
                    }
                },
            })
            .withOption('processing', true) //for show progress bar
            .withOption('serverSide', true) // for server side processing
            .withPaginationType('full_numbers') // for get full pagination options // first / last / prev / next and page numbers
            .withDisplayLength(10) // Page size
            .withOption('aaSorting', [1, 'asc'])
            .withOption('responsive', true)
            .withOption('createdRow', createdRow);

        $scope.dtInstance = {};


        //Reload Datatable
        $scope.GetAllDeviceSetting = function(IsUpdate) {
            var resetPaging = false;
            if (IsUpdate == true) {
                resetPaging = true;
            };
            $scope.dtInstance.reloadData(callback, resetPaging);
        }

        $scope.reloadData = function() {}

        function callback(json) {}

        //compile Datatable And Apply Class
        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }


        function NumberHtml(data, type, full, meta) {
            return (meta.row + 1);
        }

        function Verified(data, type, full, meta) {
            var Flg;
            if (data == true) {
                Flg = '<i class="icon-checkbox-marked-circle green-500-fg"></i>';
            } else {
                Flg = '<i class="icon-cancel red-500-fg"></i>';
            }
            return Flg;

        }

        function actionsHtml(data, type, full, meta) {
            var btns = '<md-button class="md-accent md-raised md-hue-2" ng-click="ShowDeviceModal($event,' + data.id + ')" aria-label="">Detail</md-button>';
            // btns += '<md-button class="md-accent md-raised md-hue-2" ng-click="ResendOTP(' + data.id + ')">Resend OTP</md-button>';
            // btns += '<md-button class="md-raised md-primary" ng-click="ResetPassword(' + data.id + ')">Reset Password</md-button>';

            return btns;
        };


        //show User Devices
        $scope.ShowDeviceModal = function(ev, id) {
            $scope.obj = _.findWhere($scope.lstdata, { id: id });
            $mdDialog.show({
                controller: 'EventListController',
                controllerAs: 'vm',
                templateUrl: 'app/main/DeviceSetting_Call_Sms/dialogs/EventList/EventList.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    objUser: $scope.obj,
                    Tasks: [],
                    event: ev,

                }
            })
        }


        //Dynamic Pagging End

        $scope.init();
    }
})();

(function() {
    'use strict';

    angular
        .module('app.devicedetail')
        .controller('DeviceDetailController', DeviceDetailController);

    /** @ngInject */
    function DeviceDetailController($http, $scope, $rootScope, $state, $q, $timeout, $mdToast, $document, $mdDialog, $cookieStore, $stateParams, DTOptionsBuilder, DTColumnDefBuilder, DTColumnBuilder, $compile) {

        var vm = this;

        $scope.init = function() {
            $scope.modelSearch = {
                CustomerMasterId: $state.params.id,
            }
            $scope.GetAllCustomer();
            $scope.GetAllDeviceSetting();
        }

        $scope.GetAllCustomer = function() {
            $http.get($rootScope.RoutePath + "customer/GetAllUser").then(function(data) {
                $scope.lstCustomer = data.data;
            });
        }

        $scope.GetAllDeviceSetting = function() {
                $http.get($rootScope.RoutePath + "devicesetting_call_sms/GetAllDeviceSetting").then(function(data) {
                    $scope.lstDeviceSetting = data.data;
                });
            }
            //Dynamic Pagging

        $scope.FilterStatus = 1;
        $scope.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable().renderWith(NumberHtml),
            DTColumnBuilder.newColumn('tblcustomermaster.Name'),
            DTColumnBuilder.newColumn('DeviceType'),
            DTColumnBuilder.newColumn('DeviceName'),
            DTColumnBuilder.newColumn('DeviceSerial'),
            // DTColumnBuilder.newColumn('Country'),
            // DTColumnBuilder.newColumn('Type'),
            DTColumnBuilder.newColumn(null).notSortable().renderWith(actionsHtml)
        ]

        $scope.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
                url: $rootScope.RoutePath + "customerdevices/GetAllDynamicCustomerDevice",
                data: function(d) {
                    d.CustomerMasterId = $scope.modelSearch.CustomerMasterId;
                    return d;
                },
                type: "get",
                dataSrc: function(json) {
                    if (json.success != false) {
                        $scope.lstdata = json.data;
                        return json.data;
                    } else {
                        return [];
                    }
                },
            })
            .withOption('processing', true) //for show progress bar
            .withOption('serverSide', true) // for server side processing
            .withOption('responsive', true)
            .withOption('autoWidth', false)
            .withPaginationType('full_numbers') // for get full pagination options // first / last / prev / next and page numbers
            .withDisplayLength(10) // Page size
            .withOption('aaSorting', [1, 'asc'])
            .withOption('createdRow', createdRow);

        $scope.dtInstance = {};


        //Reload Datatable
        $scope.GetAllUser = function(status, IsUpdate) {
            var resetPaging = false;
            if (IsUpdate == true) {
                resetPaging = true;
            };
            $scope.dtInstance.reloadData(callback, resetPaging);
            $('#DeviceDetailtable').dataTable()._fnAjaxUpdate();
        }

        $scope.reloadData = function() {}

        function callback(json) {}

        //compile Datatable And Apply Class
        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }


        function NumberHtml(data, type, full, meta) {
            return (meta.row + 1);
        }

        function Verified(data, type, full, meta) {
            var Flg;
            if (data == true) {
                Flg = '<i class="icon-checkbox-marked-circle green-500-fg"></i>';
            } else {
                Flg = '<i class="icon-cancel red-500-fg"></i>';
            }
            return Flg;

        }

        function actionsHtml(data, type, full, meta) {
            var btns = '<md-button class="md-accent md-raised md-hue-2" ng-click="ShowDeviceModal($event,' + data.id + ')" aria-label="">Device</md-button>';
            if (data.DeviceType == 'CallSMS') {
                btns += '<md-button class="md-accent md-raised md-hue-2" ng-click="ShowEventList($event,' + data.id + ')">Event List</md-button>';
            }
            // btns += '<md-button class="md-raised md-primary" ng-click="ResetPassword(' + data.id + ')">Reset Password</md-button>';
            return btns;
        };


        //show User Devices
        $scope.ShowDeviceModal = function(ev, id) {
            $scope.obj = _.findWhere($scope.lstdata, { id: id });
            $mdDialog.show({
                controller: 'DeviceTypeDetailController',
                controllerAs: 'vm',
                templateUrl: 'app/main/DeviceDetail/dialogs/DeviceTypeDetail/DeviceTypeDetail.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    objUser: $scope.obj,
                    Tasks: [],
                    event: ev,

                }
            })
        }

        //show Event List
        $scope.ShowEventList = function(ev, id) {
            $scope.obj = _.findWhere($scope.lstDeviceSetting, { CustomerDeviceId: id });
            $mdDialog.show({
                controller: 'EventListController',
                controllerAs: 'vm',
                templateUrl: 'app/main/DeviceDetail/dialogs/EventList/EventList.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    objUser: $scope.obj,
                    Tasks: [],
                    event: ev,

                }
            })
        }


        //Dynamic Pagging End

        $scope.init();
    }
})();

(function() {
    'use strict';

    angular
        .module('app.customerservice')
        .controller('CustomerServiceController', CustomerServiceController);

    /** @ngInject */
    function CustomerServiceController($http, $scope, $state, $rootScope, $location, $anchorScroll, $mdToast, $document, $cookieStore, $mdDialog, $stateParams, DTOptionsBuilder, DTColumnDefBuilder, $filter, $q, $timeout, DTColumnBuilder, $compile) {

        var vm = this;
        $rootScope.UserName = $cookieStore.get('UserName');
        $rootScope.UserId = $cookieStore.get('UserId');
        vm.GetAllDeviceByCustomerId = GetAllDeviceByCustomerId;

        vm.states = GetAllUser();
        vm.selectedItem = null;
        vm.searchText = null;
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;

        $scope.FilterValue = $location.search();

        var socket = io($rootScope.RoutePath);

        socket.on('DeviceLiveLog', function(msg) {
            var obj = JSON.parse(msg);
            if ($scope.UserInfo != undefined && $scope.UserInfo != '' && $scope.UserInfo != null) {
                if (obj.CustomerMasterId == $scope.UserInfo.id) {
                    obj.TimeStamp = moment.tz(obj.TimeStamp, $scope.UserInfo.TimeZone).format('hh:mm a DD-MM-YYYY');
                    var t = $('#CustomerService').DataTable();
                    // t.row.add([null,
                    //     obj.DeviceName,
                    //     obj.Event,
                    //     obj.TimeStamp
                    // ]).draw(false);
                    t.row.add(obj).draw(false);
                    $scope.LstLiveLog.push(obj);
                }
            }
        });

        $scope.init = function() {
            $scope.model = {
                CustomerUnq_Id: '',
                MobileNo: '',
                CustomerName: '',
                EmailAddress: '',
            };
            $scope.FlagSearch = true;
            $scope.tab = { selectedIndex: 0 };
            if (_.isEmpty($scope.FilterValue) != true) {
                if ($scope.FilterValue.CustomerUnq_Id != undefined) {
                    $scope.model.CustomerUnq_Id = $scope.FilterValue.CustomerUnq_Id;
                } else if ($scope.FilterValue.MobileNo != undefined) {
                    $scope.model.MobileNo = $scope.FilterValue.MobileNo;
                } else if ($scope.FilterValue.CustomerName != undefined) {
                    $scope.model.CustomerName = $scope.FilterValue.CustomerName;
                } else if ($scope.FilterValue.EmailAddress != undefined) {
                    $scope.model.EmailAddress = $scope.FilterValue.EmailAddress;
                }
                $scope.GetCustomerDetail($scope.model);
            }
            // $scope.GetAllUser();
        }

        /**
         * Search for User... use $timeout to simulate
         * remote dataservice call.
         */
        function querySearch(query) {
            var results = query ? $scope.List.filter(createFilterFor(query)) : $scope.List,
                deferred;
            return results;
            // var deferred = $q.defer();
            // $timeout(function() { deferred.resolve(results); }, Math.random() * 1000, false);
            // return deferred.promise;
        }
        /**
         * Create filter function for a query string
         */
        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(state) {
                return (state.value.indexOf(lowercaseQuery) === 0);
            };
        }

        function selectedItemChange(item) {
            if (item != undefined) {
                $scope.model.CustomerName = item.display;
            } else {
                $scope.model.CustomerName = '';
            }
        }

        function searchTextChange(text) {
            $scope.model.CustomerUnq_Id = '';
            $scope.model.MobileNo = '';
            $scope.model.EmailAddress = '';
        }

        function GetAllUser() {
            $http.get($rootScope.RoutePath + 'adminpanel/GetAllCustomer').then(function(data) {
                $scope.CustomerList = data.data;
                $scope.List = [];
                _.filter($scope.CustomerList, function(item) {
                    var obj = {
                        value: (item.Name).toLowerCase(),
                        display: item.Name
                    }
                    $scope.List.push(obj);
                })
            })
        }

        $scope.ChangeCustomerName = function() {
            vm.selectedItem = null;
            vm.searchText = null;
            $scope.model.CustomerName = '';
        }

        $scope.GetCustomerDetail = function(o) {
            if (o.CustomerUnq_Id != '') {
                $location.search('CustomerUnq_Id', o.CustomerUnq_Id);
            } else if (o.MobileNo != '') {
                $location.search('MobileNo', o.MobileNo);
            } else if (o.CustomerName != '') {
                $location.search('CustomerName', o.CustomerName);
            } else if (o.EmailAddress != '') {
                $location.search('EmailAddress', o.EmailAddress);
            }

            $http.get($rootScope.RoutePath + "adminpanel/GetCustomerInfo", { params: o }).then(function(data) {
                if (data.data.success == true) {
                    $scope.FlagSearch = false;
                    $scope.LstLiveLog = [];
                    $scope.UserInfo = data.data.data;
                    if ($scope.UserInfo.Type == "Individual") {
                        var date = new Date($scope.UserInfo.DOB);
                        var day = date.getDate();
                        var Month = date.getMonth() + 1;
                        var Year = date.getFullYear();
                        $scope.UserInfo.DateofBirth = ("00" + day.toString()).slice(-2) + "/" + ("00" + Month.toString()).slice(-2) + "/" + ("0000" + Year.toString()).slice(-4);
                    }
                    GetAllDeviceByCustomerId($scope.UserInfo.id);
                    // $scope.GetAllLogsByCustomerId($scope.UserInfo.id);
                    $scope.GetAllLogsByCustomerId(true);
                } else {
                    $mdDialog.show(
                        $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#popupContainer')))
                        .clickOutsideToClose(false)
                        .parent(angular.element(document.body))
                        .title(data.data.message)
                        // .textContent('You can specify some description text in here.')
                        .ariaLabel('Alert Dialog Demo')
                        .ok('OK')
                        .targetEvent('')
                    );
                }
            })
        }

        function GetAllDeviceByCustomerId(o) {
            $http.get($rootScope.RoutePath + "adminpanel/GetAllDeviceByCustomerId?UserId=" + o).then(function(data) {
                $scope.DeviceList = data.data;
            })
        }

        // $scope.GetAllLogsByCustomerId = function(o) {
        //     $http.get($rootScope.RoutePath + "adminpanel/GetAllLogsByCustomerId?UserId=" + o).then(function(data) {
        //         $scope.LstLiveLog = data.data;
        //     })
        // }

        //Dynamic Pagging
        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function(response) {
            $scope.FilterStatus = 1;
            $scope.dtColumns = [
                DTColumnBuilder.newColumn('id').renderWith(NumberHtml).notSortable(),
                DTColumnBuilder.newColumn('DeviceName').notSortable(),
                DTColumnBuilder.newColumn('Event').notSortable(),
                DTColumnBuilder.newColumn('TimeStamp').renderWith(DateFormateHtml).notSortable(),
            ]

            $scope.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
                    url: $rootScope.RoutePath + "adminpanel/GetAllLogsByCustomerIdDynamically",
                    data: function(d) {
                        if ($scope.UserInfo != undefined) {
                            d.UserId = $scope.UserInfo.id;
                        } else {
                            d.UserId = 0;
                        }
                        return d;
                    },
                    type: "get",
                    dataSrc: function(json) {
                        if (json.success != false) {
                            $scope.LstLiveLog = json.data;
                            return json.data;
                        } else {
                            return [];
                        }
                    },
                })
                .withOption('processing', true) //for show progress bar
                .withOption('serverSide', true) // for server side processing
                .withOption('searching', false)
                .withPaginationType('full_numbers') // for get full pagination options // first / last / prev / next and page numbers
                .withDisplayLength(25) // Page size
                .withOption('aaSorting', [
                    [3, 'desc'],
                    [0, 'desc']
                ])
                .withOption('responsive', true)
                .withOption('autoWidth', false)
                .withOption('deferRender', true)
                .withOption('createdRow', createdRow);
        });
        $scope.dtInstance = {};


        //Reload Datatable
        $scope.GetAllLogsByCustomerId = function(IsUpdate) {
            var resetPaging = false;
            if (IsUpdate == true) {
                resetPaging = true;
            };
        }

        $scope.reloadData = function() {}

        function callback(json) {}

        //compile Datatable And Apply Class
        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }

        function NumberHtml(data, type, full, meta) {
            return (meta.row + 1);
        }

        function DateFormateHtml(data, type, full, meta) {
            if (data != null && data != undefined && data != '') {
                return moment.tz(data, $scope.UserInfo.TimeZone).format('hh:mm a DD-MM-YYYY');
            } else {
                return 'N/A';
            }
        }

        // $scope.dtOptions2 = DTOptionsBuilder.newOptions()
        //     .withPaginationType('full_numbers')
        //     .withDisplayLength(100)
        //     .withOption('responsive', true)
        //     .withOption('autoWidth', false)
        //     .withOption('searching', false)
        //     .withOption('paging', false)
        //     .withOption('info', false)
        //     .withOption('deferRender', true)
        //     .withOption('language', {
        //         'zeroRecords': "No Record Found",
        //         'emptyTable': "No Record Found"
        //     })

        // $scope.dtColumnDefsDevice = [
        //     DTColumnDefBuilder.newColumnDef(0).notSortable(),
        //     DTColumnDefBuilder.newColumnDef(1).notSortable(),
        //     DTColumnDefBuilder.newColumnDef(2).notSortable(),
        //     DTColumnDefBuilder.newColumnDef(3).notSortable(),
        // ];

        $scope.ShowSetting = function(item) {
            if (item.DeviceType == "Socket") {
                $scope.ShowSocketSetting(item);
            } else if (item.DeviceType == "Alarm") {
                $scope.ShowAlarmSetting(item);
            } else if (item.DeviceType == "Mat") {
                $scope.ShowMatSetting(item);
            }
        }

        //Show Socket Setting
        $scope.ShowSocketSetting = function(o) {
            $mdDialog.show({
                skipHide: true,
                controller: 'ActiveScoketSetting2Controller',
                controllerAs: 'vm',
                templateUrl: 'app/main/CustomerService/dialogs/SocketSetting/SocketSetting.html',
                parent: angular.element(document.body),
                targetEvent: '',
                clickOutsideToClose: false,
                locals: {
                    objSocket: o,
                    Tasks: [],
                    event: '',
                    CustomerServiceVm: vm,
                }
            })
        }

        //Show Alarm Setting
        $scope.ShowAlarmSetting = function(o) {
            $mdDialog.show({
                skipHide: true,
                controller: 'ActiveAlarmSetting2Controller',
                controllerAs: 'vm',
                templateUrl: 'app/main/CustomerService/dialogs/AlarmSetting/AlarmSetting.html',
                parent: angular.element(document.body),
                targetEvent: '',
                clickOutsideToClose: false,
                locals: {
                    objAlarm: o,
                    Tasks: [],
                    event: '',
                    CustomerServiceVm: vm,

                }
            })
        }

        //Show Mat Setting
        $scope.ShowMatSetting = function(o) {
            $mdDialog.show({
                skipHide: true,
                controller: 'ActiveMatSetting2Controller',
                controllerAs: 'vm',
                templateUrl: 'app/main/CustomerService/dialogs/MatSetting/MatSetting.html',
                parent: angular.element(document.body),
                targetEvent: '',
                clickOutsideToClose: false,
                locals: {
                    objMat: o,
                    Tasks: [],
                    event: '',
                    CustomerServiceVm: vm,
                }
            })
        }

        $scope.ShowDebug = function(o) {
            $mdDialog.show({
                skipHide: true,
                controller: 'DebugController',
                controllerAs: 'vm',
                templateUrl: 'app/main/CustomerService/dialogs/Debug/Debug.html',
                parent: angular.element(document.body),
                targetEvent: '',
                clickOutsideToClose: false,
                locals: {
                    ObjData: o,
                    Tasks: [],
                    event: '',
                    CustomerServiceVm: vm,
                }
            })
        }

        $scope.GoBack = function() {
            if (_.isEmpty($location.search()) != true) {
                $location.search('CustomerUnq_Id', null);
                $location.search('MobileNo', null);
                $location.search('CustomerName', null);
                $location.search('EmailAddress', null);
            }

            $scope.model = {
                CustomerUnq_Id: '',
                MobileNo: '',
                CustomerName: '',
                EmailAddress: '',
            };
            vm.selectedItem = null;
            vm.searchText = null;
            $scope.FlagSearch = true;
            $scope.tab = { selectedIndex: 0 };
        }

        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function(response) {
            $scope.init();
        })
    }

})();
(function() {
    'use strict';

    angular
        .module('app.customerdevices')
        .controller('CustomerDevicesController', CustomerDevicesController);

    /** @ngInject */
    function CustomerDevicesController($http, $scope, $state, $rootScope, $location, $anchorScroll, $mdToast, $document, $cookieStore, $mdDialog, $stateParams, DTOptionsBuilder, DTColumnDefBuilder) {

        var vm = this;
        $rootScope.UserName = $cookieStore.get('UserName');
        $rootScope.UserId = $cookieStore.get('UserId');
        var socket = io($rootScope.RoutePath);
        socket.on('DeviceConnectionStatusUpdate', function(msg) {
            // $('#messages').append($('<li>').text(msg));           
            var obj = JSON.parse(msg);
            var objDevice = _.filter($scope.lstCustomerDevice, function(item) {
                if (item.DeviceSerial == obj.MacAddress && item.IsActive == true) {
                    return item;
                }
            });
            if (objDevice[0]) {
                $scope.$apply(function() {
                    objDevice[0].Connection_Status = obj.Connection_Status;
                });
            };
        });

        socket.on('DeviceConnectionStatus', function(msg) {
            // $('#messages').append($('<li>').text(msg));           
            var obj = JSON.parse(msg);
            var objDevice = _.filter($scope.lstCustomerDevice, function(item) {
                if (item.DeviceSerial == obj.MacAddress && item.CustomerMasterId == obj.CustomerId) {
                    return item;
                }
            });
            if (objDevice[0]) {
                $scope.$apply(function() {
                    objDevice[0].Connection_Status = obj.Connection_Status;
                });
            };
        });
        // socket.emit('dailog', JSON.stringify(Userid));

        $scope.init = function() {
            $scope.model = {
                id: '',
                CustomerMasterId: '',
                DeviceType: '',
                DeviceName: '',
                DeviceSerial: '',
                CreatedDate: new Date(),
                CreatedBy: '',
                ModifiedDate: '',
                ModifiedBy: '',
                CustomerDeviceId: '',
                MD_Timer: '',
                Alert_Msg_Timer: '',
                Standby_Timer: '',
                LED_Timer: '',
                Text_for_1St_Step: '',
                Text_for_2nd_Step: '',
                Text_for_Alert_Event: '',

                TriggerType: '',
                LightOff_Timer: '',
                Scheduler_StartTime: '',
                Scheduler_EndTime: '',
                Type: null,
                MobileNo: null,
                Email: null,
                Event_Scheduler_StartTime: null,
                Event_Scheduler_EndTime: null,
                Alert_Scheduler_StartTime: null,
                Alert_Scheduler_Endtime: null,
                Device_Mat_Id: '',
                SchedulType: 'Always On',

                // Text_for_SMSFirstStep: '',
                Scheduler_StartTime_FirstStep: '',
                Scheduler_EndTime_FirstStep: '',
                MobileNo_FirstStep: '',
                SchedulType_FirstStep: 'Always On',

                // Text_for_SMSSecondStep: '',
                Scheduler_StartTime_SecondStep: '',
                Scheduler_EndTime_SecondStep: '',
                MobileNo_SecondStep: '',
                SchedulType_SecondStep: 'Always On',

                // Text_for_AlertSMS: '',
                Scheduler_StartTime_AlertSMS: '',
                Scheduler_EndTime_AlertSMS: '',
                MobileNo_AlertSMS: '',
                SchedulType_AlertSMS: 'Always On',

                Setting_Sync_Flag: '',
                Connection_Status: '',
                IsActive: '',

            };

            $("#MobileNo").intlTelInput();

            $scope.SMSmodel = {
                id: '',
                MobileNo: '',
                Scheduler_StartTime: '',
                Scheduler_EndTime: '',
                Device_Mat_Id: '',
                First_Step: 0,
                Second_Step: 0,
                Alert: 0,
                Device_Faliure: 0,
                SchedulType_SMS: 'Always On',
            }

            $scope.Mobiles = [{ id: 'Mobile1' }];
            $scope.Mobiles2 = [{ id: 'Mobile1' }];
            $scope.Mobiles3 = [{ id: 'Mobile1' }];

            $scope.tab = { selectedIndex: 0 };
            $scope.GetAllCustomerDevice();
            $scope.GetUserDevices();
            $scope.GetAllDeviceSetting();
            $scope.GetMatList();
            HideLoader();
            $scope.lstSMS = [];

            $scope.TimingList = [{ value: 30000, time: '30 Seconds' }, { value: 60000, time: '1 Minute' }, { value: 120000, time: '2 Minute' }, { value: 180000, time: '3 Minute' }, { value: 240000, time: '4 Minute' }, { value: 300000, time: '5 Minute' }, { value: 360000, time: '6 Minute' }, { value: 420000, time: '7 Minute' }, { value: 480000, time: '8 Minute' }, { value: 540000, time: '9 Minute' }, { value: 600000, time: '10 Minute' }, { value: 660000, time: '11 Minute' }, { value: 720000, time: '12 Minute' }, { value: 780000, time: '13 Minute' }, { value: 840000, time: '14 Minute' }, { value: 900000, time: '15 Minute' }, { value: 960000, time: '16 Minute' }, { value: 1020000, time: '17 Minute' }, { value: 1080000, time: '18 Minute' }, { value: 1140000, time: '19 Minute' }, { value: 1200000, time: '20 Minute' }, { value: 1500000, time: '25 Minute' }, { value: 1800000, time: '30 Minute' }, { value: 2100000, time: '35 Minute' }, { value: 2400000, time: '40 Minute' }, { value: 2700000, time: '45 Minute' }, { value: 3000000, time: '50 Minute' }, { value: 3300000, time: '55 Minute' }, { value: 3600000, time: '1 Hour' }];
            // for (var i = 1; i <= 12; i++) {
            //     var obj = new Object();
            //     obj = i * 5;
            //     $scope.TimingList.push(obj);
            // }
            $scope.TimingListforMDtime = [{ value: 10000, time: '10 Seconds' }, { value: 15000, time: '15 Seconds' }, { value: 20000, time: '20 Seconds' }, { value: 25000, time: '25 Seconds' }, { value: 30000, time: '30 Seconds' }, { value: 60000, time: '1 Minute' }, { value: 120000, time: '2 Minute' }, { value: 180000, time: '3 Minute' }, { value: 240000, time: '4 Minute' }, { value: 300000, time: '5 Minute' }, { value: 360000, time: '6 Minute' }, { value: 420000, time: '7 Minute' }, { value: 480000, time: '8 Minute' }, { value: 540000, time: '9 Minute' }, { value: 600000, time: '10 Minute' }, { value: 900000, time: '15 Minute' }, { value: 1200000, time: '20 Minute' }, { value: 1500000, time: '25 Minute' }, { value: 1800000, time: '30 Minute' }];


            // Timepicker start
            $('.mobiscrollTime').scroller({ preset: 'time' });
            $('.mobiscrollDate').scroller();
            $('.mobiscrollDateTime').scroller({ preset: 'datetime' });

        }

        $scope.toggle = function() {
            $scope.Reset()
            if (!$scope.flgforIcon) {
                $scope.flgforIcon = true;
            } else {
                $scope.flgforIcon = false;
            }

            $(function() {
                $(".showBtn").toggleClass("active");
                $(".ShowContentBox").slideToggle();
            });
        };

        $scope.GetAllCustomerDevice = function() {
            $http.get($rootScope.RoutePath + "customerdevices/GetAllCustomerDevice").then(function(data) {
                $scope.lstdata = _.where(data.data, { DeviceType: 'Mat', CustomerMasterId: $rootScope.UserId });
            });
        }

        // $scope.GetUserDevices = function(o) {
        //     var params = {
        //         EmailAddress: $rootScope.UserName
        //     }
        //     $http.get($rootScope.RoutePath + "customerdevices/GetAllCustomerDeviceByUser", { params: params }).then(function(data) {
        //         console.log(data)
        //         $scope.lstCustomerDevice = data.data;

        //     });
        // }

        $scope.GetMatList = function() {
            var params = {
                CustomerMasterId: $rootScope.UserId
            }
            $http.get($rootScope.RoutePath + "customerdevices/GetAllMatDeviceByUser", { params: params }).then(function(data) {
                $scope.MatList = data.data.data;

            });
        }

        $scope.GetUserDevices = function(o) {

            var params = {
                EmailAddress: $rootScope.UserName
            }
            $http.get($rootScope.RoutePath + "customerdevices/GetAllCustomerDeviceByUser", { params: params }).then(function(data) {
                $rootScope.lstCustomerDevice = data.data;
                socket.emit('dailog', JSON.stringify($rootScope.UserId));
            });
        }

        $scope.GetAllDeviceSetting = function() {
            $http.get($rootScope.RoutePath + "devicesetting_call_sms/GetAllDeviceSetting").then(function(data) {
                $scope.lstDeviceSetting = data.data;
            });
        }

        $scope.GetAllDeviceTypeDetailByDevice = function(o) {
            var params = {
                id: o.id
            }
            $http.get($rootScope.RoutePath + "customerdevices/GetAllDeviceTypeDetailByDevice", { params: params }).then(function(data) {
                $scope.lstDevice = data.data;

                $scope.model.CustomerDeviceId = $scope.lstDevice[0].CustomerDeviceId;
                if (o.DeviceType == "Mat") {

                    $scope.model.MD_Timer = $scope.lstDevice[0].MD_Timer;
                    $scope.model.Alert_Msg_Timer = $scope.lstDevice[0].Alert_Msg_Timer;
                    $scope.model.Standby_Timer = $scope.lstDevice[0].Standby_Timer;
                    $scope.model.LED_Timer = $scope.lstDevice[0].LED_Timer;

                    $scope.model.Scheduler_StartTime_FirstStep = ConvertToTime($scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].Scheduler_StartTime_FirstStep);
                    $scope.model.Scheduler_EndTime_FirstStep = ConvertToTime($scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].Scheduler_EndTime_FirstStep);
                    $scope.model.Text_for_SMSFirstStep = $scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].Text_for_SMSFirstStep;
                    if ($scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].Scheduler_StartTime_FirstStep == null && $scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].Scheduler_EndTime_FirstStep == null) {
                        $scope.model.SchedulType_FirstStep = 'Always On';
                    } else {
                        $scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].Scheduler_StartTime_FirstStep = ConvertToTime($scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].Scheduler_StartTime_FirstStep);
                        $scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].Scheduler_EndTime_FirstStep = ConvertToTime($scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].Scheduler_EndTime_FirstStep);
                        $scope.model.SchedulType_FirstStep = 'Scheduling';
                    }

                    $scope.model.Scheduler_StartTime_SecondStep = ConvertToTime($scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].Scheduler_StartTime_SecondStep);
                    $scope.model.Scheduler_EndTime_SecondStep = ConvertToTime($scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].Scheduler_EndTime_SecondStep);
                    $scope.model.Text_for_SMSSecondStep = $scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].Text_for_SMSSecondStep;
                    if ($scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].Scheduler_StartTime_SecondStep == null && $scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].Scheduler_EndTime_SecondStep == null) {
                        $scope.model.SchedulType_SecondStep = 'Always On';
                    } else {
                        $scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].Scheduler_StartTime_SecondStep = ConvertToTime($scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].Scheduler_StartTime_SecondStep);
                        $scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].Scheduler_EndTime_SecondStep = ConvertToTime($scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].Scheduler_EndTime_SecondStep);
                        $scope.model.SchedulType_SecondStep = 'Scheduling';
                    }

                    $scope.model.Scheduler_StartTime_AlertSMS = ConvertToTime($scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].Scheduler_StartTime_AlertSMS);
                    $scope.model.Scheduler_EndTime_AlertSMS = ConvertToTime($scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].Scheduler_EndTime_AlertSMS);
                    $scope.model.Text_for_AlertSMS = $scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].Text_for_AlertSMS;
                    if ($scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].Scheduler_StartTime_AlertSMS == null && $scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].Scheduler_EndTime_AlertSMS == null) {
                        $scope.model.SchedulType_AlertSMS = 'Always On';
                    } else {
                        $scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].Scheduler_StartTime_AlertSMS = ConvertToTime($scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].Scheduler_StartTime_AlertSMS);
                        $scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].Scheduler_EndTime_AlertSMS = ConvertToTime($scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].Scheduler_EndTime_AlertSMS);
                        $scope.model.SchedulType_AlertSMS = 'Scheduling';
                    }

                    var m1 = $scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].MobileNo_FirstStep.split(',');
                    var m2 = $scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].MobileNo_SecondStep.split(',');
                    var m3 = $scope.lstDevice[0].tblcustomerdevice.tbldevicesetting_callsms[0].MobileNo_AlertSMS.split(',');

                    for (var i = 0; i < m1.length; i++) {
                        $scope.Mobiles[i].name = parseInt(m1[i]);
                        if (i != m1.length - 1) {
                            $scope.addMore();
                        }
                    }

                    for (var j = 0; j < m2.length; j++) {
                        $scope.Mobiles2[j].name = parseInt(m2[j]);
                        if (j != m2.length - 1) {
                            $scope.addMore2();
                        }
                    }

                    for (var k = 0; k < m3.length; k++) {
                        $scope.Mobiles3[k].name = parseInt(m3[k]);
                        if (k != m3.length - 1) {
                            $scope.addMore3();
                        }
                    }

                } else if (o.DeviceType == "Socket") {

                    $scope.model.TriggerType = $scope.lstDevice[0].TriggerType;
                    $scope.model.LightOff_Timer = $scope.lstDevice[0].LightOff_Timer;

                    if ($scope.lstDevice[0].Scheduler_StartTime == null && $scope.lstDevice[0].Scheduler_EndTime == null) {
                        $scope.model.SchedulType = 'Always On';
                    } else {
                        $scope.model.Scheduler_StartTime = ConvertToTime($scope.lstDevice[0].Scheduler_StartTime);
                        $scope.model.Scheduler_EndTime = ConvertToTime($scope.lstDevice[0].Scheduler_EndTime);
                        $scope.model.SchedulType = 'Scheduling';
                    }



                    // if ($scope.lstDevice[0].Scheduler_StartTime == "00:00:00" && $scope.lstDevice[0].Scheduler_EndTime == "00:00:00") {
                    //     $scope.model.Scheduler_StartTime = '';
                    //     $scope.model.Scheduler_EndTime = '';
                    //     $scope.model.SchedulType = 'Always On';
                    // } else {
                    //     $scope.model.Scheduler_StartTime = ConvertToTime($scope.lstDevice[0].Scheduler_StartTime);
                    //     $scope.model.Scheduler_EndTime = ConvertToTime($scope.lstDevice[0].Scheduler_EndTime);

                    //     $scope.model.SchedulType = 'Scheduling';
                    // }

                    $scope.model.Mat_id = $scope.lstDevice[0].Mat_id;
                } else {
                    $scope.model.Alarm_Time = $scope.lstDevice[0].Alarm_Time;
                    $scope.model.AlertType = $scope.lstDevice[0].AlertType;
                    $scope.model.TriggerType = $scope.lstDevice[0].TriggerType;

                    if ($scope.lstDevice[0].Scheduler_StartTime == null && $scope.lstDevice[0].Scheduler_EndTime == null) {
                        $scope.model.SchedulType = 'Always On';
                    } else {
                        $scope.model.Scheduler_StartTime = ConvertToTime($scope.lstDevice[0].Scheduler_StartTime);
                        $scope.model.Scheduler_EndTime = ConvertToTime($scope.lstDevice[0].Scheduler_EndTime);
                        $scope.model.SchedulType = 'Scheduling';
                    }
                    $scope.model.Mat_id = $scope.lstDevice[0].Mat_id;
                }
                // $scope.model.DeviceType = $scope.DeviceType;
            });
        }

        $scope.FetchCustomerDeviceById = function(o) {
            if (!$scope.flgforIcon) {
                $scope.toggle();
            }
            $rootScope.FlgAddedEditlocal = true;
            $scope.tab.selectedIndex = 1;
            $scope.model.id = o.id;
            $scope.model.CustomerMasterId = o.CustomerMasterId;
            $scope.model.DeviceType = o.DeviceType;
            $scope.model.DeviceName = o.DeviceName;
            $scope.model.DeviceSerial = o.DeviceSerial;
            if (o.DeviceType == "Mat") {
                $scope.model.MD_Timer = o.MD_Timer;
                $scope.model.Alert_Msg_Timer = o.Alert_Msg_Timer;
                $scope.model.Standby_Timer = o.Standby_Timer;
                $scope.model.LED_Timer = o.LED_Timer;
                $scope.model.Setting_Sync_Flag = o.Setting_Sync_Flag;
                $scope.model.Connection_Status = o.Connection_Status;
                $scope.model.IsActive = o.IsActive;
                $scope.model.Text_for_1St_Step = o.Text_for_1St_Step;
                $scope.model.Text_for_2nd_Step = o.Text_for_2nd_Step;
                $scope.model.Text_for_Alert_Event = o.Text_for_Alert_Event;
                $scope.GetAllSMSByMatId(o.id);
            } else if (o.DeviceType == "Socket") {
                $scope.model.TriggerType = o.TriggerType;
                $scope.model.LightOff_Timer = o.LightOff_Timer;

                if (o.Scheduler_StartTime == '00:00:00' && o.Scheduler_EndTime == '23:59:59') {
                    $scope.model.Scheduler_StartTime = '';
                    $scope.model.Scheduler_EndTime = '';
                    $scope.model.SchedulType = 'Always On';
                } else {
                    $scope.model.Scheduler_StartTime = ConvertToTime(o.Scheduler_StartTime);
                    $scope.model.Scheduler_EndTime = ConvertToTime(o.Scheduler_EndTime);
                    $scope.model.SchedulType = 'Scheduling';
                }



                // if ($scope.lstDevice[0].Scheduler_StartTime == "00:00:00" && $scope.lstDevice[0].Scheduler_EndTime == "00:00:00") {
                //     $scope.model.Scheduler_StartTime = '';
                //     $scope.model.Scheduler_EndTime = '';
                //     $scope.model.SchedulType = 'Always On';
                // } else {
                //     $scope.model.Scheduler_StartTime = ConvertToTime($scope.lstDevice[0].Scheduler_StartTime);
                //     $scope.model.Scheduler_EndTime = ConvertToTime($scope.lstDevice[0].Scheduler_EndTime);

                //     $scope.model.SchedulType = 'Scheduling';
                // }

                $scope.model.Device_Mat_Id = o.Device_Mat_Id;
                $scope.model.Setting_Sync_Flag = o.Setting_Sync_Flag;
                $scope.model.Connection_Status = o.Connection_Status;
                $scope.model.IsActive = o.IsActive;
            } else {
                $scope.model.Alarm_Time = o.Alarm_Time;
                $scope.model.AlertType = o.AlertType;
                $scope.model.TriggerType = o.TriggerType;

                if (o.Scheduler_StartTime == '00:00:00' && o.Scheduler_EndTime == '23:59:59') {
                    $scope.model.Scheduler_StartTime = '';
                    $scope.model.Scheduler_EndTime = '';
                    $scope.model.SchedulType = 'Always On';
                } else {
                    $scope.model.Scheduler_StartTime = ConvertToTime(o.Scheduler_StartTime);
                    $scope.model.Scheduler_EndTime = ConvertToTime(o.Scheduler_EndTime);
                    $scope.model.SchedulType = 'Scheduling';
                }
                $scope.model.Device_Mat_Id = o.Device_Mat_Id;
                $scope.model.Setting_Sync_Flag = o.Setting_Sync_Flag;
                $scope.model.Connection_Status = o.Connection_Status;
                $scope.model.IsActive = o.IsActive;
            }
            // $scope.model.CreatedDate = o.CreatedDate;
            // $scope.model.CreatedBy = o.CreatedBy;
            // $scope.model.ModifiedDate = o.ModifiedDate;
            // $scope.model.ModifiedBy = o.ModifiedBy;
            // $scope.GetAllDeviceTypeDetailByDevice(o);
        }

        $scope.CreateCustomerDevice = function(o, lst) {
            ShowLoader();
            o.CustomerMasterId = $rootScope.UserId;
            o.CreatedBy = $rootScope.UserName;
            if (lst.MobileNo != '') {
                if (lst.SchedulType_SMS == "Always On") {
                    lst.Scheduler_StartTime = "00:00:00";
                    lst.Scheduler_EndTime = "23:59:59";
                }
                $scope.lstSMS.push(lst);
                $scope.SMSmodel = {
                    id: '',
                    MobileNo: '',
                    Scheduler_StartTime: '',
                    Scheduler_EndTime: '',
                    Device_Mat_Id: '',
                    First_Step: 0,
                    Second_Step: 0,
                    Alert: 0,
                    Device_Faliure: 0,
                    SchedulType_SMS: 'Always On',
                }
            }
            o.SMSList = $scope.lstSMS;

            // if (o.SchedulType_FirstStep == "Always On") {
            //     o.Scheduler_StartTime_FirstStep = null;
            //     o.Scheduler_EndTime_FirstStep = null;
            // }

            // if (o.SchedulType_SecondStep == "Always On") {
            //     o.Scheduler_StartTime_SecondStep = null;
            //     o.Scheduler_EndTime_SecondStep = null;
            // }

            // if (o.SchedulType_AlertSMS == "Always On") {
            //     o.Scheduler_StartTime_AlertSMS = null;
            //     o.Scheduler_EndTime_AlertSMS = null;
            // }

            if (o.SchedulType == "Always On") {
                o.Scheduler_StartTime = "00:00:00";
                o.Scheduler_EndTime = "23:59:59";
            }

            // for (var i = 0; i < $scope.Mobiles.length; i++) {
            //     if (i == 0) {
            //         o.MobileNo_FirstStep = $scope.Mobiles[i].name;
            //     } else {
            //         o.MobileNo_FirstStep = o.MobileNo_FirstStep + "," + $scope.Mobiles[i].name;
            //     }
            // }

            // for (var j = 0; j < $scope.Mobiles2.length; j++) {
            //     if (j == 0) {
            //         o.MobileNo_SecondStep = $scope.Mobiles2[j].name;
            //     } else {
            //         o.MobileNo_SecondStep = o.MobileNo_SecondStep + "," + $scope.Mobiles2[j].name;
            //     }
            // }

            // for (var k = 0; k < $scope.Mobiles3.length; k++) {
            //     if (k == 0) {
            //         o.MobileNo_AlertSMS = $scope.Mobiles3[k].name;
            //     } else {
            //         o.MobileNo_AlertSMS = o.MobileNo_AlertSMS + "," + $scope.Mobiles3[k].name;
            //     }
            // }

            $http.post($rootScope.RoutePath + "customerdevices/SaveCustomerDevice", o).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );

                    $rootScope.FlgAddedEditlocal = false;
                    if ($rootScope.FlgAddedAccess == true) {
                        $rootScope.FlgAddedEditlocal = true
                    }
                    $scope.resetForm();
                    $scope.init();
                } else {
                    if (data.data.data == 'TOKEN') {

                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                        $scope.resetForm();
                        $scope.init();
                    }
                }
                HideLoader();
            });
            // }

        }

        $scope.CreateDevice = function(o) {
            ShowLoader();
            $http.post($rootScope.RoutePath + "customerdevices/SaveDevice", o).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );
                    $rootScope.FlgAddedEditlocal = false;
                    if ($rootScope.FlgAddedAccess == true) {
                        $rootScope.FlgAddedEditlocal = true
                    }
                    $scope.resetForm();
                    $scope.init();
                } else {
                    if (data.data.data == 'TOKEN') {
                        //$cookieStore.remove('UserName');
                        //$cookieStore.remove('token');
                        //window.location.href = '/app/login';
                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                    }
                }
                HideLoader();
            });
        };

        $scope.DeleteCustomerDevice = function(o, ev) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure to delete this Customer Device?')
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent(ev)
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function() {
                var params = {
                    DeviceType: o.DeviceType,
                    id: o.id
                }
                $http.get($rootScope.RoutePath + "customerdevices/DeleteCustomerDevice", { params: params }).then(function(data) {
                    if (data.data.success) {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                        $scope.init();
                    } else {
                        if (data.data.data == 'TOKEN') {
                            $rootScope.logout();
                        } else {
                            $mdToast.show(
                                $mdToast.simple()
                                .textContent(data.data.message)
                                .position('top right')
                                .hideDelay(3000)
                            );
                        }
                    }
                });
            }, function() {});
        }

        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0),
            DTColumnDefBuilder.newColumnDef(1),
            DTColumnDefBuilder.newColumnDef(2),
            DTColumnDefBuilder.newColumnDef(3),
            DTColumnDefBuilder.newColumnDef(4),
            DTColumnDefBuilder.newColumnDef(5),
            DTColumnDefBuilder.newColumnDef(6).notSortable(),
        ];

        function convertdateformat(date) {
            var D = new Date();
            // var sec = date.getSeconds();
            // var min = date.getMinutes();
            // var hour = date.getHours();

            var year = D.getUTCFullYear();
            var month = D.getMonth() + 1; // beware: January = 0; February = 1, etc.
            var day = D.getDate();

            return ("0000" + year.toString()).slice(-4) + "-" + ("00" + month.toString()).slice(-2) + "-" + ("00" + day.toString()).slice(-2) + " " + date + ' GMT+0530 (India Standard Time)';
        }

        function ConvertToTime(Time) {

            if (Time != null) {
                var splitedData = Time.split(':')
                if (parseInt(splitedData[0]) < 12) {
                    if (splitedData[0] == 0) {
                        return 12 + ":" + splitedData[1] + " AM";
                    } else {
                        return splitedData[0] + ":" + splitedData[1] + " AM";
                    }
                } else {
                    if (parseInt(splitedData[0]) - 12 == 0) {
                        return 12 + ":" + splitedData[1] + " PM";
                    } else {
                        return parseInt(splitedData[0]) - 12 + ":" + splitedData[1] + " PM";
                    }
                }
            } else {
                return null;
            }
        }

        function ConvertToFullTime(Time) {

            var splitedData = Time.split(' ')
            var againSplit = splitedData[0].split(':');

            if (splitedData[1] == "PM") {
                againSplit[0] = parseInt(againSplit[0]) + 12;
            }

            var date = new Date();
            date.setHours(parseInt(againSplit[0]));
            date.setMinutes(parseInt(againSplit[1]))
            return date;
        }

        $scope.dtOptions2 = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withDisplayLength(100)
            .withOption('responsive', true)
            .withOption('autoWidth', false)
            .withOption('searching', false)
            .withOption('paging', false)
            .withOption('info', false)
            .withOption('deferRender', true)
            .withOption('language', {
                'zeroRecords': "No Record Found",
                'emptyTable': "No Record Found"
            })

        $scope.dtColumnDefsDevice = [
            DTColumnDefBuilder.newColumnDef(0),
            DTColumnDefBuilder.newColumnDef(1),
            DTColumnDefBuilder.newColumnDef(2),
            DTColumnDefBuilder.newColumnDef(3),
            DTColumnDefBuilder.newColumnDef(4),
            DTColumnDefBuilder.newColumnDef(5),
            DTColumnDefBuilder.newColumnDef(6),
            DTColumnDefBuilder.newColumnDef(7),
            DTColumnDefBuilder.newColumnDef(8).notSortable(),
        ];


        $scope.addMore = function() {
            var newItemNo = $scope.Mobiles.length + 1;
            $scope.Mobiles.push({ 'id': 'Mobile' + newItemNo });
        };

        $scope.remove = function() {
            if ($scope.Mobiles.length != 1) {
                var newItemNo = $scope.Mobiles.length - 1;
                $scope.Mobiles.pop($scope.Mobiles[$scope.Mobiles.length - 1]);
            }
        };

        $scope.showAddChoice = function(Mobile) {
            return Mobile.id === $scope.Mobiles[$scope.Mobiles.length - 1].id;
        };



        $scope.addMore2 = function(o) {
            if (o.SchedulType_SMS == "Always On") {
                o.Scheduler_StartTime = "00:00:00";
                o.Scheduler_EndTime = "23:59:59";
            }
            // var newItemNo = $scope.Mobiles2.length + 1;
            // $scope.Mobiles2.push({ 'id': 'Mobile' + newItemNo });
            $scope.lstSMS.push(o);
            $scope.SMSmodel = {
                id: '',
                MobileNo: '',
                Scheduler_StartTime: '',
                Scheduler_EndTime: '',
                Device_Mat_Id: '',
                First_Step: 0,
                Second_Step: 0,
                Alert: 0,
                Device_Faliure: 0,
                SchedulType_SMS: 'Always On',
            }
        };

        $scope.remove2 = function($index, o, ev) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure to delete this SMS Configuration?')
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent(ev)
                .ok('Yes')
                .cancel('No');
            $mdDialog.show(confirm).then(function() {
                if (o.id != "" && o.id != 0) {
                    var params = {
                        id: o.id
                    }
                    $http.get($rootScope.RoutePath + "devicesetting_call_sms/DeleteSMSSetting", { params: params }).then(function(data) {
                        if (data.data.success) {
                            $mdToast.show(
                                $mdToast.simple()
                                .textContent(data.data.message)
                                .position('top right')
                                .hideDelay(3000)
                            );
                            $scope.lstSMS.splice($index, 1);
                        } else {
                            if (data.data.data == 'TOKEN') {
                                $rootScope.logout();
                            } else {
                                $mdToast.show(
                                    $mdToast.simple()
                                    .textContent(data.data.message)
                                    .position('top right')
                                    .hideDelay(3000)
                                );
                            }
                        }
                    });
                } else {
                    $scope.lstSMS.splice($index, 1);
                }
            }, function() {});

        };

        $scope.showAddChoice2 = function(Mobile) {
            return Mobile.id === $scope.Mobiles2[$scope.Mobiles2.length - 1].id;
        };



        $scope.addMore3 = function() {
            var newItemNo = $scope.Mobiles3.length + 1;
            $scope.Mobiles3.push({ 'id': 'Mobile' + newItemNo });
        };

        $scope.remove3 = function() {
            if ($scope.Mobiles3.length != 1) {
                var newItemNo = $scope.Mobiles3.length - 1;
                $scope.Mobiles3.pop($scope.Mobiles3[$scope.Mobiles3.length - 1]);
            }
        };

        $scope.showAddChoice3 = function(Mobile) {
            return Mobile.id === $scope.Mobiles3[$scope.Mobiles3.length - 1].id;
        };


        $scope.resetForm = function() {
            $scope.CustomerDeviceForm.$setUntouched();
            $scope.CustomerDeviceForm.$setPristine();
        }

        $scope.ResetEdit = function() {
            if ($rootScope.FlgAddedAccess == true) {
                $scope.model = {
                    id: '',
                    CustomerMasterId: '',
                    DeviceType: '',
                    DeviceName: '',
                    DeviceSerial: '',
                    CreatedDate: new Date(),
                    CreatedBy: '',
                    ModifiedDate: '',
                    ModifiedBy: '',
                };
                $scope.resetForm();
                $scope.GetAllCustomerDevice();
            }
        }

        $scope.ResetTab = function() {
            if ($rootScope.FlgAddedAccess != true) {
                $scope.FlgAddedEditlocal = false;
            }
        }

        $scope.Reset = function() {
            $rootScope.FlgAddedEditlocal = false;
            if ($rootScope.FlgAddedAccess == true) {
                $rootScope.FlgAddedEditlocal = true;
            }
            $scope.init();
            $scope.resetForm();
        }

        //show User Devices
        $scope.ShowDeviceModal = function(ev, o) {
            $scope.obj = _.filter($scope.lstCustomerDevice, function(item) {
                if (item.id == o.id && item.DeviceType == o.DeviceType) {
                    return item;
                }
            });
            $mdDialog.show({
                controller: 'DeviceTypeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/CustomerDevices/dialogs/DeviceTypeDetail/DeviceTypeDetail.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    objUser: $scope.obj[0],
                    Tasks: [],
                    event: ev,

                }
            })
        }

        //show Event List
        $scope.ShowEventList = function(ev, id) {
            $scope.obj = _.findWhere($scope.lstDeviceSetting, { CustomerDeviceId: id });
            $mdDialog.show({
                controller: 'EventListDetailController',
                controllerAs: 'vm',
                templateUrl: 'app/main/CustomerDevices/dialogs/EventList/EventList.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    objUser: $scope.obj,
                    Tasks: [],
                    event: ev,

                }
            })
        }

        $scope.GetAllSMSByMatId = function(o) {
            var params = {
                id: o
            }
            $http.get($rootScope.RoutePath + "customerdevices/GetAllSMSByMatId", { params: params }).then(function(data) {
                $scope.lstSMS = data.data.data;

            });
        }

        function ShowLoader() {
            document.getElementById('processing1').style.display = "block";
            document.body.scrollTop = "0px";
        }

        function HideLoader() {
            document.getElementById('processing1').style.display = "none";
        }

        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function(response) {
            $scope.init();
        })
    }

})();
(function() {
    'use strict';

    angular
        .module('app.customer')
        .controller('CustomerController', CustomerController);

    /** @ngInject */
    function CustomerController($http, $scope, $rootScope, $window, $state, $q, $timeout, $mdToast, $document, $mdDialog, $cookieStore, $stateParams, DTOptionsBuilder, DTColumnDefBuilder, DTColumnBuilder, $compile) {

        var vm = this;

        $scope.init = function() {

        }

        //Dynamic Pagging

        $scope.FilterStatus = 1;
        $scope.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable().renderWith(NumberHtml),
            DTColumnBuilder.newColumn('Name'),
            DTColumnBuilder.newColumn('CustomerAccountNo'),
            DTColumnBuilder.newColumn('EmailAddress'),
            DTColumnBuilder.newColumn('ContactNo'),
            DTColumnBuilder.newColumn('Pincode'),
            DTColumnBuilder.newColumn('Type'),
            DTColumnBuilder.newColumn('tblcustomerdevices.length'),
            DTColumnBuilder.newColumn(null).notSortable().renderWith(actionsHtml)
        ]

        $scope.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
                url: $rootScope.RoutePath + "customer/GetAllDynamicCustomer",
                data: function(d) {
                    return d;
                },
                type: "get",
                dataSrc: function(json) {
                    if (json.success != false) {
                        $scope.lstdata = json.data;
                        return json.data;
                    } else {
                        return [];
                    }
                },
            })
            .withOption('processing', true) //for show progress bar
            .withOption('serverSide', true) // for server side processing
            .withOption('responsive', true)
            .withOption('autoWidth', false)
            .withPaginationType('full_numbers') // for get full pagination options // first / last / prev / next and page numbers
            .withDisplayLength(10) // Page size
            .withOption('aaSorting', [1, 'asc'])
            .withOption('createdRow', createdRow);

        $scope.dtInstance = {};


        //Reload Datatable
        $scope.GetAllUser = function(IsUpdate) {
            var resetPaging = false;
            if (IsUpdate == true) {
                resetPaging = true;
            };
            $scope.dtInstance.reloadData(callback, resetPaging);
        }

        $scope.reloadData = function() {}

        function callback(json) {}

        //compile Datatable And Apply Class
        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }


        function NumberHtml(data, type, full, meta) {
            return (meta.row + 1);
        }

        function Verified(data, type, full, meta) {
            var Flg;
            if (data == true) {
                Flg = '<i class="icon-checkbox-marked-circle green-500-fg"></i>';
            } else {
                Flg = '<i class="icon-cancel red-500-fg"></i>';
            }
            return Flg;

        }

        function actionsHtml(data, type, full, meta) {
            var btns = '<md-button class="md-accent md-raised md-hue-2" ng-click="ShowDeviceModal($event,' + data.id + ')" aria-label="">Detail</md-button>';
            // btns += '<md-button class="md-accent md-raised md-hue-2" ng-click="ResendOTP(' + data.id + ')">Resend OTP</md-button>';
            // btns += '<md-button class="md-raised md-primary" ng-click="ResetPassword(' + data.id + ')">Reset Password</md-button>';

            return btns;
        };


        //show User Devices
        $scope.ShowDeviceModal = function(ev, id) {
            // $scope.obj = _.findWhere($scope.lstdata, { id: id });
            $state.go('app.devicedetail', { id: id })
        }


        //Dynamic Pagging End

        $scope.init();
    }
})();
(function() {
    'use strict';

    angular
        .module('app.ChangePassword', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.ChangePassword', {
            url: '/app/ChangePassword/:UniqueKey/:Web',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.ChangePassword': {
                    templateUrl: 'app/main/ChangePassword/ChangePassword.html',
                    controller: 'ChangePasswordController as vm'
                }
            },
            bodyClass: 'ChangePassword',
            ModuleName: 'ChangePassword'
        });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/ChangePassword');

        // msNavigationServiceProvider.saveItem('Settings.Setting', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Users.ChangePassword', {
        //     title: 'Change Password',
        //     state: 'app.ChangePassword',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.ChangePassword')
        .controller('ChangePasswordController', ChangePasswordController);

    /** @ngInject */
    function ChangePasswordController($http, $scope, $rootScope, $state, $mdToast, $document, $cookieStore, $mdDialog, $stateParams, DTOptionsBuilder, DTColumnDefBuilder) {
        // var vm = this;

        if ($stateParams.Web == 'mobile') {
            var Agent = window.navigator.userAgent;
            if (Agent.toLocaleLowerCase().indexOf("iphone") >= 0 || Agent.toLocaleLowerCase().indexOf("ipad") >= 0 || Agent.toLocaleLowerCase().indexOf("android") >= 0) {
                window.location = "cloudmatapp://changepassword?" + $stateParams.UniqueKey;
            }

        }
        $scope.init = function() {
            $scope.flglink = false;
            $scope.model = {
                password: '',
                confirmpassword: '',
                UniqueNumber: $stateParams.UniqueKey,
            };
            $scope.VerifyChangepasswordLink();
            $scope.IsSucess = false;
        }

        $scope.VerifyChangepasswordLink = function() {
            $http.get($rootScope.RoutePath + "account/VerifyChangepasswordLink?UniqueNumber=" + $stateParams.UniqueKey).then(function(data) {
                if (data.data.success == true) {
                    $scope.flglink = true;
                }
            });
        }

        $scope.ChangePassword = function(o) {
            // if (o.password.length < 6) {
            //     $mdToast.show(
            //         $mdToast.simple()
            //         .textContent("Enter six digit Password.")
            //         .position('top right')
            //         .hideDelay(3000)
            //     );

            //     return;
            // } else if (o.password != o.confirmpassword) {
            //     $mdToast.show(
            //         $mdToast.simple()
            //         .textContent("Password and New Password must be same.")
            //         .position('top right')
            //         .hideDelay(3000)
            //     );

            //     return;
            // } else {
            $http.post($rootScope.RoutePath + "account/ChangePasswordByLink", o).then(function(response) {

                if (response.data.success == true) {
                    $scope.IsSucess = true;
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(response.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );
                    // $scope.GetAllBanner();
                    $rootScope.FlgAddedEditlocal = false;
                    $scope.Reset();
                } else {
                    if (response.data.data == 'TOKEN') {
                        //$cookieStore.remove('UserName');
                        //$cookieStore.remove('token');
                        //window.location.href = '/app/login';
                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(response.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                    }
                }
            });
            // }
        }

        $scope.Reset = function() {
            $scope.model = {
                password: '',
                confirmpassword: '',
                UniqueNumber: '',
            };
            $scope.resetForm();
        }

        $scope.resetForm = function() {
            $scope.FormChangePassword.$setUntouched();
            $scope.FormChangePassword.$setPristine();
        }

        $scope.init();

    }
})();
(function() {
    'use strict';

    angular
        .module('app.linkeddevices')
        .controller('ActiveDevicesController', ActiveDevicesController);

    /** @ngInject */
    function ActiveDevicesController($http, $scope, $state, $rootScope, $location, $anchorScroll, $mdToast, $document, $cookieStore, $mdDialog, $stateParams, DTOptionsBuilder, DTColumnDefBuilder) {

        var vm = this;
        $rootScope.UserName = $cookieStore.get('UserName');
        $rootScope.UserId = $cookieStore.get('UserId');
        vm.GetMatList = GetMatList;

        var socket = io($rootScope.RoutePath);
        socket.on('DeviceConnectionStatusUpdate', function(msg) {

            var obj = JSON.parse(msg);
            if (obj.Type == "Mat" || obj.Type == "Cordless Mat") {
                var objDevice = _.filter($scope.MatList, function(item) {
                    if (item.DeviceSerial == obj.MacAddress && item.IsActive == true && item.DeviceType == obj.Type) {
                        return item;
                    }
                });
            } else {
                var objDevice = _.filter($scope.MatList, function(item) {
                    for (var i = 0; i < item.children.length; i++) {
                        if (item.children[i].DeviceSerial == obj.MacAddress && item.children[i].IsActive == true && item.children[i].DeviceType == obj.Type) {
                            return item;
                        }
                    }
                });
            }

            if (objDevice != '') {
                $scope.$apply(function() {
                    if (obj.Type == "Mat" || obj.Type == "Cordless Mat") {
                        objDevice[0].Connection_Status = obj.Connection_Status;
                    } else {
                        for (var i = 0; i < objDevice[0].children.length; i++) {
                            if (objDevice[0].children[i].DeviceSerial == obj.MacAddress && objDevice[0].children[i].IsActive == true && objDevice[0].children[i].DeviceType == obj.Type) {
                                objDevice[0].children[i].Connection_Status = obj.Connection_Status;
                            }
                        }
                    }
                });
            };
        });

        socket.on('DeviceConnectionStatus', function(msg) {
            var obj = JSON.parse(msg);
            if (obj.Type == "Mat" || obj.Type == "Cordless Mat") {
                var objDevice = _.filter($scope.MatList, function(item) {
                    if (item.DeviceSerial == obj.MacAddress && item.CustomerMasterId == obj.CustomerId && item.DeviceType == obj.Type) {
                        return item;
                    }
                });
            } else {
                var objDevice = _.filter($scope.MatList, function(item) {
                    for (var i = 0; i < item.children.length; i++) {
                        if (item.children[i].DeviceSerial == obj.MacAddress && item.children[i].CustomerMasterId == obj.CustomerId && item.children[i].DeviceType == obj.Type) {
                            return item;
                        }
                    }
                });
            }
            if (objDevice != '') {
                $scope.$apply(function() {
                    if (obj.Type == "Mat" || obj.Type == "Cordless Mat") {
                        objDevice[0].Connection_Status = obj.Connection_Status;
                        objDevice[0].IsActive = obj.IsActive;
                    } else {
                        for (var i = 0; i < objDevice[0].children.length; i++) {
                            if (objDevice[0].children[i].DeviceSerial == obj.MacAddress && objDevice[0].children[i].CustomerMasterId == obj.CustomerId && objDevice[0].children[i].DeviceType == obj.Type) {
                                objDevice[0].children[i].Connection_Status = obj.Connection_Status;
                                objDevice[0].children[i].IsActive = obj.IsActive;
                            }
                        }
                    }
                });
            };
        });

        socket.on('AddDevice', function(msg) {
            var obj = JSON.parse(msg);
            if (obj != null && (obj.CustomerId == $rootScope.UserId || obj.CustomerMasterId == $rootScope.UserId)) {
                $scope.$apply(function() {
                    $rootScope.GetMatList();
                })
            }
        });

        $scope.init = function() {
            $scope.model = {}

            $scope.GetAllCustomerDevice();
            $scope.GetUserDevices();
            $scope.GetAllDeviceSetting();
            GetMatList();
        }

        $scope.ShowSetting = function(item) {
            if (item.DeviceType == "Socket") {
                $scope.ShowSocketSetting(item);
            } else if (item.DeviceType == "Alarm") {
                $scope.ShowAlarmSetting(item);
            } else if (item.DeviceType == "Mat" || item.DeviceType == "Cordless Mat") {
                $scope.ShowMatSetting(item);
            }
        }

        $scope.GetAllCustomerDevice = function() {
            $http.get($rootScope.RoutePath + "customerdevices/GetAllCustomerDevice").then(function(data) {
                $scope.lstdata = _.where(data.data, { DeviceType: 'Mat', CustomerMasterId: $rootScope.UserId });
            });
        }

        $scope.treeOptions = {
            nodeChildren: "children",
            dirSelectable: true,
            injectClasses: {
                ul: "a1",
                li: "a2",
                liSelected: "a7",
                iExpanded: "a3",
                iCollapsed: "a4",
                iLeaf: "a5",
                label: "a6",
                labelSelected: "a8"
            }
        }

        $scope.ChangeFlg = function(o) {
            if (o.EditFlag == false) {
                o.EditFlag = true;
            } else {
                o.EditFlag = false;
            }
        }

        function GetMatList() {
            $scope.list = [];
            var params = {
                CustomerMasterId: $rootScope.UserId
            }
            $http.get($rootScope.RoutePath + "customerdevices/GetAllMatDeviceByUser", { params: params }).then(function(data) {
                $scope.MatList = data.data.data;
                $scope.MatList = _.filter($scope.MatList, function(item) {
                    if (item.Type == 'Mat') {
                        item.DeviceType = "Mat";
                        item.DisplayType = "Mat";
                    } else {
                        item.DeviceType = "Cordless Mat";
                        item.DisplayType = "Cordless Mat";
                    }
                    item.EditFlag = false;
                    item.children = [];
                    if (item.tbldevice_alarms.length > 0) {
                        for (var i = 0; i < item.tbldevice_alarms.length; i++) {
                            item.tbldevice_alarms[i].DeviceType = "Alarm";
                            item.tbldevice_alarms[i].DisplayType = "Alarm";
                            item.tbldevice_alarms[i].EditFlag = false;
                            item.children.push(item.tbldevice_alarms[i]);
                        }
                    }
                    if (item.tbldevice_sockets.length > 0) {
                        for (var j = 0; j < item.tbldevice_sockets.length; j++) {
                            item.tbldevice_sockets[j].DeviceType = "Socket";
                            item.tbldevice_sockets[j].DisplayType = "Lamp";
                            item.tbldevice_sockets[j].EditFlag = false;
                            item.children.push(item.tbldevice_sockets[j]);
                        }
                    }
                    return item;
                })
            });
        }

        $rootScope.GetMatList = function() {
            $scope.list = [];
            var params = {
                CustomerMasterId: $rootScope.UserId
            }
            $http.get($rootScope.RoutePath + "customerdevices/GetAllMatDeviceByUser", { params: params }).then(function(data) {
                $scope.MatList = data.data.data;
                $scope.MatList = _.filter($scope.MatList, function(item) {
                    if (item.Type == 'Mat') {
                        item.DeviceType = "Mat";
                        item.DisplayType = "Mat";
                    } else {
                        item.DeviceType = "Cordless Mat";
                        item.DisplayType = "Cordless Mat";
                    }

                    item.EditFlag = false;
                    item.children = [];
                    if (item.tbldevice_alarms.length > 0) {
                        for (var i = 0; i < item.tbldevice_alarms.length; i++) {
                            item.tbldevice_alarms[i].DeviceType = "Alarm";
                            item.tbldevice_alarms[i].DisplayType = "Alarm";
                            item.tbldevice_alarms[i].EditFlag = false;
                            item.children.push(item.tbldevice_alarms[i]);
                        }
                    }
                    if (item.tbldevice_sockets.length > 0) {
                        for (var j = 0; j < item.tbldevice_sockets.length; j++) {
                            item.tbldevice_sockets[j].DeviceType = "Socket";
                            item.tbldevice_sockets[j].DisplayType = "Lamp";
                            item.tbldevice_sockets[j].EditFlag = false;
                            item.children.push(item.tbldevice_sockets[j]);
                        }
                    }
                    return item;
                })
                socket.emit('dailog', JSON.stringify($rootScope.UserId));
            });
        }

        $scope.GetUserDevices = function(o) {

            var params = {
                EmailAddress: $rootScope.UserName
            }
            $http.get($rootScope.RoutePath + "customerdevices/GetAllCustomerDeviceByUser", { params: params }).then(function(data) {
                $rootScope.lstCustomerDevice = data.data;
                socket.emit('dailog', JSON.stringify($rootScope.UserId));
            });
        }

        $scope.GetAllDeviceSetting = function() {
            $http.get($rootScope.RoutePath + "devicesetting_call_sms/GetAllDeviceSetting").then(function(data) {
                $scope.lstDeviceSetting = data.data;
            });
        }

        $scope.DeleteCustomerDevice = function(o, ev) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure to delete this Customer Device?')
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent(ev)
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function() {
                var params = {
                    DeviceType: o.DeviceType,
                    id: o.id
                }
                $http.get($rootScope.RoutePath + "customerdevices/DeleteCustomerDevice", { params: params }).then(function(data) {
                    if (data.data.success) {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                        $scope.init();
                    } else {
                        if (data.data.data == 'TOKEN') {
                            $rootScope.logout();
                        } else {
                            $mdToast.show(
                                $mdToast.simple()
                                .textContent(data.data.message)
                                .position('top right')
                                .hideDelay(3000)
                            );
                        }
                    }
                });
            }, function() {});
        }

        $scope.UnLinkDevices = function(o) {
            o.MatId = null;
            $http.post($rootScope.RoutePath + "customerdevices/UnlinkDevicesFromMat", o).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );

                    $rootScope.FlgAddedEditlocal = false;
                    if ($rootScope.FlgAddedAccess == true) {
                        $rootScope.FlgAddedEditlocal = true
                    }
                    GetMatList();
                } else {
                    if (data.data.data == 'TOKEN') {

                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                        GetMatList();
                    }
                }
            });
        }

        $scope.UpdateDevice = function(o) {
            $http.post($rootScope.RoutePath + "customerdevices/UpdateDevice", o).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );

                    $rootScope.FlgAddedEditlocal = false;
                    if ($rootScope.FlgAddedAccess == true) {
                        $rootScope.FlgAddedEditlocal = true
                    }
                    GetMatList();
                } else {
                    if (data.data.data == 'TOKEN') {

                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                        GetMatList();
                    }
                }
            });
        }

        //Show Socket Setting
        $scope.ShowSocketSetting = function(o) {
            $mdDialog.show({
                skipHide: true,
                controller: 'ActiveScoketSettingController',
                controllerAs: 'vm',
                templateUrl: 'app/main/ActiveDevices/dialogs/SocketSetting/SocketSetting.html',
                parent: angular.element(document.body),
                targetEvent: '',
                clickOutsideToClose: false,
                locals: {
                    objSocket: o,
                    Tasks: [],
                    event: '',
                    ActiveVm: vm,
                }
            })
        }

        //Show Alarm Setting
        $scope.ShowAlarmSetting = function(o) {
            $mdDialog.show({
                skipHide: true,
                controller: 'ActiveAlarmSettingController',
                controllerAs: 'vm',
                templateUrl: 'app/main/ActiveDevices/dialogs/AlarmSetting/AlarmSetting.html',
                parent: angular.element(document.body),
                targetEvent: '',
                clickOutsideToClose: false,
                locals: {
                    objAlarm: o,
                    Tasks: [],
                    event: '',
                    ActiveVm: vm,

                }
            })
        }

        //Show Mat Setting
        $scope.ShowMatSetting = function(o) {
            $mdDialog.show({
                skipHide: true,
                controller: 'ActiveMatSettingController',
                controllerAs: 'vm',
                templateUrl: 'app/main/ActiveDevices/dialogs/MatSetting/MatSetting.html',
                parent: angular.element(document.body),
                targetEvent: '',
                clickOutsideToClose: false,
                locals: {
                    objMat: o,
                    Tasks: [],
                    event: '',
                    ActiveVm: vm,
                }
            })
        }

        //Link Inlink Devices
        $scope.OpenInLinkDeviceList = function(o) {
            $mdDialog.show({
                skipHide: true,
                controller: 'LinkDeviceController',
                controllerAs: 'vm',
                templateUrl: 'app/main/ActiveDevices/dialogs/LinkDevice/LinkDevice.html',
                parent: angular.element(document.body),
                targetEvent: '',
                clickOutsideToClose: true,
                locals: {
                    objMatId: o.id,
                    Tasks: [],
                    event: '',
                    ActiveVm: vm,
                }
            })
        }

        //Open Cordless Device
        $scope.OpenCordlessDevices = function(o) {
            $mdDialog.show({
                skipHide: true,
                controller: 'CordlessDeviceController',
                controllerAs: 'vm',
                templateUrl: 'app/main/ActiveDevices/dialogs/CordlessDevice/CordlessDevice.html',
                parent: angular.element(document.body),
                targetEvent: '',
                clickOutsideToClose: true,
                locals: {
                    objMatId: o.id,
                    Tasks: [],
                    event: '',
                    ActiveVm: vm,
                }
            })
        }

        $scope.GetAllSMSByMatId = function(o) {
            var params = {
                id: o
            }
            $http.get($rootScope.RoutePath + "customerdevices/GetAllSMSByMatId", { params: params }).then(function(data) {
                $scope.lstSMS = data.data.data;

            });
        }

        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function(response) {
            $scope.init();
        })
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseTheming', fuseThemingProvider);

    /** @ngInject */
    function fuseThemingProvider()
    {
        // Inject Cookies Service
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        var registeredPalettes,
            registeredThemes;

        // Methods
        this.setRegisteredPalettes = setRegisteredPalettes;
        this.setRegisteredThemes = setRegisteredThemes;

        //////////

        /**
         * Set registered palettes
         *
         * @param _registeredPalettes
         */
        function setRegisteredPalettes(_registeredPalettes)
        {
            registeredPalettes = _registeredPalettes;
        }

        /**
         * Set registered themes
         *
         * @param _registeredThemes
         */
        function setRegisteredThemes(_registeredThemes)
        {
            registeredThemes = _registeredThemes;
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getRegisteredPalettes: getRegisteredPalettes,
                getRegisteredThemes  : getRegisteredThemes,
                setActiveTheme       : setActiveTheme,
                setThemesList        : setThemesList,
                themes               : {
                    list  : {},
                    active: {
                        'name' : '',
                        'theme': {}
                    }
                }
            };

            return service;

            //////////

            /**
             * Get registered palettes
             *
             * @returns {*}
             */
            function getRegisteredPalettes()
            {
                return registeredPalettes;
            }

            /**
             * Get registered themes
             *
             * @returns {*}
             */
            function getRegisteredThemes()
            {
                return registeredThemes;
            }

            /**
             * Set active theme
             *
             * @param themeName
             */
            function setActiveTheme(themeName)
            {
                // If theme does not exist, fallback to the default theme
                if ( angular.isUndefined(service.themes.list[themeName]) )
                {
                    // If there is no theme called "default"...
                    if ( angular.isUndefined(service.themes.list.default) )
                    {
                        $log.error('You must have at least one theme named "default"');
                        return;
                    }

                    $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                    // Otherwise set theme to default theme
                    service.themes.active.name = 'default';
                    service.themes.active.theme = service.themes.list.default;
                    $cookies.put('selectedTheme', service.themes.active.name);

                    return;
                }

                service.themes.active.name = themeName;
                service.themes.active.theme = service.themes.list[themeName];
                $cookies.put('selectedTheme', themeName);
            }

            /**
             * Set available themes list
             *
             * @param themeList
             */
            function setThemesList(themeList)
            {
                service.themes.list = themeList;
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes, fuseThemingProvider)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });

        // Store generated PALETTES and THEMES objects from $mdThemingProvider
        // in our custom provider, so we can inject them into other areas
        fuseThemingProvider.setRegisteredPalettes($mdThemingProvider._PALETTES);
        fuseThemingProvider.setRegisteredThemes($mdThemingProvider._THEMES);
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        'default'  : {
            primary   : {
                name: 'fuse-pale-blue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'red'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'pink': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'blue'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'teal'     : {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'deep-orange'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-pale-blue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            var registeredThemes = fuseTheming.getRegisteredThemes();
            var registeredPalettes = fuseTheming.getRegisteredPalettes();

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0, color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming) {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [{
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [{
                label: 'Vertical Navigation',
                value: 'verticalNavigation',
                figure: 'assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label: 'Vertical Navigation with Fullwidth Toolbar',
                value: 'verticalNavigationFullwidthToolbar',
                figure: 'assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label: 'Vertical Navigation with Fullwidth Toolbar 2',
                value: 'verticalNavigationFullwidthToolbar2',
                figure: 'assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label: 'Horizontal Navigation',
                value: 'horizontalNavigation',
                figure: 'assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label: 'Content with Toolbar',
                value: 'contentWithToolbar',
                figure: 'assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label: 'Content Only',
                value: 'contentOnly',
                figure: 'assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigationFullwidthToolbar';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName) {
            // Set active theme
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme() {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode() {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle() {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav) {
        return {
            restrict: 'E',
            scope: {},
            controller: 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile: function(tElement) {
                tElement.addClass('ms-theme-options');

                return function postLink(scope) {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav() {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject required services
        var $log = angular.injector(['ng']).get('$log'),
            $resource = angular.injector(['ngResource']).get('$resource');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Prepare the resource object
            var resourceObj = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };

            // Assign the resource
            api[key] = $resource(resourceObj.url, resourceObj.paramDefaults, resourceObj.actions, resourceObj.options);
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($q, $log)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    apiObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    apiObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app.core').filter('ellipsis', function() {
            return function(text, length) {
                if (text.length > length) {
                    return text.substr(0, length) + "...";
                }
                return text;
            }
        });


})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'EA',
            compile : function (tElement, tAttrs)
            {
                var code;
                //No attribute? code is the content
                if ( !tAttrs.code )
                {
                    code = tElement.html();
                    tElement.empty();
                }

                return function (scope, iElement, iAttrs)
                {
                    if ( iAttrs.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(iAttrs.code);
                    }
                    var shouldInterpolate = scope.$eval(iAttrs.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }

                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );

                            iElement.append(contentParent);

                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {
                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);

                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(iAttrs.language || iAttrs.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function() {
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($scope, $rootScope, $mdSidenav, $translate, $mdToast, $cookieStore, $state, $http, $window, $timeout, msNavigationService) {
        var vm = this;
        $rootScope.UserName = $cookieStore.get('UserName');
        $rootScope.UserImage = $cookieStore.get('UserImage');

        // Data
        $rootScope.global = {
            search: ''
        };

        $rootScope.logout = function() {
            $cookieStore.remove('UserName');
            $cookieStore.remove('token');
            $cookieStore.remove('UserImage');
            $cookieStore.remove('UserId')

            $rootScope.UserImage = '';
            $http.defaults.headers.common.Authorization = '';
            // $state.go('app.login');
            // $window.location.reload();
            // $window.location.href = "/#/app/login";
            $window.location.href = "/#/app/login";
            $timeout(function() {
                $window.location.reload();
            });
        }

        $rootScope.MyProfile = function() {
            $state.go('app.myprofile');
        }

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [{
            'title': 'Online',
            'icon': 'icon-checkbox-marked-circle',
            'color': '#4CAF50'
        }, {
            'title': 'Away',
            'icon': 'icon-clock',
            'color': '#FFC107'
        }, {
            'title': 'Do not Disturb',
            'icon': 'icon-minus-circle',
            'color': '#F44336'
        }, {
            'title': 'Invisible',
            'icon': 'icon-checkbox-blank-circle-outline',
            'color': '#BDBDBD'
        }, {
            'title': 'Offline',
            'icon': 'icon-checkbox-blank-circle-outline',
            'color': '#616161'
        }];
        vm.languages = {
            en: {
                'title': 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code': 'en',
                'flag': 'us'
            },
            es: {
                'title': 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code': 'es',
                'flag': 'es'
            },
            tr: {
                'title': 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code': 'tr',
                'flag': 'tr'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status) {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout() {
            // Do logout here..
        }

        /**
         * Change Language
         */
        function changeLanguage(lang) {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if (lang.code !== 'en') {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position: 'top right',
                    parent: '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded() {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query) {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for (var x = 0; x < flatNavigation.length; x++) {
                if (flatNavigation[x].uisref) {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if (query) {
                navigation = navigation.filter(function(item) {
                    if (angular.lowercase(item.title).search(angular.lowercase(query)) > -1) {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function() {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item) {
            // If item has a link
            if (item.uisref) {
                // If there are state params,
                // use them...
                if (item.stateParams) {
                    $state.go(item.state, item.stateParams);
                } else {
                    $state.go(item.state);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function() {
    'use strict';

    /**
     * Main module of the Fuse
     */
    var app = angular
        .module('fuse', [

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick panel
            'app.quick-panel',
            'treeControl',
            'hmTouchEvents',

            // Sample
            //'app.sample',
            // 'app.Dashboard',
            'app.login',
            'app.customerdevices',
            'app.devicedetail',
            'app.profiledetails',
            // 'app.devicesetting_call_sms',
            // 'app.product',
            // 'app.productdetail',
            // 'app.ProductAttribute',
            // 'app.ProductTemplate',
            // 'app.menu',
            // 'app.News',
            // 'app.EnquiryMgmt',
            // 'app.datatable',
            // 'app.media',
            // 'app.dynamicpage',
            // 'app.category',
            // 'app.City',
            // 'app.MediaSetting',
            // 'app.Module',
            // 'app.EmailSetting',
            // 'app.TaxCategory',
            // 'app.brand',
            // 'app.Widget',
            // 'app.Banner',
            //'app.Setting',
            // 'app.Vendor',
            // 'app.Warehouse',
            // 'app.ShippingMethod',
            // 'app.ShippingRestriction',
            // 'app.SpecificationAttribute',
            // 'app.Courier',
            // 'app.Store',
            // 'app.EmailTemplate',
            // 'app.paymentgateway',
            // 'app.stickyfooter',
            // 'app.discount',
            // 'app.Provider',
            // 'app.deliverydates',
            'app.roles',
            // 'app.user',
            //'app.rewardsystem',
            'app.UserPermission',
            // 'app.manufacturertemplate',
            // 'app.manufacturer',
            // 'app.ratecomputation',
            // 'app.paymenttransaction',
            // 'app.order',
            // 'app.PetShop',
            // 'app.Feedback',
            // 'app.PetDevice',
            // 'app.pet',
            'app.ChangePassword',
            'app.Register',
            'app.Forgotpassword',
            // 'app.rcutype',
            // 'app.SendEmail',
            // 'app.Language',
            // 'app.LanguageResource',
            // 'app.NewsLetterSubscription',
            // 'app.DeviceStatus',
            // 'app.Currency',
            // 'app.Post',
            // 'app.Subscription',
            // 'app.FacebookSetting',
            //'app.Support',
            // 'app.FacebookFeed',
            // 'app.MobileWidget',
            'app.customer',
            //'app.MobileLanguageResource',
            // 'app.rcu',
            // 'app.rcuconfiguration',
            // 'app.devicetype',
            // 'app.inputdevice',
            // 'app.OutputDevice',
            // 'app.dimmer',
            // 'app.temprature',
            // 'app.actiontype',
            // 'app.DeviceAddress',
            // 'app.RoomTypeInputDetail',
            // 'app.roomtypeoutputdetail',
            // 'app.rcuwizard',
            // 'app.roomtypeaction',
            // 'app.rcucommand',
            // 'app.rcufileupload',
            // 'app.rcufirmwareupgrade',
            // 'app.deviceendpoint',
            // 'app.LocationInRoomType',
            // 'app.device',
            // 'app.rcuconfig',
            // 'app.errorlog',
            // 'app.RoomInfo',
            // 'app.room_overview',
            'app.VerifyAccount',
            'app.SequenceNumberSetting',
            'app.linkeddevices',
            'app.unlinkeddevices',
            'app.salesinfo',
            'app.customerservice',
            'app.firmwareupgrade',
        ]);

    app.directive('ngEnter', function() {
        return function(scope, element, attrs) {
            element.bind("keydown keypress", function(event) {
                if (event.which === 13) {
                    scope.$apply(function() {
                        scope.$eval(attrs.ngEnter);
                    });

                    event.preventDefault();
                }
            });
        };
    });

    app.directive('equal', function() {
        return {
            require: 'ngModel',
            link: function(scope, elm, attrs, ctrl) {

                scope.$watch(attrs.equal, function(newValue) {
                    if (ctrl && ctrl.$modelValue) {
                        if (newValue === ctrl.$modelValue) {
                            ctrl.$setValidity('equal', true);
                            // return newValue;
                        } else {
                            ctrl.$setValidity('equal', false);
                            // return undefined;
                        }
                    }
                });

                ctrl.$parsers.unshift(function(viewValue) {
                    if (viewValue) {
                        if (viewValue === scope.$eval(attrs.equal)) {
                            ctrl.$setValidity('equal', true);
                            return viewValue;
                        } else {
                            ctrl.$setValidity('equal', false);
                            return undefined;
                        }
                    } else {
                        ctrl.$setValidity('equal', true);
                        return viewValue;
                    }
                });
            }
        };
    });

    app.directive('vaildnumber', function() {
        return {
            require: 'ngModel',
            link: function(scope, elm, attrs, ctrl) {
                ctrl.$parsers.unshift(function(viewValue) {
                    if (viewValue) {
                        if (elm.intlTelInput("isValidNumber")) {
                            ctrl.$setValidity('vaildnumber', true);
                            return viewValue;
                        } else {
                            ctrl.$setValidity('vaildnumber', false);
                            return viewValue;
                        }
                    } else {
                        ctrl.$setValidity('vaildnumber', true);
                        return viewValue;
                    }
                });
            }
        };
    });

})();
(function() {
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, DTOptionsBuilder, $cookieStore, $http, $window) {

        // $rootScope.RoutePath = "http://localhost:3030/";
        //////////
        $rootScope.editorOptions = {
            language: 'en'
                // uiColor: '#000000'
        };


        $rootScope.convertdateformat = function(date1) {
            var date = new Date(date1.substring(0, date1.indexOf('T')));
            var firstdayDay = date.getDate();
            var firstdayMonth = date.getMonth() + 1;
            var firstdayYear = date.getFullYear();
            return ("00" + firstdayDay.toString()).slice(-2) + "-" + ("00" + firstdayMonth.toString()).slice(-2) + "-" + ("0000" + firstdayYear.toString()).slice(-4);
        }

        $rootScope.dtOptions = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withDisplayLength(100)
            .withOption('responsive', true)
            .withOption('autoWidth', false)
            // .withOption('paging', false)
            .withOption('deferRender', true)
            .withOption('language', {
                'zeroRecords': "No Record Found",
                'emptyTable': "No Record Found"
            })
            .withOption('dom', '<"top"<"left"<"length"l>>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>');


        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function(event) {
            if (event.targetScope.$id === $scope.$id) {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, $translateProvider, fuseConfigProvider) {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        // toastr configuration
        toastr.options.timeOut = 3000;
        toastr.options.positionClass = 'toast-top-right';
        toastr.options.preventDuplicates = true;
        toastr.options.progressBar = true;

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars': false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile': true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();

(function() {
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, $http, $cookieStore, $mdDialog, $mdToast, msNavigationService, $location, $window) {
        //Predefine data
        var token = $cookieStore.get('token');
        var datatoken = $http.defaults.headers.common['Authorization'];
        if (token != null && token != undefined) {
            if (datatoken == null || datatoken == undefined) {
                $http.defaults.headers.common['Authorization'] = token;
            };
        }
        $rootScope.CurrencyCode = "RM";

        $rootScope.UserId = $cookieStore.get('UserId');
        $rootScope.UserName = $cookieStore.get('UserName');
        $rootScope.FirstName = $cookieStore.get('FirstName');
        $rootScope.LastName = $cookieStore.get('LastName');
        $rootScope.OrganizationName = $cookieStore.get('OrganizationName');
        $rootScope.AccountType = $cookieStore.get('AccountType');

        // $rootScope.RoutePath = "http://192.168.1.63:3737/";
        // $rootScope.RoutePath = "http://182.70.126.194:3737/";
        // $rootScope.RoutePath = "http://embin.hopto.org:3737/";
        // $rootScope.RoutePath = "http://103.232.124.170:4747/";
        $rootScope.RoutePath = "https://api.matoflife.com/";
        // $rootScope.RoutePath = "https://uatapi.matoflife.com/";

        $rootScope.CheckPageRights = function(ModuleName, callback) {
            $rootScope.FlgAddedAccess = false;
            $rootScope.FlgModifiedAccess = false;
            $rootScope.FlgDeletedAccess = false;

            var params = {
                tablename: ModuleName,
            }

            $http.get($rootScope.RoutePath + "userPermission/CheckRightsbyPage", { params: params }).then(function(data) {
                if (data.data.success == true) {
                    var objpermission = data.data.data;

                    $rootScope.FlgAddedAccess = objpermission.Added;
                    $rootScope.FlgAddedEditlocal = objpermission.Added;
                    $rootScope.FlgModifiedAccess = objpermission.Modified;
                    $rootScope.FlgDeletedAccess = objpermission.Deleted;
                } else {
                    $rootScope.FlgAddedAccess = false;
                    $rootScope.FlgAddedEditlocal = false;
                    $rootScope.FlgModifiedAccess = false;
                    $rootScope.FlgDeletedAccess = false;
                }
                return callback(1);
            })

            // funAdded();

            // function funAdded() {
            //     var params = {
            //         tablename: ModuleName,
            //         permission: "Added"
            //     }

            //     $http.get($rootScope.RoutePath + "userPermission/CheckRights", { params: params }).then(function(data) {
            //         if (data.data.success == true) {
            //             $rootScope.FlgAddedAccess = true;
            //             $rootScope.FlgAddedEditlocal = true;
            //         } else {
            //             $rootScope.FlgAddedAccess = false;
            //             $rootScope.FlgAddedEditlocal = false;

            //         }
            //         funModified();
            //     })
            // }

            // function funModified() {
            //     var params = {
            //         tablename: ModuleName,
            //         permission: "Modified"
            //     }

            //     $http.get($rootScope.RoutePath + "userPermission/CheckRights", { params: params }).then(function(data) {
            //         if (data.data.success == true) {
            //             $rootScope.FlgModifiedAccess = true;
            //         } else {
            //             $rootScope.FlgModifiedAccess = false;
            //         }
            //         funDeleted();
            //     })
            // }

            // function funDeleted() {
            //     var params = {
            //         tablename: ModuleName,
            //         permission: "Deleted"
            //     }

            //     $http.get($rootScope.RoutePath + "userPermission/CheckRights", { params: params }).then(function(data) {
            //         if (data.data.success == true) {
            //             $rootScope.FlgDeletedAccess = true;
            //         } else {
            //             $rootScope.FlgDeletedAccess = false;
            //         }
            //         return callback(1);
            //     })
            // }

        }

        $rootScope.MenuSet = function() {
            var token1 = $cookieStore.get('token');

            if (token1 != "" && token1 != undefined) {
                $http.defaults.headers.common['Authorization'] = token1;
                // var params = {
                //     tablename: "Dashboard",
                //     permission: "Show"
                // }

                $http.get($rootScope.RoutePath + "userPermission/GetAllPageRights").then(function(data) {
                    if (data.data.success == true) {
                        var lstAllPages = data.data.data;
                        //Customer Device
                        var lstCustomerDevice = _.filter(lstAllPages, function(obj) {
                            return obj.tblmodulemgmt.Module == 'Customer Devices';
                        });
                        if (lstCustomerDevice.length > 0) {
                            msNavigationService.saveItem('customerdevices', {
                                title: 'Customer Devices',
                                state: 'app.customerdevices',
                                icon: 'icon-lock',
                                order: lstCustomerDevice[0].tblmodulemgmt.DisplayOrder,
                                weight: 1
                            });
                        }
                        //Customer
                        var lstCustomer = _.filter(lstAllPages, function(obj) {
                            return obj.tblmodulemgmt.Module == 'Customer';
                        });
                        if (lstCustomer.length > 0) {
                            msNavigationService.saveItem('customer', {
                                title: 'Customer',
                                state: 'app.customer',
                                icon: 'icon-lock',
                                order: lstCustomer[0].tblmodulemgmt.DisplayOrder,
                                weight: 1
                            });
                        }
                        //Device Detail
                        var lstDeviceDetail = _.filter(lstAllPages, function(obj) {
                            return obj.tblmodulemgmt.Module == 'Device Detail';
                        });
                        if (lstDeviceDetail.length > 0) {
                            msNavigationService.saveItem('devicedetail', {
                                title: 'Device Detail',
                                state: 'app.devicedetail',
                                icon: 'icon-lock',
                                order: lstDeviceDetail[0].tblmodulemgmt.DisplayOrder,
                                weight: 1
                            });
                        }
                        //Device Setting
                        var lstDeviceSetting = _.filter(lstAllPages, function(obj) {
                            return obj.tblmodulemgmt.Module == 'Device Setting';
                        });
                        if (lstDeviceSetting.length > 0) {
                            msNavigationService.saveItem('devicesetting_call_sms', {
                                title: 'Device Setting',
                                state: 'app.devicesetting_call_sms',
                                icon: 'icon-lock',
                                order: lstDeviceSetting[0].tblmodulemgmt.DisplayOrder,
                                weight: 1
                            });
                        }
                        //Sequence Number Settings
                        var lstSequenceNumberSettings = _.filter(lstAllPages, function(obj) {
                            return obj.tblmodulemgmt.Module == 'Sequence Number Setting';
                        });
                        if (lstSequenceNumberSettings.length > 0) {
                            msNavigationService.saveItem('SequenceNumberSetting', {
                                title: 'Sequence Number Setting',
                                state: 'app.SequenceNumberSetting',
                                icon: 'icon-lock',
                                order: lstSequenceNumberSettings[0].tblmodulemgmt.DisplayOrder,
                                weight: 1
                            });
                        }
                        //Manage Module
                        var lstManageModule = _.filter(lstAllPages, function(obj) {
                            return obj.tblmodulemgmt.Module == 'Manage Module';
                        });
                        if (lstManageModule.length > 0) {
                            msNavigationService.saveItem('Users.Module', {
                                title: 'Manage Module',
                                state: 'app.Module',
                                icon: 'icon-view-module',
                                order: lstManageModule[0].tblmodulemgmt.DisplayOrder,
                                weight: 1
                            });
                        }
                        //Roles
                        var lstRole = _.filter(lstAllPages, function(obj) {
                            return obj.tblmodulemgmt.Module == 'Roles';
                        });
                        if (lstRole.length > 0) {
                            msNavigationService.saveItem('Users.roles', {
                                title: 'Roles',
                                state: 'app.roles',
                                icon: 'icon-lock',
                                order: lstRole[0].tblmodulemgmt.DisplayOrder,
                                weight: 1
                            });
                        }
                        //User Permission
                        var lstUserPermission = _.filter(lstAllPages, function(obj) {
                            return obj.tblmodulemgmt.Module == 'User Permission';
                        });
                        if (lstUserPermission.length > 0) {
                            msNavigationService.saveItem('Users.UserPermission', {
                                title: 'User Permission',
                                state: 'app.UserPermission',
                                icon: 'icon-lock',
                                order: lstUserPermission[0].tblmodulemgmt.DisplayOrder,
                                weight: 1
                            });
                        }
                        //Profile Details
                        var lstProfileDetails = _.filter(lstAllPages, function(obj) {
                            return obj.tblmodulemgmt.Module == 'Profile Details';
                        });
                        if (lstProfileDetails.length > 0) {
                            msNavigationService.saveItem('profiledetails', {
                                title: 'Profile Details',
                                state: 'app.profiledetails',
                                icon: 'icon-account',
                                order: lstProfileDetails[0].tblmodulemgmt.DisplayOrder,
                                weight: 1
                            });
                        }
                        //LinkedDevices
                        var lstLinkedDevices = _.filter(lstAllPages, function(obj) {
                            return obj.tblmodulemgmt.Module == 'Linked Devices';
                        });
                        if (lstLinkedDevices.length > 0) {
                            msNavigationService.saveItem('linkeddevices', {
                                title: 'Linked Devices',
                                state: 'app.linkeddevices',
                                icon: 'icon-link',
                                order: lstLinkedDevices[0].tblmodulemgmt.DisplayOrder,
                                weight: 1
                            });
                        }
                        //Unlinked Devices
                        var lstUnlinkedDevices = _.filter(lstAllPages, function(obj) {
                            return obj.tblmodulemgmt.Module == 'Unlinked Devices';
                        });
                        if (lstUnlinkedDevices.length > 0) {
                            msNavigationService.saveItem('unlinkeddevices', {
                                title: 'Unlinked Devices',
                                state: 'app.unlinkeddevices',
                                icon: 'icon-link-off',
                                order: lstUnlinkedDevices[0].tblmodulemgmt.DisplayOrder,
                                weight: 1
                            });
                        }
                        //Sales Info
                        var lstSalesInfo = _.filter(lstAllPages, function(obj) {
                            return obj.tblmodulemgmt.Module == 'Sales Info';
                        });
                        if (lstSalesInfo.length > 0) {
                            msNavigationService.saveItem('salesinfo', {
                                title: 'Sales Info',
                                state: 'app.salesinfo',
                                icon: 'icon-document',
                                order: lstSalesInfo[0].tblmodulemgmt.DisplayOrder,
                                weight: 1
                            });
                        }
                        //Customer Service
                        var lstCustomerService = _.filter(lstAllPages, function(obj) {
                            return obj.tblmodulemgmt.Module == 'Customer Service';
                        });
                        if (lstCustomerService.length > 0) {
                            msNavigationService.saveItem('customerservice', {
                                title: 'Customer Service',
                                state: 'app.customerservice',
                                icon: 'icon-headset',
                                order: lstCustomerService[0].tblmodulemgmt.DisplayOrder,
                                weight: 1
                            });
                        }
                        //Firmware Upgrade
                        var lstFirmwareUpgrade = _.filter(lstAllPages, function(obj) {
                            return obj.tblmodulemgmt.Module == 'Firmware Upgrade';
                        });
                        if (lstFirmwareUpgrade.length > 0) {
                            msNavigationService.saveItem('firmwareupgrade', {
                                title: 'Firmware Upgrade',
                                state: 'app.firmwareupgrade',
                                icon: 'icon-headset',
                                order: lstFirmwareUpgrade[0].tblmodulemgmt.DisplayOrder,
                                weight: 1
                            });
                        }
                    }
                });
            }
        }
        $rootScope.MenuSet();

        var socket = io($rootScope.RoutePath);
        socket.on('EDJCommand', function(msg) {
            socket.emit('Tick');

            socket.on('EnergyUsage', function(msg1) {
                // console.log("count", count)
                $mdDialog.hide(confirm);
            });

            var obj = JSON.parse(msg);
            // console.log(obj)
            if (obj != null && obj.CustomerId == $rootScope.UserId) {
                var confirm = $mdDialog.confirm()
                    .title('Would you like to add the ' + obj.DeviceName + ' device into your account?')
                    .textContent('')
                    .ariaLabel('Lucky day')
                    .targetEvent()
                    .ok('Decline')
                    .cancel('Accept');

                $mdDialog.show(confirm).then(function() {
                    var obj1 = new Object();
                    obj1.DeviceSerial = obj.MacAddress;
                    obj1.Status = "FF";
                    $rootScope.CreateDevice(obj1);
                }, function() {
                    var obj1 = new Object();
                    obj1.Name = obj.CustomerName;
                    obj1.DeviceType = obj.Type;
                    obj1.DeviceName = obj.DeviceName;
                    obj1.DeviceSerial = obj.MacAddress;
                    obj1.CustomerMasterId = obj.CustomerId;
                    obj1.Status = "00";
                    $rootScope.CreateDevice(obj1);
                });
            }
        });

        $rootScope.CreateDevice = function(o) {
            $http.post($rootScope.RoutePath + "customerdevices/SaveDevice", o).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );
                    $rootScope.FlgAddedEditlocal = false;
                    if ($rootScope.FlgAddedAccess == true) {
                        $rootScope.FlgAddedEditlocal = true
                    }
                    // $rootScope.GetUserDevices();
                    if (o.DeviceType == "Mat" && $location.path() == "/linkeddevices") {
                        $rootScope.GetMatList();
                    } else if (o.DeviceType != "Mat" && $location.path() == "/unlinkeddevices") {
                        $rootScope.GetAllInavtiveAlarmDevice();
                    } else {
                        socket.emit('dailog', JSON.stringify($rootScope.UserId));
                    }
                } else {
                    if (data.data.data == 'TOKEN') {
                        //$cookieStore.remove('UserName');
                        //$cookieStore.remove('token');
                        //window.location.href = '/app/login';
                        $rootScope.logout();
                    }
                    // else {
                    //     $mdToast.show(
                    //         $mdToast.simple()
                    //         .textContent(data.data.message)
                    //         .position('top right')
                    //         .hideDelay(3000)
                    //     );
                    // }
                    socket.emit('dailog', JSON.stringify($rootScope.UserId));
                }
            });
        };

        $rootScope.GetUserDevices = function() {
            var params = {
                EmailAddress: $rootScope.UserName
            }
            $http.get($rootScope.RoutePath + "customerdevices/GetAllCustomerDeviceByUser", { params: params }).then(function(data) {
                $rootScope.lstCustomerDevice = data.data;
                socket.emit('dailog', JSON.stringify($rootScope.UserId));
            });
        }

        //Predefine data
        $rootScope.$on('$stateChangeStart', function(e, to) {
            // $rootScope.CheckPageRights(to);

            $rootScope.Callfuntion = function() {
                // $http.get($rootScope.RoutePath + 'currency/GetCurrency').then(function(response) {
                //     if (response.data != null) {
                //         $rootScope.CurrencyCode = response.data.CurrencyCode;
                //     } else {
                //         $rootScope.CurrencyCode = "RM";
                //     }
                // });


                //check User Login
                $rootScope.UserName = $cookieStore.get('UserName'); 
                if ($rootScope.UserName == null || $rootScope.UserName == undefined) {
                    console.log(window.location.href);
                    if (window.location.href.indexOf('app/login') == -1 && window.location.href.indexOf('Forgotpassword') == -1 && window.location.href.indexOf('Register') == -1 && window.location.href.indexOf('VerifyAccount') == -1 && window.location.href.indexOf('ChangePassword') == -1) {
                        //$state.go("app.login");
                        window.location.href = '/#/app/login';
                    }
                }

                //check Permission
                var params = {
                    tablename: to.ModuleName,
                    permission: "Show"
                }

                $http.get($rootScope.RoutePath + "userPermission/CheckRights", { params: params }).then(function(data) {
                    if (data.data.success == false) {
                        e.preventDefault();
                        console.log(window.location.href);
                        if (window.location.href.indexOf('app/login') == -1 && window.location.href.indexOf('Forgotpassword') == -1 && window.location.href.indexOf('Register') == -1 && window.location.href.indexOf('VerifyAccount') == -1 && window.location.href.indexOf('ChangePassword') == -1) {
                            //$state.go("app.login");
                            window.location.href = '/#/app/login';
                        }
                    };

                })
            }
            $rootScope.Callfuntion();


        });
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function() {
            $rootScope.loadingProgress = true;

        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function() {
            $timeout(function() {
                delete $http.defaults.headers.common['X-Requested-With'];
                $http.defaults.headers.common['X-Requested-With'] = $state.current.ModuleName;
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function() {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
        //$locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/app/login');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies',
            function(_$cookies) {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigationFullwidthToolbar';

        var layouts = {
            verticalNavigation: {
                main: 'app/core/layouts/vertical-navigation.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar: {
                main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2: {
                main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main: 'app/core/layouts/horizontal-navigation.html',
                toolbar: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly: {
                main: 'app/core/layouts/content-only.html',
                toolbar: '',
                navigation: ''
            },
            contentWithToolbar: {
                main: 'app/core/layouts/content-with-toolbar.html',
                toolbar: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views: {
                    'main@': {
                        templateUrl: layouts[layoutStyle].main,
                        controller: 'MainController as vm'
                    },
                    'toolbar@app': {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller: 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller: 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller: 'QuickPanelController as vm'
                    }
                }
            });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function() {
    'use strict';

    angular
        .module('fuse')
        .config(config).config(override_mdMaxlength);

    /** @ngInject */
    function config() {
        // Put your custom configurations here
    }

    function override_mdMaxlength($provide) {
        $provide.decorator(
            'mdMaxlengthDirective',
            function($delegate) {
                var mdMaxlength = $delegate[0];
                var link = mdMaxlength.link;
                mdMaxlength.compile = function() {
                    //Line 18 to 64: Code of md-maxlength directive. Change in line 62
                    return function(scope, element, attr, ctrls) {
                        var maxlength;
                        var ngModelCtrl = ctrls[0];
                        var containerCtrl = ctrls[1];
                        var charCountEl = angular.element('<div class="md-char-counter">');

                        attr.$set('ngTrim', 'false');
                        containerCtrl.element.append(charCountEl);

                        ngModelCtrl.$formatters.push(renderCharCount);
                        ngModelCtrl.$viewChangeListeners.push(renderCharCount);
                        element.on(
                            'input keydown',
                            function() {
                                renderCharCount(); //make sure it's called with no args
                            }
                        );

                        scope.$watch(attr.mdMaxlength, function(value) {
                            maxlength = value;
                            if (angular.isNumber(value) && value > 0) {
                                if (!charCountEl.parent().length) {
                                    $animate.enter(
                                        charCountEl,
                                        containerCtrl.element,
                                        angular.element(containerCtrl.element[0].lastElementChild)
                                    );
                                }
                                renderCharCount();
                            } else {
                                $animate.leave(charCountEl);
                            }
                        });

                        ngModelCtrl.$validators['md-maxlength'] = function(modelValue, viewValue) {
                            if (!angular.isNumber(maxlength) || maxlength < 0) {
                                return true;
                            }
                            return (modelValue || element.val() || viewValue || '').length <= maxlength;
                        };

                        function renderCharCount(value) {
                            //Original code commented
                            //charCountEl.text( ( element.val() || value || '' ).length + '/' + maxlength );
                            //CHANGE PROPOSED BY @breeze4 (MATT BAILEY): http://tinyurl.com/pxnnvxb
                            charCountEl.text((ngModelCtrl.$modelValue || '').length + '/' + maxlength);
                            return value;
                        }
                    };
                };
                return $delegate;
            }
        );
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        // api.sample = $resource(api.baseUrl + 'sample/sample.json');

        return api;
    }

})();
var Base64 = {
 
        keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
 
        encode: function (input) {
            var output = "";
            var chr1, chr2, chr3 = "";
            var enc1, enc2, enc3, enc4 = "";
            var i = 0;
 
            do {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);
 
                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;
 
                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }
 
                output = output +
                    this.keyStr.charAt(enc1) +
                    this.keyStr.charAt(enc2) +
                    this.keyStr.charAt(enc3) +
                    this.keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = "";
                enc1 = enc2 = enc3 = enc4 = "";
            } while (i < input.length);
 
            return output;
        },
 
        decode: function (input) {
            var output = "";
            var chr1, chr2, chr3 = "";
            var enc1, enc2, enc3, enc4 = "";
            var i = 0;
 
            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            var base64test = /[^A-Za-z0-9\+\/\=]/g;
            if (base64test.exec(input)) {
                window.alert("There were invalid base64 characters in the input text.\n" +
                    "Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\n" +
                    "Expect errors in decoding.");
            }
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
 
            do {
                enc1 = this.keyStr.indexOf(input.charAt(i++));
                enc2 = this.keyStr.indexOf(input.charAt(i++));
                enc3 = this.keyStr.indexOf(input.charAt(i++));
                enc4 = this.keyStr.indexOf(input.charAt(i++));
 
                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;
 
                output = output + String.fromCharCode(chr1);
 
                if (enc3 != 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 != 64) {
                    output = output + String.fromCharCode(chr3);
                }
 
                chr1 = chr2 = chr3 = "";
                enc1 = enc2 = enc3 = enc4 = "";
 
            } while (i < input.length);
 
            return output;
        }
    };
 

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label \ntranslate=\"QUICKPANEL.TODAY\">TODAY</md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" ms-scroll \nng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label \ntranslate=\"QUICKPANEL.CHAT\">CHAT</md-tab-label><md-tab-body><md-content class=\"chat-tab scrollable\" ms-scroll \nng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" ng-controller=\"ChatTabController as vm\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label translate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</md-tab-label><md-tab-body>\n<md-content class=\"activity-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/ActiveDevices/ActiveDevices.html","<style type=\"text/css\">\nbody {\r\n        font-family: arial, verdana, sans-serif;\r\n        /* font-size: 12px; */\r\n    }\r\n    \r\n    .dww img {\r\n        width: 30px;\r\n        height: 30px;\r\n        margin: 5px 10px;\r\n    }\n</style><md-content><div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"customPageHeader\" ng-if=\"AccountType == \'Individual\'\">Welcome {{FirstName}} {{LastName}}</div><div \nclass=\"customPageHeader\" ng-if=\"AccountType == \'Organisation\'\">Welcome {{OrganizationName}}</div><div class=\"content\">\n<treecontrol class=\"tree-classic customTreeList\" tree-model=\"MatList\" options=\"treeOptions\" expanded-nodes=\"MatList\" \non-selection=\"showSelected(node)\" selected-node=\"node1\"><div layout=\"row\" layout-wrap layout-align=\"left center\">\n<md-menu><md-button aria-label=\" more \" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event) \"><md-icon \nmd-font-icon=\"icon-dots-vertical \"></md-icon></md-button><md-menu-content width=\"2 \"><md-menu-item><md-button \nng-click=\"ShowSetting(node) \" aria-label=\"Refresh widget \">Settings</md-button></md-menu-item><md-menu-item \nng-if=\"node.DeviceType==\'Cordless Mat\'\"><md-button ng-click=\"OpenCordlessDevices(node) \" aria-label=\"Refresh widget \">\nCordless Device</md-button></md-menu-item><md-menu-item \nng-if=\"node.DeviceType==\'Mat\' || node.DeviceType ==\'Cordless Mat\'\"><md-button ng-click=\"OpenInLinkDeviceList(node) \" \naria-label=\"Refresh widget \">Link Device</md-button></md-menu-item><md-menu-item \nng-if=\"node.DeviceType !=\'Mat\' && node.DeviceType !=\'Cordless Mat\'\"><md-button ng-click=\"UnLinkDevices(node) \" \naria-label=\"Refresh widget \">Unlink Device</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"DeleteCustomerDevice(node,$event) \" aria-label=\"Refresh widget \">Delete</md-button></md-menu-item>\n</md-menu-content></md-menu><span ng-if=\"node.EditFlag==false && node.Connection_Status == false\" \nhm-doubletap=\"ChangeFlg(node)\" style=\"color: red\">{{node.DeviceName}}<br><span style=\"font-size: x-small\">\n{{node.DisplayType| uppercase}}-{{node.DeviceSerial}}</span></span> <span \nng-if=\"node.EditFlag==false && node.Connection_Status == true\" hm-doubletap=\"ChangeFlg(node)\" style=\"color: green\">\n{{node.DeviceName}}<br><span style=\"font-size: x-small\">{{node.DisplayType| uppercase}}-{{node.DeviceSerial}}</span>\n</span><md-input-container ng-if=\"node.EditFlag != false\" class=\"md-block\" flex-gt-sm=\"50\"><input type=\"text\" \nname=\"DeviceName\" ng-model=\"node.DeviceName\"></md-input-container><div ng-if=\"node.EditFlag != false\"><md-button \nclass=\"md-raised md-primary\" ng-click=\"UpdateDevice(node)\">Save</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"ChangeFlg(node)\">Cancel</md-button></div></div></treecontrol></div></div></md-content>");
$templateCache.put("app/main/ChangePassword/ChangePassword.html","<div id=\"changepassword\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"changepassword-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><img src=\"/assets/icons/icon.jpg\" alt=\"\" class=\"loginLogo\"><div \nid=\"changepassword-form\" class=\"md-whiteframe-2dp\" ng-show=\"!IsSucess\"><form action=\"\" name=\"FormChangePassword\" \nng-show=\"flglink\"><h2 align=\"center\">Reset Your Password</h2><md-input-container class=\"md-block custom-Control\" \nflex-gt-sm md-no-float><label>Enter New Password</label><input name=\"password\" type=\"password\" \nng-model=\"model.password\" ng-required=\"true\" minlength=\"6\"><div ng-messages=\"FormChangePassword.password.$error\" \nng-show=\"FormChangePassword.password.$touched\"><div ng-message=\"required\"><span>You can\'t leave this empty</span></div>\n<div ng-message=\"md-maxlength\"><span>Password is 100 char long</span></div><div ng-message=\"minlength\"><span>\nEnter six digit Password</span></div></div></md-input-container><div style=\"clear: both\"></div><md-input-container \nclass=\"md-block custom-Control\" flex-gt-sm md-no-float><label>Re-Enter New Password</label><input \nname=\"confirmpassword\" type=\"password\" ng-model=\"model.confirmpassword\" ng-required=\"true\" equal=\"model.password\"><div \nng-messages=\"FormChangePassword.confirmpassword.$error\" ng-show=\"FormChangePassword.confirmpassword.$touched\"><div \nng-message=\"required\"><span>You can\'t leave this empty</span></div><div ng-message=\"md-maxlength\"><span>\nConfrim password is 100 char long</span></div><div ng-message=\"equal\"><span>These passwords don\'t match</span></div>\n</div></md-input-container><md-button class=\"md-raised md-accent submit-button\" ng-click=\"ChangePassword(model)\" \nng-disabled=\"FormChangePassword.$invalid\">Continue</md-button></form><div class=\"row text-center\"><div class=\"title\" \nng-show=\"!flglink\">Link Expired!</div></div></div><div id=\"changepassword-form\" class=\"md-whiteframe-2dp\" \nng-show=\"IsSucess\"><h2 align=\"center\">Password Changed Successfully</h2><span class=\"smallText\" align=\"center\">\nCongratulation your Password has been changed. Please click on the link below to login with New Password.</span><div \nlayout=\"row\" align=\"center\"><a class=\"linkOrange md-block\" ui-sref=\"app.login\">Go Back To Login</a></div></div></div>\n</div>");
$templateCache.put("app/main/Customer/Customer.html","<md-content><div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"customPageHeader\">Customer</div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><md-tabs \nmd-selected=\"tab.selectedIndex\" md-dynamic-height md-border-bottom><md-tab label=\"Customer List\" \nng-click=\"ResetEdit()\"><div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"content custom-content\"><table class=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"dtInstance\" \ndt-columns=\"dtColumns\" dt-options=\"dtOptions\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Customer Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Customer Account No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Email</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Phone</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">PinCode</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Customer Type</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Total Device</span></div></th><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\">Action</span></div></th></tr></thead></table></div></div></md-tab></md-tabs></div></div></div>\n</md-content><style>\n.cropArea {\r\n        background: #E4E4E4;\r\n        overflow: hidden;\r\n        width: 100%;\r\n        height: 350px;\r\n    }\n</style>");
$templateCache.put("app/main/CustomerDevices/CustomerDevices.html","<style type=\"text/css\">\nbody {\r\n        font-family: arial, verdana, sans-serif;\r\n        /* font-size: 12px; */\r\n    }\r\n    \r\n    .dww img {\r\n        width: 30px;\r\n        height: 30px;\r\n        margin: 5px 10px;\r\n    }\n</style><md-content><div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"customPageHeader\">Customer Device Management</div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\">\n<form name=\"CustomerDeviceForm\" novalidate class=\"md-inline-form\"><md-tabs md-selected=\"tab.selectedIndex\" \nmd-dynamic-height md-border-bottom><md-tab label=\"Customer Device Manage\" ng-click=\"ResetEdit()\" \nng-disabled=\"!FlgAddedEditlocal\"><div id=\"processing1\" style=\"display: block\"><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\" value=\"...\" md-diameter=\"100\" \nclass=\"page-loader\"></md-progress-circular></div></div><div class=\"custom-content\"><div class=\"mainContainer\">\n<md-content class=\"md-padding\"><a ng-click=\"toggle()\" ng-show=\"FlgAddedEditlocal\" class=\"showBtn\">Add Device<i \nng-show=\"!flgforIcon\" class=\"icon-plus-circle\"></i><i ng-show=\"flgforIcon\" class=\"icon-close-circle-outline right\"></i>\n</a><div class=\"ShowContentBox\"><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label>\nDevice Type*</label><md-select ng-model=\"model.DeviceType\" name=\"DeviceType\" required \nng-disabled=\"model.id!=0 && model.id!=\'\'\"><md-option value=\"Mat\">Mat</md-option><md-option value=\"Alarm\">Alarm\n</md-option><md-option value=\"Socket\">Socket</md-option></md-select><div \nng-messages=\"CustomerDeviceForm.DeviceType.$error\" ng-if=\"CustomerDeviceForm.DeviceType.$touched\"><div \nng-message=\"required\"><span>Device Type is required</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label>Device Name*</label><input type=\"text\" \nname=\"DeviceName\" ng-model=\"model.DeviceName\" md-maxlength=\"150\" required><div \nng-messages=\"CustomerDeviceForm.DeviceName.$error\" ng-if=\"CustomerDeviceForm.DeviceName.$touched\"><div \nng-message=\"required\"><span>Device Name is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"50\"><label>Device Serial*</label><input type=\"text\" name=\"DeviceSerial\" \nng-model=\"model.DeviceSerial\" required md-maxlength=\"150\"><div ng-messages=\"CustomerDeviceForm.DeviceSerial.$error\" \nng-if=\"CustomerDeviceForm.DeviceSerial.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\nDevice Serial is required</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"50\" ng-if=\"model.DeviceType==\'Mat\'\"><label>Multiple Detection Avoidance Time</label>\n<md-select ng-model=\"model.MD_Timer\" name=\"MD_Timer\"><md-option value=\"\">Select</md-option><md-option \nng-repeat=\"item in TimingListforMDtime\" value=\"{{item.value}}\">{{item.time}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"50\" ng-if=\"model.DeviceType==\'Mat\'\"><label>\nAlert Message Time</label><md-select ng-model=\"model.Alert_Msg_Timer\" name=\"Alert_Msg_Timer\"><md-option value=\"\">Select\n</md-option><md-option ng-repeat=\"item in TimingList\" value=\"{{item.value}}\">{{item.time}}</md-option></md-select>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\" \nng-if=\"model.DeviceType==\'Mat\'\"><label>Standby Time</label><md-select ng-model=\"model.Standby_Timer\" \nname=\"Standby_Timer\"><md-option value=\"\">Select</md-option><md-option ng-repeat=\"item in TimingList\" \nvalue=\"{{item.value}}\">{{item.time}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\" ng-if=\"model.DeviceType==\'Mat\'\"><label>Mat Light Time</label><md-select ng-model=\"model.LED_Timer\" \nname=\"LED_Timer\"><md-option value=\"\">Select</md-option><md-option ng-repeat=\"item in TimingList\" \nvalue=\"{{item.value}}\">{{item.time}}</md-option></md-select></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"50\" ng-if=\"model.DeviceType==\'Socket\' || model.DeviceType==\'Alarm\'\">\n<label>Select Mat</label><md-select name=\"Device_Mat_Id\" ng-model=\"model.Device_Mat_Id\"><md-option \nng-repeat=\"item in MatList | orderBy: \'DeviceName\'\" value=\"{{item.id}}\">{{item.DeviceName}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" md-no-float \nng-if=\"model.DeviceType==\'Socket\' || model.DeviceType==\'Alarm\'\"><md-radio-group ng-model=\"model.SchedulType\" \nname=\"SchedulType\"><md-radio-button value=\"Scheduling\" class=\"md-primary\">Scheduling</md-radio-button><md-radio-button \nvalue=\"Always On\" class=\"md-primary\">Always On (24 Hours)</md-radio-button></md-radio-group></md-input-container></div>\n<div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\" \nng-show=\"(model.DeviceType==\'Socket\' || model.DeviceType==\'Alarm\') && model.SchedulType==\'Scheduling\'\"><label>\nStart Time *</label><input type=\"text\" ng-required=\"model.SchedulType==\'Scheduling\'\" name=\"Scheduler_StartTime\" \nclass=\"mobiscroll mobiscrollTime\" readonly=\"readonly\" ng-model=\"model.Scheduler_StartTime\" \nvalue=\"model.Scheduler_StartTime\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"50\" \nng-show=\"(model.DeviceType==\'Socket\' || model.DeviceType==\'Alarm\') && model.SchedulType==\'Scheduling\'\"><label>\nEnd Time *</label><input type=\"text\" ng-required=\"model.SchedulType==\'Scheduling\'\" name=\"Scheduler_EndTime\" \nclass=\"mobiscroll mobiscrollTime\" readonly=\"readonly\" ng-model=\"model.Scheduler_EndTime\" \nvalue=\"model.Scheduler_EndTime\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"50\" ng-if=\"model.DeviceType==\'Alarm\'\"><label>Trigger Type</label><md-select \nng-model=\"model.TriggerType\" name=\"TriggerType\"><md-option value=\"At 1st Step\">At 1st Step</md-option><md-option \nvalue=\"At Alert Event\">At Alert Event</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\" ng-if=\"model.DeviceType==\'Socket\'\"><label>Light On Time</label><md-select \nng-model=\"model.LightOff_Timer\" name=\"LightOff_Timer\"><md-option value=\"\">Select</md-option><md-option \nng-repeat=\"item in TimingList\" value=\"{{item.value}}\">{{item.time}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"50\" ng-if=\"model.DeviceType==\'Alarm\'\"><label>Alarm On Time</label>\n<md-select ng-model=\"model.Alarm_Time\" name=\"Alarm_Time\"><md-option value=\"\">Select</md-option><md-option \nng-repeat=\"item in TimingList\" value=\"{{item.value}}\">{{item.time}}</md-option></md-select></md-input-container></div>\n<div layout-gt-sm=\"row\" ng-if=\"model.DeviceType==\'Mat\'\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label>\nText for SMS on First Step*</label><input type=\"text\" name=\"Text_for_1St_Step\" ng-model=\"model.Text_for_1St_Step\" \nmd-maxlength=\"150\" required><div ng-messages=\"CustomerDeviceForm.Text_for_1St_Step.$error\" \nng-if=\"CustomerDeviceForm.Text_for_1St_Step.$touched\"><div ng-message=\"required\"><span>Text for SMS is required</span>\n</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label>\nText for SMS on Second Step*</label><input type=\"text\" name=\"Text_for_2nd_Step\" ng-model=\"model.Text_for_2nd_Step\" \nmd-maxlength=\"150\" required><div ng-messages=\"CustomerDeviceForm.Text_for_2nd_Step.$error\" \nng-if=\"CustomerDeviceForm.Text_for_2nd_Step.$touched\"><div ng-message=\"required\"><span>Text for SMS is required</span>\n</div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\" \nng-if=\"model.DeviceType==\'Mat\'\"><label>Text for Alert SMS*</label><input type=\"text\" name=\"Text_for_Alert_Event\" \nng-model=\"model.Text_for_Alert_Event\" md-maxlength=\"150\" required><div \nng-messages=\"CustomerDeviceForm.Text_for_Alert_Event.$error\" ng-if=\"CustomerDeviceForm.Text_for_Alert_Event.$touched\">\n<div ng-message=\"required\"><span>Text for Alert alert sms Name is required</span></div></div></md-input-container>\n</div><div ng-if=\"model.DeviceType==\'Mat\'\"><h2 class=\"md-flex\">SMS configuration:</h2></div><div layout-gt-sm=\"row\" \nng-show=\"model.SchedulType_FirstStep==\'Scheduling\' && model.DeviceType==\'Mat\'\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\"><label>Scheduler Start Time*</label><input type=\"text\" \nng-required=\"model.SchedulType_FirstStep==\'Scheduling\'\" name=\"Scheduler_StartTime_FirstStep\" \nclass=\"mobiscroll mobiscrollTime\" readonly=\"readonly\" ng-model=\"model.Scheduler_StartTime_FirstStep\" \nvalue=\"model.Scheduler_StartTime_FirstStep\"><div ng-messages=\"CustomerDeviceForm.Scheduler_StartTime_FirstStep.$error\" \nng-if=\"CustomerDeviceForm.Scheduler_StartTime_FirstStep.$touched\"><div ng-message=\"required\"><span>\nScheduler Start Time is required</span></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\"><label>Scheduler End Time*</label><input type=\"text\" \nng-required=\"model.SchedulType_FirstStep==\'Scheduling\'\" name=\"Scheduler_EndTime_FirstStep\" \nclass=\"mobiscroll mobiscrollTime\" readonly=\"readonly\" ng-model=\"model.Scheduler_EndTime_FirstStep\" \nvalue=\"model.Scheduler_EndTime_FirstStep\"><div ng-messages=\"CustomerDeviceForm.Scheduler_EndTime_FirstStep.$error\" \nng-if=\"CustomerDeviceForm.Scheduler_EndTime_FirstStep.$touched\"><div ng-message=\"required\"><span>\nScheduler End Time is required</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" \nng-if=\"model.DeviceType==\'Mat\'\"></div><div layout-gt-sm=\"row\" \nng-show=\"model.SchedulType_SecondStep==\'Scheduling\' && model.DeviceType==\'Mat\'\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\"><label>Scheduler Start Time for Second Step*</label><input type=\"text\" \nng-required=\"model.SchedulType_SecondStep==\'Scheduling\'\" name=\"Scheduler_StartTime_SecondStep\" \nclass=\"mobiscroll mobiscrollTime\" readonly=\"readonly\" ng-model=\"model.Scheduler_StartTime_SecondStep\" \nvalue=\"model.Scheduler_StartTime_FirstStep\"><div \nng-messages=\"CustomerDeviceForm.Scheduler_StartTime_SecondStep.$error\" \nng-if=\"CustomerDeviceForm.Scheduler_StartTime_SecondStep.$touched\"><div ng-message=\"required\"><span>\nScheduler StartTime is required</span></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\"><label>Scheduler End Time for Second step*</label><input type=\"text\" \nng-required=\"model.SchedulType_SecondStep==\'Scheduling\'\" name=\"Scheduler_EndTime_SecondStep\" \nclass=\"mobiscroll mobiscrollTime\" readonly=\"readonly\" ng-model=\"model.Scheduler_EndTime_SecondStep\" \nvalue=\"model.Scheduler_EndTime_FirstStep\"><div ng-messages=\"CustomerDeviceForm.Scheduler_EndTime_SecondStep.$error\" \nng-if=\"CustomerDeviceForm.Scheduler_EndTime_SecondStep.$touched\"><div ng-message=\"required\"><span>\nScheduler EndTime is required</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" \nng-show=\"model.DeviceType==\'Mat\'\"><md-input-container class=\"md-block contactNo\" md-no-float flex-gt-sm=\"50\"><label>\nMobile No *</label><input type=\"tel\" id=\"MobileNo\" name=\"MobileNo\" ng-model=\"SMSmodel.MobileNo\" \nplaceholder=\"+11234567890\" ng-maxlength=\"15\"><div ng-messages=\"CustomerDeviceForm.MobileNo.$error\" \nng-show=\"CustomerDeviceForm.MobileNo.$touched\"><div ng-message=\"maxlength\">Please enter valid mobile number</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"50\" md-no-float><md-radio-group \nng-model=\"SMSmodel.SchedulType_SMS\" name=\"SchedulType_SMS\"><md-radio-button value=\"Scheduling\" class=\"md-primary\">\nScheduling</md-radio-button><md-radio-button value=\"Always On\" class=\"md-primary\">Always On (24 Hours)\n</md-radio-button></md-radio-group></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><md-button\n class=\"md-raised md-primary\" ng-click=\"addMore2(SMSmodel)\"><md-icon md-font-icon=\"icon-plus-circle\"></md-icon>\nAdd More Numbers</md-button></md-input-container></div><div layout-gt-sm=\"row\" \nng-show=\"SMSmodel.SchedulType_SMS==\'Scheduling\' && model.DeviceType==\'Mat\'\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\"><label>Scheduler Start Time *</label><input type=\"text\" name=\"Scheduler_StartTime\" \nclass=\"mobiscroll mobiscrollTime\" readonly=\"readonly\" ng-model=\"SMSmodel.Scheduler_StartTime\" \nvalue=\"SMSmodel.Scheduler_StartTime\"><div ng-messages=\"CustomerDeviceForm.Scheduler_StartTime.$error\" \nng-if=\"CustomerDeviceForm.Scheduler_StartTime.$touched\"><div ng-message=\"required\"><span>\nScheduler StartTime is required</span></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\"><label>Scheduler End Time *</label><input type=\"text\" name=\"Scheduler_EndTime\" \nclass=\"mobiscroll mobiscrollTime\" readonly=\"readonly\" ng-model=\"SMSmodel.Scheduler_EndTime\" \nvalue=\"SMSmodel.Scheduler_EndTime\"><div ng-messages=\"CustomerDeviceForm.Scheduler_EndTime.$error\" \nng-if=\"CustomerDeviceForm.Scheduler_EndTime.$touched\"><div ng-message=\"required\"><span>Scheduler EndTime is required\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" ng-show=\"model.DeviceType==\'Mat\'\">\n<md-input-container class=\"md-block\" flex=\"20\" flex-md=\"33\" flex-sm=\"50\" flex-xs=\"100\"><md-checkbox \nng-model=\"SMSmodel.First_Step\" class=\"md-primary\">First Step</md-checkbox></md-input-container><md-input-container \nclass=\"md-block\" flex=\"20\" flex-md=\"33\" flex-sm=\"50\" flex-xs=\"100\"><md-checkbox ng-model=\"SMSmodel.Second_Step\" \nclass=\"md-primary\">Second Step</md-checkbox></md-input-container><md-input-container class=\"md-block\" flex=\"20\" \nflex-md=\"33\" flex-sm=\"50\" flex-xs=\"100\"><md-checkbox ng-model=\"SMSmodel.Alert\" class=\"md-primary\">Alert</md-checkbox>\n</md-input-container><md-input-container class=\"md-block\" flex=\"20\" flex-md=\"33\" flex-sm=\"50\" flex-xs=\"100\">\n<md-checkbox ng-model=\"SMSmodel.Device_Faliure\" class=\"md-primary\" ng-true-value=\"\'true\'\" ng-false-value=\"\'false\'\">\nDevice Faliure</md-checkbox></md-input-container></div><div id=\"simple-table\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"content\"><table id=\"Device\" \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"dtOptions2\" dt-column-defs=\"dtColumnDefsDevice\" \nng-if=\"lstSMS !=\'\' && model.DeviceType==\'Mat\'\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Mobile No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Scheduler StartTime</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Scheduler EndTime</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">First Step</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Second Step</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Alert</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Device Faliure</span></div></th><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\">Action</span></div></th></tr></thead><tbody><tr ng-repeat=\"o in lstSMS\"><td>{{$index+1}}</td><td>\n{{o.MobileNo}}</td><td>{{o.Scheduler_StartTime}}</td><td>{{o.Scheduler_EndTime}}</td><td ng-if=\"o.First_Step==1\"><span \nstyle=\"font-size: 20px;color: green\">&#x2714;</span></td><td ng-if=\"o.First_Step!=1\"><span \nstyle=\"font-size: 20px;color: red\">&#x2716;</span></td><td ng-if=\"o.Second_Step==1\"><span \nstyle=\"font-size: 20px;color: green\">&#x2714;</span></td><td ng-if=\"o.Second_Step!=1\"><span \nstyle=\"font-size: 20px;color: red\">&#x2716;</span></td><td ng-if=\"o.Alert==1\"><span \nstyle=\"font-size: 20px;color: green\">&#x2714;</span></td><td ng-if=\"o.Alert!=1\"><span \nstyle=\"font-size: 20px;color: red\">&#x2716;</span></td><td ng-if=\"o.Device_Faliure==1\"><span \nstyle=\"font-size: 20px;color: green\">&#x2714;</span></td><td ng-if=\"o.Device_Faliure!=1\"><span \nstyle=\"font-size: 20px;color: red\">&#x2716;</span></td><td><md-button class=\"md-raised md-warn\" \nng-click=\"remove2($index,o)\">Remove</md-button></td></tr></tbody></table></div></div><div align=\"center\"><md-button \nclass=\"md-raised md-primary\" ng-disabled=\"!CustomerDeviceForm.$valid\" ng-click=\"CreateCustomerDevice(model,SMSmodel)\">\nSave</md-button><md-button class=\"md-raised md-warn\" ng-click=\"Reset()\">Cancel</md-button></div></div></md-content><div\n id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"content\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"dtOptions\" dt-column-defs=\"dtColumnDefs\"><thead><tr><th \nclass=\"all\"><div class=\"table-header\"><span class=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Customer Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Device Type</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Device Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Device Serial</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Status</span></div></th><th class=\"all\"><div class=\"table-header\"><span\n class=\"column-title\">Action</span></div></th></tr></thead><tbody><tr ng-repeat=\"o in lstCustomerDevice\"><td>\n{{$index+1}}</td><td>{{o.tblcustomermaster.Name}}</td><td>{{o.DeviceType}}</td><td>{{o.DeviceName}}</td><td>\n{{o.DeviceSerial}}</td><td ng-if=\"o.Connection_Status==1\"><md-icon md-font-icon=\"icon-link-variant\"></md-icon></td><td \nng-if=\"o.Connection_Status==0\"><md-icon md-font-icon=\"icon-link-variant-off\"></md-icon></td><td><md-button \nclass=\"md-icon-button md-accent md-raised md-hue-2\" title=\"Edit\" ng-if=\"FlgModifiedAccess\" \nng-click=\"FetchCustomerDeviceById(o)\"><md-icon md-font-icon=\"icon-pencil-box-outline\"></md-icon></md-button><md-button \nclass=\"md-icon-button md-raised md-warn md-raised md-hue-2\" title=\"Delete\" ng-if=\"FlgDeletedAccess\" \nng-click=\"DeleteCustomerDevice(o)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button><md-button \nclass=\"md-accent md-raised md-hue-2\" ng-click=\"ShowDeviceModal($event,o)\" aria-label=\"\">Device</md-button><md-button \nclass=\"md-accent md-raised md-hue-2\" ng-click=\"ShowEventList($event,o.id)\" ng-if=\"o.DeviceType == \'CallSMS\'\">Event List\n</md-button></td></tr></tbody></table></div></div></div></div></md-tab></md-tabs></form></div></div></div></md-content>\n<style type=\"text/css\" media=\"screen\">\n#processing1 {\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n        z-index: 1;\r\n        background-color: rgba(203, 203, 203, 0.6);\r\n    }\r\n    \r\n    #processing1 .page-loader {\r\n        position: absolute;\r\n        top: 50%;\r\n        left: 50%;\r\n        margin-left: -100px;\r\n        margin-top: -100px;\r\n        z-index: 2;\r\n    }\n</style>");
$templateCache.put("app/main/CustomerService/CustomerService.html","<style type=\"text/css\">\nbody {\r\n        font-family: arial, verdana, sans-serif;\r\n        /* font-size: 12px; */\r\n    }\r\n    \r\n    .dww img {\r\n        width: 30px;\r\n        height: 30px;\r\n        margin: 5px 10px;\r\n    }\n</style><md-content><div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"customPageHeader\" ng-if=\"AccountType == \'Individual\'\">Welcome Admin</div><div class=\"content\" \nng-show=\"FlagSearch\"><form name=\"CustomerServiceSearchForm\" class=\"md-inline-form\"><div layout=\"row\" flex=\"100\" \nflex-gt-sm=\"50\" layout-wrap><label class=\"darkLabel\" hide-gt-xs>Search By Customer Unique Number</label>\n<md-input-container class=\"md-block\" flex=\"60\" flex-gt-sm=\"70\" md-no-float><label class=\"darkLabel\" hide-xs>\nSearch By Customer Unique Number</label><input type=\"text\" name=\"CustomerUnq_Id\" ng-model=\"model.CustomerUnq_Id\" \nplaceholder=\"Enter Customer Unique Number\" maxlength=\"250\" \nng-change=\"model.MobileNo = \'\';model.EmailAddress = \'\' ;ChangeCustomerName()\"></md-input-container><md-input-container \nclass=\"md-block\" flex=\"40\" flex-gt-sm=\"30\"><md-button class=\"md-raised md-primary\" \nng-disabled=\"model.CustomerUnq_Id == \'\'\" ng-click=\"GetCustomerDetail(model)\">Search</md-button></md-input-container>\n</div><hr flex=\"100\" hide-gt-xs style=\"border: 1px solid #1c1c40\"><div layout=\"row\" flex=\"100\" flex-gt-sm=\"50\" \nlayout-wrap><label flex=\"100\" class=\"darkLabel\" hide-gt-xs>Search By Mobile Number</label><md-input-container \nclass=\"md-block contactNo\" flex=\"60\" flex-gt-sm=\"70\" md-no-float><label class=\"darkLabel\" hide-xs>\nSearch By Mobile Number</label><input type=\"tel\" id=\"phone1\" name=\"MobileNo\" ng-model=\"model.MobileNo\" \nplaceholder=\"Enter Mobile Number\" ng-change=\"model.CustomerUnq_Id = \'\' ;model.EmailAddress = \'\';ChangeCustomerName()\">\n</md-input-container><md-input-container class=\"md-block\" flex=\"40\" flex-gt-sm=\"30\"><md-button \nclass=\"md-raised md-primary\" ng-disabled=\"model.MobileNo == \'\'\" ng-click=\"GetCustomerDetail(model)\">Search</md-button>\n</md-input-container><script>$(\"#phone1\").intlTelInput();</script></div><hr flex=\"100\" hide-gt-xs \nstyle=\"border: 1px solid #1c1c40\"><div flex=\"100\" flex-gt-sm=\"50\"><label flex=\"100\" class=\"darkLabel\" hide-gt-xs>\nSearch By Customer Name</label><label style=\"font-size: 1.2rem\" class=\"darkLabel\" hide-xs>Search By Customer Name\n</label><div layout=\"row\" layout-wrap><md-autocomplete class=\"whiteLabel\" flex md-input-name=\"CustomerName\" \nng-model=\"model.CustomerName\" md-input-minlength=\"0\" md-input-maxlength=\"20\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedItem\" md-search-text-change=\"vm.searchTextChange(vm.searchText)\" \nmd-search-text=\"vm.searchText\" md-selected-item-change=\"vm.selectedItemChange(item)\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.display\" md-require-match \nmd-floating-label=\"Enter Customer Name\"><md-item-template><span md-highlight-text=\"vm.searchText\">{{item.display}}\n</span></md-item-template><div ng-messages=\"CustomerServiceSearchForm.CustomerName.$error\" \nng-if=\"CustomerServiceSearchForm.CustomerName.$touched\"><div ng-message=\"md-require-match\">\nPlease select an existing state.</div><div ng-message=\"minlength\">Your entry is not long enough.</div><div \nng-message=\"maxlength\">Your entry is too long.</div></div></md-autocomplete><md-input-container class=\"md-block\" \nflex=\"40\" flex-gt-sm=\"30\"><md-button class=\"md-raised md-primary\" ng-disabled=\"model.CustomerName == \'\'\" \nng-click=\"GetCustomerDetail(model)\">Search</md-button></md-input-container></div></div><hr flex=\"100\" hide-gt-xs \nstyle=\"border: 1px solid #1c1c40\"><div layout=\"row\" flex=\"100\" flex-gt-sm=\"50\" layout-wrap><label class=\"darkLabel\" \nhide-gt-xs>Search By Customer Email Address</label><md-input-container class=\"md-block\" flex=\"60\" flex-gt-sm=\"70\" \nmd-no-float><label class=\"darkLabel\" hide-xs>Search By Customer Email Address</label><input type=\"text\" \nname=\"EmailAddress\" ng-model=\"model.EmailAddress\" placeholder=\"Enter Customer Email Address\" \nng-change=\"model.MobileNo = \'\' ;model.CustomerUnq_Id = \'\';ChangeCustomerName()\"></md-input-container>\n<md-input-container class=\"md-block\" flex=\"40\" flex-gt-sm=\"30\"><md-button class=\"md-raised md-primary\" \nng-disabled=\"model.EmailAddress == \'\'\" ng-click=\"GetCustomerDetail(model)\">Search</md-button></md-input-container>\n</div></form></div><div class=\"content\" ng-if=\"!FlagSearch\"><md-icon md-font-icon=\"icon-arrow-left-bold-circle\" \nclass=\"s30\" ng-click=\"GoBack()\"><md-tooltip md-direction=\"bottom\">Back</md-tooltip></md-icon><strong \nstyle=\"font-size:1.6rem; vertical-align: sub\">Back to Search</strong><div class=\"white-bg md-whiteframe-4dp\"><md-tabs \nmd-selected=\"tab.selectedIndex\" md-dynamic-height md-border-bottom><md-tab label=\"Info\"><md-content class=\"md-padding\">\n<div class=\"custom-content\"><form name=\"FormInfo\" id=\"FormInfo\" name=\"FormInfo\" class=\"md-inline-form\"><div \nlayout=\"row\" layout-wrap><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\" md-no-float>\n<label>First Name</label><input type=\"text\" name=\"Name\" placeholder=\"Name of the Customer\" ng-model=\"UserInfo.Name\" \nreadonly=\"readonly\"></md-input-container><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"33\" md-no-float><label>Last Name</label><input type=\"text\" name=\"LastName\" \nplaceholder=\"Last name of the Customer\" ng-model=\"UserInfo.LastName\" readonly=\"readonly\"></md-input-container>\n<md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\" md-no-float><label>\nCustomer Account Number</label><input type=\"text\" name=\"CustomerAccountNo\" placeholder=\"A000000000\" \nng-model=\"UserInfo.CustomerAccountNo\" readonly=\"readonly\"></md-input-container><md-input-container class=\"md-block\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\" md-no-float><label>Pincode</label><input type=\"text\" name=\"Pincode\" \nng-model=\"UserInfo.Pincode\" readonly=\"readonly\"></md-input-container><md-input-container class=\"md-block\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"33\" md-no-float><label>Email Address</label><input type=\"email\" name=\"EmailAddress\" \nng-model=\"UserInfo.EmailAddress\" placeholder=\"myexample@example.com\" readonly=\"readonly\"></md-input-container>\n<md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\" md-no-float><label>Type</label><input \ntype=\"text\" name=\"Type\" ng-model=\"UserInfo.Type\" readonly=\"readonly\"></md-input-container><md-input-container \nclass=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\" md-no-float ng-show=\"UserInfo.Type==\'Individual\'\"><label>\nDate Of Birth(DD/MM/YYYY)</label><input type=\"text\" ng-model=\"UserInfo.DateofBirth\" placeholder=\"01/01/2017\" \nreadonly=\"readonly\"></md-input-container></div></form></div></md-content></md-tab><md-tab label=\"Config\"><md-content \nclass=\"md-padding\"><div class=\"custom-content\"><form name=\"FormConfig\" id=\"FormConfig\" name=\"FormConfig\" \nclass=\"md-inline-form\"><md-list class=\"configList\"><md-list-item layout=\"row\" ng-repeat=\"item in DeviceList\"><div \nflex=\"70\"><h3>{{item.DeviceName}}</h3></div><div flex=\"30\" align=\"right\"><md-button class=\"md-raised md-primary\" \nng-click=\"ShowSetting(item)\">Configure</md-button><md-button class=\"md-raised md-primary\" ng-click=\"ShowDebug(item)\">\nDebug</md-button></div></md-list-item><md-list-item ng-if=\"DeviceList == \'\'\" layout-align=\"center center\"><strong>\nNo Device Found</strong></md-list-item></md-list></form></div></md-content></md-tab><md-tab label=\"Log\"><div \nid=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"content custom-content\">\n<table id=\"CustomerService\" class=\"dataTable tableD1\" datatable=\"\" dt-instance=\"dtInstance\" dt-columns=\"dtColumns\" \ndt-options=\"dtOptions\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">Sr No.</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Device Name</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Event Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Time Stamp</span></div></th></tr></thead>\n</table></div></div></md-tab></md-tabs></div></div></div></md-content>");
$templateCache.put("app/main/DeviceDetail/DeviceDetail.html","<md-content><div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"customPageHeader\">Device Detail</div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><md-tabs \nmd-selected=\"tab.selectedIndex\" md-dynamic-height md-border-bottom><md-tab label=\"Device List\" ng-click=\"ResetEdit()\">\n<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"content custom-content\"><div layout-gt-sm=\"row\"><md-input-container flex=\"10\" flex-gt-xs=\"30\"><label>\nCustomer Name</label><md-select name=\"CustomerMasterId\" ng-model=\"modelSearch.CustomerMasterId\"><md-option value=\"\">All\n</md-option><md-option ng-repeat=\"o in lstCustomer  | orderBy: \'Name\'\" value=\"{{o.id}}\">{{o.Name}}</md-option>\n</md-select></md-input-container><md-button class=\"md-primary md-raised md-icon-button go-button\" \nng-click=\"GetAllUser(true)\"><md-icon>Go</md-icon></md-button></div><table id=\"DeviceDetailtable\" \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"dtInstance\" dt-columns=\"dtColumns\" dt-options=\"dtOptions\">\n<thead><tr><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">No</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Customer Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Device Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Device Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Device Serial</span></div></th><th \nclass=\"all\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead></table></div>\n</div></md-tab></md-tabs></div></div></div></md-content><style>\n.cropArea {\r\n        background: #E4E4E4;\r\n        overflow: hidden;\r\n        width: 100%;\r\n        height: 350px;\r\n    }\n</style>");
$templateCache.put("app/main/DeviceSetting_Call_Sms/DeviceSetting_Call_Sms.html","<md-content><div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg layout-align-space-between-stretch layout-row\" layout=\"row\" layout-align=\"space-between\">\n<div layout=\"column\" layout-align=\"center start\" class=\"layout-align-center-start layout-column\"><div \nclass=\"breadcrumb layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16 ng-isolate-scope md-font icon-home material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator ng-isolate-scope md-font icon-chevron-right material-icons md-default-theme\" aria-hidden=\"true\">\n</md-icon><span class=\"parent\">Device Setting Call/Sms</span></div><div class=\"title\">Device Setting Call/Sms</div>\n</div></div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><md-tabs md-selected=\"tab.selectedIndex\" \nmd-dynamic-height md-border-bottom><md-tab label=\"Device Setting List\" ng-click=\"ResetEdit()\"><div id=\"simple-table\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"content custom-content\"><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"dtInstance\" dt-columns=\"dtColumns\" dt-options=\"dtOptions\">\n<thead><tr><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">No</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Device Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Mobile No</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Email</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Event_Scheduler_StartTime</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Event_Scheduler_EndTime</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Alert_Scheduler_StartTime</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Alert_Scheduler_Endtime\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Mat</span></div></th>\n<th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead></table>\n</div></div></md-tab></md-tabs></div></div></div></md-content><style>\n.cropArea {\r\n    background: #E4E4E4;\r\n    overflow: hidden;\r\n    width: 100%;\r\n    height: 350px;\r\n}</style>");
$templateCache.put("app/main/FirmwareUpgrade/FirmwareUpgrade.html","<md-content><div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"customPageHeader\" ng-if=\"AccountType == \'Individual\'\">Firmware Upgrade</div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-4dp\"><form name=\"AddFirmwareUpgradeForm\" novalidate class=\"md-inline-form\"><div \nid=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"content\"><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"40\"><label>Select Device Type *</label><md-select \nname=\"DeviceType\" ng-model=\"model.DeviceType\"><md-option value=\"Mat\">Mat</md-option><md-option value=\"Cordless Mat\">\nCordless Mat</md-option><md-option value=\"Alarm\">Alarm</md-option><md-option value=\"Lamp\">Lamp</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\"><md-button \nclass=\"md-icon-button md-accent md-raised md-hue-2\" title=\"Find\" ng-click=\"GetAllDevice(model.DeviceType)\">Go\n</md-button></md-input-container></div><table id=\"DeviceList\" class=\"dataTable tableD1\" datatable=\"ng\" \ndt-options=\"dtOptions2\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Customer Unique Number</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span\n class=\"column-title\">Device Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Device Serial No.</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header text-center\"><span class=\"column-title\">Status</span></div></th><th class=\"all\"><div \nclass=\"table-header\"><md-checkbox aria-label=\" \" ng-checked=\"isChecked()\" md-indeterminate=\"isIndeterminate()\" \nng-click=\"toggleAll()\"><span ng-if=\"isChecked()\"></span></md-checkbox></div></th></tr></thead><tbody><tr \nng-repeat=\"o in lstDevice\"><td>{{$index+1}}</td><td>{{o.tblcustomermaster.CustomerAccountNo}}</td><td>{{o.DeviceName}}\n</td><td>{{o.DeviceSerial}}</td><td align=\"center\"><md-icon ng-if=\"o.Connection_Status==false\" \nmd-font-icon=\"icon-link-variant-off\" title=\"Disconnected\"></md-icon><md-icon ng-if=\"o.Connection_Status==true\" \nmd-font-icon=\"icon-link-variant\" title=\"Connected\"></md-icon></td><td><md-checkbox aria-label=\"Checkbox 1\" \nng-model=\"o.checked\" ng-checked=\"exists(o, selected)\" ng-click=\"toggle(o, selected)\"></md-checkbox></td></tr></tbody>\n</table><md-content class=\"md-padding\"><div align=\"center\"><md-button type=\"button\" ng-disabled=\"selected.length == 0\" \nclass=\"md-raised md-primary\" ng-click=\"OpenFile()\">Start Upgrade</md-button></div></md-content></div></div></form>\n</div></div></div></md-content><style>\n#FirmwareUpgrade.fullwidth {\r\n        width: 100%\r\n    }\r\n    \r\n    #FirmwareUpgrade.smallwidth {\r\n        width: 140px;\r\n    }\r\n    \r\n    #processing {\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n        z-index: 1000;\r\n        background-color: grey;\r\n        opacity: .6;\r\n    }\r\n    \r\n    #processing img {\r\n        position: absolute;\r\n        top: 50%;\r\n        left: 50%;\r\n        margin-left: -32px;\r\n        margin-top: -32px;\r\n    }\r\n    \r\n    .ajax-loader {\r\n        position: absolute;\r\n        left: 50%;\r\n        top: 50%;\r\n        display: block;\r\n    }\n</style>");
$templateCache.put("app/main/Forgotpassword/Forgotpassword.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><img src=\"/assets/icons/icon.jpg\" alt=\"\" class=\"loginLogo\"><div \nid=\"forgot-password-form\" class=\"md-whiteframe-2dp\" ng-show=\"!flgSendOTP\"><form action=\"\" name=\"forgotPasswordForm\"><h2\n align=\"center\">Reset Your Password</h2><md-radio-group ng-model=\"VerifyWith\" layout=\"row\" layout-wrap \nng-show=\"IsActive\"><div flex=\"40\" flex-gt-xs=\"30\" flex-gt-md=\"50\" align=\"left\"><md-radio-button class=\"md-primary\" \nvalue=\"Email\">Email</md-radio-button></div><div flex=\"60\" flex-gt-xs=\"70\" flex-gt-md=\"50\" align=\"left\"><md-radio-button\n class=\"md-primary\" value=\"ContactNo\">Mobile Number</md-radio-button></div></md-radio-group><div \nng-if=\"VerifyWith==\'Email\'\"><md-input-container flex-gt-sm class=\"md-block custom-Control\" ng-show=\"IsActive\" \nmd-no-float><label>Enter Your Email Id</label><input required=\"VerifyWith==\'Email\'\" type=\"email\" name=\"EmailAddress\" \nng-model=\"model.EmailAddress\" ng-pattern=\"/^.+@.+\\..+$/\" ng-change=\"ChangeErrorMessageFlag()\"><div \nng-messages=\"forgotPasswordForm.EmailAddress.$error\" ng-if=\"forgotPasswordForm.EmailAddress.$touched\" role=\"alert\"><div\n ng-message=\"required\"><span>You can\'t leave this empty</span></div><div ng-message=\"pattern\"><span>\nEmail must be a valid Email Address</span></div></div><span style=\"color: red;font-size: 12px\" \nng-show=\"EmailErrorMessage == true\">This Email not registered with us.</span></md-input-container><md-button \nclass=\"md-raised md-accent submit-button\" ng-click=\"ResetPassword()\" \nng-disabled=\"forgotPasswordForm.EmailAddress.$invalid || forgotPasswordForm.EmailAddress.$pristine\" \nng-show=\"IsActive && VerifyWith==\'Email\'\">Continue</md-button></div><div ng-show=\"VerifyWith==\'ContactNo\'\">\n<md-input-container class=\"md-block contactNo custom-Control\" flex-gt-sm md-no-float><input type=\"tel\" id=\"ContactNo\" \nname=\"ContactNo\" style=\"height:28px !important\" ng-model=\"model.ContactNo\" placeholder=\"+11234567890\" \nng-maxlength=\"15\" required=\"VerifyWith==\'ContactNo\'\" ng-change=\"MobileErrorMessage = false\"><script>\n$(\"#ContactNo\").intlTelInput();</script><div ng-messages=\"forgotPasswordForm.ContactNo.$error\" \nng-show=\"forgotPasswordForm.ContactNo.$touched\"><div ng-message=\"required\">You can\'t leave this empty</div><div \nng-message=\"maxlength\">Must be a valid 15 digit Mobile Number</div></div><span style=\"color: red;font-size: 12px\" \nng-show=\"MobileErrorMessage == true\">This Mobile Number not registered with us.</span></md-input-container><div \nclass=\"padding-5 md-block\"></div><md-button class=\"md-raised md-accent submit-button\" \nng-click=\"VerifyMobileNo(model.ContactNo)\" \nng-disabled=\"forgotPasswordForm.ContactNo.$invalid || forgotPasswordForm.ContactNo.$pristine\">Continue</md-button>\n</div><div ng-show=\"!IsActive && VerifyWith==\'Email\'\"><span class=\"smallText\" align=\"left\"><strong>\nDear {{Firstname}} {{Lastname}},</strong></span> <span class=\"smallText\" align=\"left\">\nWe have sent password reset mail to your mail id : {{emailid}}. Please reset your password.</span> <span \nclass=\"smallText\" align=\"left\">No Email Received? Check your Spam / Junk folder or Click RESEND.</span><md-button \nclass=\"md-raised md-accent submit-button\" ng-click=\"ResendPassword() \" \nng-disabled=\"forgotPasswordForm.EmailAddress.$invalid \" ng-show=\"!IsActive && VerifyWith==\'Email\'\">Resend</md-button>\n</div><div layout=\"row\" align=\"center\"><a class=\"linkOrange md-block\" align=\"center\" ui-sref=\"app.login\">\nGo Back To Login</a></div></form></div><div id=\"forgot-password-form\" class=\"md-whiteframe-2dp\" ng-show=\"flgSendOTP\">\n<form action=\"\" name=\"OTPForm\"><h2 align=\"center\">Reset Your Password</h2><span class=\"smallText\">\nEnter the One Time Password (OTP) which has been sent on the mobile number.</span><div layout=\"row\" \nlayout-align=\"center start\"><div flex align=\"left\"><md-input-container class=\"md-block custom-Control\" md-no-float>\n<label>Enter OTP</label><input type=\"text\" name=\"OTP\" ng-model=\"model.OTP\" required flex-gt-sm \nng-change=\"OTPErrorMessage = false\"><div ng-messages=\"OTPForm.OTP.$error\" ng-show=\"OTPForm.OTP.$touched\" role=\"alert\">\n<div ng-message=\"required\"><span>You can\'t leave this empty</span></div></div><span style=\"color: red;font-size: 12px\" \nng-show=\"OTPErrorMessage == true\">This OTP is incorrect.</span></md-input-container></div><div flex align=\"left\">\n<md-button class=\"md-raised md-accent submit-button\" ng-click=\"VerifyMobileNo(model.ContactNo)\">Resend OTP</md-button>\n</div></div><md-button class=\"md-raised md-accent submit-button\" ng-click=\"SubmitOTP(model.OTP,model.ContactNo)\" \nng-disabled=\"OTPForm.OTP.$invalid || OTPForm.OTP.$pristine\">Submit</md-button><div layout=\"row\" align=\"center\"><a \nclass=\"linkOrange\" ui-sref=\"app.login\">Go Back To Login</a></div></form></div></div></div>");
$templateCache.put("app/main/InactiveDevices/InactiveDevices.html","<style type=\"text/css\">\nbody {\r\n        font-family: arial, verdana, sans-serif;\r\n        /* font-size: 12px; */\r\n    }\r\n    \r\n    .dww img {\r\n        width: 30px;\r\n        height: 30px;\r\n        margin: 5px 10px;\r\n    }\n</style><md-content><div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"customPageHeader\" ng-if=\"AccountType == \'Individual\'\">Welcome {{FirstName}} {{LastName}}</div><div \nclass=\"customPageHeader\" ng-if=\"AccountType == \'Organisation\'\">Welcome {{OrganizationName}}</div><div class=\"content\">\n<treecontrol class=\"tree-classic customTreeList\" tree-model=\"InActiveDeviceList\" expanded-nodes=\"InActiveDeviceList\" \noptions=\"treeOptions\" on-selection=\"showSelected(node)\" selected-node=\"node1\"><div layout=\"row\" layout-wrap \nlayout-align=\"left center\"><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\">\n<md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"ShowSetting(node)\" aria-label=\"Refresh widget\">Settings</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"DeleteCustomerDevice(node,$event)\" aria-label=\"Refresh widget\">Delete</md-button></md-menu-item>\n</md-menu-content></md-menu><span ng-if=\"node.EditFlag==false && node.Connection_Status == false\" \nhm-doubletap=\"ChangeFlg(node)\" style=\"color: red\">{{node.DeviceName}}<br><span style=\"font-size: x-small\">\n{{node.DisplayType| uppercase}}-{{node.DeviceSerial}}</span></span> <span \nng-if=\"node.EditFlag==false && node.Connection_Status == true\" hm-doubletap=\"ChangeFlg(node)\" style=\"color: green\">\n{{node.DeviceName}}<br><span style=\"font-size: x-small\">{{node.DisplayType| uppercase}}-{{node.DeviceSerial}}</span>\n</span><md-input-container ng-if=\"node.EditFlag != false\" class=\"md-block\" flex-gt-sm=\"50\"><input type=\"text\" \nname=\"DeviceName\" ng-model=\"node.DeviceName\"></md-input-container><div ng-if=\"node.EditFlag != false\"><md-button \nclass=\"md-raised md-primary\" ng-click=\"UpdateDevice(node)\">Save</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"ChangeFlg(node)\">Cancel</md-button></div></div></treecontrol></div></div></md-content>");
$templateCache.put("app/main/Module/Module.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Module</span></div><div \nclass=\"title\">Module Management</div></div></div><div class=\"content\"><md-content class=\"widget-page\"><md-tabs \nmd-dynamic-height md-selected=\"tab.selectedIndex\" md-border-bottom><md-tab label=\"Manage Module Permission\"><md-content\n class=\"md-padding\" md-selected=\"selectedIndex\"><div class=\"md-whiteframe-4dp\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr>\n<th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">Module</span></div></th><th class=\"all\"><div \nclass=\"table-header\"><span class=\"column-title\">Is Active</span></div></th></tr></thead><tbody><tr \nng-repeat=\"o in lstModules\"><td>{{ o.Module }}</td><td><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" \nng-model=\"o.IsActive\" ng-change=\"SaveModule(o)\" class=\"md-primary\"></md-checkbox></td></tr></tbody></table></div>\n</md-content></md-tab></md-tabs></md-content></div></div>");
$templateCache.put("app/main/MyProfile/MyProfile.html","<md-content><div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"customPageHeader\">Profile Information</div><div class=\"content\"><md-content class=\"md-whiteframe-4dp\"><md-tabs \nmd-dynamic-height md-selected=\"tab.selectedIndex\" md-border-bottom><md-tab label=\"My Profile\"><md-content \nclass=\"md-padding\"><div class=\"custom-content\"><form name=\"Form\" id=\"Form\" name=\"Form\" class=\"md-inline-form\"><div \nclass=\"content\"><md-content class=\"custom-content\" ms-scroll><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"50\" md-no-float><label>First Name*</label><input type=\"text\" name=\"Name\" \nng-model=\"model.Name\" required maxlength=\"250\"><div ng-messages=\"Form.Name.$error\" ng-if=\"Form.Name.$touched\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>You can\'t leave this empty</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"50\" md-no-float><label>Last Name*</label><input \ntype=\"text\" name=\"LastName\" ng-model=\"model.LastName\" required maxlength=\"250\"><div ng-messages=\"Form.LastName.$error\" \nng-show=\"Form.LastName.$touched\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nYou can\'t leave this empty</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"50\" md-no-float><label>Customer Account Number</label><input type=\"text\" \nname=\"CustomerAccountNo\" ng-model=\"model.CustomerAccountNo\" required maxlength=\"250\" readonly=\"readonly\"><div \nng-messages=\"Form.CustomerAccountNo.$error\" ng-if=\"Form.CustomerAccountNo.$touched\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\"><span>You can\'t leave this empty</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"50\" md-no-float><label>Pincode*</label><input type=\"text\" name=\"Pincode\" \nng-model=\"model.Pincode\" required maxlength=\"250\"><div ng-messages=\"Form.Pincode.$error\" ng-if=\"Form.Pincode.$touched\">\n<div ng-message=\"required\"><span>You can\'t leave this empty</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\" md-no-float><label>Email Address</label><input \ntype=\"email\" name=\"EmailAddress\" ng-model=\"model.EmailAddress\" ng-pattern=\"/^.+@.+\\..+$/\" required maxlength=\"250\" \nreadonly=\"readonly\"><div ng-messages=\"Form.EmailAddress.$error\" ng-if=\"Form.EmailAddress.$touched\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>You can\'t leave this empty</span></div><div ng-message=\"pattern\">\n<span>Email Address must be a valid e-mail address</span></div></div></md-input-container><div layout=\"row\" flex=\"80\" \nflex-gt-sm=\"50\"><md-input-container class=\"md-block contactNo\" md-no-float flex=\"70\" flex-gt-sm=\"70\"><label>\nMobile Number*</label><input type=\"tel\" id=\"Phone\" name=\"ContactNo\" ng-model=\"model.ContactNo\" \nplaceholder=\"+11234567890\" ng-maxlength=\"17\" required \nng-change=\"ChangeContactNo(model.ContactNo,Form.ContactNo.$valid)\"><div ng-messages=\"Form.ContactNo.$error\" \nng-if=\"Form.ContactNo.$touched\"><div ng-message=\"required\">You can\'t leave this empty</div><div ng-message=\"maxlength\">\nMust be a 15 digit Contact No</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"30\" \nflex-gt-sm=\"30\"><md-button class=\"md-raised md-primary\" ng-disabled=\"!flgChangeContact\" \nng-click=\"VerifyMobileNo(model.ContactNo)\"><span ng-show=\"!flgSendOTP\">Verify</span> <span ng-show=\"flgSendOTP\">Resend\n</span></md-button></md-input-container></div></div><div layout=\"row\" flex=\"80\" flex-gt-sm=\"50\" \nng-if=\"flgSendOTP && !IsValidOTP\"><md-input-container class=\"md-block\" flex=\"70\" flex-gt-sm=\"70\" md-no-float><label>\nEnter OTP*</label><input type=\"text\" name=\"OTP\" ng-model=\"model.OTP\" required maxlength=\"50\"><div \nng-messages=\"Form.OTP.$error\" ng-show=\"Form.OTP.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\nYou can\'t leave this empty</span></div></div></md-input-container><md-input-container class=\"md-block\" flex=\"30\" \nflex-gt-sm=\"30\"><md-button class=\"md-raised md-primary\" ng-disabled=\"Form.OTP.$invalid\" \nng-click=\"SubmitOTP(model.OTP)\">Submit</md-button></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"50\" md-no-float><label>Type*</label><md-select ng-model=\"model.Type\" \nname=\"Type\" required><md-option value=\"Individual\">Individual</md-option><md-option value=\"Organisation\">Organisation\n</md-option></md-select><div ng-messages=\"Form.Type.$error\" ng-if=\"Form.Type.$touched\"><div ng-message=\"required\">\n<span>You can\'t leave this empty</span></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\" md-no-float ng-show=\"model.Type==\'Organisation\' \"><label>URL</label><input type=\"text\" name=\"URL\" \nng-model=\"model.URL\" maxlength=\"250\"></md-input-container><div layout=\"row\" flex-gt-sm=\"50\" \nng-show=\"model.Type==\'Individual\'\"><md-input-container flex flex-gt-sm=\"25\"><span>Date Of Birth :</span>\n</md-input-container><md-input-container flex flex-gt-sm=\"25\"><md-select placeholder=\"Month\" name=\"month\" id=\"month\" \nng-model=\"model.month\" ng-change=\"updateDate(\'month\')\"><md-option ng-repeat=\"m in months\" value=\"{{m.id}}\">{{m.name}}\n</md-option></md-select></md-input-container><md-input-container flex flex-gt-sm=\"25\"><md-select placeholder=\"Day\" \nname=\"day\" id=\"day\" ng-model=\"model.day\" ng-change=\"updateDate(\'day\')\"><md-option ng-repeat=\"d in days\" value=\"{{d}}\">\n{{d}}</md-option></md-select></md-input-container><md-input-container flex flex-gt-sm=\"25\"><md-select \nplaceholder=\"Year\" name=\"year\" id=\"year\" ng-model=\"model.year\" ng-change=\"updateDate(\'year\')\"><md-option \nng-repeat=\"y in years\" value=\"{{y}}\">{{y}}</md-option></md-select></md-input-container></div></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex flex-gt-sm=\"50\" md-no-float><label>Country</label><md-select name=\"Country\" \nng-model=\"model.Country\"><md-option value=\"\">Select</md-option><md-option ng-repeat=\"o in lstCountry\" \nvalue=\"{{o.Country}}\">{{o.Country}}</md-option></md-select><div ng-messages=\"Form.Country.$error\" \nng-show=\"Form.Country.$touched\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nYou can\'t leave this empty</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"50\" \nmd-no-float ng-if=\"model.Type==\'Organisation\'\"><label>Organization Name</label><input type=\"text\" \nname=\"OrganizationName\" ng-model=\"model.OrganizationName\" required=\"model.Type==\'Organisation\'\" maxlength=\"250\"><div \nng-messages=\"Form.OrganizationName.$error\" ng-if=\"Form.OrganizationName.$touched\" role=\"alert\" multiple=\"multiple\"><div\n ng-message=\"required\"><span>You can\'t leave this empty</span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex flex-gt-sm=\"50\" md-no-float><label>Time Zone</label><md-select \nname=\"Timezone\" ng-model=\"model.TimeZone\"><md-option value=\"\">Select</md-option><md-option \nng-repeat=\"o in lstTimeZones\" value=\"{{o.TimeZone}}\">{{o.text}}</md-option></md-select><div \nng-messages=\"Form.Timezone.$error\" ng-show=\"Form.Timezone.$touched\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>You can\'t leave this empty</span></div></div></md-input-container></div><div \nng-show=\"FlgImage \" class=\"row\" flex=\"100 \" flex-gt-xs=\"100 \"><img ng-src=\"{{myCroppedImage}} \" id=\"UploadedImage \" \nerr-src=\"assets/images/no-image.png \" width=\"150px \"><br><md-button class=\"md-raised md-primary\" \nng-click=\"RemoveImage() \">Remove</md-button></div><div><label>Image</label><md-input-container class=\"md-block\" \nflex=\"100\" flex-gt-xs=\"50\"><lf-ng-md-file-input id=\"fileInput \" name=\"files00 \" lf-files=\"Mediafiles \" \nlf-api=\"apiMedia \" ng-click=\"removeAllFiles()\" onchange=\"angular.element(this).scope().setFiles(this)\" \nlf-mimetype=\"image/* \" base-sixty-four-input></lf-ng-md-file-input><div ng-messages=\"Form.files00.$error \" \nstyle=\"color:red\"><div ng-message=\"mimetype \">Only image file supported</div></div></md-input-container></div><div \nlayout-gt-sm=\"row \" flex=\"100 \" ng-show=\"FlgCropImage \"><div class=\"cropArea\"><img-crop image=\"myImage \" \nresult-image=\"myCroppedImage \" on-change=\"CropImageToFile() \" result-image-size=\"300 \" area-min-size=\"300 \" \narea-type=\"square \"></img-crop></div></div><div align=\"center\"><md-button class=\"md-raised md-primary\" \nng-disabled=\"Form.$invalid || flgChangeContact \" ng-click=\"SaveMyProfile(model) \">Save</md-button></div></md-content>\n</div></form></div></md-content><script>\n$(\"#Phone \").intlTelInput({\r\n                                utilsScript: \"../bower_components/intl-tel-input-master/build/js/utils.js \"\r\n                            });\r\n\r\n                            $(\"#ContactPersionMobile \").intlTelInput({\r\n                                utilsScript: \"../bower_components/intl-tel-input-master/build/js/utils.js \"\r\n                            });\n</script></md-tab><md-tab label=\"Change Password\" ng-click=\"ResetTab()\"><md-content class=\"md-padding\"><form \nname=\"RegisterForm \" class=\"md-inline-form\"><div class=\"content\"><md-content class=\"custom-content\" ms-scroll>\n<md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label>Old password*</label><input name=\"oldpassword\" \ntype=\"password\" ng-model=\"modelPassword.oldpassword \" ng-required=\"true \" md-maxlength=\"100 \"><div \nng-messages=\"RegisterForm.oldpassword.$error \" ng-if=\"RegisterForm.oldpassword.$touched \"><div ng-message=\"required \">\n<span>You can\'t leave this empty</span></div><div ng-message=\"md-maxlength\"><span>Old password is 100 char long</span>\n</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label>Password*</label><input \nname=\"password \" type=\"password\" ng-model=\"modelPassword.password \" ng-required=\"true \" minlength=\"6\"><div \nng-messages=\"RegisterForm.password.$error \" ng-if=\"RegisterForm.password.$touched \"><div ng-message=\"required \"><span>\nYou can\'t leave this empty</span></div><div ng-message=\"minlength\"><span>Enter six digit Password.</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label>Confrim password*</label><input \nname=\"confirmpassword\" type=\"password\" ng-model=\"modelPassword.confirmpassword \" ng-required=\"true\" minlength=\"6\" \nequal=\"modelPassword.password\"><div ng-messages=\"RegisterForm.confirmpassword.$error \" \nng-if=\"RegisterForm.confirmpassword.$touched \"><div ng-message=\"required \"><span>You can\'t leave this empty</span>\n</div><div ng-message=\"equal\"><span>These passwords don\'t match</span></div></div></md-input-container><div \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"RegisterForm.$invalid \" \nng-click=\"ChangePassword(modelPassword)\">Change Password</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"Reset() \">Cancel</md-button></div><br></md-content></div></form></md-content></md-tab></md-tabs></md-content>\n</div></div></md-content><style>\n.cropArea {\r\n        background: #E4E4E4;\r\n        overflow: hidden;\r\n        width: 100%;\r\n        height: 350px;\r\n    }\n</style>");
$templateCache.put("app/main/Register/Register.html","<div id=\"register\" class=\"flex-scrollable\" layout=\"column\" ms-scroll ng-show=\"!flgResendMail\"><div \nid=\"register-form-wrapper-new\" layout=\"column\" layout-align=\"center center\"><img src=\"/assets/icons/icon.jpg\" alt=\"\" \nclass=\"loginLogo\"><div id=\"register-form\"><h1 translate=\"Create an Account\" class=\"margin-bottom-25\">Create an Account\n</h1><div ng-show=\"!flgResendMail\"><form name=\"RegisterForm\" class=\"formReg\" novalidate><div layout=\"row\" layout-wrap \nlayout-align=\"center start\"><div flex=\"100\" flex-gt-sm=\"40\" align=\"right\"></div><div flex=\"100\" flex-gt-sm=\"60\">\n<md-input-container class=\"md-block\" md-no-float><md-radio-group layout=\"row\" ng-model=\"model.Type\" name=\"Type\" \nrequired ng-change=\"ResetModel(model.Type)\"><md-radio-button flex value=\"Individual\" class=\"md-primary\">Individual\n</md-radio-button><md-radio-button flex value=\"Organisation\" class=\"md-primary\">Organization</md-radio-button>\n</md-radio-group><div ng-messages=\"RegisterForm.Type.$error\" ng-show=\"RegisterForm.Type.$touched\"><div \nng-message=\"required\"><span>Type is required</span></div></div></md-input-container></div></div><div \nclass=\"padding-10\"></div><div flex-gt-sm ng-show=\"model.Type==\'Organisation\'\"><strong>Organization\'s details :</strong>\n</div><div layout=\"row\" layout-wrap layout-align=\"center center\" ng-if=\"model.Type==\'Organisation\'\"><div flex=\"100\" \nflex-gt-sm=\"40\"><label>Organization Name* :</label></div><div flex=\"100\" flex-gt-sm=\"60\"><md-input-container \nclass=\"md-block\" md-no-float><input type=\"text\" name=\"OrganizationName\" ng-model=\"model.OrganizationName\" \nmaxlength=\"500\" required=\"model.Type==\'Organisation\'\"><div ng-messages=\"RegisterForm.OrganizationName.$error\" \nng-show=\"RegisterForm.OrganizationName.$touched\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nYou can\'t leave this empty</span></div></div></md-input-container></div></div><div layout=\"row\" layout-wrap \nlayout-align=\"center center\" ng-if=\"model.Type==\'Organisation\'\"><div flex=\"100\" flex-gt-sm=\"40\"><label>\nOrganization URL* :</label></div><div flex=\"100\" flex-gt-sm=\"60\"><md-input-container class=\"md-block\" md-no-float>\n<input type=\"text\" name=\"URL\" ng-model=\"model.URL\" maxlength=\"250\" required=\"model.Type==\'Organisation\'\"><div \nng-messages=\"RegisterForm.URL.$error\" ng-show=\"RegisterForm.URL.$touched\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>You can\'t leave this empty</span></div></div></md-input-container></div></div><div \nlayout=\"row\" layout-wrap layout-align=\"center center\" ng-if=\"model.Type==\'Organisation\'\"><div flex=\"100\" \nflex-gt-sm=\"40\"><label>Country or Region* :</label></div><div flex=\"100\" flex-gt-sm=\"60\"><md-input-container \nclass=\"md-block\" md-no-float><md-select name=\"Country\" ng-model=\"model.Country\" required=\"model.Type==\'Organisation\'\">\n<md-option value=\"\">Select</md-option><md-option ng-repeat=\"o in lstCountry\" value=\"{{o.Country}}\">{{o.Country}}\n</md-option></md-select><div ng-messages=\"RegisterForm.Country.$error\" ng-show=\"RegisterForm.Country.$touched\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>You can\'t leave this empty</span></div></div>\n</md-input-container></div></div><div layout=\"row\" layout-wrap layout-align=\"center center\" \nng-if=\"model.Type==\'Organisation\'\"><div flex=\"100\" flex-gt-sm=\"40\"><label>ZIP/PIN Code* :</label></div><div flex=\"100\" \nflex-gt-sm=\"60\"><md-input-container class=\"md-block\" flex><input type=\"text\" name=\"Pincode\" ng-model=\"model.Pincode\" \nrequired=\"model.Type==\'Organisation\'\"><div ng-messages=\"RegisterForm.Pincode.$error\" \nng-show=\"RegisterForm.Pincode.$touched\"><div ng-message=\"required\"><span>You can\'t leave this empty</span></div></div>\n</md-input-container></div></div><div layout=\"row\" layout-wrap layout-align=\"center center\" \nng-if=\"model.Type==\'Organisation\'\"><div flex=\"100\" flex-gt-sm=\"40\"><label>Timezone* :</label></div><div flex=\"100\" \nflex-gt-sm=\"60\"><md-input-container class=\"md-block\" md-no-float><md-select name=\"TimeZone\" ng-model=\"model.TimeZone\" \nrequired=\"model.Type==\'Organisation\'\"><md-option value=\"\">Select</md-option><md-option ng-repeat=\"o in lstTimeZones\" \nvalue=\"{{o.TimeZone}}\">{{o.text}}</md-option></md-select><div ng-messages=\"RegisterForm.TimeZone.$error\" \nng-show=\"RegisterForm.TimeZone.$touched\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nYou can\'t leave this empty</span></div></div></md-input-container></div></div><div flex-gt-sm \nng-show=\"model.Type==\'Organisation\'\"><strong>Admin member\'s details :</strong></div><div layout=\"row\" layout-wrap \nlayout-align=\"center start\"><div flex=\"100\" flex-gt-sm=\"40\"><label>Email* :</label></div><div flex=\"100\" \nflex-gt-sm=\"60\"><md-input-container class=\"md-block\" md-no-float layout=\"row\" layout-wrap><input type=\"email\" \nname=\"EmailAddress\" ng-model=\"model.EmailAddress\" ng-pattern=\"/^.+@.+\\..+$/\" required maxlength=\"250\" \nng-change=\"IsValidEmail = true\" ng-blur=\"CheckEmail(model.EmailAddress)\"><div \nng-messages=\"RegisterForm.EmailAddress.$error\" ng-show=\"RegisterForm.EmailAddress.$touched\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>You can\'t leave this empty</span></div><div ng-message=\"pattern\">\n<span>Email must be a valid e-mail address</span></div></div><span style=\"color: red;font-size: 12px\" \nng-show=\"!IsValidEmail\">Email already exists</span></md-input-container></div></div><div layout=\"row\" layout-wrap \nlayout-align=\"center center\" ng-if=\"model.Type==\'Individual\'\"><div flex=\"100\" flex-gt-sm=\"40\"><label>First Name* :\n</label></div><div flex=\"100\" flex-gt-sm=\"60\"><md-input-container class=\"md-block\" md-no-float><input type=\"text\" \nname=\"Name\" ng-model=\"model.Name\" required=\"model.Type==\'Individual\'\" maxlength=\"250\"><div \nng-messages=\"RegisterForm.Name.$error\" ng-show=\"RegisterForm.Name.$touched\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>You can\'t leave this empty</span></div></div></md-input-container></div></div><div \nlayout=\"row\" layout-wrap layout-align=\"center center\" ng-if=\"model.Type==\'Individual\'\"><div flex=\"100\" flex-gt-sm=\"40\">\n<label>Last Name* :</label></div><div flex=\"100\" flex-gt-sm=\"60\"><md-input-container class=\"md-block\" md-no-float>\n<input type=\"text\" name=\"LastName\" ng-model=\"model.LastName\" required=\"model.Type==\'Individual\'\" maxlength=\"250\"><div \nng-messages=\"RegisterForm.LastName.$error\" ng-show=\"RegisterForm.LastName.$touched\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\"><span>You can\'t leave this empty</span></div></div></md-input-container></div></div><div \nlayout=\"row\" layout-wrap layout-align=\"center start\"><div flex=\"100\" flex-gt-sm=\"40\"><label>Password* :</label></div>\n<div flex=\"100\" flex-gt-sm=\"60\"><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"Password\" ng-model=\"model.Password\" required minlength=\"6\"><div ng-messages=\"RegisterForm.Password.$error\" \nng-show=\"RegisterForm.Password.$touched\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nYou can\'t leave this empty</span></div><div ng-message=\"minlength\"><span>Enter six digit Password.</span></div></div>\n</md-input-container></div></div><div layout=\"row\" layout-wrap layout-align=\"center start\"><div flex=\"100\" \nflex-gt-sm=\"40\"><label>Confirm Password* :</label></div><div flex=\"100\" flex-gt-sm=\"60\"><md-input-container \nclass=\"md-block\" md-no-float><input type=\"password\" name=\"ConfirmPassword\" ng-model=\"model.ConfirmPassword\" required \nminlength=\"6\" equal=\"model.Password\"><div ng-messages=\"RegisterForm.ConfirmPassword.$error\" \nng-show=\"RegisterForm.ConfirmPassword.$touched\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nYou can\'t leave this empty</span></div><div ng-message=\"equal\"><span>These passwords don\'t match</span></div></div>\n</md-input-container></div></div><div layout=\"row\" layout-wrap layout-align=\"center center\"><div flex=\"100\" \nflex-gt-sm=\"40\"><label>Mobile Number* :</label></div><div flex=\"100\" flex-gt-sm=\"60\"><div layout=\"row\" layout-wrap \nlayout-align=\"left start\"><md-input-container class=\"md-block contactNo\" flex=\"100\" flex-gt-sm=\"70\"><input type=\"tel\" \nid=\"Phone\" name=\"ContactNo\" ng-model=\"model.ContactNo\" ng-maxlength=\"15\" required ng-change=\"errorMessage = false\"><div\n ng-messages=\"RegisterForm.ContactNo.$error\" ng-show=\"RegisterForm.ContactNo.$touched\"><div ng-message=\"required\">\nEnter Mobile Number</div><div ng-message=\"maxlength\">Must be a valid 15 digit Contact No</div></div><span \nstyle=\"color: red;font-size: 12px\" ng-show=\"errorMessage == true\">{{message}}</span> <span \nstyle=\"color: green;font-size: 12px\" ng-show=\"IsSuceessOtp == true\">{{Otpmsg}}</span></md-input-container>\n<md-input-container class=\"md-block\" flex=\"100\" flex-gt-sm=\"20\"><md-button class=\"md-raised md-primary\" \nng-disabled=\"!RegisterForm.ContactNo.$valid || IsValidOTP\" ng-click=\"VerifyMobileNo(model.ContactNo)\"><span \nng-show=\"!flgSendOTP\">Verify</span> <span ng-show=\"flgSendOTP\">Resend</span></md-button></md-input-container></div>\n</div></div><div layout=\"row\" layout-wrap layout-align=\"center center\" ng-show=\"!IsValidOTP\"><div flex=\"100\" \nflex-gt-sm=\"40\" ng-show=\"flgSendOTP\"><label>Enter OTP* :</label></div><div flex=\"100\" flex-gt-sm=\"60\" \nng-show=\"flgSendOTP\"><div layout=\"row\" layout-align=\"left start\"><md-input-container class=\"md-block\" flex-gt-sm=\"70\" \nmd-no-float><input type=\"text\" name=\"OTP\" ng-model=\"model.OTP\" required maxlength=\"50\" \nng-change=\"OTPErrormessage =false\"><div ng-messages=\"RegisterForm.OTP.$error\" ng-show=\"RegisterForm.OTP.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>You can\'t leave this empty</span></div></div><span \nstyle=\"color: red;font-size: 12px\" ng-show=\"OTPErrormessage == true\">OTP is incorrect.</span> <span \nstyle=\"color: green;font-size: 12px\" ng-show=\"IsSendOtp == true\">{{OtpSendMsg}}</span></md-input-container>\n<md-input-container ng-show=\"flgSendOTP\" class=\"md-block\" flex-gt-sm=\"20\"><md-button class=\"md-raised md-primary\" \nng-disabled=\"RegisterForm.OTP.$invalid || IsValidOTP\" ng-click=\"SubmitOTP(model.OTP)\">Submit</md-button>\n</md-input-container></div></div></div><div layout=\"row\" layout-wrap layout-align=\"center center\" \nng-if=\"model.Type==\'Individual\'\"><div flex=\"100\" flex-gt-sm=\"40\"><label>Country or Region* :</label></div><div \nflex=\"100\" flex-gt-sm=\"60\"><md-input-container class=\"md-block\" md-no-float><md-select name=\"Country\" \nng-model=\"model.Country\" required=\"model.Type==\'Individual\'\"><md-option value=\"\">Select</md-option><md-option \nng-repeat=\"o in lstCountry\" value=\"{{o.Country}}\">{{o.Country}}</md-option></md-select><div \nng-messages=\"RegisterForm.Country.$error\" ng-show=\"RegisterForm.Country.$touched\" role=\"alert\" multiple=\"multiple\"><div\n ng-message=\"required\"><span>You can\'t leave this empty</span></div></div></md-input-container></div></div><div \nlayout=\"row\" layout-wrap layout-align=\"center center\" ng-if=\"model.Type==\'Individual\'\"><div flex=\"100\" flex-gt-sm=\"40\">\n<label>ZIP/PIN Code* :</label></div><div flex=\"100\" flex-gt-sm=\"60\"><md-input-container class=\"md-block\" flex><input \ntype=\"text\" name=\"Pincode\" ng-model=\"model.Pincode\" required=\"model.Type==\'Individual\'\"><div \nng-messages=\"RegisterForm.Pincode.$error\" ng-show=\"RegisterForm.Pincode.$touched\"><div ng-message=\"required\"><span>\nYou can\'t leave this empty</span></div></div></md-input-container></div></div><div layout=\"row\" layout-wrap \nlayout-align=\"center center\" ng-if=\"model.Type==\'Individual\'\"><div flex=\"100\" flex-gt-sm=\"40\"><label>Timezone* :\n</label></div><div flex=\"100\" flex-gt-sm=\"60\"><md-input-container class=\"md-block\" md-no-float><md-select \nname=\"TimeZone\" ng-model=\"model.TimeZone\" required=\"model.Type==\'Individual\'\"><md-option value=\"\">Select</md-option>\n<md-option ng-repeat=\"o in lstTimeZones\" value=\"{{o.TimeZone}}\">{{o.text}}</md-option></md-select><div \nng-messages=\"RegisterForm.TimeZone.$error\" ng-show=\"RegisterForm.TimeZone.$touched\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\"><span>You can\'t leave this empty</span></div></div></md-input-container></div></div><div \nlayout=\"row\" layout-wrap layout-align=\"center center\" ng-if=\"model.Type==\'Individual\'\"><div flex=\"100\" flex-gt-sm=\"40\">\n<label>Date of Birth :</label></div><div flex=\"100\" flex-gt-sm=\"60\" layout=\"row\"><md-input-container flex><md-select \nplaceholder=\"Month\" name=\"month\" id=\"month\" ng-model=\"model.month\" ng-change=\"updateDate(\'month\')\"><md-option \nng-repeat=\"m in months\" value=\"{{m.id}}\">{{m.name}}</md-option></md-select></md-input-container><md-input-container \nflex><md-select placeholder=\"Day\" name=\"day\" id=\"day\" ng-model=\"model.day\" ng-change=\"updateDate(\'day\')\"><md-option \nng-repeat=\"d in days\" value=\"{{d}}\">{{d}}</md-option></md-select></md-input-container><md-input-container flex>\n<md-select placeholder=\"Year\" name=\"year\" id=\"year\" ng-model=\"model.year\" ng-change=\"updateDate(\'year\')\"><md-option \nng-repeat=\"y in years\" value=\"{{y}}\">{{y}}</md-option></md-select></md-input-container></div><span \nstyle=\"color: red;font-size: 12px\" ng-show=\"ValidDate == false\">Invalid Date of Birth.</span></div><div \nclass=\"padding-5\"></div><div layout=\"row\" layout-wrap layout-align=\"center center\"><div flex=\"100\" flex-gt-sm=\"40\">\n</div><div flex=\"100\" flex-gt-sm=\"60\" layout=\"row\"><md-input-container flex=\"70\"><input type=\"text\" name=\"txtCaptcha\" \nreadonly=\"readOnly\" ng-model=\"Captcha\" id=\"txtCaptcha\" \nstyle=\"background-image:url(\'/assets/images/capcha.jpg\'); text-align:center; border:none;font-weight:bold; font-family:Arial Black\">\n</md-input-container><md-button flex=\"15\" class=\"md-fab md-mini md-primary\" ng-click=\"DrawCaptcha()\"><md-icon \nmd-font-icon=\"icon-rotate-3d\" class=\"white-fg\"></md-icon></md-button><md-button flex=\"15\" \nclass=\"md-fab md-mini md-primary\" ng-click=\"PlayCaptcha(Captcha)\"><md-icon md-font-icon=\"icon-play-circle\" \nclass=\"white-fg\"></md-icon></md-button></div></div><div layout=\"row\" layout-wrap layout-align=\"center center\"><div \nflex=\"100\" flex-gt-sm=\"40\"><label>Enter Captcha here :</label></div><div flex=\"100\" flex-gt-sm=\"60\"><md-input-container\n class=\"md-block\" md-no-float><input type=\"text\" name=\"captcha\" ng-model=\"model.captcha\"></md-input-container><span \nstyle=\"color: red;font-size: 12px\" ng-show=\"CaptchaError\">Invalid Captcha Code</span></div></div></form><div \nclass=\"margin-bottom-10\" align=\"center\"><md-button class=\"md-raised md-accent\" aria-label=\"Register\" \nng-click=\"Register(model)\" \nng-disabled=\"!IsValidOTP || RegisterForm.$invalid || RegisterForm.$pristine || !IsValidEmail ||!ValidDate\">Register\n</md-button></div><div layout=\"row\" align=\"center\"><a class=\"linkOrange md-block\" align=\"center\" ui-sref=\"app.login\">\nGo Back To Login</a></div></div></div></div></div><div id=\"changepassword\" class=\"flex-scrollable\" layout=\"column\" \nms-scroll ng-show=\"flgResendMail\"><div id=\"changepassword-form-wrapper\" layout=\"column\" layout-align=\"center center\">\n<img src=\"/assets/icons/icon.jpg\" alt=\"\" class=\"loginLogo\"><div id=\"changepassword-form\" class=\"md-whiteframe-2dp\"><h2>\nVerify Your Email Address</h2><span class=\"smallText\" align=\"center\">\nA verification email has been sent on your email address. Click on the verification link to activate your account.\n</span><div layout=\"row\" align=\"center\"><a class=\"linkOrange md-block\" ui-sref=\"app.login\">Go Back To Login</a></div>\n</div></div></div><script src=\"https://www.google.com/recaptcha/api.js\"></script><script>\nvar isCaptchaValid = false;\r\n\r\n    function doCaptchaValidate(source, args) {\r\n        args.IsValid = isCaptchaValid;\r\n    }\r\n    var verifyCallback = function(response) {\r\n        isCaptchaValid = true;\r\n        console.log(isCaptchaValid)\r\n        document.getElementById(\"CaptchValid\").value = isCaptchaValid;\r\n    };\n</script><script>\n$(\"#Phone\").intlTelInput({\r\n        // allowDropdown: false,\r\n        // autoHideDialCode: false,\r\n        // autoPlaceholder: \"off\",\r\n        // dropdownContainer: \"body\",\r\n        // excludeCountries: [\"us\"],\r\n        // formatOnDisplay: false,\r\n        // geoIpLookup: function(callback) {\r\n        //   $.get(\"http://ipinfo.io\", function() {}, \"jsonp\").always(function(resp) {\r\n        //     var countryCode = (resp && resp.country) ? resp.country : \"\";\r\n        //     callback(countryCode);\r\n        //   });\r\n        // },\r\n        // initialCountry: \"auto\",\r\n        // nationalMode: false,\r\n        // onlyCountries: [\'us\', \'gb\', \'ch\', \'ca\', \'do\'],\r\n        // placeholderNumberType: \"MOBILE\",\r\n        // preferredCountries: [\'cn\', \'jp\'],\r\n        // separateDialCode: true,\r\n        utilsScript: \"../bower_components/intl-tel-input-master/build/js/utils.js\"\r\n    });\r\n    $(\"#ContactPersionMobile\").intlTelInput({\r\n        utilsScript: \"../bower_components/intl-tel-input-master/build/js/utils.js\"\r\n    });\n</script>");
$templateCache.put("app/main/Roles/Roles.html","<md-content><div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"customPageHeader\">Role Management</div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><form \nname=\"FormManageRoles\" novalidate class=\"ms-stepper\" aria-invalid=\"false\"><md-tabs md-selected=\"tab.selectedIndex\" \nmd-dynamic-height md-border-bottom><md-tab label=\"Role List\" ng-click=\"Reset()\"><div id=\"simple-table\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"content custom-content\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"dtOptions\" dt-column-defs=\"dtColumnDefs\"><thead><tr><th \nclass=\"all\"><div class=\"table-header\"><span class=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Role Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Role Description</span></div></th><th class=\"all\"><div \nclass=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"item in lstRoles\"><td>{{$index+1}}</td><td>{{item.RoleName}}</td><td>{{item.Description}}</td><td><md-button\n class=\"md-icon-button md-accent md-raised md-hue-2\" ng-if=\"FlgModifiedAccess\" ng-click=\"FetchRoleById(item)\"><md-icon \nmd-font-icon=\"icon-pencil-box-outline\"></md-icon></md-button><md-button \nclass=\"md-icon-button md-raised md-warn md-raised md-hue-2\" ng-if=\"FlgDeletedAccess\" ng-click=\"DeleteRole(item.id)\">\n<md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div></div></md-tab><md-tab \nlabel=\"Manage Role\" ng-click=\"ResetEdit()\" ng-if=\"FlgAddedEditlocal\"><md-content class=\"md-padding\"><div \nclass=\"custom-content\"><div layout-gt-sm=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Role name *\n</label><input type=\"text\" name=\"RoleName\" ng-model=\"model.RoleName\" required maxlength=\"256\" md-maxlength=\"256\"><div \nng-messages=\"FormManageRoles.RoleName.$error\" ng-if=\"FormManageRoles.RoleName.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Role name field is required</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"Description\" \nng-model=\"model.Description\" placeholder=\"Description \"></md-input-container></div><div align=\"center\"><md-button \nclass=\"md-raised md-primary\" ng-click=\"CreateRole(model)\" ng-disabled=\"FormManageRoles.$invalid\">save</md-button>\n<md-button class=\"md-raised md-warn\" ng-click=\"Reset()\">cancel</md-button></div></div></md-content></md-tab></md-tabs>\n</form></div></div></div></md-content>");
$templateCache.put("app/main/SalesInfo/SalesInfo.html","<style type=\"text/css\">\nbody {\r\n        font-family: arial, verdana, sans-serif;\r\n        /* font-size: 12px; */\r\n    }\r\n    \r\n    .dww img {\r\n        width: 30px;\r\n        height: 30px;\r\n        margin: 5px 10px;\r\n    }\n</style><md-content><div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"customPageHeader\" ng-if=\"AccountType == \'Individual\'\">Welcome Admin</div><div class=\"content\" \nng-if=\"FlagSearch\"><md-content class=\"md-padding\" layout=\"column\"><form name=\"SalesInfo\"><md-radio-group \nng-model=\"SearchField\"><label class=\"darkLabel\">Search By Zip Code</label><div layout=\"row\" \nlayout-align=\"start center\" layout-wrap><md-input-container flex=\"10\" flex-gt-xs=\"5\" flex-gt-md=\"5\" class=\"md-block\" \nmd-no-float><md-radio-button value=\"ZipCode\" class=\"md-primary\" ng-click=\"model.StartDate = \'\';model.EndDate=\'\'\">\n</md-radio-button></md-input-container><md-chips ng-model=\"vm.ZipCodes\" flex=\"90\" flex-gt-xs=\"50\" flex-gt-md=\"30\" \nname=\"ZipCodes\" placeholder=\"+ Add more Zip Codes\"></md-chips><md-input-container flex=\"100\" flex-gt-xs=\"40\" \nflex-gt-md=\"20\" class=\"md-block\" md-no-float><md-button class=\"md-raised md-primary\" \nng-disabled=\"SearchField == \'Date\' || vm.ZipCodes.length == 0\" ng-click=\"GetSalesInfoByZipCode(vm.ZipCodes)\">Search\n</md-button></md-input-container></div><hr hide-gt-xs style=\"border: 1px solid #1c1c40\"><br><div layout=\"row\" \nlayout-align=\"start start\" layout-wrap><md-input-container flex=\"10\" flex-gt-xs=\"5\" flex-gt-md=\"5\" class=\"md-block\" \nmd-no-float><md-radio-button value=\"Date\" class=\"md-primary\" ng-click=\"vm.ZipCodes = []\"></md-radio-button>\n</md-input-container><md-input-container flex=\"90\" flex-gt-xs=\"25\" flex-gt-md=\"15\" class=\"md-block\" md-no-float><label \nclass=\"darkLabel\">Start Date</label><input mdc-datetime-picker placeholder=\"Please select\" date=\"true\" time=\"false\" \ntype=\"text\" id=\"time\" min-date=\"minDate\" format=\"DD-MM-YYYY\" ng-model=\"model.StartDate\"></md-input-container>\n<md-input-container flex=\"60\" flex-gt-xs=\"25\" flex-gt-md=\"15\" class=\"md-block\" md-no-float><label class=\"darkLabel\">\nEnd Date</label><input mdc-datetime-picker date=\"true\" placeholder=\"Please select\" time=\"false\" type=\"text\" id=\"time\" \nmin-date=\"model.StartDate\" format=\"DD-MM-YYYY\" ng-model=\"model.EndDate\"></md-input-container><md-input-container \nflex=\"40\" flex-gt-xs=\"25\" flex-gt-md=\"15\" class=\"md-block\" style=\"margin-top:5px\" md-no-float><md-button \nclass=\"md-raised md-primary\" ng-disabled=\"SearchField == \'ZipCode\' || (model.StartDate == \'\' && model.EndDate == \'\')\" \nng-click=\"GetSalesInfoByDate(model)\">Search</md-button></md-input-container></div></md-radio-group></form></md-content>\n</div><div class=\"content\" ng-if=\"!FlagSearch\"><md-icon md-font-icon=\"icon-arrow-left-bold-circle\" class=\"s30\" \nng-click=\"GoBack()\"><md-tooltip md-direction=\"bottom\">Back</md-tooltip></md-icon><strong \nstyle=\"font-size:1.6rem; vertical-align: sub\">Back to Search</strong><div class=\"white-bg md-whiteframe-4dp\"><div \nid=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"content\"><div \nalign=\"center\"><h3><b>Total Number of Devices : {{ListOfSales.length}}</b></h3></div><table id=\"Device\" \nclass=\"dataTable tableD1\" datatable=\"ng\" dt-options=\"dtOptions2\" dt-column-defs=\"dtColumnDefsDevice\"><thead><tr><th \nclass=\"all\"><div class=\"table-header\"><span class=\"column-title\">Sr No.</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">Customer Unique Number</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Device Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Device Serial No.</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Customer Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Activation Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"item in ListOfSales\"><td align=\"center\">{{$index+1}}</td><td>{{item.CustomerAccountNo}}</td><td>\n{{item.DeviceType}}</td><td>{{item.DeviceSerial}}</td><td>{{item.CustomerName}}</td><td>\n{{item.CreatedDate | date: \'dd-MM-yyyy\'}}</td><td ng-if=\"item.Connection_Status == 1\">Connected</td><td \nng-if=\"item.Connection_Status == 0\">Disconnected</td></tr></tbody></table><div align=\"center\"><md-button \nclass=\"md-raised md-primary\" ng-click=\"ExportSalesInfo(model,vm.ZipCodes)\">Export</md-button></div></div></div></div>\n</div></div></md-content>");
$templateCache.put("app/main/SequenceNumberSetting/SequenceNumberSetting.html","<md-content><div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"customPageHeader\">Manage Sequence Number Setting</div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-4dp\"><form name=\"formSequenceSetting\" class=\"md-inline-form\"><md-tabs \nmd-selected=\"tab.selectedIndex\" md-dynamic-height md-border-bottom><md-tab label=\"Manage Sequence Number Setting\" \nnng-click=\"ResetEdit()\" ng-disabled=\"!FlgAddedEditlocal\"><div class=\"custom-content\"><md-content class=\"md-padding\">\n<div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label>{{model.Name}} :- *</label><input \nname=\"Value\" ng-model=\"model.Value\" type=\"text\" maxlength=\"2000\" ng-required=\"true\"><div \nng-messages=\"formSequenceSetting.Value.$error\" ng-if=\"formSequenceSetting.Value.$touched\"><div ng-message=\"required\">\n<span>Value is required</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n<table><tr><th>d</th><td>- Date</td></tr><tr><th>M</th><td>- Month</td></tr><tr><th>y</th><td>- Year</td></tr><tr><th>n\n</th><td>- Digits</td></tr><tr><th>{}</th><td>- Fix Character</td></tr><tr><th valign=\"top\">{n}</th><td>\n- take n Character .<br>(<span class=\"red\">Only Supported for Transaction and Quotation Number</span>)</td></tr>\n</table><table><tr><th>Format</th><th>Result</th></tr><tr><td>{ABC}ddMMyyyy3n<br>For All</td><td>ABC03112016001</td>\n</tr></table></md-input-container></div><div align=\"left\"><md-button class=\"md-raised md-primary\" \nng-disabled=\"!formSequenceSetting.$valid\" ng-click=\"CreateSequenceSetting(model)\">Save</md-button><md-button \nclass=\"md-raised md-primary\" ng-click=\"GenerateAccountNumber()\">Generate</md-button></div></md-content><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr>\n<th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">No</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Last Sequence Number</span></div></th><th class=\"all\"><div \nclass=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"o in lstSequenceSetting\"><td>{{ $index+1 }}</td><td>{{ o.Name }}</td><td>{{ o.Value }}</td><td><md-button \nclass=\"md-raised md-primary\" ng-click=\"ResetMerchantNumber()\">Reset</md-button></td></tr></tbody></table></div>\n</md-tab></md-tabs></form></div></div></div></md-content>");
$templateCache.put("app/main/User/User.html","<md-content><div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg layout-align-space-between-stretch layout-row\" layout=\"row\" layout-align=\"space-between\">\n<div layout=\"column\" layout-align=\"center start\" class=\"layout-align-center-start layout-column\"><div \nclass=\"breadcrumb layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16 ng-isolate-scope md-font icon-home material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator ng-isolate-scope md-font icon-chevron-right material-icons md-default-theme\" aria-hidden=\"true\">\n</md-icon><span class=\"parent\">User</span></div><div class=\"title\">User Management</div></div></div><div \nclass=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><form name=\"AddUserForm\" novalidate class=\"md-inline-form\">\n<md-tabs md-selected=\"tab.selectedIndex\" md-dynamic-height md-border-bottom><md-tab label=\"Users  List\" \nng-click=\"Reset()\"><div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"content custom-content\"><table id=\"Usertable\" class=\"dataTable row-border hover\" datatable=\"\" \ndt-instance=\"dtInstance\" dt-columns=\"dtColumns\" dt-options=\"dtOptions\"><thead><tr><th class=\"all\"><div \nclass=\"table-header\"><span class=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Image</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">User Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Email</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Phone</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">User Role</span></div></th><th class=\"all\"><div class=\"table-header\">\n<span class=\"column-title\">Action</span></div></th></tr></thead></table></div></div></md-tab><md-tab label=\"Add Users\" \nng-click=\"ResetEdit()\" ng-disabled=\"!FlgAddedEditlocal\"><md-content class=\"md-padding\"><div class=\"custom-content\"><div\n layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label>User name *</label><input type=\"text\" \nname=\"username\" md-maxlength=\"250\" ng-model=\"model.username\" required><div ng-messages=\"AddUserForm.username.$error\" \nng-if=\"AddUserForm.username.$touched\"><div ng-message=\"required\"><span>User name is required</span></div><div \nng-message=\"md-maxlength\"><span>User name can\'t be greater than 250 character</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label>Email address *</label><input type=\"Email\" name=\"email\" \nng-model=\"model.email\" md-maxlength=\"250\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"AddUserForm.email.$error\" ng-if=\"AddUserForm.email.$touched\"><div ng-message=\"required\"><span>\nEmail is required</span></div><div ng-message=\"pattern\"><span>Email must be a valid E-mail address</span></div><div \nng-message=\"md-maxlength\"><span>Email must be in between 250 characters long</span></div></div></md-input-container>\n</div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label>Phone number</label><input \ntype=\"number\" name=\"Phone\" ng-model=\"model.phone\" placeholder=\"1234567890\" ng-pattern=\"/^(0|[1-9][0-9]*)$/\" \nmax=\"999999999999999\" min=\"0\"><div ng-messages=\"AddUserForm.Phone.$error\"><div ng-message=\"max\" class=\"my-message\">\nPhone number can\'t be longer than 15 number</div><div ng-message=\"pattern\" class=\"my-message\">Please Enter Vaild number\n</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"50\" align=\"center\">Gender:\n<md-radio-group ng-model=\"model.gender\"><md-radio-button value=\"Male\" class=\"md-primary\">Male</md-radio-button>\n<md-radio-button value=\"Female\" class=\"md-primary\">Female</md-radio-button></md-radio-group></md-input-container></div>\n<div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex=\"30\"><md-subheader class=\"md-no-sticky\">Select role\n</md-subheader><md-list-item ng-repeat=\"o in lstRoles\"><p>{{o.RoleName}}</p><md-checkbox class=\"md-secondary\" \nng-model=\"o.checked\" value=\"{{o.id}}\"></md-checkbox></md-list-item></md-input-container></div><div ng-show=\"FlgImage\" \nclass=\"row\" flex=\"100\" flex-gt-xs=\"100\"><img ng-src=\"{{myCroppedImage}}\" id=\"UploadedImage\" \nerr-src=\"assets/images/no-image.png\" width=\"150px\"><br><md-button class=\"md-raised md-primary\" \nng-click=\"RemoveImage()\">Remove</md-button></div><div layout=\"row\" flex=\"100\" flex-gt-xs=\"50\"><label>Image</label>\n<md-input-container class=\"md-block\" flex><lf-ng-md-file-input id=\"fileInput\" name=\"files00\" lf-files=\"Mediafiles\" \nlf-api=\"apiMedia\" ng-click=\"removeAllFiles()\" onchange=\"angular.element(this).scope().setFiles(this)\" \nlf-mimetype=\"image/*\" base-sixty-four-input></lf-ng-md-file-input><div ng-messages=\"AddUserForm.files00.$error\" \nstyle=\"color:red\"><div ng-message=\"mimetype\">Only image file supported</div></div></md-input-container></div><div \nlayout-gt-sm=\"row\" flex=\"100\" ng-show=\"FlgCropImage\"><div class=\"cropArea\"><img-crop image=\"myImage\" \nresult-image=\"myCroppedImage\" on-change=\"CropImageToFile()\" result-image-size=\"300\" area-min-size=\"300\" \narea-type=\"square\"></img-crop></div></div><div align=\"center\"><md-button class=\"md-raised md-primary\" \nng-disabled=\"!AddUserForm.$valid\" ng-click=\"CreateUser(model)\">Save</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"Reset()\">Cancel</md-button></div></div></md-content></md-tab></md-tabs></form></div></div></div></md-content>\n<style>\n.cropArea {\r\n        background: #E4E4E4;\r\n        overflow: hidden;\r\n        width: 100%;\r\n        height: 350px;\r\n    }\n</style>");
$templateCache.put("app/main/UserPermission/UserPermission.html","<md-content><div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"customPageHeader\">User Permission</div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><form \nname=\"FormManageRoles\" novalidate class=\"ms-stepper\" aria-invalid=\"false\"><md-tabs md-selected=\"tab.selectedIndex\" \nmd-dynamic-height md-border-bottom><md-tab label=\"User Permission\"><div id=\"simple-table\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"content custom-content\"><div class=\"row\">\n<md-input-container class=\"md-block\" flex><label>Role</label><md-select ng-model=\"model.RoleName\" \nng-change=\"GetAllPermissionByRole()\"><md-option value=\"\">Select Role</md-option><md-option value=\"{{o.RoleName}}\" \nng-repeat=\"o in lstRoles | orderBy: \'RoleName\'\">{{o.RoleName}}</md-option></md-select></md-input-container></div><table\n class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"dtOptions\" dt-column-defs=\"dtColumnDefs\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">No</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Module</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><md-checkbox value=\"modelPermission.View\" \nng-model=\"modelPermission.View\" aria-label=\"View\" class=\"md-accent\" ng-change=\"ChangePermissionAllView()\">View\n</md-checkbox></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n<md-checkbox value=\"modelPermission.Add\" ng-model=\"modelPermission.Add\" aria-label=\"View\" class=\"md-accent\" \nng-change=\"ChangePermissionAllAdd()\">Add</md-checkbox></span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\"><md-checkbox value=\"modelPermission.Update\" \nng-model=\"modelPermission.Update\" aria-label=\"View\" class=\"md-accent\" ng-change=\"ChangePermissionAllUpdate()\">Update\n</md-checkbox></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n<md-checkbox value=\"modelPermission.Delete\" ng-model=\"modelPermission.Delete\" aria-label=\"View\" class=\"md-accent\" \nng-change=\"ChangePermissionAllDelete()\">Delete</md-checkbox></span></div></th></tr></thead><tbody><tr \nng-repeat=\"o in lstModules\"><td>{{$index+1}}</td><td>{{o.Module}}</td><td><md-checkbox ng-model=\"o.Show\" \nvalue=\"o.Show\" ng-change=\"ChangePermission(o)\" aria-label=\"View\" class=\"md-accent\"></md-checkbox></td><td><md-checkbox \nng-model=\"o.Added\" value=\"o.Added\" ng-change=\"ChangePermission(o)\" aria-label=\"Add\" class=\"md-accent\"></md-checkbox>\n</td><td><md-checkbox ng-model=\"o.Modified\" value=\"o.Modified\" ng-change=\"ChangePermission(o)\" aria-label=\"Update\" \nclass=\"md-accent\"></md-checkbox></td><td><md-checkbox ng-model=\"o.Deleted\" value=\"o.Deleted\" \nng-change=\"ChangePermission(o)\" aria-label=\"View\" class=\"md-accent\"></md-checkbox></td></tr></tbody></table></div>\n</div></md-tab></md-tabs></form></div></div></div></md-content>");
$templateCache.put("app/main/VerifyAccount/VerifyAccount.html","<div id=\"verifyaccount\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"verifyaccount-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><img src=\"/assets/icons/icon.jpg\" alt=\"\" class=\"loginLogo\"><div \nid=\"verifyaccount-form\" class=\"md-whiteframe-2dp\"><h2>Account Verification</h2><span class=\"smallText\" align=\"center\" \nng-if=\"!flgVerify && !flagExpire\">Your account does not verify yet.</span> <span class=\"smallText\" align=\"center\" \nng-if=\"flgVerify && !flagExpire\">Your Account Verify Sucessfully.</span> <span class=\"smallText\" align=\"center\" \nng-if=\"flagExpire\">Your Account Verification link has expired.</span><div layout=\"row\" align=\"center\"><a \nclass=\"linkOrange md-block\" ui-sref=\"app.login\">Go Back To Login</a></div></div></div></div>");
$templateCache.put("app/main/datatable/datatable.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Tables</span></div><div \nclass=\"title\">Datatable</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button\" ng-click=\"GetAllData()\"><md-icon md-font-icon=\"icon-link\"></md-icon><span>Reference\n</span></md-button></div></div><div class=\"content\"><div class=\"md-title mb-32\">Zero Configuration</div><div \nclass=\"white-bg md-whiteframe-4dp\"><form id=\"formFilter\"><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" \nflex><label>Product name</label><input name=\"Name\" id=\"Name\" ng-model=\"Name\"></md-input-container></div><div \nalign=\"right\"><md-button class=\"md-button md-accent md-raised md-hue-1\" ng-click=\"GetAllData()\">Search</md-button>\n</div></form><table datatable=\"\" class=\"dataTable row-border hover\" dt-instance=\"vm.dtInstance\" \ndt-columns=\"vm.dtColumns\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\">\n<md-checkbox ng-click=\"toggleSeleted()\" ng-model=\"toggleChecked\" aria-label=\"Checkbox 1\" class=\"md-primary\">\n</md-checkbox></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">No</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Image</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Author</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead>\n<tbody></tbody></table></div></div></div>");
$templateCache.put("app/main/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><img src=\"/assets/icons/icon.jpg\" alt=\"\" class=\"loginLogo\"><div id=\"login-form\" \nclass=\"md-whiteframe-2dp\"><div ng-show=\"Isactive && IsEmail\"><div class=\"title\">Sign In<br>Enter Your Email Address\n</div><form name=\"EmailForm\" novalidate><md-input-container class=\"md-block custom-Control\" md-no-float><label>\nYour Email</label><input type=\"text\" name=\"Name\" ng-model=\"model.Name\" required ng-change=\"EmailErrorMessage = false\">\n<div ng-messages=\"EmailForm.Name.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nYou can\'t leave this empty</span></div><span style=\"color: red;font-size: 12px\" ng-show=\"EmailErrorMessage == true\">\nInvalid Email.</span></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"LOG IN\" ng-click=\"EmailCheck(model)\" ng-disabled=\"EmailForm.$invalid || EmailForm.$pristine\">Continue\n</md-button></form><div layout=\"row\" align=\"left\"><a class=\"linkOrange\" ui-sref=\"app.Register\">Create New account</a>\n</div></div><div ng-show=\"Isactive && !IsEmail\"><div class=\"title\">Welcome {{model.Name}}<br>Enter Your Password</div>\n<form name=\"loginForm\" novalidate><md-input-container class=\"md-block custom-Control\" md-no-float><label>Your Password\n</label><input type=\"password\" name=\"Password\" ng-model=\"model.Password\" required \nng-change=\"PasswordErrorMessage = false\"><div ng-messages=\"loginForm.Password.$error\" role=\"alert\"><div \nng-message=\"required\"><span>You can\'t leave this empty</span></div></div><span style=\"color: red;font-size: 12px\" \nng-show=\"PasswordErrorMessage == true\">Invalid Password.</span></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-click=\"Login(model)\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\">Continue</md-button></form><div layout=\"row\" align=\"left\"><a \nclass=\"linkOrange\" ui-sref=\"app.Forgotpassword\">Forgot Password</a></div></div><div ng-show=\"!Isactive\"><form \nname=\"forgotPasswordForm\"><h2 align=\"center\">Verify Your Email Address</h2><span class=\"smallText\" align=\"center\" \nng-if=\"!IsResend\">\nDoesn\'t look like you have verified your email address yet, if you would like us to resend now then click below.</span>\n<span class=\"smallText\" align=\"center\" ng-show=\"IsResend\">\nIf you do not receive verification email within 30 seconds, please check your Junk Mail folder or click on Resend button.\n</span><md-button class=\"md-raised md-accent submit-button\" aria-label=\"RESEND EMAIL\" ng-click=\"ResendEmail()\">Resend\n</md-button></form><div class=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"linkOrange\" \nng-click=\"BackLogin()\">Go Back To Login</a></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Row Color\" md-menu-origin \nng-click=\"$mdOpenMenu($event)\" ng-class=\"selectedColor.class\"><span ng-show=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-show=\"!selectedColor.palette\">Select Color</span>\n</md-button><md-menu-content class=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-if=\"!selectedColor.palette\">Select Color</span>\n<md-button class=\"remove-color-button md-icon-button\" ng-click=\"removeColor()\" aria-label=\"Remove Color\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-if=\"!selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in palettes\" ng-click=\"activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-if=\"selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+selectedPalette+\'-\'+hue+\'-bg\'\" \nng-repeat=\"(hue, values) in selectedHues\" ng-click=\"selectColor(selectedPalette,hue)\" layout=\"row\" \nlayout-align=\"start end\" md-ink-ripple><span class=\"label\">{{hue}} </span><i \nng-if=\"selectedPalette == selectedColor.palette && hue == selectedColor.hue\" class=\"s16 icon-check\"></i></div></div>\n</div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon \nid=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><md-icon \nid=\"ms-search-bar-collapser\" md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></label><input \nid=\"ms-search-bar-input\" type=\"text\" ng-model=\"global.search\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"center center\"><md-icon \nclass=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\">\n</md-icon></md-toolbar><ms-navigation class=\"scrollable mainMenu\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\">\n</ms-navigation><ms-nav><ms-nav-item><a ms-nav-button md-ink-ripple ng-click=\"logout()\"><i class=\"icon-logout s16\"></i>\n <span class=\"ms-nav-label\">Logout</span></a></ms-nav-item></ms-nav>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\" layout=\"column\" layout-align=\"start start\"><div class=\"secondary-text\">\n<div>{{vm.date | date:\'EEEE\'}}</div><div layout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> \n<span class=\"md-subhead\">th</span> <span>{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list>\n<md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span>\n</md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div \nclass=\"md-list-item-text\"><h3>{{event.title}}</h3><p>{{event.detail}}</p></div></md-list-item></md-list><md-divider>\n</md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader>\n<md-list-item class=\"md-2-line\" ng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\">\n<h3>{{note.title}}</h3><p>{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list>\n<md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader>\n<md-list-item><h3 translate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.notify\" aria-label=\"Notifications\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item><md-list-item><h3 \ntranslate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.cloud\" \naria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch class=\"md-secondary md-warn\" \nng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\"></span> <span class=\"logo-text\">Mat of Life</span>\n</div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"{{RoutePath}}MediaUploads/UserUpload/{{UserImage}}\" err-src=\"assets/images/avatars/profile.jpg\"></div><span \nclass=\"username\" hide-sm>{{UserName}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm>\n</md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\"></span> <span class=\"logo-text\">Mat of Life</span>\n</div><div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div\n layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"{{RoutePath}}MediaUploads/UserUpload/{{UserImage}}\" err-src=\"assets/images/avatars/profile.jpg\"></div><span \nclass=\"username\" hide-sm>{{UserName}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm>\n</md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-shortcuts></ms-shortcuts><div \nclass=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\">\n</md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"{{RoutePath}}MediaUploads/UserUpload/{{UserImage}}\" err-src=\"assets/images/avatars/profile.jpg\"></div><span \nclass=\"username\" hide show-gt-sm>{{UserName}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs>\n</md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\"></span> <span class=\"logo-text\">PC</span></div><div \nclass=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"{{RoutePath}}MediaUploads/UserUpload/{{UserImage}}\" err-src=\"assets/images/avatars/profile.jpg\"></div><span \nclass=\"username\" hide-sm>{{UserName}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm>\n</md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" \nlayout-align-sm=\"start center\" layout-align-gt-xs=\"center center\" flex><md-button id=\"navigation-toggle\" \nclass=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><ms-shortcuts></ms-shortcuts><img src=\"../assets/icons/icon.jpg\" alt=\"\" class=\"headerLogo\"></div><div \nlayout=\"row\" layout-align=\"start center\"></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/ActiveDevices/dialogs/InformationDetail/InformationDetail.html","<md-dialog><md-toolbar class=\"md-grey-50-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><span class=\"title black-fg\">Information</span><md-button class=\"md-icon-button\" \nng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close black-fg\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content style=\"padding-top:0\"><div class=\"md-dialog-content\" \nng-if=\"Flag==\'FlagSchedulType\'\"><h2>Schedul Type :</h2><p>\nThe mango is a juicy stone fruit belonging to the genus Mangifera, consisting of numerous tropical fruiting trees, cultivated mostly for edible fruit. The majority of these species are found in nature as wild mangoes. They all belong to the flowering plant family Anacardiaceae. The mango is native to South and Southeast Asia, from where it has been distributed worldwide to become one of the most cultivated fruits in the tropics.\n</p></div><div class=\"md-dialog-content\" ng-if=\"Type==\'Alarm\' && Flag==\'FlagAlarmOnTime\'\"><h2>Alarm On Time :</h2><p>\nThe mango is a juicy stone fruit belonging to the genus Mangifera, consisting of numerous tropical fruiting trees, cultivated mostly for edible fruit. The majority of these species are found in nature as wild mangoes. They all belong to the flowering plant family Anacardiaceae. The mango is native to South and Southeast Asia, from where it has been distributed worldwide to become one of the most cultivated fruits in the tropics.\n</p></div><div class=\"md-dialog-content\" ng-if=\"Type==\'Alarm\' && Flag==\'FlagTriggerType\'\"><h2>Trigger Type :</h2><p>\nThe mango is a juicy stone fruit belonging to the genus Mangifera, consisting of numerous tropical fruiting trees, cultivated mostly for edible fruit. The majority of these species are found in nature as wild mangoes. They all belong to the flowering plant family Anacardiaceae. The mango is native to South and Southeast Asia, from where it has been distributed worldwide to become one of the most cultivated fruits in the tropics.\n</p></div><div class=\"md-dialog-content\" ng-if=\"Type==\'Socket\' && Flag==\'FlagLightOnTime\'\"><h2>Light On Time :</h2><p>\nThe mango is a juicy stone fruit belonging to the genus Mangifera, consisting of numerous tropical fruiting trees, cultivated mostly for edible fruit. The majority of these species are found in nature as wild mangoes. They all belong to the flowering plant family Anacardiaceae. The mango is native to South and Southeast Asia, from where it has been distributed worldwide to become one of the most cultivated fruits in the tropics.\n</p></div><div class=\"md-dialog-content\" ng-if=\"Type==\'Mat\' && Flag==\'FlagSMStextonFirstStep\'\"><h2>\nSMS text on First Step :</h2><p>\nThe mango is a juicy stone fruit belonging to the genus Mangifera, consisting of numerous tropical fruiting trees, cultivated mostly for edible fruit. The majority of these species are found in nature as wild mangoes. They all belong to the flowering plant family Anacardiaceae. The mango is native to South and Southeast Asia, from where it has been distributed worldwide to become one of the most cultivated fruits in the tropics.\n</p></div><div class=\"md-dialog-content\" ng-if=\"Type==\'Mat\' && Flag==\'FlagSMStextonSecondStep\'\"><h2>\nFlag SMS text on Second Step :</h2><p>\nThe mango is a juicy stone fruit belonging to the genus Mangifera, consisting of numerous tropical fruiting trees, cultivated mostly for edible fruit. The majority of these species are found in nature as wild mangoes. They all belong to the flowering plant family Anacardiaceae. The mango is native to South and Southeast Asia, from where it has been distributed worldwide to become one of the most cultivated fruits in the tropics.\n</p></div><div class=\"md-dialog-content\" ng-if=\"Type==\'Mat\' && Flag==\'FlagSMSonAlert\'\"><h2>SMS on Alert :</h2><p>\nThe mango is a juicy stone fruit belonging to the genus Mangifera, consisting of numerous tropical fruiting trees, cultivated mostly for edible fruit. The majority of these species are found in nature as wild mangoes. They all belong to the flowering plant family Anacardiaceae. The mango is native to South and Southeast Asia, from where it has been distributed worldwide to become one of the most cultivated fruits in the tropics.\n</p></div><div class=\"md-dialog-content\" ng-if=\"Type==\'Mat\' && Flag==\'FlagMultipleDetectionAvoidanceTime\'\"><h2>\nMultiple Detection Avoidance Time :</h2><p>\nThe mango is a juicy stone fruit belonging to the genus Mangifera, consisting of numerous tropical fruiting trees, cultivated mostly for edible fruit. The majority of these species are found in nature as wild mangoes. They all belong to the flowering plant family Anacardiaceae. The mango is native to South and Southeast Asia, from where it has been distributed worldwide to become one of the most cultivated fruits in the tropics.\n</p></div><div class=\"md-dialog-content\" ng-if=\"Type==\'Mat\' && Flag==\'FlagAlertMessageTime\'\"><h2>Alert Message Time :\n</h2><p>\nThe mango is a juicy stone fruit belonging to the genus Mangifera, consisting of numerous tropical fruiting trees, cultivated mostly for edible fruit. The majority of these species are found in nature as wild mangoes. They all belong to the flowering plant family Anacardiaceae. The mango is native to South and Southeast Asia, from where it has been distributed worldwide to become one of the most cultivated fruits in the tropics.\n</p></div><div class=\"md-dialog-content\" ng-if=\"Type==\'Mat\' && Flag==\'FlagStandbyTime\'\"><h2>Standby Time :</h2><p>\nThe mango is a juicy stone fruit belonging to the genus Mangifera, consisting of numerous tropical fruiting trees, cultivated mostly for edible fruit. The majority of these species are found in nature as wild mangoes. They all belong to the flowering plant family Anacardiaceae. The mango is native to South and Southeast Asia, from where it has been distributed worldwide to become one of the most cultivated fruits in the tropics.\n</p></div><div class=\"md-dialog-content\" ng-if=\"Type==\'Mat\' && Flag==\'FlagMatLightTime\'\"><h2>Mat Light Time :</h2><p>\nThe mango is a juicy stone fruit belonging to the genus Mangifera, consisting of numerous tropical fruiting trees, cultivated mostly for edible fruit. The majority of these species are found in nature as wild mangoes. They all belong to the flowering plant family Anacardiaceae. The mango is native to South and Southeast Asia, from where it has been distributed worldwide to become one of the most cultivated fruits in the tropics.\n</p></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/ActiveDevices/dialogs/CordlessDevice/CordlessDevice.html","<md-dialog><md-toolbar class=\"md-grey-50-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><span class=\"title black-fg\">Cordless Devices</span><md-button class=\"md-icon-button\" \nng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close black-fg\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content style=\"padding-top:0\"><form name=\"SocketSettingForm\" novalidate \nclass=\"md-inline-form\"><div class=\"responsive-table\"><table id=\"Device\" class=\"dataTable tableD1\" datatable=\"ng\" \ndt-options=\"dtOptions2\" dt-column-defs=\"dtColumnDefsDevice\" ng-if=\"lstSMS !=\'\'\"><thead><tr><th class=\"all\"><div \nclass=\"table-header\"><span class=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">NRF Address</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Connection Status</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Is Low Battery</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Time Stamp</span></div></th></tr></thead><tbody><tr \nng-repeat=\"o in CordlessDeviceList\"><td>{{$index+1}}</td><td>{{o.NRFAddress}}</td><td ng-if=\"o.Connection_Status==1\">\n<span style=\"font-size: 20px;color: green\">&#x2714;</span></td><td ng-if=\"o.Connection_Status!=1\"><span \nstyle=\"font-size: 20px;color: red\">&#x2716;</span></td><td ng-if=\"o.IsLowBattery==1\"><span \nstyle=\"font-size: 20px;color: green\">&#x2714;</span></td><td ng-if=\"o.IsLowBattery!=1\"><span \nstyle=\"font-size: 20px;color: red\">&#x2716;</span></td><td>{{o.LowBatteryTimeStamp | date: \'dd-MM-yyyy hh:mm a\'}}</td>\n</tr></tbody></table></div></form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/ActiveDevices/dialogs/LinkDevice/LinkDevice.html","<md-dialog><md-toolbar class=\"md-grey-50-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><span class=\"title black-fg\">Select Device From the List</span><md-button \nclass=\"md-icon-button\" ng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close black-fg\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding-top:0\"><form name=\"SocketSettingForm\" \nnovalidate class=\"md-inline-form\"><div ng-repeat=\"item in InActiveDeviceList\"><md-checkbox class=\"md-primary\" \nng-checked=\"exists1(item, Selected)\" ng-click=\"toggle1(item, Selected)\">{{ item.DeviceName }} <span \nng-if=\"exists1(item, Selected)\"></span></md-checkbox></div><div align=\"center\"><md-button class=\"md-raised md-primary\" \nng-disabled=\"!SocketSettingForm.$valid\" ng-click=\"LinkDevices(Selected)\">Save</md-button></div></form>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/ActiveDevices/dialogs/MatSetting/MatSetting.html","<md-dialog class=\"flex-50\"><md-toolbar class=\"md-grey-50-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><span class=\"title black-fg\">{{model.DeviceName}}</span><md-button class=\"md-icon-button\" \nng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close black-fg\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content style=\"padding-top:0\"><md-tabs md-selected=\"tab.selectedIndex\" md-dynamic-height \nmd-border-bottom><md-tab label=\"SMS Setting\" ng-click=\"ResetEdit()\"><form name=\"MatSettingForm\" novalidate \nclass=\"md-inline-form\"><div class=\"custom-content\"><md-content><div class=\"content\"><div class=\"responsive-table\">\n<table id=\"Device\" class=\"dataTable tableD1\" datatable=\"ng\" dt-options=\"dtOptions2\" \ndt-column-defs=\"dtColumnDefsDevice\" ng-if=\"lstSMS !=\'\'\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Mobile No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">StartTime</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">EndTime</span></div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">\nFirst Step</span></div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">Second Step</span>\n</div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">Alert</span></div></th><th class=\"all\">\n<div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"o in lstSMS\"><td>{{$index+1}}</td><td>{{o.MobileNo}}</td><td>{{o.Scheduler_StartTime}}</td><td>\n{{o.Scheduler_EndTime}}</td><td align=\"center\"><md-checkbox class=\"md-primary\" ng-change=\"UpdateSMSSetting(o)\" \nng-model=\"o.First_Step\"></md-checkbox></td><td align=\"center\"><md-checkbox class=\"md-primary\" \nng-change=\"UpdateSMSSetting(o)\" ng-model=\"o.Second_Step\"></md-checkbox></td><td align=\"center\"><md-checkbox \nclass=\"md-primary\" ng-change=\"UpdateSMSSetting(o)\" ng-model=\"o.Alert\"></md-checkbox></td><td><md-button \nclass=\"md-icon-button md-accent md-raised md-hue-2\" title=\"Edit\" ng-click=\"FetchSMSSettingById(o)\"><md-icon \nmd-font-icon=\"icon-pencil-box-outline\"></md-icon></md-button><md-button \nclass=\"md-icon-button md-raised md-warn md-raised md-hue-2\" title=\"Delete\" ng-click=\"remove2($index,o)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div><br><div><strong class=\"md-flex\">\nAdd-Modify SMS Notification :</strong></div><br><div layout-gt-sm=\"row\" class=\"formReg\"><md-input-container \nclass=\"md-block contactNo\" md-no-float flex-gt-sm=\"50\"><span>Add & Modify Mobile No</span> <input type=\"tel\" \nid=\"MobileNo\" name=\"MobileNo\" ng-model=\"SMSmodel.MobileNo\" placeholder=\"+11234567890\" required \nvaildnumber=\"SMSmodel.MobileNo\"><div ng-messages=\"MatSettingForm.MobileNo.$error\" \nng-show=\"MatSettingForm.MobileNo.$touched\"><div ng-message=\"required\">Mobile no is required</div><div \nng-message=\"vaildnumber\">Please enter valid mobile number</div></div></md-input-container><script>\n$(\"#MobileNo\").intlTelInput({\r\n                                            utilsScript: \'../bower_components/intl-tel-input-master/build/js/utils.js\',\r\n                                        });\n</script></div><div layout-gt-sm=\"row\" class=\"formReg\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><span>\nSMS text on First Step <span class=\"infoBtnCon\"><md-icon md-font-icon=\"icon-question-mark-circle\" \nstyle=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" ng-mouseover=\"showDiv = !showDiv\" \nng-mouseleave=\"showDiv = !showDiv\"></md-icon><div class=\"infoWin\" style=\"bottom:-74px\" ng-show=\"showDiv\">\nIt is the content of text message to be sent when client has stepped on mat.</div></span></span><input type=\"text\" \nname=\"Text_for_1St_Step\" ng-model=\"SMSmodel.Text_for_1St_Step\" required><div \nng-messages=\"MatSettingForm.Text_for_1St_Step.$error\" ng-if=\"MatSettingForm.Text_for_1St_Step.$touched\"><div \nng-message=\"required\"><span>Text for SMS is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"50\"><span>SMS text on Second Step <span class=\"infoBtnCon\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\" style=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" \nng-mouseover=\"showDiv1 = !showDiv1\" ng-mouseleave=\"showDiv1 = !showDiv1\"></md-icon><div class=\"infoWin\" \nstyle=\"bottom:-74px\" ng-show=\"showDiv1\">\nIt is the content of text message to be sent when client has stepped back on mat.</div></span></span><input \ntype=\"text\" name=\"Text_for_2nd_Step\" ng-model=\"SMSmodel.Text_for_2nd_Step\" required><div \nng-messages=\"MatSettingForm.Text_for_2nd_Step.$error\" ng-if=\"MatSettingForm.Text_for_2nd_Step.$touched\"><div \nng-message=\"required\"><span>Text for SMS is required</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\" class=\"formReg\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><span>SMS on Alert <span \nclass=\"infoBtnCon\"><md-icon md-font-icon=\"icon-question-mark-circle\" \nstyle=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" ng-mouseover=\"showDiv2 = !showDiv2\" \nng-mouseleave=\"showDiv2 = !showDiv2\"></md-icon><div class=\"infoWin\" ng-show=\"showDiv2\">\nIt is the content of text message to be sent when the client does not returns within specified time after stepping onto the MAT.\n</div></span></span><input type=\"text\" name=\"Text_for_Alert_Event\" ng-model=\"SMSmodel.Text_for_Alert_Event\" required>\n<div ng-messages=\"MatSettingForm.Text_for_Alert_Event.$error\" ng-if=\"MatSettingForm.Text_for_Alert_Event.$touched\"><div\n ng-message=\"required\"><span>Text for SMS is required</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"100\"><md-radio-group \nng-model=\"SMSmodel.SchedulType_SMS\" name=\"SchedulType_SMS\"><md-radio-button value=\"Scheduling\" class=\"md-primary\">\nScheduling</md-radio-button><span class=\"infoBtnCon\"><md-icon md-font-icon=\"icon-question-mark-circle\" \nstyle=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" ng-mouseover=\"showDiv3 = !showDiv3\" \nng-mouseleave=\"showDiv3 = !showDiv3\"></md-icon><div class=\"infoWin\" ng-show=\"showDiv3\">\nThe LAMP,SMS and Alarm will activated only if the current system time is between Start Time and End Time.</div></span>\n<md-radio-button value=\"Always On\" class=\"md-primary\">Always On (24 Hours)</md-radio-button></md-radio-group>\n</md-input-container></div><br><div layout-gt-sm=\"row\" ng-show=\"SMSmodel.SchedulType_SMS==\'Scheduling\'\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label>Scheduler Start Time</label><input type=\"text\" \nname=\"Scheduler_StartTime\" class=\"mobiscroll mobiscrollTime\" readonly=\"readonly\" \nng-model=\"SMSmodel.Scheduler_StartTime\" value=\"SMSmodel.Scheduler_StartTime\"><div \nng-messages=\"MatSettingForm.Scheduler_StartTime.$error\" ng-if=\"MatSettingForm.Scheduler_StartTime.$touched\"><div \nng-message=\"required\"><span>Scheduler StartTime is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"50\"><label>Scheduler End Time</label><input type=\"text\" name=\"Scheduler_EndTime\" \nclass=\"mobiscroll mobiscrollTime\" readonly=\"readonly\" ng-model=\"SMSmodel.Scheduler_EndTime\" \nvalue=\"SMSmodel.Scheduler_EndTime\"><div ng-messages=\"MatSettingForm.Scheduler_EndTime.$error\" \nng-if=\"MatSettingForm.Scheduler_EndTime.$touched\"><div ng-message=\"required\"><span>Scheduler EndTime is required</span>\n</div></div></md-input-container><script>\n$(\'.mobiscrollTime\').scroller({\r\n                                            preset: \'time\'\r\n                                        });\r\n                                        $(\'.mobiscrollDate\').scroller();\r\n                                        $(\'.mobiscrollDateTime\').scroller({\r\n                                            preset: \'datetime\'\r\n                                        });\n</script></div></div><div align=\"center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"!MatSettingForm.$valid\" \nng-click=\"CreateSMSSetting(SMSmodel)\">Save</md-button><md-button class=\"md-raised md-warn\" ng-click=\"Reset1()\">Cancel\n</md-button></div></md-content></div></form></md-tab><md-tab label=\"Advanced Setting\"><div class=\"custom-content\"><form\n name=\"MatAdvanceSettingForm\" novalidate class=\"md-inline-form\"><md-content><div layout-gt-sm=\"row\"><md-input-container\n class=\"md-block formReg\" flex-gt-sm=\"50\"><span>Multiple Detection Avoidance Time <span class=\"infoBtnCon\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\" style=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" \nng-mouseover=\"showDiv4 = !showDiv4\" ng-mouseleave=\"showDiv4 = !showDiv4\"></md-icon><div class=\"infoWin\" \nstyle=\"bottom:-170px\" ng-show=\"showDiv4\">\nIt is the time for which MAT will remain deactivated after stepping onto the MAT.It is kept in order to avoid false detection which is caused due to unintentionally stepping multiple times onto the MAT .The MAT will be automatically activated again after this amount of time has been elapsed.\n</div></span></span><md-select ng-model=\"model.MD_Timer\" name=\"MD_Timer\"><md-option value=\"\">Select</md-option>\n<md-option ng-repeat=\"item in TimingListforMDtime\" value=\"{{item.value}}\">{{item.time}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block formReg\" flex-gt-sm=\"50\"><span>Alert Message Time <span \nclass=\"infoBtnCon\"><md-icon md-font-icon=\"icon-question-mark-circle\" \nstyle=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" ng-mouseover=\"showDiv5 = !showDiv5\" \nng-mouseleave=\"showDiv5 = !showDiv5\"></md-icon><div class=\"infoWin\" ng-show=\"showDiv5\">\nIt is the time interval after which if client didn’t stepped back onto the Mat then an Alert SMS will be sent onto the registered mobile number.\n</div></span></span><md-select ng-model=\"model.Alert_Msg_Timer\" name=\"Alert_Msg_Timer\"><md-option value=\"\">Select\n</md-option><md-option ng-repeat=\"item in TimingList\" value=\"{{item.value}}\">{{item.time}}</md-option></md-select>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block formReg\" flex-gt-sm=\"50\"><span>\nStandby Time <span class=\"infoBtnCon\"><md-icon md-font-icon=\"icon-question-mark-circle\" \nstyle=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" ng-mouseover=\"showDiv6 = !showDiv6\" \nng-mouseleave=\"showDiv6 = !showDiv6\"></md-icon><div class=\"infoWin\" style=\"bottom:-74px\" ng-show=\"showDiv6\">\nIt is the time for which MAT will be deactivated after pressing standby button on MAT UNIT.</div></span></span>\n<md-select ng-model=\"model.Standby_Timer\" name=\"Standby_Timer\"><md-option value=\"\">Select</md-option><md-option \nng-repeat=\"item in TimingList\" value=\"{{item.value}}\">{{item.time}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block formReg\" flex-gt-sm=\"50\"><span>Mat Light Time <span class=\"infoBtnCon\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\" style=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" \nng-mouseover=\"showDiv7 = !showDiv7\" ng-mouseleave=\"showDiv7 = !showDiv7\"></md-icon><div class=\"infoWin\" \nstyle=\"bottom:-106px\" ng-show=\"showDiv7\">\nIt is the time till which the MAT leds should be turned On. Please note that this led turn on automatically when the First step of the client has been detected.\n</div></span></span><md-select ng-model=\"model.LED_Timer\" name=\"LED_Timer\"><md-option value=\"\">Select</md-option>\n<md-option ng-repeat=\"item in TimingList\" value=\"{{item.value}}\">{{item.time}}</md-option></md-select>\n</md-input-container></div><div align=\"center\"><md-button class=\"md-raised md-primary\" \nng-click=\"CreateCustomerDevice(model)\">Save</md-button></div></md-content></form></div></md-tab></md-tabs><style \ntype=\"text/css\">\nbody {\r\n                font-family: arial, verdana, sans-serif;\r\n                /* font-size: 12px; */\r\n            }\r\n            \r\n            .dww img {\r\n                width: 30px;\r\n                height: 30px;\r\n                margin: 5px 10px;\r\n            }\n</style></md-dialog-content></md-dialog>");
$templateCache.put("app/main/ActiveDevices/dialogs/SocketSetting/SocketSetting.html","<md-dialog class=\"flex-50\"><md-toolbar class=\"md-grey-50-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><span class=\"title black-fg\">{{model.DeviceName}}</span><md-button class=\"md-icon-button\" \nng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close black-fg\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content style=\"padding-top:0\"><form name=\"SocketSettingForm\" novalidate \nclass=\"md-inline-form\"><md-tabs md-selected=\"tab.selectedIndex\" md-dynamic-height md-border-bottom><md-tab \nlabel=\"Setting\" ng-click=\"ResetEdit()\" ng-disabled=\"!FlgAddedEditlocal\"><div class=\"custom-content\"><md-content><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block formReg\" flex-gt-sm=\"50\"><span>Light On Time <span \nclass=\"infoBtnCon\"><md-icon id=\"icon\" md-font-icon=\"icon-question-mark-circle\" \nstyle=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" ng-mouseover=\"showDiv = !showDiv\" \nng-mouseleave=\"showDiv = !showDiv\"></md-icon><div class=\"infoWin\" ng-show=\"showDiv\" style=\"bottom:-105px\">\nIt is the time till which the MAT leds should be turned On. Please note that this led turn on automatically when the First step of the client has been detected.\n</div></span></span><md-select ng-model=\"model.LightOff_Timer\" name=\"LightOff_Timer\"><md-option value=\"\">Select\n</md-option><md-option ng-repeat=\"item in TimingList\" value=\"{{item.value}}\">{{item.time}}</md-option></md-select>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" md-no-float><md-radio-group \nng-model=\"model.SchedulType\" name=\"SchedulType\"><md-radio-button value=\"Scheduling\" class=\"md-primary\">Scheduling\n</md-radio-button><span class=\"infoBtnCon\"><md-icon md-font-icon=\"icon-question-mark-circle\" \nstyle=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" ng-mouseover=\"showDiv1 = !showDiv1\" \nng-mouseleave=\"showDiv1 = !showDiv1\"></md-icon><div class=\"infoWin\" ng-show=\"showDiv1\">\nStart Time and End Time: The LAMP,SMS and Alarm will activated only if the current system time is between Start Time and End Time.\n</div></span><md-radio-button value=\"Always On\" class=\"md-primary\">Always On (24 Hours)</md-radio-button>\n</md-radio-group></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\" ng-show=\"model.SchedulType==\'Scheduling\'\"><label>Start Time</label><input type=\"text\" \nng-required=\"model.SchedulType==\'Scheduling\'\" name=\"Scheduler_StartTime\" class=\"mobiscroll mobiscrollTime\" \nreadonly=\"readonly\" ng-model=\"model.Scheduler_StartTime\" value=\"model.Scheduler_StartTime\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"50\" ng-show=\"model.SchedulType==\'Scheduling\'\"><label>End Time</label>\n<input type=\"text\" ng-required=\"model.SchedulType==\'Scheduling\'\" name=\"Scheduler_EndTime\" \nclass=\"mobiscroll mobiscrollTime\" readonly=\"readonly\" ng-model=\"model.Scheduler_EndTime\" \nvalue=\"model.Scheduler_EndTime\"></md-input-container><script>\n$(\'.mobiscrollTime\').scroller({\r\n                                        preset: \'time\'\r\n                                    });\r\n                                    $(\'.mobiscrollDate\').scroller();\r\n                                    $(\'.mobiscrollDateTime\').scroller({\r\n                                        preset: \'datetime\'\r\n                                    });\n</script></div><div align=\"center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"!SocketSettingForm.$valid\" \nng-click=\"CreateCustomerDevice(model,SMSmodel)\">Save</md-button></div></md-content></div></md-tab></md-tabs></form>\n<style type=\"text/css\">\nbody {\r\n                font-family: arial, verdana, sans-serif;\r\n                /* font-size: 12px; */\r\n            }\r\n            \r\n            .dww img {\r\n                width: 30px;\r\n                height: 30px;\r\n                margin: 5px 10px;\r\n            }\n</style></md-dialog-content></md-dialog>");
$templateCache.put("app/main/ActiveDevices/dialogs/AlarmSetting/AlarmSetting.html","<md-dialog class=\"flex-50\"><md-toolbar class=\"md-grey-50-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><span class=\"title black-fg\">{{model.DeviceName}}</span><md-button class=\"md-icon-button\" \nng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close black-fg\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content style=\"padding-top:0\"><form name=\"AlarmSettingForm\" novalidate \nclass=\"md-inline-form\"><md-tabs md-selected=\"tab.selectedIndex\" md-dynamic-height md-border-bottom><md-tab \nlabel=\"Setting\" ng-click=\"ResetEdit()\" ng-disabled=\"!FlgAddedEditlocal\"><div class=\"custom-content\"><md-content><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block formReg\" flex-gt-sm=\"50\" ng-if=\"model.DeviceType==\'Alarm\'\">\n<span>Alarm On Time <span class=\"infoBtnCon\"><md-icon md-font-icon=\"icon-question-mark-circle\" \nstyle=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" ng-mouseover=\"showDiv = !showDiv\" \nng-mouseleave=\"showDiv = !showDiv\"></md-icon><div class=\"infoWin\" ng-show=\"showDiv\">\nThe time for which Alarm will be turned ON. After this time is elapsed Alarm will be turned off automatically.</div>\n</span></span><md-select ng-model=\"model.Alarm_Time\" name=\"Alarm_Time\"><md-option value=\"\">Select</md-option><md-option\n ng-repeat=\"item in TimingList\" value=\"{{item.value}}\">{{item.time}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block formReg\" flex-gt-sm=\"50\" ng-if=\"model.DeviceType==\'Alarm\'\"><span>Trigger Type <span\n class=\"infoBtnCon\"><md-icon md-font-icon=\"icon-question-mark-circle\" \nstyle=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" ng-mouseover=\"showDiv1 = !showDiv1\" \nng-mouseleave=\"showDiv1 = !showDiv1\"></md-icon><div class=\"infoWin\" style=\"bottom:-58px\" ng-show=\"showDiv1\">\nAlarm will be triggered whenever selected type of event occurred.</div></span></span><md-select \nng-model=\"model.TriggerType\" name=\"TriggerType\"><md-option value=\"At 1st Step\">At 1st Step</md-option><md-option \nvalue=\"At Alert Event\">At Alert Event</md-option></md-select></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block formReg\" flex-gt-sm=\"50\" ng-if=\"model.DeviceType==\'Alarm\'\"><span>Volume <span \nclass=\"infoBtnCon\"><md-icon md-font-icon=\"icon-question-mark-circle\" \nstyle=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" ng-mouseover=\"showDiv3 = !showDiv3\" \nng-mouseleave=\"showDiv3 = !showDiv3\"></md-icon><div class=\"infoWin\" style=\"bottom:-58px;width:130px\" \nng-show=\"showDiv3\">Buzzer volume in percentage.</div></span></span><input type=\"number\" name=\"Volume\" \nng-model=\"model.Volume\" style=\"border: 1px solid #333 !important;overflow: hidden;padding-right: 7px\">\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" md-no-float><md-radio-group \nng-model=\"model.SchedulType\" name=\"SchedulType\"><md-radio-button value=\"Scheduling\" class=\"md-primary\">Scheduling\n</md-radio-button><span class=\"infoBtnCon\"><md-icon md-font-icon=\"icon-question-mark-circle\" \nstyle=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" ng-mouseover=\"showDiv2 = !showDiv2\" \nng-mouseleave=\"showDiv2 = !showDiv2\"></md-icon><div class=\"infoWin\" ng-show=\"showDiv2\">\nStart Time and End Time: The LAMP,SMS and Alarm will activated only if the current system time is between Start Time and End Time.\n</div></span><md-radio-button value=\"Always On\" class=\"md-primary\">Always On (24 Hours)</md-radio-button>\n</md-radio-group></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\" ng-show=\"model.SchedulType==\'Scheduling\'\"><label>Start Time</label><input type=\"text\" \nng-required=\"model.SchedulType==\'Scheduling\'\" name=\"Scheduler_StartTime\" class=\"mobiscroll mobiscrollTime\" \nreadonly=\"readonly\" ng-model=\"model.Scheduler_StartTime\" value=\"model.Scheduler_StartTime\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"50\" ng-show=\"model.SchedulType==\'Scheduling\'\"><label>End Time</label>\n<input type=\"text\" ng-required=\"model.SchedulType==\'Scheduling\'\" name=\"Scheduler_EndTime\" \nclass=\"mobiscroll mobiscrollTime\" readonly=\"readonly\" ng-model=\"model.Scheduler_EndTime\" \nvalue=\"model.Scheduler_EndTime\"></md-input-container><script>\n$(\'.mobiscrollTime\').scroller({\r\n                                        preset: \'time\'\r\n                                    });\r\n                                    $(\'.mobiscrollDate\').scroller();\r\n                                    $(\'.mobiscrollDateTime\').scroller({\r\n                                        preset: \'datetime\'\r\n                                    });\n</script></div><div align=\"center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"!AlarmSettingForm.$valid\" \nng-click=\"CreateCustomerDevice(model,SMSmodel)\">Save</md-button></div></md-content></div></md-tab></md-tabs></form>\n<style type=\"text/css\">\nbody {\r\n                font-family: arial, verdana, sans-serif;\r\n                /* font-size: 12px; */\r\n            }\r\n            \r\n            .dww img {\r\n                width: 30px;\r\n                height: 30px;\r\n                margin: 5px 10px;\r\n            }\n</style></md-dialog-content></md-dialog>");
$templateCache.put("app/main/Customer/dialogs/DeviceModel/DeviceModel.html","<md-dialog class=\"flex-50\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><span class=\"title\">Customer Devices</span><md-button class=\"md-icon-button\" \nng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><ms-form-wizard flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Device Name</span></div></th><th class=\"all\"><div class=\"secondary-text\"><span \nclass=\"column-title\">Device Serial</span></div></th><th class=\"all\"><div class=\"secondary-text\"><span \nclass=\"column-title\">Device Type</span></div></th></tr></thead><tbody><tr ng-repeat=\"o in lstDevice\"><td>{{ $index+1 }}\n</td><td>{{ o.DeviceName}}</td><td>{{ o.DeviceSerial }}</td><td>{{ o.DeviceType}}</td></tr></tbody></table>\n</ms-form-wizard></md-dialog-content></md-dialog>");
$templateCache.put("app/main/CustomerDevices/dialogs/DeviceTypeDetail/DeviceTypeDetail.html","<md-dialog class=\"flex-50\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><span class=\"title\">Device Type Detail</span><md-button class=\"md-icon-button\" \nng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><ms-form-wizard flex></ms-form-wizard><table class=\"dataTable row-border hover\"><thead>\n<tr><th class=\"all\" ng-show=\"model.DeviceType == \'Mat\'\"><div class=\"table-header\"><span class=\"column-title\">MD Timer\n</span></div></th><th class=\"all\" ng-show=\"model.DeviceType == \'Mat\'\"><div class=\"all\"><span class=\"column-title\">\nAlert Msg Timer</span></div></th><th class=\"all\" ng-show=\"model.DeviceType == \'Mat\'\"><div class=\"all\"><span \nclass=\"column-title\">Standby Timer</span></div></th><th class=\"all\" ng-show=\"model.DeviceType == \'Mat\'\"><div \nclass=\"all\"><span class=\"column-title\">LED Timer</span></div></th><th class=\"all\" ng-show=\"model.DeviceType == \'Mat\'\">\n<div class=\"all\"><span class=\"column-title\">Text for 1St Step</span></div></th><th class=\"all\" \nng-show=\"model.DeviceType == \'Mat\'\"><div class=\"all\"><span class=\"column-title\">Text for 2nd Step</span></div></th><th \nclass=\"all\" ng-show=\"model.DeviceType == \'Mat\'\"><div class=\"all\"><span class=\"column-title\">Text for Alert Event</span>\n</div></th><th class=\"all\" ng-show=\"model.DeviceType == \'Alarm\'\"><div class=\"all\"><span class=\"column-title\">\nTrigger Type</span></div></th><th class=\"all\" ng-show=\"model.DeviceType == \'Socket\'\"><div class=\"all\"><span \nclass=\"column-title\">Light On Timer</span></div></th><th class=\"all\" \nng-show=\"model.DeviceType == \'Socket\' || model.DeviceType == \'Alarm\'\"><div class=\"all\"><span class=\"column-title\">\nScheduler StartTime</span></div></th><th class=\"all\" \nng-show=\"model.DeviceType == \'Socket\' || model.DeviceType == \'Alarm\'\"><div class=\"all\"><span class=\"column-title\">\nScheduler EndTime</span></div></th><th class=\"all\" ng-show=\"model.DeviceType == \'Alarm\'\"><div class=\"all\"><span \nclass=\"column-title\">Alarm Time</span></div></th><th class=\"all\" \nng-show=\"model.DeviceType == \'Socket\' || model.DeviceType == \'Alarm\' || model.DeviceType == \'CallSMS\'\"><div \nclass=\"all\"><span class=\"column-title\">mat</span></div></th></tr></thead><tbody><tr><td \nng-show=\"model.DeviceType == \'Mat\'\">{{model.MD_Timer[0].time}}</td><td ng-show=\"model.DeviceType == \'Mat\'\">\n{{model.Alert_Msg_Timer[0].time}}</td><td ng-show=\"model.DeviceType == \'Mat\'\">{{model.Standby_Timer[0].time}}</td><td \nng-show=\"model.DeviceType == \'Mat\'\">{{model.LED_Timer[0].time}}</td><td ng-show=\"model.DeviceType == \'Mat\'\">\n{{model.Text_for_1St_Step}}</td><td ng-show=\"model.DeviceType == \'Mat\'\">{{model.Text_for_2nd_Step}}</td><td \nng-show=\"model.DeviceType == \'Mat\'\">{{model.Text_for_Alert_Event}}</td><td ng-show=\"model.DeviceType == \'Alarm\'\">\n{{model.TriggerType}}</td><td ng-show=\"model.DeviceType == \'Socket\'\">{{model.LightOff_Timer[0].time}}</td><td \nng-show=\"model.DeviceType == \'Socket\' || model.DeviceType == \'Alarm\'\">{{model.Scheduler_StartTime}}</td><td \nng-show=\"model.DeviceType == \'Socket\' || model.DeviceType == \'Alarm\'\">{{model.Scheduler_EndTime}}</td><td \nng-show=\"model.DeviceType == \'Alarm\'\">{{model.Alarm_Time[0].time}}</td><td \nng-show=\"model.DeviceType == \'Socket\' || model.DeviceType == \'Alarm\' || model.DeviceType == \'CallSMS\'\">{{model.Mat_id}}\n</td></tr></tbody></table></md-dialog-content></md-dialog>");
$templateCache.put("app/main/CustomerDevices/dialogs/EventList/EventList.html","<md-dialog class=\"flex-50\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><span class=\"title\">Event List</span><md-button class=\"md-icon-button\" \nng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\">\n<table class=\"dataTable row-border hover\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\">Event</span></div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">\nEventType</span></div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">ActionType</span></div>\n</th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">Message</span></div></th></tr></thead><tbody>\n<tr><td>{{model.Event}}</td><td>{{model.EventType}}</td><td>{{model.ActionType}}</td><td>{{model.Message}}</td></tr>\n</tbody></table></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/CustomerService/dialogs/Debug/Debug.html","<md-dialog class=\"flex-50\" style=\"max-width:500px;width:500px\"><md-toolbar class=\"md-grey-50-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><span class=\"title black-fg\">{{model.DeviceName}}\n</span><md-button class=\"md-icon-button\" ng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close black-fg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding-top:0\"><form \nname=\"AlarmSettingForm\" novalidate class=\"md-inline-form\"><div class=\"custom-content\"><md-content><div layout=\"row\" \nlayout-align=\"space-around\"><div layout=\"column\" layout-align=\"start center\"><md-button style=\"width: 90%\" \nclass=\"md-raised md-primary\" ng-click=\"RebootDevice()\">Reboot Device</md-button><md-button style=\"width: 90%\" \nclass=\"md-raised md-primary\" ng-click=\"DeviceInConfigMode()\">Enter Config Mode</md-button><md-button \nstyle=\"width: 90%\" class=\"md-raised md-primary\" ng-click=\"DeviceIdentify()\">Device Identify</md-button></div><div \nlayout=\"column\" layout-align=\"start center\"><md-button style=\"width: 90%\" class=\"md-raised md-primary\" \nng-if=\"model.DeviceType==\'Mat\'\" ng-click=\"TurnOnMatLED()\">Turn On Mat LED</md-button><md-button style=\"width: 90%\" \nclass=\"md-raised md-primary\" ng-if=\"model.DeviceType==\'Mat\'\" ng-click=\"TurnOffMatLED()\">Turn Off Mat LED</md-button>\n<md-button style=\"width: 90%\" class=\"md-raised md-primary\" ng-if=\"model.DeviceType==\'Socket\'\" ng-click=\"TurnOnLight()\">\nTurn On Light</md-button><md-button style=\"width: 90%\" class=\"md-raised md-primary\" ng-if=\"model.DeviceType==\'Socket\'\" \nng-click=\"TurnOffLight()\">Turn Off Light</md-button><md-button style=\"width: 90%\" class=\"md-raised md-primary\" \nng-if=\"model.DeviceType==\'Alarm\'\" ng-click=\"TurnOnAlarm()\">Turn On Alarm</md-button><md-button style=\"width: 90%\" \nclass=\"md-raised md-primary\" ng-if=\"model.DeviceType==\'Alarm\'\" ng-click=\"TurnOffAlarm()\">Turn Off Alarm</md-button>\n</div></div></md-content></div></form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/CustomerService/dialogs/SocketSetting/SocketSetting.html","<md-dialog class=\"flex-50\"><md-toolbar class=\"md-grey-50-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><span class=\"title black-fg\">{{model.DeviceName}}</span><md-button class=\"md-icon-button\" \nng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close black-fg\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content style=\"padding-top:0\"><form name=\"SocketSettingForm\" novalidate \nclass=\"md-inline-form\"><md-tabs md-selected=\"tab.selectedIndex\" md-dynamic-height md-border-bottom><md-tab \nlabel=\"Setting\" ng-click=\"ResetEdit()\" ng-disabled=\"!FlgAddedEditlocal\"><div class=\"custom-content\"><md-content><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block formReg\" flex-gt-sm=\"50\"><span>Light On Time <span \nclass=\"infoBtnCon\"><md-icon id=\"icon\" md-font-icon=\"icon-question-mark-circle\" \nstyle=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" ng-mouseover=\"showDiv = !showDiv\" \nng-mouseleave=\"showDiv = !showDiv\"></md-icon><div class=\"infoWin\" ng-show=\"showDiv\" style=\"bottom:-105px\">\nIt is the time till which the MAT leds should be turned On. Please note that this led turn on automatically when the First step of the client has been detected.\n</div></span></span><md-select ng-model=\"model.LightOff_Timer\" name=\"LightOff_Timer\"><md-option value=\"\">Select\n</md-option><md-option ng-repeat=\"item in TimingList\" value=\"{{item.value}}\">{{item.time}}</md-option></md-select>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" md-no-float><md-radio-group \nng-model=\"model.SchedulType\" name=\"SchedulType\"><md-radio-button value=\"Scheduling\" class=\"md-primary\">Scheduling\n</md-radio-button><span class=\"infoBtnCon\"><md-icon md-font-icon=\"icon-question-mark-circle\" \nstyle=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" ng-mouseover=\"showDiv1 = !showDiv1\" \nng-mouseleave=\"showDiv1 = !showDiv1\"></md-icon><div class=\"infoWin\" ng-show=\"showDiv1\">\nStart Time and End Time: The LAMP,SMS and Alarm will activated only if the current system time is between Start Time and End Time.\n</div></span><md-radio-button value=\"Always On\" class=\"md-primary\">Always On (24 Hours)</md-radio-button>\n</md-radio-group></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\" ng-show=\"model.SchedulType==\'Scheduling\'\"><label>Start Time</label><input type=\"text\" \nng-required=\"model.SchedulType==\'Scheduling\'\" name=\"Scheduler_StartTime\" class=\"mobiscroll mobiscrollTime\" \nreadonly=\"readonly\" ng-model=\"model.Scheduler_StartTime\" value=\"model.Scheduler_StartTime\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"50\" ng-show=\"model.SchedulType==\'Scheduling\'\"><label>End Time</label>\n<input type=\"text\" ng-required=\"model.SchedulType==\'Scheduling\'\" name=\"Scheduler_EndTime\" \nclass=\"mobiscroll mobiscrollTime\" readonly=\"readonly\" ng-model=\"model.Scheduler_EndTime\" \nvalue=\"model.Scheduler_EndTime\"></md-input-container><script>\n$(\'.mobiscrollTime\').scroller({\r\n                                        preset: \'time\'\r\n                                    });\r\n                                    $(\'.mobiscrollDate\').scroller();\r\n                                    $(\'.mobiscrollDateTime\').scroller({\r\n                                        preset: \'datetime\'\r\n                                    });\n</script></div><div align=\"center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"!SocketSettingForm.$valid\" \nng-click=\"CreateCustomerDevice(model,SMSmodel)\">Save</md-button></div></md-content></div></md-tab></md-tabs></form>\n<style type=\"text/css\">\nbody {\r\n                font-family: arial, verdana, sans-serif;\r\n                /* font-size: 12px; */\r\n            }\r\n            \r\n            .dww img {\r\n                width: 30px;\r\n                height: 30px;\r\n                margin: 5px 10px;\r\n            }\n</style></md-dialog-content></md-dialog>");
$templateCache.put("app/main/CustomerService/dialogs/MatSetting/MatSetting.html","<md-dialog class=\"flex-50\"><md-toolbar class=\"md-grey-50-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><span class=\"title black-fg\">{{model.DeviceName}}</span><md-button class=\"md-icon-button\" \nng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close black-fg\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content style=\"padding-top:0\"><md-tabs md-selected=\"tab.selectedIndex\" md-dynamic-height \nmd-border-bottom><md-tab label=\"SMS Setting\" ng-click=\"ResetEdit()\"><form name=\"MatSettingForm\" novalidate \nclass=\"md-inline-form\"><div class=\"custom-content\"><md-content><div class=\"content\"><div class=\"responsive-table\">\n<table id=\"Device\" class=\"dataTable tableD1\" datatable=\"ng\" dt-options=\"dtOptions2\" \ndt-column-defs=\"dtColumnDefsDevice\" ng-if=\"lstSMS !=\'\'\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Mobile No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">StartTime</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">EndTime</span></div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">\nFirst Step</span></div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">Second Step</span>\n</div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">Alert</span></div></th><th class=\"all\">\n<div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"o in lstSMS\"><td>{{$index+1}}</td><td>{{o.MobileNo}}</td><td>{{o.Scheduler_StartTime}}</td><td>\n{{o.Scheduler_EndTime}}</td><td align=\"center\"><md-checkbox class=\"md-primary\" ng-change=\"UpdateSMSSetting(o)\" \nng-model=\"o.First_Step\"></md-checkbox></td><td align=\"center\"><md-checkbox class=\"md-primary\" \nng-change=\"UpdateSMSSetting(o)\" ng-model=\"o.Second_Step\"></md-checkbox></td><td align=\"center\"><md-checkbox \nclass=\"md-primary\" ng-change=\"UpdateSMSSetting(o)\" ng-model=\"o.Alert\"></md-checkbox></td><td><md-button \nclass=\"md-icon-button md-accent md-raised md-hue-2\" title=\"Edit\" ng-click=\"FetchSMSSettingById(o)\"><md-icon \nmd-font-icon=\"icon-pencil-box-outline\"></md-icon></md-button><md-button \nclass=\"md-icon-button md-raised md-warn md-raised md-hue-2\" title=\"Delete\" ng-click=\"remove2($index,o)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div><br><div><strong class=\"md-flex\">\nAdd-Modify SMS Notification :</strong></div><br><div layout-gt-sm=\"row\" class=\"formReg\"><md-input-container \nclass=\"md-block contactNo\" md-no-float flex-gt-sm=\"50\"><span>Add & Modify Mobile No</span> <input type=\"tel\" \nid=\"MobileNo\" name=\"MobileNo\" ng-model=\"SMSmodel.MobileNo\" placeholder=\"+11234567890\" vaildnumber=\"SMSmodel.MobileNo\" \nrequired><div ng-messages=\"MatSettingForm.MobileNo.$error\" ng-show=\"MatSettingForm.MobileNo.$touched\"><div \nng-message=\"vaildnumber\">Please enter valid mobile number</div><div ng-message=\"required\">Mobile no is required</div>\n</div></md-input-container><script>\n$(\"#MobileNo\").intlTelInput({\r\n                                            utilsScript: \'../bower_components/intl-tel-input-master/build/js/utils.js\',\r\n                                        });\n</script></div><div layout-gt-sm=\"row\" class=\"formReg\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><span>\nSMS text on First Step <span class=\"infoBtnCon\"><md-icon md-font-icon=\"icon-question-mark-circle\" \nstyle=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" ng-mouseover=\"showDiv = !showDiv\" \nng-mouseleave=\"showDiv = !showDiv\"></md-icon><div class=\"infoWin\" style=\"bottom:-74px\" ng-show=\"showDiv\">\nIt is the content of text message to be sent when client has stepped on mat.</div></span></span><input type=\"text\" \nname=\"Text_for_1St_Step\" ng-model=\"SMSmodel.Text_for_1St_Step\" required><div \nng-messages=\"MatSettingForm.Text_for_1St_Step.$error\" ng-if=\"MatSettingForm.Text_for_1St_Step.$touched\"><div \nng-message=\"required\"><span>Text for SMS is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"50\"><span>SMS text on Second Step <span class=\"infoBtnCon\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\" style=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" \nng-mouseover=\"showDiv1 = !showDiv1\" ng-mouseleave=\"showDiv1 = !showDiv1\"></md-icon><div class=\"infoWin\" \nstyle=\"bottom:-74px\" ng-show=\"showDiv1\">\nIt is the content of text message to be sent when client has stepped back on mat.</div></span></span><input \ntype=\"text\" name=\"Text_for_2nd_Step\" ng-model=\"SMSmodel.Text_for_2nd_Step\" required><div \nng-messages=\"MatSettingForm.Text_for_2nd_Step.$error\" ng-if=\"MatSettingForm.Text_for_2nd_Step.$touched\"><div \nng-message=\"required\"><span>Text for SMS is required</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\" class=\"formReg\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><span>SMS on Alert <span \nclass=\"infoBtnCon\"><md-icon md-font-icon=\"icon-question-mark-circle\" \nstyle=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" ng-mouseover=\"showDiv2 = !showDiv2\" \nng-mouseleave=\"showDiv2 = !showDiv2\"></md-icon><div class=\"infoWin\" ng-show=\"showDiv2\">\nIt is the content of text message to be sent when the client does not returns within specified time after stepping onto the MAT.\n</div></span></span><input type=\"text\" name=\"Text_for_Alert_Event\" ng-model=\"SMSmodel.Text_for_Alert_Event\" required>\n<div ng-messages=\"MatSettingForm.Text_for_Alert_Event.$error\" ng-if=\"MatSettingForm.Text_for_Alert_Event.$touched\"><div\n ng-message=\"required\"><span>Text for SMS is required</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><md-radio-group \nng-model=\"SMSmodel.SchedulType_SMS\" name=\"SchedulType_SMS\"><md-radio-button value=\"Scheduling\" class=\"md-primary\">\nScheduling</md-radio-button><span class=\"infoBtnCon\"><md-icon md-font-icon=\"icon-question-mark-circle\" \nstyle=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" ng-mouseover=\"showDiv3 = !showDiv3\" \nng-mouseleave=\"showDiv3 = !showDiv3\"></md-icon><div class=\"infoWin\" ng-show=\"showDiv3\">\nThe LAMP,SMS and Alarm will activated only if the current system time is between Start Time and End Time.</div></span>\n<md-radio-button value=\"Always On\" class=\"md-primary\">Always On (24 Hours)</md-radio-button></md-radio-group>\n</md-input-container></div><br><div layout-gt-sm=\"row\" ng-show=\"SMSmodel.SchedulType_SMS==\'Scheduling\'\">\n<md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label>Scheduler Start Time</label><input type=\"text\" \nname=\"Scheduler_StartTime\" class=\"mobiscroll mobiscrollTime\" readonly=\"readonly\" \nng-model=\"SMSmodel.Scheduler_StartTime\" value=\"SMSmodel.Scheduler_StartTime\"><div \nng-messages=\"MatSettingForm.Scheduler_StartTime.$error\" ng-if=\"MatSettingForm.Scheduler_StartTime.$touched\"><div \nng-message=\"required\"><span>Scheduler StartTime is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"50\"><label>Scheduler End Time</label><input type=\"text\" name=\"Scheduler_EndTime\" \nclass=\"mobiscroll mobiscrollTime\" readonly=\"readonly\" ng-model=\"SMSmodel.Scheduler_EndTime\" \nvalue=\"SMSmodel.Scheduler_EndTime\"><div ng-messages=\"MatSettingForm.Scheduler_EndTime.$error\" \nng-if=\"MatSettingForm.Scheduler_EndTime.$touched\"><div ng-message=\"required\"><span>Scheduler EndTime is required</span>\n</div></div></md-input-container><script>\n$(\'.mobiscrollTime\').scroller({\r\n                                            preset: \'time\'\r\n                                        });\r\n                                        $(\'.mobiscrollDate\').scroller();\r\n                                        $(\'.mobiscrollDateTime\').scroller({\r\n                                            preset: \'datetime\'\r\n                                        });\n</script></div></div><div align=\"center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"!MatSettingForm.$valid\" \nng-click=\"CreateSMSSetting(SMSmodel)\">Save</md-button><md-button class=\"md-raised md-warn\" ng-click=\"Reset1()\">Cancel\n</md-button></div></md-content></div></form></md-tab><md-tab label=\"Advanced Setting\"><div class=\"custom-content\"><form\n name=\"MatAdvanceSettingForm\" novalidate class=\"md-inline-form\"><md-content><div layout-gt-sm=\"row\"><md-input-container\n class=\"md-block formReg\" flex-gt-sm=\"50\"><span>Multiple Detection Avoidance Time <span class=\"infoBtnCon\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\" style=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" \nng-mouseover=\"showDiv4 = !showDiv4\" ng-mouseleave=\"showDiv4 = !showDiv4\"></md-icon><div class=\"infoWin\" \nstyle=\"bottom:-170px\" ng-show=\"showDiv4\">\nIt is the time for which MAT will remain deactivated after stepping onto the MAT.It is kept in order to avoid false detection which is caused due to unintentionally stepping multiple times onto the MAT .The MAT will be automatically activated again after this amount of time has been elapsed.\n</div></span></span><md-select ng-model=\"model.MD_Timer\" name=\"MD_Timer\"><md-option value=\"\">Select</md-option>\n<md-option ng-repeat=\"item in TimingListforMDtime\" value=\"{{item.value}}\">{{item.time}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block formReg\" flex-gt-sm=\"50\"><span>Alert Message Time <span \nclass=\"infoBtnCon\"><md-icon md-font-icon=\"icon-question-mark-circle\" \nstyle=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" ng-mouseover=\"showDiv5 = !showDiv5\" \nng-mouseleave=\"showDiv5 = !showDiv5\"></md-icon><div class=\"infoWin\" ng-show=\"showDiv5\">\nIt is the time interval after which if client didn’t stepped back onto the Mat then an Alert SMS will be sent onto the registered mobile number.\n</div></span></span><md-select ng-model=\"model.Alert_Msg_Timer\" name=\"Alert_Msg_Timer\"><md-option value=\"\">Select\n</md-option><md-option ng-repeat=\"item in TimingList\" value=\"{{item.value}}\">{{item.time}}</md-option></md-select>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block formReg\" flex-gt-sm=\"50\"><span>\nStandby Time <span class=\"infoBtnCon\"><md-icon md-font-icon=\"icon-question-mark-circle\" \nstyle=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" ng-mouseover=\"showDiv6 = !showDiv6\" \nng-mouseleave=\"showDiv6 = !showDiv6\"></md-icon><div class=\"infoWin\" style=\"bottom:-74px\" ng-show=\"showDiv6\">\nIt is the time for which MAT will be deactivated after pressing standby button on MAT UNIT.</div></span></span>\n<md-select ng-model=\"model.Standby_Timer\" name=\"Standby_Timer\"><md-option value=\"\">Select</md-option><md-option \nng-repeat=\"item in TimingList\" value=\"{{item.value}}\">{{item.time}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block formReg\" flex-gt-sm=\"50\"><span>Mat Light Time <span class=\"infoBtnCon\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\" style=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" \nng-mouseover=\"showDiv7 = !showDiv7\" ng-mouseleave=\"showDiv7 = !showDiv7\"></md-icon><div class=\"infoWin\" \nstyle=\"bottom:-106px\" ng-show=\"showDiv7\">\nIt is the time till which the MAT leds should be turned On. Please note that this led turn on automatically when the First step of the client has been detected.\n</div></span></span><md-select ng-model=\"model.LED_Timer\" name=\"LED_Timer\"><md-option value=\"\">Select</md-option>\n<md-option ng-repeat=\"item in TimingList\" value=\"{{item.value}}\">{{item.time}}</md-option></md-select>\n</md-input-container></div><div align=\"center\"><md-button class=\"md-raised md-primary\" \nng-click=\"CreateCustomerDevice(model)\">Save</md-button></div></md-content></form></div></md-tab></md-tabs><style \ntype=\"text/css\">\nbody {\r\n                font-family: arial, verdana, sans-serif;\r\n                /* font-size: 12px; */\r\n            }\r\n            \r\n            .dww img {\r\n                width: 30px;\r\n                height: 30px;\r\n                margin: 5px 10px;\r\n            }\n</style></md-dialog-content></md-dialog>");
$templateCache.put("app/main/DeviceDetail/dialogs/DeviceTypeDetail/DeviceTypeDetail.html","<md-dialog class=\"flex-50\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><span class=\"title\">Device Type Detail</span><md-button class=\"md-icon-button\" \nng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><table class=\"dataTable row-border hover\"><thead><tr><th class=\"all\" \nng-show=\"model.DeviceType == \'Mat\'\"><div class=\"all\"><span class=\"column-title\">MD Timer</span></div></th><th \nclass=\"all\" ng-show=\"model.DeviceType == \'Mat\'\"><div class=\"all\"><span class=\"column-title\">Alert Msg Timer</span>\n</div></th><th class=\"all\" ng-show=\"model.DeviceType == \'Mat\'\"><div class=\"all\"><span class=\"column-title\">\nStandby Timer</span></div></th><th class=\"all\" ng-show=\"model.DeviceType == \'Mat\'\"><div class=\"all\"><span \nclass=\"column-title\">LED Timer</span></div></th><th class=\"all\" \nng-show=\"model.DeviceType == \'Socket\' || model.DeviceType == \'Alarm\'\"><div class=\"all\"><span class=\"column-title\">\nTrigger Type</span></div></th><th class=\"all\" ng-show=\"model.DeviceType == \'Socket\'\"><div class=\"all\"><span \nclass=\"column-title\">LightOff Timer</span></div></th><th class=\"all\" \nng-show=\"model.DeviceType == \'Socket\' || model.DeviceType == \'Alarm\'\"><div class=\"all\"><span class=\"column-title\">\nScheduler StartTime</span></div></th><th class=\"all\" \nng-show=\"model.DeviceType == \'Socket\' || model.DeviceType == \'Alarm\'\"><div class=\"all\"><span class=\"column-title\">\nScheduler EndTime</span></div></th><th class=\"all\" ng-show=\"model.DeviceType == \'Alarm\'\"><div class=\"all\"><span \nclass=\"column-title\">Alarm Time</span></div></th><th class=\"all\" ng-show=\"model.DeviceType == \'Alarm\'\"><div \nclass=\"all\"><span class=\"column-title\">Alert Type</span></div></th><th class=\"all\" \nng-show=\"model.DeviceType == \'CallSMS\'\"><div class=\"all\"><span class=\"column-title\">Type</span></div></th><th \nclass=\"all\" ng-show=\"model.DeviceType == \'CallSMS\'\"><div class=\"all\"><span class=\"column-title\">MobileNo</span></div>\n</th><th class=\"all\" ng-show=\"model.DeviceType == \'CallSMS\'\"><div class=\"all\"><span class=\"column-title\">Email</span>\n</div></th><th class=\"all\" ng-show=\"model.DeviceType == \'CallSMS\'\"><div class=\"all\"><span class=\"column-title\">\nEvent Scheduler StartTime</span></div></th><th class=\"all\" ng-show=\"model.DeviceType == \'CallSMS\'\"><div class=\"all\">\n<span class=\"column-title\">Event Scheduler EndTime</span></div></th><th class=\"all\" \nng-show=\"model.DeviceType == \'CallSMS\'\"><div class=\"all\"><span class=\"column-title\">Alert Scheduler StartTime</span>\n</div></th><th class=\"all\" ng-show=\"model.DeviceType == \'CallSMS\'\"><div class=\"all\"><span class=\"column-title\">\nAlert Scheduler EndTime</span></div></th><th class=\"all\" \nng-show=\"model.DeviceType == \'Socket\' || model.DeviceType == \'Alarm\' || model.DeviceType == \'CallSMS\'\"><div \nclass=\"all\"><span class=\"column-title\">mat</span></div></th></tr></thead><tbody><tr><td \nng-show=\"model.DeviceType == \'Mat\'\">{{model.MD_Timer}}</td><td ng-show=\"model.DeviceType == \'Mat\'\">\n{{model.Alert_Msg_Timer}}</td><td ng-show=\"model.DeviceType == \'Mat\'\">{{model.Standby_Timer}}</td><td \nng-show=\"model.DeviceType == \'Mat\'\">{{model.LED_Timer}}</td><td \nng-show=\"model.DeviceType == \'Socket\' || model.DeviceType == \'Alarm\'\">{{model.TriggerType}}</td><td \nng-show=\"model.DeviceType == \'Socket\'\">{{model.LightOff_Timer}}</td><td \nng-show=\"model.DeviceType == \'Socket\' || model.DeviceType == \'Alarm\'\">{{model.Scheduler_StartTime}}</td><td \nng-show=\"model.DeviceType == \'Socket\' || model.DeviceType == \'Alarm\'\">{{model.Scheduler_EndTime}}</td><td \nng-show=\"model.DeviceType == \'Alarm\'\">{{model.Alarm_Time}}</td><td ng-show=\"model.DeviceType == \'Alarm\'\">\n{{model.AlertType}}</td><td ng-show=\"model.DeviceType == \'CallSMS\'\">{{model.Type}}</td><td \nng-show=\"model.DeviceType == \'CallSMS\'\">{{model.MobileNo}}</td><td ng-show=\"model.DeviceType == \'CallSMS\'\">\n{{model.Email}}</td><td ng-show=\"model.DeviceType == \'CallSMS\'\">{{model.Event_Scheduler_StartTime}}</td><td \nng-show=\"model.DeviceType == \'CallSMS\'\">{{model.Event_Scheduler_EndTime}}</td><td \nng-show=\"model.DeviceType == \'CallSMS\'\">{{model.Alert_Scheduler_StartTime}}</td><td \nng-show=\"model.DeviceType == \'CallSMS\'\">{{model.Alert_Scheduler_Endtime}}</td><td \nng-show=\"model.DeviceType == \'Socket\' || model.DeviceType == \'Alarm\' || model.DeviceType == \'CallSMS\'\">{{model.Mat_id}}\n</td></tr></tbody></table></md-dialog-content></md-dialog>");
$templateCache.put("app/main/DeviceDetail/dialogs/EventList/EventList.html","<md-dialog class=\"flex-50\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><span class=\"title\">Event List</span><md-button class=\"md-icon-button\" \nng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\">\n<table class=\"dataTable row-border hover\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\">Event</span></div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">\nEventType</span></div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">ActionType</span></div>\n</th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">Message</span></div></th></tr></thead><tbody>\n<tr><td>{{model.Event}}</td><td>{{model.EventType}}</td><td>{{model.ActionType}}</td><td>{{model.Message}}</td></tr>\n</tbody></table></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/CustomerService/dialogs/AlarmSetting/AlarmSetting.html","<md-dialog class=\"flex-50\"><md-toolbar class=\"md-grey-50-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><span class=\"title black-fg\">{{model.DeviceName}}</span><md-button class=\"md-icon-button\" \nng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close black-fg\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content style=\"padding-top:0\"><form name=\"AlarmSettingForm\" novalidate \nclass=\"md-inline-form\"><md-tabs md-selected=\"tab.selectedIndex\" md-dynamic-height md-border-bottom><md-tab \nlabel=\"Setting\" ng-click=\"ResetEdit()\" ng-disabled=\"!FlgAddedEditlocal\"><div class=\"custom-content\"><md-content><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block formReg\" flex-gt-sm=\"50\" ng-if=\"model.DeviceType==\'Alarm\'\">\n<span>Alarm On Time <span class=\"infoBtnCon\"><md-icon md-font-icon=\"icon-question-mark-circle\" \nstyle=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" ng-mouseover=\"showDiv = !showDiv\" \nng-mouseleave=\"showDiv = !showDiv\"></md-icon><div class=\"infoWin\" ng-show=\"showDiv\">\nThe time for which Alarm will be turned ON. After this time is elapsed Alarm will be turned off automatically.</div>\n</span></span><md-select ng-model=\"model.Alarm_Time\" name=\"Alarm_Time\"><md-option value=\"\">Select</md-option><md-option\n ng-repeat=\"item in TimingList\" value=\"{{item.value}}\">{{item.time}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block formReg\" flex-gt-sm=\"50\" ng-if=\"model.DeviceType==\'Alarm\'\"><span>Trigger Type <span\n class=\"infoBtnCon\"><md-icon md-font-icon=\"icon-question-mark-circle\" \nstyle=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" ng-mouseover=\"showDiv1 = !showDiv1\" \nng-mouseleave=\"showDiv1 = !showDiv1\"></md-icon><div class=\"infoWin\" style=\"bottom:-58px\" ng-show=\"showDiv1\">\nAlarm will be triggered whenever selected type of event occurred.</div></span></span><md-select \nng-model=\"model.TriggerType\" name=\"TriggerType\"><md-option value=\"At 1st Step\">At 1st Step</md-option><md-option \nvalue=\"At Alert Event\">At Alert Event</md-option></md-select></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block formReg\" flex-gt-sm=\"50\" ng-if=\"model.DeviceType==\'Alarm\'\"><span>Volume <span \nclass=\"infoBtnCon\"><md-icon md-font-icon=\"icon-question-mark-circle\" \nstyle=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" ng-mouseover=\"showDiv3 = !showDiv3\" \nng-mouseleave=\"showDiv3 = !showDiv3\"></md-icon><div class=\"infoWin\" style=\"bottom:-58px;width:130px\" \nng-show=\"showDiv3\">Buzzer volume in percentage.</div></span></span><input type=\"number\" name=\"Volume\" \nng-model=\"model.Volume\" style=\"border: 1px solid #333 !important;overflow: hidden;padding-right: 7px\">\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" md-no-float><md-radio-group \nng-model=\"model.SchedulType\" name=\"SchedulType\"><md-radio-button value=\"Scheduling\" class=\"md-primary\">Scheduling\n</md-radio-button><span class=\"infoBtnCon\"><md-icon md-font-icon=\"icon-question-mark-circle\" \nstyle=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" ng-mouseover=\"showDiv2 = !showDiv2\" \nng-mouseleave=\"showDiv2 = !showDiv2\"></md-icon><div class=\"infoWin\" ng-show=\"showDiv2\">\nStart Time and End Time: The LAMP,SMS and Alarm will activated only if the current system time is between Start Time and End Time.\n</div></span><md-radio-button value=\"Always On\" class=\"md-primary\">Always On (24 Hours)</md-radio-button>\n</md-radio-group></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\" ng-show=\"model.SchedulType==\'Scheduling\'\"><label>Start Time</label><input type=\"text\" \nng-required=\"model.SchedulType==\'Scheduling\'\" name=\"Scheduler_StartTime\" class=\"mobiscroll mobiscrollTime\" \nreadonly=\"readonly\" ng-model=\"model.Scheduler_StartTime\" value=\"model.Scheduler_StartTime\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"50\" ng-show=\"model.SchedulType==\'Scheduling\'\"><label>End Time</label>\n<input type=\"text\" ng-required=\"model.SchedulType==\'Scheduling\'\" name=\"Scheduler_EndTime\" \nclass=\"mobiscroll mobiscrollTime\" readonly=\"readonly\" ng-model=\"model.Scheduler_EndTime\" \nvalue=\"model.Scheduler_EndTime\"></md-input-container><script>\n$(\'.mobiscrollTime\').scroller({\r\n                                        preset: \'time\'\r\n                                    });\r\n                                    $(\'.mobiscrollDate\').scroller();\r\n                                    $(\'.mobiscrollDateTime\').scroller({\r\n                                        preset: \'datetime\'\r\n                                    });\n</script></div><div align=\"center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"!AlarmSettingForm.$valid\" \nng-click=\"CreateCustomerDevice(model,SMSmodel)\">Save</md-button></div></md-content></div></md-tab></md-tabs></form>\n<style type=\"text/css\">\nbody {\r\n                font-family: arial, verdana, sans-serif;\r\n                /* font-size: 12px; */\r\n            }\r\n            \r\n            .dww img {\r\n                width: 30px;\r\n                height: 30px;\r\n                margin: 5px 10px;\r\n            }\n</style></md-dialog-content></md-dialog>");
$templateCache.put("app/main/DeviceSetting_Call_Sms/dialogs/EventList/EventList.html","<md-dialog class=\"flex-50\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><span class=\"title\">Event List</span><md-button class=\"md-icon-button\" \nng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><ms-form-wizard flex><form name=\"formEmailTemplate\" novalidate class=\"ms-stepper\" \naria-invalid=\"false\"><md-content class=\"md-padding\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label>Event\n</label><input name=\"Event\" ng-model=\"model.Event\"></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\"><label>EventType</label><input name=\"EventType\" ng-model=\"model.EventType\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label>ActionType</label><input name=\"ActionType\" \nng-model=\"model.ActionType\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label>Message\n</label><input name=\"Message\" ng-model=\"model.Message\"></md-input-container></md-content></form></ms-form-wizard>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/FirmwareUpgrade/dialogs/FileList/FileList.html","<md-dialog><md-toolbar class=\"md-grey-50-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><span class=\"title black-fg\">Select File From the List</span><md-button \nclass=\"md-icon-button\" ng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close black-fg\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding-top:0\"><form name=\"FileListForm\" novalidate \nclass=\"md-inline-form\"><md-radio-group ng-model=\"model.Filename\"><md-radio-button ng-repeat=\"item in FileList\" \nng-value=\"item\" aria-label=\"{{item}}\">{{item}}</md-radio-button></md-radio-group><div ng-if=\"FileList.length == 0\">\nNo file found.</div><div align=\"center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"model.Filename==\'\'\" \nng-click=\"CallUpgrade()\">Save</md-button></div></form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/FirmwareUpgrade/dialogs/ProgressModal/ProgressModal.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"formProductAttributeCombinationExport\" \nclass=\"md-inline-form\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><span class=\"title\">Device Firmware Upgrade</span></div></md-toolbar><md-dialog-content \nms-scroll><div align=\"center\"><strong>{{DispalyMessage}} Device Name: {{DeviceName}} ({{UploadDevice}}/{{TotalDevice}})\n</strong></div><div layout=\"row\"><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.determinateValueDeviceProcessProgressBar}}\"></md-progress-linear></div><div align=\"center\"><strong>\n({{ProgressPercentage}} %)</strong></div><br><div align=\"center\"><md-button type=\"button\" class=\"md-raised md-primary\" \nng-disabled=\"IsStopDisabled\" ng-click=\"ForceStopProcess()\">Stop</md-button></div></md-dialog-content></form>\n</md-dialog><style type=\"text/css\">\nmd-progress-linear .md-container {\r\n        display: block;\r\n        position: relative;\r\n        overflow: hidden;\r\n        width: 100%;\r\n        height: 30px !important;\r\n        -webkit-transform: translate(0, 0) scale(1, 1);\r\n        transform: translate(0, 0) scale(1, 1);\r\n    }\r\n    \r\n    md-progress-linear .md-container.md-mode-buffer {\r\n        display: block;\r\n        position: relative;\r\n        overflow: hidden;\r\n        width: 100%;\r\n        height: 30px !important;\r\n    }\r\n    \r\n    md-progress-linear .md-container .md-bar1 {\r\n        position: absolute;\r\n        left: 0;\r\n        top: 0;\r\n        bottom: 0;\r\n        width: 100%;\r\n        height: 0px !important;\r\n    }\r\n    \r\n    md-progress-linear {\r\n        display: block;\r\n        position: relative;\r\n        width: 100%;\r\n        height: 30px !important;\r\n        padding-top: 0 !important;\r\n        margin-bottom: 0 !important;\r\n    }\r\n    \r\n    md-progress-linear .md-bar {\r\n        background-color: rgb(44, 209, 2);\r\n    }\r\n    \r\n    md-progress-linear .md-container.md-mode-buffer {\r\n        background-color: whitesmoke !important;\r\n        -webkit-transition: all 0.2s linear;\r\n        transition: all 0.2s linear;\r\n    }\r\n    \r\n    .md-bar.md-bar2 {\r\n        height: initial !important;\r\n    }\n</style>");
$templateCache.put("app/main/InactiveDevices/dialogs/InformationDetail/InformationDetail.html","<md-dialog><md-toolbar class=\"md-grey-50-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><span class=\"title black-fg\">Information</span><md-button class=\"md-icon-button\" \nng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close black-fg\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content style=\"padding-top:0\"><div class=\"md-dialog-content\" \nng-if=\"Flag==\'FlagSchedulType\'\"><h2>Schedule Type :</h2><p>\nThe mango is a juicy stone fruit belonging to the genus Mangifera, consisting of numerous tropical fruiting trees, cultivated mostly for edible fruit. The majority of these species are found in nature as wild mangoes. They all belong to the flowering plant family Anacardiaceae. The mango is native to South and Southeast Asia, from where it has been distributed worldwide to become one of the most cultivated fruits in the tropics.\n</p></div><div class=\"md-dialog-content\" ng-if=\"Type==\'Alarm\' && Flag==\'FlagAlarmOnTime\'\"><h2>Alarm On Time :</h2><p>\nThe mango is a juicy stone fruit belonging to the genus Mangifera, consisting of numerous tropical fruiting trees, cultivated mostly for edible fruit. The majority of these species are found in nature as wild mangoes. They all belong to the flowering plant family Anacardiaceae. The mango is native to South and Southeast Asia, from where it has been distributed worldwide to become one of the most cultivated fruits in the tropics.\n</p></div><div class=\"md-dialog-content\" ng-if=\"Type==\'Alarm\' && Flag==\'FlagTriggerType\'\"><h2>Trigger Type :</h2><p>\nThe mango is a juicy stone fruit belonging to the genus Mangifera, consisting of numerous tropical fruiting trees, cultivated mostly for edible fruit. The majority of these species are found in nature as wild mangoes. They all belong to the flowering plant family Anacardiaceae. The mango is native to South and Southeast Asia, from where it has been distributed worldwide to become one of the most cultivated fruits in the tropics.\n</p></div><div class=\"md-dialog-content\" ng-if=\"Type==\'Socket\' && Flag==\'FlagLightOnTime\'\"><h2>Light On Time :</h2><p>\nThe mango is a juicy stone fruit belonging to the genus Mangifera, consisting of numerous tropical fruiting trees, cultivated mostly for edible fruit. The majority of these species are found in nature as wild mangoes. They all belong to the flowering plant family Anacardiaceae. The mango is native to South and Southeast Asia, from where it has been distributed worldwide to become one of the most cultivated fruits in the tropics.\n</p></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/InactiveDevices/dialogs/SocketSetting/SocketSetting.html","<md-dialog class=\"flex-50\"><md-toolbar class=\"md-grey-50-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><span class=\"title black-fg\">{{model.DeviceName}}</span><md-button class=\"md-icon-button\" \nng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close black-fg\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content style=\"padding-top:0\"><form name=\"SocketSettingForm\" novalidate \nclass=\"md-inline-form\"><md-tabs md-selected=\"tab.selectedIndex\" md-dynamic-height md-border-bottom><md-tab \nlabel=\"Setting\" ng-click=\"ResetEdit()\" ng-disabled=\"!FlgAddedEditlocal\"><div class=\"custom-content\"><md-content><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block formReg\" flex-gt-sm=\"50\"><span>Light On Time <span \nclass=\"infoBtnCon\"><md-icon id=\"icon\" md-font-icon=\"icon-question-mark-circle\" \nstyle=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" ng-mouseover=\"showDiv = !showDiv\" \nng-mouseleave=\"showDiv = !showDiv\"></md-icon><div class=\"infoWin\" ng-show=\"showDiv\" style=\"bottom:-105px\">\nIt is the time till which the MAT leds should be turned On. Please note that this led turn on automatically when the First step of the client has been detected.\n</div></span></span><md-select ng-model=\"model.LightOff_Timer\" name=\"LightOff_Timer\"><md-option value=\"\">Select\n</md-option><md-option ng-repeat=\"item in TimingList\" value=\"{{item.value}}\">{{item.time}}</md-option></md-select>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" md-no-float><md-radio-group \nng-model=\"model.SchedulType\" name=\"SchedulType\"><md-radio-button value=\"Scheduling\" class=\"md-primary\">Scheduling\n</md-radio-button><span class=\"infoBtnCon\"><md-icon md-font-icon=\"icon-question-mark-circle\" \nstyle=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" ng-mouseover=\"showDiv1 = !showDiv1\" \nng-mouseleave=\"showDiv1 = !showDiv1\"></md-icon><div class=\"infoWin\" ng-show=\"showDiv1\">\nStart Time and End Time: The LAMP,SMS and Alarm will activated only if the current system time is between Start Time and End Time.\n</div></span><md-radio-button value=\"Always On\" class=\"md-primary\">Always On (24 Hours)</md-radio-button>\n</md-radio-group></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\" ng-show=\"model.SchedulType==\'Scheduling\'\"><label>Start Time</label><input type=\"text\" \nng-required=\"model.SchedulType==\'Scheduling\'\" name=\"Scheduler_StartTime\" class=\"mobiscroll mobiscrollTime\" \nreadonly=\"readonly\" ng-model=\"model.Scheduler_StartTime\" value=\"model.Scheduler_StartTime\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"50\" ng-show=\"model.SchedulType==\'Scheduling\'\"><label>End Time</label>\n<input type=\"text\" ng-required=\"model.SchedulType==\'Scheduling\'\" name=\"Scheduler_EndTime\" \nclass=\"mobiscroll mobiscrollTime\" readonly=\"readonly\" ng-model=\"model.Scheduler_EndTime\" \nvalue=\"model.Scheduler_EndTime\"></md-input-container><script>\n$(\'.mobiscrollTime\').scroller({\r\n                                        preset: \'time\'\r\n                                    });\r\n                                    $(\'.mobiscrollDate\').scroller();\r\n                                    $(\'.mobiscrollDateTime\').scroller({\r\n                                        preset: \'datetime\'\r\n                                    });\n</script></div><div align=\"center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"!SocketSettingForm.$valid\" \nng-click=\"CreateCustomerDevice(model,SMSmodel)\">Save</md-button></div></md-content></div></md-tab></md-tabs></form>\n<style type=\"text/css\">\nbody {\r\n                font-family: arial, verdana, sans-serif;\r\n                /* font-size: 12px; */\r\n            }\r\n            \r\n            .dww img {\r\n                width: 30px;\r\n                height: 30px;\r\n                margin: 5px 10px;\r\n            }\n</style></md-dialog-content></md-dialog>");
$templateCache.put("app/main/InactiveDevices/dialogs/AlarmSetting/AlarmSetting.html","<md-dialog class=\"flex-50\"><md-toolbar class=\"md-grey-50-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><span class=\"title black-fg\">{{model.DeviceName}}</span><md-button class=\"md-icon-button\" \nng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close black-fg\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content style=\"padding-top:0\"><form name=\"AlarmSettingForm\" novalidate \nclass=\"md-inline-form\"><md-tabs md-selected=\"tab.selectedIndex\" md-dynamic-height md-border-bottom><md-tab \nlabel=\"Setting\" ng-click=\"ResetEdit()\" ng-disabled=\"!FlgAddedEditlocal\"><div class=\"custom-content\"><md-content><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block formReg\" flex-gt-sm=\"50\" ng-if=\"model.DeviceType==\'Alarm\'\">\n<span>Alarm On Time <span class=\"infoBtnCon\"><md-icon md-font-icon=\"icon-question-mark-circle\" \nstyle=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" ng-mouseover=\"showDiv = !showDiv\" \nng-mouseleave=\"showDiv = !showDiv\"></md-icon><div class=\"infoWin\" ng-show=\"showDiv\">\nThe time for which Alarm will be turned ON. After this time is elapsed Alarm will be turned off automatically.</div>\n</span></span><md-select ng-model=\"model.Alarm_Time\" name=\"Alarm_Time\"><md-option value=\"\">Select</md-option><md-option\n ng-repeat=\"item in TimingList\" value=\"{{item.value}}\">{{item.time}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block formReg\" flex-gt-sm=\"50\" ng-if=\"model.DeviceType==\'Alarm\'\"><span>Trigger Type <span\n class=\"infoBtnCon\"><md-icon md-font-icon=\"icon-question-mark-circle\" \nstyle=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" ng-mouseover=\"showDiv1 = !showDiv1\" \nng-mouseleave=\"showDiv1 = !showDiv1\"></md-icon><div class=\"infoWin\" style=\"bottom:-58px\" ng-show=\"showDiv1\">\nAlarm will be triggered whenever selected type of event occurred.</div></span></span><md-select \nng-model=\"model.TriggerType\" name=\"TriggerType\"><md-option value=\"At 1st Step\">At 1st Step</md-option><md-option \nvalue=\"At Alert Event\">At Alert Event</md-option></md-select></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block formReg\" flex-gt-sm=\"50\" ng-if=\"model.DeviceType==\'Alarm\'\"><span>Volume <span \nclass=\"infoBtnCon\"><md-icon md-font-icon=\"icon-question-mark-circle\" \nstyle=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" ng-mouseover=\"showDiv3 = !showDiv3\" \nng-mouseleave=\"showDiv3 = !showDiv3\"></md-icon><div class=\"infoWin\" style=\"bottom:-58px;width:130px\" \nng-show=\"showDiv3\">Buzzer volume in percentage.</div></span></span><input type=\"number\" name=\"Volume\" \nng-model=\"model.Volume\" style=\"border: 1px solid #333 !important;overflow: hidden;padding-right: 7px\">\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" md-no-float><md-radio-group \nng-model=\"model.SchedulType\" name=\"SchedulType\"><md-radio-button value=\"Scheduling\" class=\"md-primary\">Scheduling\n</md-radio-button><span class=\"infoBtnCon\"><md-icon md-font-icon=\"icon-question-mark-circle\" \nstyle=\"cursor:pointer;vertical-align: text-bottom\" class=\"s18 blue-500-fg\" ng-mouseover=\"showDiv2 = !showDiv2\" \nng-mouseleave=\"showDiv2 = !showDiv2\"></md-icon><div class=\"infoWin\" ng-show=\"showDiv2\">\nStart Time and End Time: The LAMP,SMS and Alarm will activated only if the current system time is between Start Time and End Time.\n</div></span><md-radio-button value=\"Always On\" class=\"md-primary\">Always On (24 Hours)</md-radio-button>\n</md-radio-group></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\" ng-show=\"model.SchedulType==\'Scheduling\'\"><label>Start Time</label><input type=\"text\" \nng-required=\"model.SchedulType==\'Scheduling\'\" name=\"Scheduler_StartTime\" class=\"mobiscroll mobiscrollTime\" \nreadonly=\"readonly\" ng-model=\"model.Scheduler_StartTime\" value=\"model.Scheduler_StartTime\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"50\" ng-show=\"model.SchedulType==\'Scheduling\'\"><label>End Time</label>\n<input type=\"text\" ng-required=\"model.SchedulType==\'Scheduling\'\" name=\"Scheduler_EndTime\" \nclass=\"mobiscroll mobiscrollTime\" readonly=\"readonly\" ng-model=\"model.Scheduler_EndTime\" \nvalue=\"model.Scheduler_EndTime\"></md-input-container><script>\n$(\'.mobiscrollTime\').scroller({\r\n                                        preset: \'time\'\r\n                                    });\r\n                                    $(\'.mobiscrollDate\').scroller();\r\n                                    $(\'.mobiscrollDateTime\').scroller({\r\n                                        preset: \'datetime\'\r\n                                    });\n</script></div><div align=\"center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"!AlarmSettingForm.$valid\" \nng-click=\"CreateCustomerDevice(model,SMSmodel)\">Save</md-button></div></md-content></div></md-tab></md-tabs></form>\n<style type=\"text/css\">\nbody {\r\n                font-family: arial, verdana, sans-serif;\r\n                /* font-size: 12px; */\r\n            }\r\n            \r\n            .dww img {\r\n                width: 30px;\r\n                height: 30px;\r\n                margin: 5px 10px;\r\n            }\n</style></md-dialog-content></md-dialog>");
$templateCache.put("app/main/login/dialogs/Register/Register.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"title\" \ntranslate=\"NEW CUSTOMERS\">NEW CUSTOMERS</div><form name=\"RegisterForm\" novalidate><md-input-container class=\"md-block\" \nmd-no-float><label>User Name<md-icon class=\"md-warn\">*</md-icon></label><input type=\"text\" name=\"username\" \nng-model=\"model.username\" required><div ng-messages=\"RegisterForm.username.$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\"><span>User Name is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><label>Email Address<md-icon class=\"md-warn\">*</md-icon></label><input type=\"email\" \nname=\"email\" ng-model=\"model.email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"RegisterForm.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Email is required</span></div><div \nng-message=\"pattern\"><span>Email must be a valid e-mail address</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><label>Password</label><input type=\"password\" name=\"password\" \nng-model=\"model.password\" required><div ng-messages=\"RegisterForm.password.$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\"><span>Password is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><label>Confirm Password<md-icon class=\"md-warn\">*</md-icon></label><input type=\"password\" \nname=\"cpassword\" ng-model=\"model.cpassword\" required><div ng-messages=\"RegisterForm.cpassword.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Confirm Password is required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><label>Phone Number</label><input name=\"phone\" \nng-model=\"model.phone\" type=\"number\" placeholder=\"1234567890\" max=\"9999999999\" min=\"0\"><div \nng-messages=\"RegisterForm.phone.$error\"><div ng-message=\"max\" class=\"my-message\">\nPhone Number can\'t be longer than 10 number.</div></div></md-input-container><md-input-container class=\"md-block\" flex>\n<label>Country</label><md-select name=\"country\" ng-model=\"model.country\" \nng-change=\"GetAllStateByCountry(model.country)\"><md-option ng-repeat=\"o in lstCountry\" value=\" {{o.Country}}\">\n{{o.Country}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex><label>State\n</label><md-select name=\"state\" ng-model=\"model.state\" ng-disabled=\"model.country==\'\'\"><md-option \nng-repeat=\"o in lstState\" value=\"{{o.Name}}\">{{ o.Name }}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><label>City</label><input type=\"text\" name=\"city\" \nng-model=\"model.city\"></md-input-container><label>Gender</label><md-input-container class=\"md-block\" flex>\n<md-radio-group ng-model=\"model.gender\"><md-radio-button value=\"Male\" class=\"md-primary\">Male</md-radio-button>\n<md-radio-button value=\"Female\" class=\"md-primary\">Female</md-radio-button></md-radio-group></md-input-container>\n<md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"Register\" ng-click=\"Register(model)\" \nng-disabled=\"RegisterForm.$invalid || RegisterForm.$pristine\">Register</md-button><md-button type=\"reset\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"Register\" ng-click=\"Cancel()\">Cancel</md-button></form></div>\n</div></div>");
$templateCache.put("app/main/login/dialogs/ForgotPassword/ForgotPassword.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>F\n</span></div><div class=\"title\" translate=\"Forgot Password\">Forgot Password</div><form name=\"ForgotPasswordForm\" \nnovalidate><md-input-container class=\"md-block\" md-no-float><label>Username or email address</label><input type=\"text\" \nname=\"email\" ng-model=\"model.Email\" required><div ng-messages=\"ForgotPasswordForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>User name or email is required</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"Forgot Password\" \nng-click=\"ForgotPassword(model)\" ng-disabled=\"ForgotPasswordForm.$invalid || ForgotPasswordForm.$pristine\">\nForgot Password</md-button></form></div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><a href=\"{{card.link}}\" ng-if=\"card.type==\'link\'\" target=\"_blank\"><img \nclass=\"image\" ng-src=\"{{card.full_picture}}\"><div class=\"text-center\" ng-click=\"GotoLink(d)\"><i \nclass=\"icon-link play-icon\"></i></div></a><a href=\"{{card.source}}\" ng-if=\"card.type==\'video\'\" target=\"_blank\"><img \nclass=\"image\" ng-src=\"{{card.full_picture}}\"><div class=\"text-center\" ng-click=\"playVideo(d)\"><i \nclass=\"icon-play play-icon\"></i></div></a><a ng-if=\"card.type==\'photo\'\"><img class=\"image\" \nng-src=\"{{card.full_picture}}\"></a></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" ng-if=\"card.name\">\n{{card.name}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.message\">{{card.message}}</div><div \nclass=\"text pt-16\" ng-if=\"card.description\">{{card.description}}</div></div><div class=\"buttons m-8\"><md-icon \nmd-font-icon=\"icon-heart\" class=\"s24\"></md-icon>{{card.likes.summary.total_count}}<md-icon md-font-icon=\"icon-comment\" \nclass=\"s24\"></md-icon>{{card.comments.summary.total_count}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps\" layout=\"row\" layout-align=\"start center\"><div class=\"step md-accent-bg\" \nlayout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{step.stepNumber}} \n</span><span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\">\n{{step.stepNumber}}</span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">{{step.stepTitle}}\n</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div>\n</div><div class=\"ms-stepper-steps\" ng-transclude></div></div>");}]);